/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Platform API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptInquiryBody
} from '../../../types/platform/acceptInquiryBody';

import type {
  AcceptInquiryPathParameters
} from '../../../types/platform/acceptInquiryPathParameters';

import type {
  AcceptInquiryResponseBody
} from '../../../types/platform/acceptInquiryResponseBody';

import type {
  ActionError
} from '../../../types/platform/actionError';

import type {
  AddMosaicPageViewPathParameters
} from '../../../types/platform/addMosaicPageViewPathParameters';

import type {
  AddSchemaFieldPathParameters
} from '../../../types/platform/addSchemaFieldPathParameters';

import type {
  AddViewBody
} from '../../../types/platform/addViewBody';

import type {
  AddedView
} from '../../../types/platform/addedView';

import type {
  AllocationsBody
} from '../../../types/platform/allocationsBody';

import type {
  ApproveOrderPathParameters
} from '../../../types/platform/approveOrderPathParameters';

import type {
  ArchiveCustomColumnParams
} from '../../../types/platform/archiveCustomColumnParams';

import type {
  ArchiveCustomColumnPathParameters
} from '../../../types/platform/archiveCustomColumnPathParameters';

import type {
  ArchivePrincipalAccountAssignmentRulesTreePathParameters
} from '../../../types/platform/archivePrincipalAccountAssignmentRulesTreePathParameters';

import type {
  AssignOrderPathParameters
} from '../../../types/platform/assignOrderPathParameters';

import type {
  Attestation
} from '../../../types/platform/attestation';

import type {
  AttestationPreviewSpec
} from '../../../types/platform/attestationPreviewSpec';

import type {
  AttestationUploadResponse
} from '../../../types/platform/attestationUploadResponse';

import type {
  AttestationUploadSpec
} from '../../../types/platform/attestationUploadSpec';

import type {
  BestExOrderAnnotation
} from '../../../types/platform/bestExOrderAnnotation';

import type {
  BulkApproveRequestBody
} from '../../../types/platform/bulkApproveRequestBody';

import type {
  BulkApproveResponseBody
} from '../../../types/platform/bulkApproveResponseBody';

import type {
  BulkAssignRequestBody
} from '../../../types/platform/bulkAssignRequestBody';

import type {
  BulkAssignResponseBody
} from '../../../types/platform/bulkAssignResponseBody';

import type {
  BulkCancelRequestBody
} from '../../../types/platform/bulkCancelRequestBody';

import type {
  BulkCancelResponseBody
} from '../../../types/platform/bulkCancelResponseBody';

import type {
  BulkExecuteRequestBody
} from '../../../types/platform/bulkExecuteRequestBody';

import type {
  BulkExecuteResponseBody
} from '../../../types/platform/bulkExecuteResponseBody';

import type {
  BulkLookupRfqConfigRequestBody
} from '../../../types/platform/bulkLookupRfqConfigRequestBody';

import type {
  BulkLookupRfqConfigResponseBody
} from '../../../types/platform/bulkLookupRfqConfigResponseBody';

import type {
  BulkOrderEntry
} from '../../../types/platform/bulkOrderEntry';

import type {
  BulkOrderEntryFileDownload
} from '../../../types/platform/bulkOrderEntryFileDownload';

import type {
  BulkOrderEntryFileUpload
} from '../../../types/platform/bulkOrderEntryFileUpload';

import type {
  BulkOrderEntrySheet
} from '../../../types/platform/bulkOrderEntrySheet';

import type {
  BulkSendPrincipalBookListRfqs422
} from '../../../types/platform/bulkSendPrincipalBookListRfqs422';

import type {
  CancelAllocationPathParameters
} from '../../../types/platform/cancelAllocationPathParameters';

import type {
  CancelExecutionOrderPathParameters
} from '../../../types/platform/cancelExecutionOrderPathParameters';

import type {
  CancelNewIssuePathParameters
} from '../../../types/platform/cancelNewIssuePathParameters';

import type {
  CancelNewIssueResponseBody
} from '../../../types/platform/cancelNewIssueResponseBody';

import type {
  CancelOrderPathParameters
} from '../../../types/platform/cancelOrderPathParameters';

import type {
  CancelOrderRequestBody
} from '../../../types/platform/cancelOrderRequestBody';

import type {
  CancelReplaceExecutionOrderRequestBody
} from '../../../types/platform/cancelReplaceExecutionOrderRequestBody';

import type {
  CancelReplaceExecutionOrderResponseBody
} from '../../../types/platform/cancelReplaceExecutionOrderResponseBody';

import type {
  CancelRfqPathParameters
} from '../../../types/platform/cancelRfqPathParameters';

import type {
  CancelTradePathParameters
} from '../../../types/platform/cancelTradePathParameters';

import type {
  CancelTradeRequestBody
} from '../../../types/platform/cancelTradeRequestBody';

import type {
  CancelTradeResponseBody
} from '../../../types/platform/cancelTradeResponseBody';

import type {
  CheckNewIssueFinalizePathParameters
} from '../../../types/platform/checkNewIssueFinalizePathParameters';

import type {
  CheckNewIssueFinalizeRequestBody
} from '../../../types/platform/checkNewIssueFinalizeRequestBody';

import type {
  CheckNewIssueFinalizeResponseBody
} from '../../../types/platform/checkNewIssueFinalizeResponseBody';

import type {
  ClearDefaultSavedSearchParams
} from '../../../types/platform/clearDefaultSavedSearchParams';

import type {
  ClearDefaultSavedSearchPathParameters
} from '../../../types/platform/clearDefaultSavedSearchPathParameters';

import type {
  ConfigEntry
} from '../../../types/platform/configEntry';

import type {
  ConfigScopeBody
} from '../../../types/platform/configScopeBody';

import type {
  ConfirmNewIssueFinalTermsBody
} from '../../../types/platform/confirmNewIssueFinalTermsBody';

import type {
  ConfirmNewIssueFinalTermsPathParameters
} from '../../../types/platform/confirmNewIssueFinalTermsPathParameters';

import type {
  ConfirmNewIssueFinalTermsRequestBody
} from '../../../types/platform/confirmNewIssueFinalTermsRequestBody';

import type {
  CourseCompletions
} from '../../../types/platform/courseCompletions';

import type {
  CourseTree
} from '../../../types/platform/courseTree';

import type {
  CreateAttestationPathParameters
} from '../../../types/platform/createAttestationPathParameters';

import type {
  CreateAttestationRequestBody
} from '../../../types/platform/createAttestationRequestBody';

import type {
  CreateBulkOrderEntryDraftPathParameters
} from '../../../types/platform/createBulkOrderEntryDraftPathParameters';

import type {
  CreateBulkOrderEntryFilePathParameters
} from '../../../types/platform/createBulkOrderEntryFilePathParameters';

import type {
  CreateBulkOrderEntryFileRequestBody
} from '../../../types/platform/createBulkOrderEntryFileRequestBody';

import type {
  CreateBulkOrderEntryRequestBody
} from '../../../types/platform/createBulkOrderEntryRequestBody';

import type {
  CreateConfigPathParameters
} from '../../../types/platform/createConfigPathParameters';

import type {
  CreateConfigRequestBody
} from '../../../types/platform/createConfigRequestBody';

import type {
  CreateCustodianManualExecutionOrderPathParameters
} from '../../../types/platform/createCustodianManualExecutionOrderPathParameters';

import type {
  CreateCustomColumnBody
} from '../../../types/platform/createCustomColumnBody';

import type {
  CreateCustomColumnParams
} from '../../../types/platform/createCustomColumnParams';

import type {
  CreateCustomColumnUploadBody
} from '../../../types/platform/createCustomColumnUploadBody';

import type {
  CreateCustomColumnUploadPathParameters
} from '../../../types/platform/createCustomColumnUploadPathParameters';

import type {
  CreateExternalExecutionOrderPathParameters
} from '../../../types/platform/createExternalExecutionOrderPathParameters';

import type {
  CreateExternalQuotesUploadRequestBody
} from '../../../types/platform/createExternalQuotesUploadRequestBody';

import type {
  CreateExternalQuotesUploadResponseBody
} from '../../../types/platform/createExternalQuotesUploadResponseBody';

import type {
  CreateListRequest
} from '../../../types/platform/createListRequest';

import type {
  CreateNewIssueDocUploadsPathParameters
} from '../../../types/platform/createNewIssueDocUploadsPathParameters';

import type {
  CreateNewIssueDocUploadsRequestBody
} from '../../../types/platform/createNewIssueDocUploadsRequestBody';

import type {
  CreateNewIssueParams
} from '../../../types/platform/createNewIssueParams';

import type {
  CreateNewIssuePathParameters
} from '../../../types/platform/createNewIssuePathParameters';

import type {
  CreateNewIssueRequestBody
} from '../../../types/platform/createNewIssueRequestBody';

import type {
  CreateOfferingEntitlementsRequestBody
} from '../../../types/platform/createOfferingEntitlementsRequestBody';

import type {
  CreateOfferingEntitlementsResponseBody
} from '../../../types/platform/createOfferingEntitlementsResponseBody';

import type {
  CreateOfferingRequestBody
} from '../../../types/platform/createOfferingRequestBody';

import type {
  CreateOfferingResponseBody
} from '../../../types/platform/createOfferingResponseBody';

import type {
  CreateOrderEntryDraftParams
} from '../../../types/platform/createOrderEntryDraftParams';

import type {
  CreateOrderEntryDraftRequestBody
} from '../../../types/platform/createOrderEntryDraftRequestBody';

import type {
  CreateOrderGroupsRequestBody
} from '../../../types/platform/createOrderGroupsRequestBody';

import type {
  CreateOrderGroupsResponseBody
} from '../../../types/platform/createOrderGroupsResponseBody';

import type {
  CreateOrderRfqPathParameters
} from '../../../types/platform/createOrderRfqPathParameters';

import type {
  CreateOverlayRowsBody
} from '../../../types/platform/createOverlayRowsBody';

import type {
  CreateOverlayRowsParams
} from '../../../types/platform/createOverlayRowsParams';

import type {
  CreateOverlayRowsPathParameters
} from '../../../types/platform/createOverlayRowsPathParameters';

import type {
  CreateOverlayUploadPathParameters
} from '../../../types/platform/createOverlayUploadPathParameters';

import type {
  CreatePageBody
} from '../../../types/platform/createPageBody';

import type {
  CreateRFQBody
} from '../../../types/platform/createRFQBody';

import type {
  CreateRFQResponse
} from '../../../types/platform/createRFQResponse';

import type {
  CreateSavedSearchPathParameters
} from '../../../types/platform/createSavedSearchPathParameters';

import type {
  CreateSavedSearchRequestBody
} from '../../../types/platform/createSavedSearchRequestBody';

import type {
  CreateSyncUploadsResponseBody
} from '../../../types/platform/createSyncUploadsResponseBody';

import type {
  CreateUploadBody
} from '../../../types/platform/createUploadBody';

import type {
  CreateUploadOutputBody
} from '../../../types/platform/createUploadOutputBody';

import type {
  CreateUserRequestBody
} from '../../../types/platform/createUserRequestBody';

import type {
  CustomColumnBody
} from '../../../types/platform/customColumnBody';

import type {
  DeleteConfigPathParameters
} from '../../../types/platform/deleteConfigPathParameters';

import type {
  DeleteMosaicPageParams
} from '../../../types/platform/deleteMosaicPageParams';

import type {
  DeleteMosaicPagePathParameters
} from '../../../types/platform/deleteMosaicPagePathParameters';

import type {
  DeleteNewIssuePathParameters
} from '../../../types/platform/deleteNewIssuePathParameters';

import type {
  DeleteOrderEntryDraftParams
} from '../../../types/platform/deleteOrderEntryDraftParams';

import type {
  DeleteOrderEntryDraftPathParameters
} from '../../../types/platform/deleteOrderEntryDraftPathParameters';

import type {
  DeleteResponseBody
} from '../../../types/platform/deleteResponseBody';

import type {
  DeleteSavedSearchPathParameters
} from '../../../types/platform/deleteSavedSearchPathParameters';

import type {
  DeleteSchemaPathParameters
} from '../../../types/platform/deleteSchemaPathParameters';

import type {
  DescriptionBody
} from '../../../types/platform/descriptionBody';

import type {
  DistributorReview
} from '../../../types/platform/distributorReview';

import type {
  DistributorReviewBody
} from '../../../types/platform/distributorReviewBody';

import type {
  EditCustomColumnBody
} from '../../../types/platform/editCustomColumnBody';

import type {
  EditFinalizedNewIssueParams
} from '../../../types/platform/editFinalizedNewIssueParams';

import type {
  EditFinalizedNewIssuePathParameters
} from '../../../types/platform/editFinalizedNewIssuePathParameters';

import type {
  EditSchemaFieldPathParameters
} from '../../../types/platform/editSchemaFieldPathParameters';

import type {
  EnrichedAttestation
} from '../../../types/platform/enrichedAttestation';

import type {
  EvaluateOrderAttestationsPathParameters
} from '../../../types/platform/evaluateOrderAttestationsPathParameters';

import type {
  ExecuteActionRequestBody
} from '../../../types/platform/executeActionRequestBody';

import type {
  ExecutionFeesResponseBody
} from '../../../types/platform/executionFeesResponseBody';

import type {
  ExecutionOrderRequestCustodianManual
} from '../../../types/platform/executionOrderRequestCustodianManual';

import type {
  ExecutionOrderResponse
} from '../../../types/platform/executionOrderResponse';

import type {
  ExternalExecutionOrderRequestBody
} from '../../../types/platform/externalExecutionOrderRequestBody';

import type {
  FilterList
} from '../../../types/platform/filterList';

import type {
  FilterResult
} from '../../../types/platform/filterResult';

import type {
  FilterlistCreateVersionPathParameters
} from '../../../types/platform/filterlistCreateVersionPathParameters';

import type {
  FilterlistDeleteListPathParameters
} from '../../../types/platform/filterlistDeleteListPathParameters';

import type {
  FilterlistGetVersionPathParameters
} from '../../../types/platform/filterlistGetVersionPathParameters';

import type {
  FilterlistListVersionsPathParameters
} from '../../../types/platform/filterlistListVersionsPathParameters';

import type {
  FinalizeNewIssuePathParameters
} from '../../../types/platform/finalizeNewIssuePathParameters';

import type {
  FinalizeNewIssueResponseBody
} from '../../../types/platform/finalizeNewIssueResponseBody';

import type {
  GenerateFiltersRequest
} from '../../../types/platform/generateFiltersRequest';

import type {
  GenerateTitleRequest
} from '../../../types/platform/generateTitleRequest';

import type {
  GetActionPathParameters
} from '../../../types/platform/getActionPathParameters';

import type {
  GetAssetClassSchemaParams
} from '../../../types/platform/getAssetClassSchemaParams';

import type {
  GetAssetClassSchemaPathParameters
} from '../../../types/platform/getAssetClassSchemaPathParameters';

import type {
  GetAssetClassSchemaResponseBody
} from '../../../types/platform/getAssetClassSchemaResponseBody';

import type {
  GetBasePriceEstimateParams
} from '../../../types/platform/getBasePriceEstimateParams';

import type {
  GetBasePriceEstimateResponseBody
} from '../../../types/platform/getBasePriceEstimateResponseBody';

import type {
  GetBestExOrderAnnotationPathParameters
} from '../../../types/platform/getBestExOrderAnnotationPathParameters';

import type {
  GetBulkOrderEntryFilePathParameters
} from '../../../types/platform/getBulkOrderEntryFilePathParameters';

import type {
  GetBulkOrderEntryPathParameters
} from '../../../types/platform/getBulkOrderEntryPathParameters';

import type {
  GetConfigsForOrganizationsParams
} from '../../../types/platform/getConfigsForOrganizationsParams';

import type {
  GetConfigsForOrganizationsPathParameters
} from '../../../types/platform/getConfigsForOrganizationsPathParameters';

import type {
  GetConfigsForOrganizationsResponseBody
} from '../../../types/platform/getConfigsForOrganizationsResponseBody';

import type {
  GetConfigsParams
} from '../../../types/platform/getConfigsParams';

import type {
  GetConfigsPathParameters
} from '../../../types/platform/getConfigsPathParameters';

import type {
  GetConfigsResponseBody
} from '../../../types/platform/getConfigsResponseBody';

import type {
  GetCustomColumnParams
} from '../../../types/platform/getCustomColumnParams';

import type {
  GetCustomColumnPathParameters
} from '../../../types/platform/getCustomColumnPathParameters';

import type {
  GetCustomColumnUploadTemplateParams
} from '../../../types/platform/getCustomColumnUploadTemplateParams';

import type {
  GetCustomColumnUploadTemplatePathParameters
} from '../../../types/platform/getCustomColumnUploadTemplatePathParameters';

import type {
  GetEducationContentPlaybackUrlPathParameters
} from '../../../types/platform/getEducationContentPlaybackUrlPathParameters';

import type {
  GetEducationCourseBySlugPathParameters
} from '../../../types/platform/getEducationCourseBySlugPathParameters';

import type {
  GetEducationCourseCompletionsPathParameters
} from '../../../types/platform/getEducationCourseCompletionsPathParameters';

import type {
  GetEducationCoursePathParameters
} from '../../../types/platform/getEducationCoursePathParameters';

import type {
  GetEducationLessonPathParameters
} from '../../../types/platform/getEducationLessonPathParameters';

import type {
  GetExecutionFeesPathParameters
} from '../../../types/platform/getExecutionFeesPathParameters';

import type {
  GetExternalQuotesUploadStatusResponseBody
} from '../../../types/platform/getExternalQuotesUploadStatusResponseBody';

import type {
  GetFeeConfigParams
} from '../../../types/platform/getFeeConfigParams';

import type {
  GetFeeConfigPathParameters
} from '../../../types/platform/getFeeConfigPathParameters';

import type {
  GetFeeConfigResponseBody
} from '../../../types/platform/getFeeConfigResponseBody';

import type {
  GetInquiryPathParameters
} from '../../../types/platform/getInquiryPathParameters';

import type {
  GetInstrumentDescriptionPathParameters
} from '../../../types/platform/getInstrumentDescriptionPathParameters';

import type {
  GetInstrumentLogoPathParameters
} from '../../../types/platform/getInstrumentLogoPathParameters';

import type {
  GetIssuerParentEntityLogoParams
} from '../../../types/platform/getIssuerParentEntityLogoParams';

import type {
  GetMarketPricesRequestBody
} from '../../../types/platform/getMarketPricesRequestBody';

import type {
  GetMarketPricesResponseBody
} from '../../../types/platform/getMarketPricesResponseBody';

import type {
  GetMosaicPagePathParameters
} from '../../../types/platform/getMosaicPagePathParameters';

import type {
  GetMosaicViewPathParameters
} from '../../../types/platform/getMosaicViewPathParameters';

import type {
  GetNBBOResponseBody
} from '../../../types/platform/getNBBOResponseBody';

import type {
  GetNbboPathParameters
} from '../../../types/platform/getNbboPathParameters';

import type {
  GetNewIssueDocPathParameters
} from '../../../types/platform/getNewIssueDocPathParameters';

import type {
  GetNewIssuePathParameters
} from '../../../types/platform/getNewIssuePathParameters';

import type {
  GetNewIssueResponseBody
} from '../../../types/platform/getNewIssueResponseBody';

import type {
  GetNewIssueSchemaResponseBody
} from '../../../types/platform/getNewIssueSchemaResponseBody';

import type {
  GetOfferingPathParameters
} from '../../../types/platform/getOfferingPathParameters';

import type {
  GetOfferingResponseBody
} from '../../../types/platform/getOfferingResponseBody';

import type {
  GetOfferingSchemaResponseBody
} from '../../../types/platform/getOfferingSchemaResponseBody';

import type {
  GetOrderAttestationsPathParameters
} from '../../../types/platform/getOrderAttestationsPathParameters';

import type {
  GetOrderBookParams
} from '../../../types/platform/getOrderBookParams';

import type {
  GetOrderBookPathParameters
} from '../../../types/platform/getOrderBookPathParameters';

import type {
  GetOrderBookResponseBody
} from '../../../types/platform/getOrderBookResponseBody';

import type {
  GetOrderCostsFromCustomerPriceRequestBody
} from '../../../types/platform/getOrderCostsFromCustomerPriceRequestBody';

import type {
  GetOrderCostsFromCustomerPriceResponseBody
} from '../../../types/platform/getOrderCostsFromCustomerPriceResponseBody';

import type {
  GetOrderCostsRequestBody
} from '../../../types/platform/getOrderCostsRequestBody';

import type {
  GetOrderCostsResponseBody
} from '../../../types/platform/getOrderCostsResponseBody';

import type {
  GetOrderEntryDraftParams
} from '../../../types/platform/getOrderEntryDraftParams';

import type {
  GetOrderEntryDraftPathParameters
} from '../../../types/platform/getOrderEntryDraftPathParameters';

import type {
  GetOrderEntryDraftTemplateParams
} from '../../../types/platform/getOrderEntryDraftTemplateParams';

import type {
  GetOrderFeesPathParameters
} from '../../../types/platform/getOrderFeesPathParameters';

import type {
  GetOrderValidationFlagsPathParameters
} from '../../../types/platform/getOrderValidationFlagsPathParameters';

import type {
  GetOverlayUploadPathParameters
} from '../../../types/platform/getOverlayUploadPathParameters';

import type {
  GetPageConfigParams
} from '../../../types/platform/getPageConfigParams';

import type {
  GetPageConfigPathParameters
} from '../../../types/platform/getPageConfigPathParameters';

import type {
  GetPrincipalAccountAssignmentRulesTreePathParameters
} from '../../../types/platform/getPrincipalAccountAssignmentRulesTreePathParameters';

import type {
  GetSampleOrderPathParameters
} from '../../../types/platform/getSampleOrderPathParameters';

import type {
  GetSampleOrderResponseBody
} from '../../../types/platform/getSampleOrderResponseBody';

import type {
  GetSavedSearchLayoutPathParameters
} from '../../../types/platform/getSavedSearchLayoutPathParameters';

import type {
  GetSavedSearchPathParameters
} from '../../../types/platform/getSavedSearchPathParameters';

import type {
  GetSchemaParams
} from '../../../types/platform/getSchemaParams';

import type {
  GetSchemaPathParameters
} from '../../../types/platform/getSchemaPathParameters';

import type {
  GetSupportedAlgosPathParameters
} from '../../../types/platform/getSupportedAlgosPathParameters';

import type {
  GetSupportedAlgosResponseBody
} from '../../../types/platform/getSupportedAlgosResponseBody';

import type {
  GetSupportedParametersPathParameters
} from '../../../types/platform/getSupportedParametersPathParameters';

import type {
  GetSupportedParametersResponseBody
} from '../../../types/platform/getSupportedParametersResponseBody';

import type {
  GetTradingInstrumentMunipointsUrlPathParameters
} from '../../../types/platform/getTradingInstrumentMunipointsUrlPathParameters';

import type {
  GetUserByIdPathParameters
} from '../../../types/platform/getUserByIdPathParameters';

import type {
  GetUserPathParameters
} from '../../../types/platform/getUserPathParameters';

import type {
  GetUserProfilePathParameters
} from '../../../types/platform/getUserProfilePathParameters';

import type {
  GrantResponseBody
} from '../../../types/platform/grantResponseBody';

import type {
  HumaAPIError
} from '../../../types/platform/humaAPIError';

import type {
  HydrateQuotesRequest
} from '../../../types/platform/hydrateQuotesRequest';

import type {
  HydratedQuote
} from '../../../types/platform/hydratedQuote';

import type {
  Info
} from '../../../types/platform/info';

import type {
  Inquiry
} from '../../../types/platform/inquiry';

import type {
  InquiryResponseBody
} from '../../../types/platform/inquiryResponseBody';

import type {
  InstrumentRfqPreviewResponseBody
} from '../../../types/platform/instrumentRfqPreviewResponseBody';

import type {
  LessonCompletion
} from '../../../types/platform/lessonCompletion';

import type {
  LessonCompletionInput
} from '../../../types/platform/lessonCompletionInput';

import type {
  LessonDetail
} from '../../../types/platform/lessonDetail';

import type {
  LinkSchemaToOrgPathParameters
} from '../../../types/platform/linkSchemaToOrgPathParameters';

import type {
  ListActionSetsResponseBody
} from '../../../types/platform/listActionSetsResponseBody';

import type {
  ListActionsResponseBody
} from '../../../types/platform/listActionsResponseBody';

import type {
  ListBulkOrderEntryTemplateFieldsResponseBody
} from '../../../types/platform/listBulkOrderEntryTemplateFieldsResponseBody';

import type {
  ListCustomColumnEntitiesBody
} from '../../../types/platform/listCustomColumnEntitiesBody';

import type {
  ListCustomColumnTypesBody
} from '../../../types/platform/listCustomColumnTypesBody';

import type {
  ListCustomColumnsBody
} from '../../../types/platform/listCustomColumnsBody';

import type {
  ListCustomColumnsParams
} from '../../../types/platform/listCustomColumnsParams';

import type {
  ListEntitlementOrganizationsResponseBody
} from '../../../types/platform/listEntitlementOrganizationsResponseBody';

import type {
  ListFeeSchedulesResponseBody
} from '../../../types/platform/listFeeSchedulesResponseBody';

import type {
  ListListsResponse
} from '../../../types/platform/listListsResponse';

import type {
  ListMosaicPagesParams
} from '../../../types/platform/listMosaicPagesParams';

import type {
  ListNewIssueDocsPathParameters
} from '../../../types/platform/listNewIssueDocsPathParameters';

import type {
  ListNewIssueDocsResponseBody
} from '../../../types/platform/listNewIssueDocsResponseBody';

import type {
  ListNewIssuesParams
} from '../../../types/platform/listNewIssuesParams';

import type {
  ListNewIssuesResponseBody
} from '../../../types/platform/listNewIssuesResponseBody';

import type {
  ListObjectGroupGrantsResponseBody
} from '../../../types/platform/listObjectGroupGrantsResponseBody';

import type {
  ListObjectTypesResponseBody
} from '../../../types/platform/listObjectTypesResponseBody';

import type {
  ListOfferingEntitlementsResponseBody
} from '../../../types/platform/listOfferingEntitlementsResponseBody';

import type {
  ListOfferingsParams
} from '../../../types/platform/listOfferingsParams';

import type {
  ListOfferingsResponseBody
} from '../../../types/platform/listOfferingsResponseBody';

import type {
  ListOrderTradersPathParameters
} from '../../../types/platform/listOrderTradersPathParameters';

import type {
  ListOverlayUploadsParams
} from '../../../types/platform/listOverlayUploadsParams';

import type {
  ListOverlayUploadsPathParameters
} from '../../../types/platform/listOverlayUploadsPathParameters';

import type {
  ListPendingAttestationsParams
} from '../../../types/platform/listPendingAttestationsParams';

import type {
  ListPendingDocumentsResponseBody
} from '../../../types/platform/listPendingDocumentsResponseBody';

import type {
  ListReceivedSavedViewsResponseBody
} from '../../../types/platform/listReceivedSavedViewsResponseBody';

import type {
  ListRfqPreviewRequestBody
} from '../../../types/platform/listRfqPreviewRequestBody';

import type {
  ListRfqPreviewResponseBody
} from '../../../types/platform/listRfqPreviewResponseBody';

import type {
  ListRfqSubmitRequestBody
} from '../../../types/platform/listRfqSubmitRequestBody';

import type {
  ListSavedSearchOrgShareCandidatesPathParameters
} from '../../../types/platform/listSavedSearchOrgShareCandidatesPathParameters';

import type {
  ListSavedSearchOrgSharesPathParameters
} from '../../../types/platform/listSavedSearchOrgSharesPathParameters';

import type {
  ListSavedSearchSharesPathParameters
} from '../../../types/platform/listSavedSearchSharesPathParameters';

import type {
  ListSavedSearchesParams
} from '../../../types/platform/listSavedSearchesParams';

import type {
  ListSavedSearchesPathParameters
} from '../../../types/platform/listSavedSearchesPathParameters';

import type {
  ListSavedSearchesResponseBody
} from '../../../types/platform/listSavedSearchesResponseBody';

import type {
  ListSavedViewOrgShareCandidatesResponseBody
} from '../../../types/platform/listSavedViewOrgShareCandidatesResponseBody';

import type {
  ListSavedViewOrgSharesResponseBody
} from '../../../types/platform/listSavedViewOrgSharesResponseBody';

import type {
  ListSavedViewSharesResponseBody
} from '../../../types/platform/listSavedViewSharesResponseBody';

import type {
  ListSchemasParams
} from '../../../types/platform/listSchemasParams';

import type {
  ListSharesResponseBody
} from '../../../types/platform/listSharesResponseBody';

import type {
  ListTeamGrantedResponseBody
} from '../../../types/platform/listTeamGrantedResponseBody';

import type {
  ListTeamGrantsResponseBody
} from '../../../types/platform/listTeamGrantsResponseBody';

import type {
  ListTradersResponseBody
} from '../../../types/platform/listTradersResponseBody';

import type {
  ListTradingArchivedFeeSchedulesParams
} from '../../../types/platform/listTradingArchivedFeeSchedulesParams';

import type {
  ListTradingArchivedRepFeeSchedulesParams
} from '../../../types/platform/listTradingArchivedRepFeeSchedulesParams';

import type {
  ListTradingFeeSchedulesParams
} from '../../../types/platform/listTradingFeeSchedulesParams';

import type {
  ListTradingRepFeeSchedulesParams
} from '../../../types/platform/listTradingRepFeeSchedulesParams';

import type {
  ListTradingScheduledFeeSchedulesParams
} from '../../../types/platform/listTradingScheduledFeeSchedulesParams';

import type {
  ListTradingScheduledRepFeeSchedulesParams
} from '../../../types/platform/listTradingScheduledRepFeeSchedulesParams';

import type {
  ListTradingVenueConfigurationsParams
} from '../../../types/platform/listTradingVenueConfigurationsParams';

import type {
  ListUploadsOutputBody
} from '../../../types/platform/listUploadsOutputBody';

import type {
  ListUserTeamAccessResponseBody
} from '../../../types/platform/listUserTeamAccessResponseBody';

import type {
  ListUsersParams
} from '../../../types/platform/listUsersParams';

import type {
  ListUsersResponseBody
} from '../../../types/platform/listUsersResponseBody';

import type {
  ListVenueConfigurationsResponseBody
} from '../../../types/platform/listVenueConfigurationsResponseBody';

import type {
  ListVersionsResponse
} from '../../../types/platform/listVersionsResponse';

import type {
  LogoBody
} from '../../../types/platform/logoBody';

import type {
  LookupOverlayCellsBody
} from '../../../types/platform/lookupOverlayCellsBody';

import type {
  LookupOverlayCellsParams
} from '../../../types/platform/lookupOverlayCellsParams';

import type {
  LookupOverlayCellsPathParameters
} from '../../../types/platform/lookupOverlayCellsPathParameters';

import type {
  LookupOverlayCellsResponseBody
} from '../../../types/platform/lookupOverlayCellsResponseBody';

import type {
  MuniPointsURLResponseBody
} from '../../../types/platform/muniPointsURLResponseBody';

import type {
  NewIssueSummary
} from '../../../types/platform/newIssueSummary';

import type {
  ObjectGroupBody
} from '../../../types/platform/objectGroupBody';

import type {
  ObjectMembersResponseBody
} from '../../../types/platform/objectMembersResponseBody';

import type {
  OfferingDocBody
} from '../../../types/platform/offeringDocBody';

import type {
  OfferingDocUploadsResponseBody
} from '../../../types/platform/offeringDocUploadsResponseBody';

import type {
  OfferingEntitlement
} from '../../../types/platform/offeringEntitlement';

import type {
  OrderApprovalRequestBody
} from '../../../types/platform/orderApprovalRequestBody';

import type {
  OrderApprovalResponseBody
} from '../../../types/platform/orderApprovalResponseBody';

import type {
  OrderAssignRequestBody
} from '../../../types/platform/orderAssignRequestBody';

import type {
  OrderAssignResponseBody
} from '../../../types/platform/orderAssignResponseBody';

import type {
  OrderAttestationEvaluation
} from '../../../types/platform/orderAttestationEvaluation';

import type {
  OrderAttestationsBody
} from '../../../types/platform/orderAttestationsBody';

import type {
  OrderClaimResponseBody
} from '../../../types/platform/orderClaimResponseBody';

import type {
  OrderEntryDraft
} from '../../../types/platform/orderEntryDraft';

import type {
  OrderEntryDraftPatchResult
} from '../../../types/platform/orderEntryDraftPatchResult';

import type {
  OrderEntryDraftTemplate
} from '../../../types/platform/orderEntryDraftTemplate';

import type {
  OrderFeesResponseBody
} from '../../../types/platform/orderFeesResponseBody';

import type {
  OrderRejectionRequestBody
} from '../../../types/platform/orderRejectionRequestBody';

import type {
  OrderRejectionResponseBody
} from '../../../types/platform/orderRejectionResponseBody';

import type {
  OverlayWriteBody
} from '../../../types/platform/overlayWriteBody';

import type {
  PageList
} from '../../../types/platform/pageList';

import type {
  PageRecord
} from '../../../types/platform/pageRecord';

import type {
  PageVersion
} from '../../../types/platform/pageVersion';

import type {
  ParseBulkOrderEntryResponseBody
} from '../../../types/platform/parseBulkOrderEntryResponseBody';

import type {
  ParseBulkOrderEntrySheetPathParameters
} from '../../../types/platform/parseBulkOrderEntrySheetPathParameters';

import type {
  PatchAllocationPathParameters
} from '../../../types/platform/patchAllocationPathParameters';

import type {
  PatchAllocationRequestBody
} from '../../../types/platform/patchAllocationRequestBody';

import type {
  PatchAllocationResponseBody
} from '../../../types/platform/patchAllocationResponseBody';

import type {
  PatchCurrentUserProfileRequestBody
} from '../../../types/platform/patchCurrentUserProfileRequestBody';

import type {
  PatchCustomColumnParams
} from '../../../types/platform/patchCustomColumnParams';

import type {
  PatchCustomColumnPathParameters
} from '../../../types/platform/patchCustomColumnPathParameters';

import type {
  PatchOrderEntryDraftParams
} from '../../../types/platform/patchOrderEntryDraftParams';

import type {
  PatchOrderEntryDraftPathParameters
} from '../../../types/platform/patchOrderEntryDraftPathParameters';

import type {
  PatchOrderEntryDraftRequestBody
} from '../../../types/platform/patchOrderEntryDraftRequestBody';

import type {
  PatchOverlayCellsBody
} from '../../../types/platform/patchOverlayCellsBody';

import type {
  PatchOverlayCellsParams
} from '../../../types/platform/patchOverlayCellsParams';

import type {
  PatchOverlayCellsPathParameters
} from '../../../types/platform/patchOverlayCellsPathParameters';

import type {
  PatchOverlayColumnBody
} from '../../../types/platform/patchOverlayColumnBody';

import type {
  PatchOverlayColumnParams
} from '../../../types/platform/patchOverlayColumnParams';

import type {
  PatchOverlayColumnPathParameters
} from '../../../types/platform/patchOverlayColumnPathParameters';

import type {
  PatchSchemaPathParameters
} from '../../../types/platform/patchSchemaPathParameters';

import type {
  PlatformAddObjectGroupMembersPathParameters
} from '../../../types/platform/platformAddObjectGroupMembersPathParameters';

import type {
  PlatformAddTeamMembersPathParameters
} from '../../../types/platform/platformAddTeamMembersPathParameters';

import type {
  PlatformCreateObjectGroupRequestBody
} from '../../../types/platform/platformCreateObjectGroupRequestBody';

import type {
  PlatformCreateTeamRequestBody
} from '../../../types/platform/platformCreateTeamRequestBody';

import type {
  PlatformDeleteGrantParams
} from '../../../types/platform/platformDeleteGrantParams';

import type {
  PlatformDeleteGrantPathParameters
} from '../../../types/platform/platformDeleteGrantPathParameters';

import type {
  PlatformDeleteObjectGroupPathParameters
} from '../../../types/platform/platformDeleteObjectGroupPathParameters';

import type {
  PlatformDeleteTeamPathParameters
} from '../../../types/platform/platformDeleteTeamPathParameters';

import type {
  PlatformGetObjectGroupPathParameters
} from '../../../types/platform/platformGetObjectGroupPathParameters';

import type {
  PlatformGetTeamPathParameters
} from '../../../types/platform/platformGetTeamPathParameters';

import type {
  PlatformGrantTeamPathParameters
} from '../../../types/platform/platformGrantTeamPathParameters';

import type {
  PlatformGrantTeamRequestBody
} from '../../../types/platform/platformGrantTeamRequestBody';

import type {
  PlatformListActionSetsPathParameters
} from '../../../types/platform/platformListActionSetsPathParameters';

import type {
  PlatformListGrantsParams
} from '../../../types/platform/platformListGrantsParams';

import type {
  PlatformListObjectGroupGrantsPathParameters
} from '../../../types/platform/platformListObjectGroupGrantsPathParameters';

import type {
  PlatformListSharesParams
} from '../../../types/platform/platformListSharesParams';

import type {
  PlatformListTeamGrantedPathParameters
} from '../../../types/platform/platformListTeamGrantedPathParameters';

import type {
  PlatformListTeamGrantsPathParameters
} from '../../../types/platform/platformListTeamGrantsPathParameters';

import type {
  PlatformListUserTeamAccessParams
} from '../../../types/platform/platformListUserTeamAccessParams';

import type {
  PlatformListUserTeamAccessPathParameters
} from '../../../types/platform/platformListUserTeamAccessPathParameters';

import type {
  PlatformObjectGroupBody
} from '../../../types/platform/platformObjectGroupBody';

import type {
  PlatformObjectMembersRequestBody
} from '../../../types/platform/platformObjectMembersRequestBody';

import type {
  PlatformRemoveObjectGroupMembersPathParameters
} from '../../../types/platform/platformRemoveObjectGroupMembersPathParameters';

import type {
  PlatformRemoveTeamMembersPathParameters
} from '../../../types/platform/platformRemoveTeamMembersPathParameters';

import type {
  PlatformRenameObjectGroupPathParameters
} from '../../../types/platform/platformRenameObjectGroupPathParameters';

import type {
  PlatformRenameObjectGroupRequestBody
} from '../../../types/platform/platformRenameObjectGroupRequestBody';

import type {
  PlatformRevokeTeamGrantPathParameters
} from '../../../types/platform/platformRevokeTeamGrantPathParameters';

import type {
  PlatformSetTeamMembersPathParameters
} from '../../../types/platform/platformSetTeamMembersPathParameters';

import type {
  PlatformShareRequestBody
} from '../../../types/platform/platformShareRequestBody';

import type {
  PlatformShareTarget
} from '../../../types/platform/platformShareTarget';

import type {
  PlatformTeamMembersRequestBody
} from '../../../types/platform/platformTeamMembersRequestBody';

import type {
  PlatformUpdateTeamPathParameters
} from '../../../types/platform/platformUpdateTeamPathParameters';

import type {
  PlatformUpdateTeamRequestBody
} from '../../../types/platform/platformUpdateTeamRequestBody';

import type {
  PlatformUpsertGrantRequestBody
} from '../../../types/platform/platformUpsertGrantRequestBody';

import type {
  PlaybackURLResponseBody
} from '../../../types/platform/playbackURLResponseBody';

import type {
  PostBestExOrderAnnotationRequestBody
} from '../../../types/platform/postBestExOrderAnnotationRequestBody';

import type {
  PostEducationLessonCompletePathParameters
} from '../../../types/platform/postEducationLessonCompletePathParameters';

import type {
  PostEducationQuizAttemptPathParameters
} from '../../../types/platform/postEducationQuizAttemptPathParameters';

import type {
  PostNewIssueActionBody
} from '../../../types/platform/postNewIssueActionBody';

import type {
  PostNewIssueActionPathParameters
} from '../../../types/platform/postNewIssueActionPathParameters';

import type {
  PostOfferingActionBody
} from '../../../types/platform/postOfferingActionBody';

import type {
  PostOfferingActionPathParameters
} from '../../../types/platform/postOfferingActionPathParameters';

import type {
  PostOrderQuoteAnalyticsRequestBody
} from '../../../types/platform/postOrderQuoteAnalyticsRequestBody';

import type {
  PostOrderQuoteAnalyticsResponseBody
} from '../../../types/platform/postOrderQuoteAnalyticsResponseBody';

import type {
  PreviewInstrumentRfqParams
} from '../../../types/platform/previewInstrumentRfqParams';

import type {
  PreviewInstrumentRfqPathParameters
} from '../../../types/platform/previewInstrumentRfqPathParameters';

import type {
  PreviewResult
} from '../../../types/platform/previewResult';

import type {
  PrincipalAccountAssignmentRulesGetResponseBody
} from '../../../types/platform/principalAccountAssignmentRulesGetResponseBody';

import type {
  PrincipalAccountAssignmentRulesListResponseBody
} from '../../../types/platform/principalAccountAssignmentRulesListResponseBody';

import type {
  PrincipalAccountAssignmentRulesPreviewRequestBody
} from '../../../types/platform/principalAccountAssignmentRulesPreviewRequestBody';

import type {
  PrincipalAccountAssignmentRulesPreviewResponseBody
} from '../../../types/platform/principalAccountAssignmentRulesPreviewResponseBody';

import type {
  PrincipalAccountAssignmentRulesSupportedExpressionsResponseBody
} from '../../../types/platform/principalAccountAssignmentRulesSupportedExpressionsResponseBody';

import type {
  PrincipalAccountAssignmentRulesTreeItem
} from '../../../types/platform/principalAccountAssignmentRulesTreeItem';

import type {
  PrincipalAccountAssignmentRulesUpsertRequestBody
} from '../../../types/platform/principalAccountAssignmentRulesUpsertRequestBody';

import type {
  PrincipalBookBulkListRFQRequestBody
} from '../../../types/platform/principalBookBulkListRFQRequestBody';

import type {
  PrincipalBookBulkListRFQResponseBody
} from '../../../types/platform/principalBookBulkListRFQResponseBody';

import type {
  PrincipalMembersResponseBody
} from '../../../types/platform/principalMembersResponseBody';

import type {
  ProcessNewIssueDocPathParameters
} from '../../../types/platform/processNewIssueDocPathParameters';

import type {
  ProcessNewIssueDocResponseBody
} from '../../../types/platform/processNewIssueDocResponseBody';

import type {
  PublishSavedSearchPathParameters
} from '../../../types/platform/publishSavedSearchPathParameters';

import type {
  QueryActionRequestBody
} from '../../../types/platform/queryActionRequestBody';

import type {
  QuizAttempt
} from '../../../types/platform/quizAttempt';

import type {
  QuizAttemptInput
} from '../../../types/platform/quizAttemptInput';

import type {
  RegistryCreateSchemaBody
} from '../../../types/platform/registryCreateSchemaBody';

import type {
  RegistryEditFieldBody
} from '../../../types/platform/registryEditFieldBody';

import type {
  RegistryFieldBody
} from '../../../types/platform/registryFieldBody';

import type {
  RegistryLinkSchemaBody
} from '../../../types/platform/registryLinkSchemaBody';

import type {
  RegistryLinkSchemaResponseBody
} from '../../../types/platform/registryLinkSchemaResponseBody';

import type {
  RegistryListBaseSchemasResponseBody
} from '../../../types/platform/registryListBaseSchemasResponseBody';

import type {
  RegistryListSchemasResponseBody
} from '../../../types/platform/registryListSchemasResponseBody';

import type {
  RegistryPatchSchemaBody
} from '../../../types/platform/registryPatchSchemaBody';

import type {
  RegistrySchemaDetailBody
} from '../../../types/platform/registrySchemaDetailBody';

import type {
  RejectOrderPathParameters
} from '../../../types/platform/rejectOrderPathParameters';

import type {
  RemoveMosaicPageViewParams
} from '../../../types/platform/removeMosaicPageViewParams';

import type {
  RemoveMosaicPageViewPathParameters
} from '../../../types/platform/removeMosaicPageViewPathParameters';

import type {
  ReorderMosaicPageViewsPathParameters
} from '../../../types/platform/reorderMosaicPageViewsPathParameters';

import type {
  ReorderViewsBody
} from '../../../types/platform/reorderViewsBody';

import type {
  ReplaceExecutionOrderPathParameters
} from '../../../types/platform/replaceExecutionOrderPathParameters';

import type {
  ReplaceIOIOrderRequestBody
} from '../../../types/platform/replaceIOIOrderRequestBody';

import type {
  ReplaceIOIOrderResponseBody
} from '../../../types/platform/replaceIOIOrderResponseBody';

import type {
  ReplaceIoiOrderPathParameters
} from '../../../types/platform/replaceIoiOrderPathParameters';

import type {
  RerequestInquiryBody
} from '../../../types/platform/rerequestInquiryBody';

import type {
  RerequestInquiryPathParameters
} from '../../../types/platform/rerequestInquiryPathParameters';

import type {
  RerequestInquiryResponseBody
} from '../../../types/platform/rerequestInquiryResponseBody';

import type {
  ResolveDefaultPrincipalBooksRequestBody
} from '../../../types/platform/resolveDefaultPrincipalBooksRequestBody';

import type {
  ResolveDefaultPrincipalBooksResponseBody
} from '../../../types/platform/resolveDefaultPrincipalBooksResponseBody';

import type {
  ResolveDefaultSavedSearchParams
} from '../../../types/platform/resolveDefaultSavedSearchParams';

import type {
  ResolveDefaultSavedSearchPathParameters
} from '../../../types/platform/resolveDefaultSavedSearchPathParameters';

import type {
  ResolveOrderAllocationsPathParameters
} from '../../../types/platform/resolveOrderAllocationsPathParameters';

import type {
  ResolveResponseBody
} from '../../../types/platform/resolveResponseBody';

import type {
  RespondToInquiryPathParameters
} from '../../../types/platform/respondToInquiryPathParameters';

import type {
  RespondToInquiryResponseBody
} from '../../../types/platform/respondToInquiryResponseBody';

import type {
  RunResult
} from '../../../types/platform/runResult';

import type {
  SampleUser
} from '../../../types/platform/sampleUser';

import type {
  SavedSearchLayoutBody
} from '../../../types/platform/savedSearchLayoutBody';

import type {
  SavedSearchLayoutResponseBody
} from '../../../types/platform/savedSearchLayoutResponseBody';

import type {
  SavedSearchResponse
} from '../../../types/platform/savedSearchResponse';

import type {
  SavedView
} from '../../../types/platform/savedView';

import type {
  SavedViewOrgShareBody
} from '../../../types/platform/savedViewOrgShareBody';

import type {
  SavedViewShareBody
} from '../../../types/platform/savedViewShareBody';

import type {
  SearchRefDataRequestBody
} from '../../../types/platform/searchRefDataRequestBody';

import type {
  SearchRefDataResponseBody
} from '../../../types/platform/searchRefDataResponseBody';

import type {
  SetDefaultSavedSearchParams
} from '../../../types/platform/setDefaultSavedSearchParams';

import type {
  SetDefaultSavedSearchPathParameters
} from '../../../types/platform/setDefaultSavedSearchPathParameters';

import type {
  SetDefaultSavedSearchRequestBody
} from '../../../types/platform/setDefaultSavedSearchRequestBody';

import type {
  ShareResponseBody
} from '../../../types/platform/shareResponseBody';

import type {
  ShareSavedSearchPathParameters
} from '../../../types/platform/shareSavedSearchPathParameters';

import type {
  ShareSavedSearchToOrgPathParameters
} from '../../../types/platform/shareSavedSearchToOrgPathParameters';

import type {
  ShareSavedViewRequestBody
} from '../../../types/platform/shareSavedViewRequestBody';

import type {
  ShareSavedViewToOrgRequestBody
} from '../../../types/platform/shareSavedViewToOrgRequestBody';

import type {
  SingleViewConfigBody
} from '../../../types/platform/singleViewConfigBody';

import type {
  StructuredInvestmentFormReferenceData
} from '../../../types/platform/structuredInvestmentFormReferenceData';

import type {
  SubmitAllocationsResponseBody
} from '../../../types/platform/submitAllocationsResponseBody';

import type {
  SubmitAutoExRFQExecutionOrderBody
} from '../../../types/platform/submitAutoExRFQExecutionOrderBody';

import type {
  SubmitAutoexRfqExecutionOrderPathParameters
} from '../../../types/platform/submitAutoexRfqExecutionOrderPathParameters';

import type {
  SubmitInventoryExecutionOrderBody
} from '../../../types/platform/submitInventoryExecutionOrderBody';

import type {
  SubmitInventoryExecutionOrderPathParameters
} from '../../../types/platform/submitInventoryExecutionOrderPathParameters';

import type {
  SubmitLOBExecutionOrderBody
} from '../../../types/platform/submitLOBExecutionOrderBody';

import type {
  SubmitLOBSORExecutionOrderBody
} from '../../../types/platform/submitLOBSORExecutionOrderBody';

import type {
  SubmitLobManualExecutionOrderPathParameters
} from '../../../types/platform/submitLobManualExecutionOrderPathParameters';

import type {
  SubmitLobSorExecutionOrderPathParameters
} from '../../../types/platform/submitLobSorExecutionOrderPathParameters';

import type {
  SubmitOrderAllocationsPathParameters
} from '../../../types/platform/submitOrderAllocationsPathParameters';

import type {
  SubmitOrderEntryDraftParams
} from '../../../types/platform/submitOrderEntryDraftParams';

import type {
  SubmitOrderEntryDraftPathParameters
} from '../../../types/platform/submitOrderEntryDraftPathParameters';

import type {
  SubmitOrderEntryDraftRequestBody
} from '../../../types/platform/submitOrderEntryDraftRequestBody';

import type {
  SubmitRFQExecutionOrderBody
} from '../../../types/platform/submitRFQExecutionOrderBody';

import type {
  SubmitRfqManualExecutionOrderPathParameters
} from '../../../types/platform/submitRfqManualExecutionOrderPathParameters';

import type {
  SuggestBulkOrderEntryMappingPathParameters
} from '../../../types/platform/suggestBulkOrderEntryMappingPathParameters';

import type {
  SuggestBulkOrderEntryMappingRequestBody
} from '../../../types/platform/suggestBulkOrderEntryMappingRequestBody';

import type {
  SuggestBulkOrderEntryMappingResponseBody
} from '../../../types/platform/suggestBulkOrderEntryMappingResponseBody';

import type {
  TeamBody
} from '../../../types/platform/teamBody';

import type {
  TeamGrantResponseBody
} from '../../../types/platform/teamGrantResponseBody';

import type {
  TitleDescription
} from '../../../types/platform/titleDescription';

import type {
  UnarchiveCustomColumnParams
} from '../../../types/platform/unarchiveCustomColumnParams';

import type {
  UnarchiveCustomColumnPathParameters
} from '../../../types/platform/unarchiveCustomColumnPathParameters';

import type {
  UnclaimOrderPathParameters
} from '../../../types/platform/unclaimOrderPathParameters';

import type {
  UngroupOrderPathParameters
} from '../../../types/platform/ungroupOrderPathParameters';

import type {
  UnlinkSchemaFromOrgPathParameters
} from '../../../types/platform/unlinkSchemaFromOrgPathParameters';

import type {
  UnpublishSavedSearchPathParameters
} from '../../../types/platform/unpublishSavedSearchPathParameters';

import type {
  UnshareResponseBody
} from '../../../types/platform/unshareResponseBody';

import type {
  UnshareSavedSearchFromOrgPathParameters
} from '../../../types/platform/unshareSavedSearchFromOrgPathParameters';

import type {
  UnshareSavedSearchPathParameters
} from '../../../types/platform/unshareSavedSearchPathParameters';

import type {
  UpdateConfigPathParameters
} from '../../../types/platform/updateConfigPathParameters';

import type {
  UpdateConfigRequestBody
} from '../../../types/platform/updateConfigRequestBody';

import type {
  UpdateConfigResponseBody
} from '../../../types/platform/updateConfigResponseBody';

import type {
  UpdateDistributorReviewPathParameters
} from '../../../types/platform/updateDistributorReviewPathParameters';

import type {
  UpdateListRequest
} from '../../../types/platform/updateListRequest';

import type {
  UpdateMosaicPagePathParameters
} from '../../../types/platform/updateMosaicPagePathParameters';

import type {
  UpdateMosaicViewPathParameters
} from '../../../types/platform/updateMosaicViewPathParameters';

import type {
  UpdateNewIssueFinalSizePathParameters
} from '../../../types/platform/updateNewIssueFinalSizePathParameters';

import type {
  UpdateNewIssueFinalSizeRequestBody
} from '../../../types/platform/updateNewIssueFinalSizeRequestBody';

import type {
  UpdateNewIssueParams
} from '../../../types/platform/updateNewIssueParams';

import type {
  UpdateNewIssuePathParameters
} from '../../../types/platform/updateNewIssuePathParameters';

import type {
  UpdateNewIssueRequestBody
} from '../../../types/platform/updateNewIssueRequestBody';

import type {
  UpdateOfferingPathParameters
} from '../../../types/platform/updateOfferingPathParameters';

import type {
  UpdateOfferingRequestBody
} from '../../../types/platform/updateOfferingRequestBody';

import type {
  UpdateOfferingResponseBody
} from '../../../types/platform/updateOfferingResponseBody';

import type {
  UpdateOrderAnnotationPathParameters
} from '../../../types/platform/updateOrderAnnotationPathParameters';

import type {
  UpdateOrderAnnotationRequestBody
} from '../../../types/platform/updateOrderAnnotationRequestBody';

import type {
  UpdateOrderAnnotationResponseBody
} from '../../../types/platform/updateOrderAnnotationResponseBody';

import type {
  UpdatePageBody
} from '../../../types/platform/updatePageBody';

import type {
  UpdatePageConfigParams
} from '../../../types/platform/updatePageConfigParams';

import type {
  UpdatePageConfigPathParameters
} from '../../../types/platform/updatePageConfigPathParameters';

import type {
  UpdatePageConfigRequestBody
} from '../../../types/platform/updatePageConfigRequestBody';

import type {
  UpdateSavedSearchLayoutPathParameters
} from '../../../types/platform/updateSavedSearchLayoutPathParameters';

import type {
  UpdateSavedSearchPathParameters
} from '../../../types/platform/updateSavedSearchPathParameters';

import type {
  UpdateSavedSearchRequestBody
} from '../../../types/platform/updateSavedSearchRequestBody';

import type {
  UpdateViewBody
} from '../../../types/platform/updateViewBody';

import type {
  UploadDTO
} from '../../../types/platform/uploadDTO';

import type {
  UpsertPrincipalAccountAssignmentRulesTreeParams
} from '../../../types/platform/upsertPrincipalAccountAssignmentRulesTreeParams';

import type {
  User
} from '../../../types/platform/user';

import type {
  UserProfileResponse
} from '../../../types/platform/userProfileResponse';

import type {
  ValidationFlagsResponseBody
} from '../../../types/platform/validationFlagsResponseBody';

import type {
  ViewRecord
} from '../../../types/platform/viewRecord';

import { customFetch } from '../../../../src/custom-fetch';
import type { ErrorType } from '../../../../src/custom-fetch';

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type executeActionResponse200 = {
  data: RunResult
  status: 200
}

export type executeActionResponse403 = {
  data: ActionError
  status: 403
}

export type executeActionResponse404 = {
  data: ActionError
  status: 404
}

export type executeActionResponse409 = {
  data: ActionError
  status: 409
}

export type executeActionResponse422 = {
  data: HumaAPIError
  status: 422
}

export type executeActionResponse500 = {
  data: HumaAPIError
  status: 500
}

export type executeActionResponse502 = {
  data: ActionError
  status: 502
}

export type executeActionResponse504 = {
  data: ActionError
  status: 504
}

export type executeActionResponseSuccess = (executeActionResponse200) & {
  headers: Headers;
};
export type executeActionResponseError = (executeActionResponse403 | executeActionResponse404 | executeActionResponse409 | executeActionResponse422 | executeActionResponse500 | executeActionResponse502 | executeActionResponse504) & {
  headers: Headers;
};

export type executeActionResponse = executeActionResponseSuccess

export const getExecuteActionUrl = () => {




  return `/auth/v1/action`
}

/**
 * Errors raised by the action engine carry error_details.retryable: whether the same request, sent again under the same Idempotency-Key, can succeed. 502 and 504 are retryable unless the run had already committed a page, and a dependency's own wait is passed on as error_details.retry_after and the Retry-After header. Request-validation failures (a 422 whose error_details is a list of field errors) are raised before the engine runs, carry neither field, and are never retryable.
 * @summary Execute an action
 */
export const executeAction = async (executeActionRequestBody: ExecuteActionRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<executeActionResponse> => {

  return customFetch<executeActionResponse>(getExecuteActionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(executeActionRequestBody)
  }
);}





export const getExecuteActionMutationOptions = <TError = ErrorType<ActionError | HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeAction>>, TError,{data: ExecuteActionRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof executeAction>>, TError,{data: ExecuteActionRequestBody}, TContext> => {

const mutationKey = ['executeAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeAction>>, {data: ExecuteActionRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  executeAction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExecuteActionMutationResult = NonNullable<Awaited<ReturnType<typeof executeAction>>>
    export type ExecuteActionMutationBody = ExecuteActionRequestBody
    export type ExecuteActionMutationError = ErrorType<ActionError | HumaAPIError>

    /**
 * @summary Execute an action
 */
export const useExecuteAction = <TError = ErrorType<ActionError | HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeAction>>, TError,{data: ExecuteActionRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeAction>>,
        TError,
        {data: ExecuteActionRequestBody},
        TContext
      > => {
      return useMutation(getExecuteActionMutationOptions(options), queryClient);
    }
    export type queryActionResponse200 = {
  data: PreviewResult
  status: 200
}

export type queryActionResponse403 = {
  data: ActionError
  status: 403
}

export type queryActionResponse404 = {
  data: ActionError
  status: 404
}

export type queryActionResponse422 = {
  data: HumaAPIError
  status: 422
}

export type queryActionResponse500 = {
  data: HumaAPIError
  status: 500
}

export type queryActionResponse502 = {
  data: ActionError
  status: 502
}

export type queryActionResponse504 = {
  data: ActionError
  status: 504
}

export type queryActionResponseSuccess = (queryActionResponse200) & {
  headers: Headers;
};
export type queryActionResponseError = (queryActionResponse403 | queryActionResponse404 | queryActionResponse422 | queryActionResponse500 | queryActionResponse502 | queryActionResponse504) & {
  headers: Headers;
};

export type queryActionResponse = queryActionResponseSuccess

export const getQueryActionUrl = () => {




  return `/auth/v1/action/query`
}

/**
 * Errors raised by the action engine carry error_details.retryable: whether the same request, sent again under the same Idempotency-Key, can succeed. 502 and 504 are retryable unless the run had already committed a page, and a dependency's own wait is passed on as error_details.retry_after and the Retry-After header. Request-validation failures (a 422 whose error_details is a list of field errors) are raised before the engine runs, carry neither field, and are never retryable.
 * @summary Check action availability
 */
export const queryAction = async (queryActionRequestBody: QueryActionRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<queryActionResponse> => {

  return customFetch<queryActionResponse>(getQueryActionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(queryActionRequestBody)
  }
);}





export const getQueryActionMutationOptions = <TError = ErrorType<ActionError | HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryAction>>, TError,{data: QueryActionRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof queryAction>>, TError,{data: QueryActionRequestBody}, TContext> => {

const mutationKey = ['queryAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof queryAction>>, {data: QueryActionRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  queryAction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QueryActionMutationResult = NonNullable<Awaited<ReturnType<typeof queryAction>>>
    export type QueryActionMutationBody = QueryActionRequestBody
    export type QueryActionMutationError = ErrorType<ActionError | HumaAPIError>

    /**
 * @summary Check action availability
 */
export const useQueryAction = <TError = ErrorType<ActionError | HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryAction>>, TError,{data: QueryActionRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof queryAction>>,
        TError,
        {data: QueryActionRequestBody},
        TContext
      > => {
      return useMutation(getQueryActionMutationOptions(options), queryClient);
    }
    export type listActionsResponse200 = {
  data: ListActionsResponseBody
  status: 200
}

export type listActionsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listActionsResponseSuccess = (listActionsResponse200) & {
  headers: Headers;
};
export type listActionsResponseError = (listActionsResponseDefault) & {
  headers: Headers;
};

export type listActionsResponse = listActionsResponseSuccess

export const getListActionsUrl = () => {




  return `/auth/v1/action/schema/actions`
}

/**
 * @summary List available actions
 */
export const listActions = async ( options?: Parameters<typeof customFetch>[1]): Promise<listActionsResponse> => {

  return customFetch<listActionsResponse>(getListActionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListActionsQueryKey = () => {
    return [
    `/auth/v1/action/schema/actions`
    ] as const;
    }


export const getListActionsQueryOptions = <TData = Awaited<ReturnType<typeof listActions>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActions>>> = ({ signal }) => listActions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListActionsQueryResult = NonNullable<Awaited<ReturnType<typeof listActions>>>
export type ListActionsQueryError = ErrorType<HumaAPIError>


export function useListActions<TData = Awaited<ReturnType<typeof listActions>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActions>>,
          TError,
          Awaited<ReturnType<typeof listActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActions<TData = Awaited<ReturnType<typeof listActions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActions>>,
          TError,
          Awaited<ReturnType<typeof listActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActions<TData = Awaited<ReturnType<typeof listActions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List available actions
 */

export function useListActions<TData = Awaited<ReturnType<typeof listActions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListActionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listActions>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActions>>> = ({ signal }) => listActions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListActionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listActions>>>
export type ListActionsSuspenseQueryError = ErrorType<HumaAPIError>


export function useListActionsSuspense<TData = Awaited<ReturnType<typeof listActions>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActionsSuspense<TData = Awaited<ReturnType<typeof listActions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActionsSuspense<TData = Awaited<ReturnType<typeof listActions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List available actions
 */

export function useListActionsSuspense<TData = Awaited<ReturnType<typeof listActions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listActions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getActionResponse200 = {
  data: Info
  status: 200
}

export type getActionResponse404 = {
  data: ActionError
  status: 404
}

export type getActionResponseSuccess = (getActionResponse200) & {
  headers: Headers;
};
export type getActionResponseError = (getActionResponse404) & {
  headers: Headers;
};

export type getActionResponse = getActionResponseSuccess

export const getGetActionUrl = ({ name }: GetActionPathParameters,) => {




  return `/auth/v1/action/schema/actions/${name}`
}

/**
 * @summary Get an action definition
 */
export const getAction = async ({ name }: GetActionPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getActionResponse> => {

  return customFetch<getActionResponse>(getGetActionUrl({ name }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActionQueryKey = ({ name }: GetActionPathParameters,) => {
    return [
    `/auth/v1/action/schema/actions/${name}`
    ] as const;
    }


export const getGetActionQueryOptions = <TData = Awaited<ReturnType<typeof getAction>>, TError = ErrorType<ActionError>>({ name }: GetActionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionQueryKey({ name });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAction>>> = ({ signal }) => getAction({ name }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActionQueryResult = NonNullable<Awaited<ReturnType<typeof getAction>>>
export type GetActionQueryError = ErrorType<ActionError>


export function useGetAction<TData = Awaited<ReturnType<typeof getAction>>, TError = ErrorType<ActionError>>(
 pathParams: GetActionPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAction>>,
          TError,
          Awaited<ReturnType<typeof getAction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAction<TData = Awaited<ReturnType<typeof getAction>>, TError = ErrorType<ActionError>>(
 pathParams: GetActionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAction>>,
          TError,
          Awaited<ReturnType<typeof getAction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAction<TData = Awaited<ReturnType<typeof getAction>>, TError = ErrorType<ActionError>>(
 pathParams: GetActionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an action definition
 */

export function useGetAction<TData = Awaited<ReturnType<typeof getAction>>, TError = ErrorType<ActionError>>(
 { name }: GetActionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActionQueryOptions({ name },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAction>>, TError = ErrorType<ActionError>>({ name }: GetActionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionQueryKey({ name });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAction>>> = ({ signal }) => getAction({ name }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAction>>>
export type GetActionSuspenseQueryError = ErrorType<ActionError>


export function useGetActionSuspense<TData = Awaited<ReturnType<typeof getAction>>, TError = ErrorType<ActionError>>(
 pathParams: GetActionPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActionSuspense<TData = Awaited<ReturnType<typeof getAction>>, TError = ErrorType<ActionError>>(
 pathParams: GetActionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActionSuspense<TData = Awaited<ReturnType<typeof getAction>>, TError = ErrorType<ActionError>>(
 pathParams: GetActionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an action definition
 */

export function useGetActionSuspense<TData = Awaited<ReturnType<typeof getAction>>, TError = ErrorType<ActionError>>(
 { name }: GetActionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActionSuspenseQueryOptions({ name },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listPendingAttestationsResponse200 = {
  data: ListPendingDocumentsResponseBody
  status: 200
}

export type listPendingAttestationsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listPendingAttestationsResponseSuccess = (listPendingAttestationsResponse200) & {
  headers: Headers;
};
export type listPendingAttestationsResponseError = (listPendingAttestationsResponseDefault) & {
  headers: Headers;
};

export type listPendingAttestationsResponse = listPendingAttestationsResponseSuccess

export const getListPendingAttestationsUrl = (params?: ListPendingAttestationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/attestations/pending?${stringifiedParams}` : `/auth/v1/attestations/pending`
}

/**
 * @summary List documents the caller still has to attest to
 */
export const listPendingAttestations = async (params?: ListPendingAttestationsParams, options?: Parameters<typeof customFetch>[1]): Promise<listPendingAttestationsResponse> => {

  return customFetch<listPendingAttestationsResponse>(getListPendingAttestationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPendingAttestationsQueryKey = (params?: ListPendingAttestationsParams,) => {
    return [
    `/auth/v1/attestations/pending`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPendingAttestationsQueryOptions = <TData = Awaited<ReturnType<typeof listPendingAttestations>>, TError = ErrorType<HumaAPIError>>(params?: ListPendingAttestationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingAttestationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPendingAttestations>>> = ({ signal }) => listPendingAttestations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPendingAttestationsQueryResult = NonNullable<Awaited<ReturnType<typeof listPendingAttestations>>>
export type ListPendingAttestationsQueryError = ErrorType<HumaAPIError>


export function useListPendingAttestations<TData = Awaited<ReturnType<typeof listPendingAttestations>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListPendingAttestationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingAttestations>>,
          TError,
          Awaited<ReturnType<typeof listPendingAttestations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingAttestations<TData = Awaited<ReturnType<typeof listPendingAttestations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListPendingAttestationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPendingAttestations>>,
          TError,
          Awaited<ReturnType<typeof listPendingAttestations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingAttestations<TData = Awaited<ReturnType<typeof listPendingAttestations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListPendingAttestationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List documents the caller still has to attest to
 */

export function useListPendingAttestations<TData = Awaited<ReturnType<typeof listPendingAttestations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListPendingAttestationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPendingAttestationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPendingAttestationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listPendingAttestations>>, TError = ErrorType<HumaAPIError>>(params?: ListPendingAttestationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingAttestationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPendingAttestations>>> = ({ signal }) => listPendingAttestations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPendingAttestationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPendingAttestations>>>
export type ListPendingAttestationsSuspenseQueryError = ErrorType<HumaAPIError>


export function useListPendingAttestationsSuspense<TData = Awaited<ReturnType<typeof listPendingAttestations>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListPendingAttestationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingAttestationsSuspense<TData = Awaited<ReturnType<typeof listPendingAttestations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListPendingAttestationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPendingAttestationsSuspense<TData = Awaited<ReturnType<typeof listPendingAttestations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListPendingAttestationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List documents the caller still has to attest to
 */

export function useListPendingAttestationsSuspense<TData = Awaited<ReturnType<typeof listPendingAttestations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListPendingAttestationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPendingAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPendingAttestationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createAttestationResponse200 = {
  data: Attestation
  status: 200
}

export type createAttestationResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type createAttestationResponseSuccess = (createAttestationResponse200) & {
  headers: Headers;
};
export type createAttestationResponseError = (createAttestationResponseDefault) & {
  headers: Headers;
};

export type createAttestationResponse = createAttestationResponseSuccess

export const getCreateAttestationUrl = ({ documentId }: CreateAttestationPathParameters,) => {




  return `/auth/v1/attestations/${documentId}/attest`
}

/**
 * @summary Record the caller's attestation of a document
 */
export const createAttestation = async ({ documentId }: CreateAttestationPathParameters,
    createAttestationRequestBody: CreateAttestationRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createAttestationResponse> => {

  return customFetch<createAttestationResponse>(getCreateAttestationUrl({ documentId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAttestationRequestBody)
  }
);}





export const getCreateAttestationMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttestation>>, TError,{pathParams: CreateAttestationPathParameters;data: CreateAttestationRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAttestation>>, TError,{pathParams: CreateAttestationPathParameters;data: CreateAttestationRequestBody}, TContext> => {

const mutationKey = ['createAttestation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAttestation>>, {pathParams: CreateAttestationPathParameters;data: CreateAttestationRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  createAttestation(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAttestationMutationResult = NonNullable<Awaited<ReturnType<typeof createAttestation>>>
    export type CreateAttestationMutationBody = CreateAttestationRequestBody
    export type CreateAttestationMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Record the caller's attestation of a document
 */
export const useCreateAttestation = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttestation>>, TError,{pathParams: CreateAttestationPathParameters;data: CreateAttestationRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAttestation>>,
        TError,
        {pathParams: CreateAttestationPathParameters;data: CreateAttestationRequestBody},
        TContext
      > => {
      return useMutation(getCreateAttestationMutationOptions(options), queryClient);
    }
    export type screeneraiGenerateFiltersResponse200 = {
  data: FilterResult
  status: 200
}

export type screeneraiGenerateFiltersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type screeneraiGenerateFiltersResponseSuccess = (screeneraiGenerateFiltersResponse200) & {
  headers: Headers;
};
export type screeneraiGenerateFiltersResponseError = (screeneraiGenerateFiltersResponseDefault) & {
  headers: Headers;
};

export type screeneraiGenerateFiltersResponse = screeneraiGenerateFiltersResponseSuccess

export const getScreeneraiGenerateFiltersUrl = () => {




  return `/auth/v1/bond-screener-ai/generate-filters`
}

/**
 * @summary Convert natural language to bond screener filters
 */
export const screeneraiGenerateFilters = async (generateFiltersRequest: GenerateFiltersRequest, options?: Parameters<typeof customFetch>[1]): Promise<screeneraiGenerateFiltersResponse> => {

  return customFetch<screeneraiGenerateFiltersResponse>(getScreeneraiGenerateFiltersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(generateFiltersRequest)
  }
);}





export const getScreeneraiGenerateFiltersMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof screeneraiGenerateFilters>>, TError,{data: GenerateFiltersRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof screeneraiGenerateFilters>>, TError,{data: GenerateFiltersRequest}, TContext> => {

const mutationKey = ['screeneraiGenerateFilters'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof screeneraiGenerateFilters>>, {data: GenerateFiltersRequest}> = (props) => {
          const {data} = props ?? {};

          return  screeneraiGenerateFilters(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScreeneraiGenerateFiltersMutationResult = NonNullable<Awaited<ReturnType<typeof screeneraiGenerateFilters>>>
    export type ScreeneraiGenerateFiltersMutationBody = GenerateFiltersRequest
    export type ScreeneraiGenerateFiltersMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Convert natural language to bond screener filters
 */
export const useScreeneraiGenerateFilters = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof screeneraiGenerateFilters>>, TError,{data: GenerateFiltersRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof screeneraiGenerateFilters>>,
        TError,
        {data: GenerateFiltersRequest},
        TContext
      > => {
      return useMutation(getScreeneraiGenerateFiltersMutationOptions(options), queryClient);
    }
    export type screeneraiGenerateTitleResponse200 = {
  data: TitleDescription
  status: 200
}

export type screeneraiGenerateTitleResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type screeneraiGenerateTitleResponseSuccess = (screeneraiGenerateTitleResponse200) & {
  headers: Headers;
};
export type screeneraiGenerateTitleResponseError = (screeneraiGenerateTitleResponseDefault) & {
  headers: Headers;
};

export type screeneraiGenerateTitleResponse = screeneraiGenerateTitleResponseSuccess

export const getScreeneraiGenerateTitleUrl = () => {




  return `/auth/v1/bond-screener-ai/generate-title`
}

/**
 * @summary Generate title and description from bond filters
 */
export const screeneraiGenerateTitle = async (generateTitleRequest: GenerateTitleRequest, options?: Parameters<typeof customFetch>[1]): Promise<screeneraiGenerateTitleResponse> => {

  return customFetch<screeneraiGenerateTitleResponse>(getScreeneraiGenerateTitleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(generateTitleRequest)
  }
);}





export const getScreeneraiGenerateTitleMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof screeneraiGenerateTitle>>, TError,{data: GenerateTitleRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof screeneraiGenerateTitle>>, TError,{data: GenerateTitleRequest}, TContext> => {

const mutationKey = ['screeneraiGenerateTitle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof screeneraiGenerateTitle>>, {data: GenerateTitleRequest}> = (props) => {
          const {data} = props ?? {};

          return  screeneraiGenerateTitle(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScreeneraiGenerateTitleMutationResult = NonNullable<Awaited<ReturnType<typeof screeneraiGenerateTitle>>>
    export type ScreeneraiGenerateTitleMutationBody = GenerateTitleRequest
    export type ScreeneraiGenerateTitleMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Generate title and description from bond filters
 */
export const useScreeneraiGenerateTitle = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof screeneraiGenerateTitle>>, TError,{data: GenerateTitleRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof screeneraiGenerateTitle>>,
        TError,
        {data: GenerateTitleRequest},
        TContext
      > => {
      return useMutation(getScreeneraiGenerateTitleMutationOptions(options), queryClient);
    }
    export type unassignConfigScopeResponse204 = {
  data: void
  status: 204
}

export type unassignConfigScopeResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type unassignConfigScopeResponseSuccess = (unassignConfigScopeResponse204) & {
  headers: Headers;
};
export type unassignConfigScopeResponseError = (unassignConfigScopeResponseDefault) & {
  headers: Headers;
};

export type unassignConfigScopeResponse = unassignConfigScopeResponseSuccess

export const getUnassignConfigScopeUrl = () => {




  return `/auth/v1/config-scopes`
}

/**
 * @summary Remove a config's scope assignment
 */
export const unassignConfigScope = async (configScopeBody: ConfigScopeBody, options?: Parameters<typeof customFetch>[1]): Promise<unassignConfigScopeResponse> => {

  return customFetch<unassignConfigScopeResponse>(getUnassignConfigScopeUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(configScopeBody)
  }
);}





export const getUnassignConfigScopeMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignConfigScope>>, TError,{data: ConfigScopeBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unassignConfigScope>>, TError,{data: ConfigScopeBody}, TContext> => {

const mutationKey = ['unassignConfigScope'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unassignConfigScope>>, {data: ConfigScopeBody}> = (props) => {
          const {data} = props ?? {};

          return  unassignConfigScope(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnassignConfigScopeMutationResult = NonNullable<Awaited<ReturnType<typeof unassignConfigScope>>>
    export type UnassignConfigScopeMutationBody = ConfigScopeBody
    export type UnassignConfigScopeMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Remove a config's scope assignment
 */
export const useUnassignConfigScope = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignConfigScope>>, TError,{data: ConfigScopeBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unassignConfigScope>>,
        TError,
        {data: ConfigScopeBody},
        TContext
      > => {
      return useMutation(getUnassignConfigScopeMutationOptions(options), queryClient);
    }
    export type assignConfigScopeResponse201 = {
  data: ConfigScopeBody
  status: 201
}

export type assignConfigScopeResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type assignConfigScopeResponseSuccess = (assignConfigScopeResponse201) & {
  headers: Headers;
};
export type assignConfigScopeResponseError = (assignConfigScopeResponseDefault) & {
  headers: Headers;
};

export type assignConfigScopeResponse = assignConfigScopeResponseSuccess

export const getAssignConfigScopeUrl = () => {




  return `/auth/v1/config-scopes`
}

/**
 * @summary Assign a config to a scope
 */
export const assignConfigScope = async (configScopeBody: ConfigScopeBody, options?: Parameters<typeof customFetch>[1]): Promise<assignConfigScopeResponse> => {

  return customFetch<assignConfigScopeResponse>(getAssignConfigScopeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(configScopeBody)
  }
);}





export const getAssignConfigScopeMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignConfigScope>>, TError,{data: ConfigScopeBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignConfigScope>>, TError,{data: ConfigScopeBody}, TContext> => {

const mutationKey = ['assignConfigScope'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignConfigScope>>, {data: ConfigScopeBody}> = (props) => {
          const {data} = props ?? {};

          return  assignConfigScope(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignConfigScopeMutationResult = NonNullable<Awaited<ReturnType<typeof assignConfigScope>>>
    export type AssignConfigScopeMutationBody = ConfigScopeBody
    export type AssignConfigScopeMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Assign a config to a scope
 */
export const useAssignConfigScope = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignConfigScope>>, TError,{data: ConfigScopeBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignConfigScope>>,
        TError,
        {data: ConfigScopeBody},
        TContext
      > => {
      return useMutation(getAssignConfigScopeMutationOptions(options), queryClient);
    }
    export type deleteConfigResponse204 = {
  data: void
  status: 204
}

export type deleteConfigResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type deleteConfigResponseSuccess = (deleteConfigResponse204) & {
  headers: Headers;
};
export type deleteConfigResponseError = (deleteConfigResponseDefault) & {
  headers: Headers;
};

export type deleteConfigResponse = deleteConfigResponseSuccess

export const getDeleteConfigUrl = ({ configId }: DeleteConfigPathParameters,) => {




  return `/auth/v1/configs/${configId}`
}

/**
 * @summary Delete a config and its scope assignments
 */
export const deleteConfig = async ({ configId }: DeleteConfigPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<deleteConfigResponse> => {

  return customFetch<deleteConfigResponse>(getDeleteConfigUrl({ configId }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteConfigMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConfig>>, TError,{pathParams: DeleteConfigPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConfig>>, TError,{pathParams: DeleteConfigPathParameters}, TContext> => {

const mutationKey = ['deleteConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConfig>>, {pathParams: DeleteConfigPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  deleteConfig(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteConfigMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConfig>>>

    export type DeleteConfigMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Delete a config and its scope assignments
 */
export const useDeleteConfig = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConfig>>, TError,{pathParams: DeleteConfigPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteConfig>>,
        TError,
        {pathParams: DeleteConfigPathParameters},
        TContext
      > => {
      return useMutation(getDeleteConfigMutationOptions(options), queryClient);
    }
    export type updateConfigResponse200 = {
  data: UpdateConfigResponseBody
  status: 200
}

export type updateConfigResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateConfigResponseSuccess = (updateConfigResponse200) & {
  headers: Headers;
};
export type updateConfigResponseError = (updateConfigResponseDefault) & {
  headers: Headers;
};

export type updateConfigResponse = updateConfigResponseSuccess

export const getUpdateConfigUrl = ({ configId }: UpdateConfigPathParameters,) => {




  return `/auth/v1/configs/${configId}`
}

/**
 * @summary Replace a config's value
 */
export const updateConfig = async ({ configId }: UpdateConfigPathParameters,
    updateConfigRequestBody: UpdateConfigRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<updateConfigResponse> => {

  return customFetch<updateConfigResponse>(getUpdateConfigUrl({ configId }),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateConfigRequestBody)
  }
);}





export const getUpdateConfigMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfig>>, TError,{pathParams: UpdateConfigPathParameters;data: UpdateConfigRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConfig>>, TError,{pathParams: UpdateConfigPathParameters;data: UpdateConfigRequestBody}, TContext> => {

const mutationKey = ['updateConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConfig>>, {pathParams: UpdateConfigPathParameters;data: UpdateConfigRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  updateConfig(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateConfig>>>
    export type UpdateConfigMutationBody = UpdateConfigRequestBody
    export type UpdateConfigMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Replace a config's value
 */
export const useUpdateConfig = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfig>>, TError,{pathParams: UpdateConfigPathParameters;data: UpdateConfigRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateConfig>>,
        TError,
        {pathParams: UpdateConfigPathParameters;data: UpdateConfigRequestBody},
        TContext
      > => {
      return useMutation(getUpdateConfigMutationOptions(options), queryClient);
    }
    export type getConfigsResponse200 = {
  data: GetConfigsResponseBody
  status: 200
}

export type getConfigsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getConfigsResponseSuccess = (getConfigsResponse200) & {
  headers: Headers;
};
export type getConfigsResponseError = (getConfigsResponseDefault) & {
  headers: Headers;
};

export type getConfigsResponse = getConfigsResponseSuccess

export const getGetConfigsUrl = ({ context }: GetConfigsPathParameters,
    params: GetConfigsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/configs/${context}?${stringifiedParams}` : `/auth/v1/configs/${context}`
}

/**
 * @summary Resolve config values for a context
 */
export const getConfigs = async ({ context }: GetConfigsPathParameters,
    params: GetConfigsParams, options?: Parameters<typeof customFetch>[1]): Promise<getConfigsResponse> => {

  return customFetch<getConfigsResponse>(getGetConfigsUrl({ context },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConfigsQueryKey = ({ context }: GetConfigsPathParameters,
    params?: GetConfigsParams,) => {
    return [
    `/auth/v1/configs/${context}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getConfigs>>, TError = ErrorType<HumaAPIError>>({ context }: GetConfigsPathParameters,
    params: GetConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigsQueryKey({ context },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigs>>> = ({ signal }) => getConfigs({ context },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: context !== null && context !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigs>>>
export type GetConfigsQueryError = ErrorType<HumaAPIError>


export function useGetConfigs<TData = Awaited<ReturnType<typeof getConfigs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsPathParameters,
    params: GetConfigsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigs>>,
          TError,
          Awaited<ReturnType<typeof getConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigs<TData = Awaited<ReturnType<typeof getConfigs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsPathParameters,
    params: GetConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigs>>,
          TError,
          Awaited<ReturnType<typeof getConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigs<TData = Awaited<ReturnType<typeof getConfigs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsPathParameters,
    params: GetConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve config values for a context
 */

export function useGetConfigs<TData = Awaited<ReturnType<typeof getConfigs>>, TError = ErrorType<HumaAPIError>>(
 { context }: GetConfigsPathParameters,
    params: GetConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigsQueryOptions({ context },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConfigsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConfigs>>, TError = ErrorType<HumaAPIError>>({ context }: GetConfigsPathParameters,
    params: GetConfigsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigsQueryKey({ context },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigs>>> = ({ signal }) => getConfigs({ context },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigs>>>
export type GetConfigsSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetConfigsSuspense<TData = Awaited<ReturnType<typeof getConfigs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsPathParameters,
    params: GetConfigsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigsSuspense<TData = Awaited<ReturnType<typeof getConfigs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsPathParameters,
    params: GetConfigsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigsSuspense<TData = Awaited<ReturnType<typeof getConfigs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsPathParameters,
    params: GetConfigsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve config values for a context
 */

export function useGetConfigsSuspense<TData = Awaited<ReturnType<typeof getConfigs>>, TError = ErrorType<HumaAPIError>>(
 { context }: GetConfigsPathParameters,
    params: GetConfigsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigsSuspenseQueryOptions({ context },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getConfigsForOrganizationsResponse200 = {
  data: GetConfigsForOrganizationsResponseBody
  status: 200
}

export type getConfigsForOrganizationsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getConfigsForOrganizationsResponseSuccess = (getConfigsForOrganizationsResponse200) & {
  headers: Headers;
};
export type getConfigsForOrganizationsResponseError = (getConfigsForOrganizationsResponseDefault) & {
  headers: Headers;
};

export type getConfigsForOrganizationsResponse = getConfigsForOrganizationsResponseSuccess

export const getGetConfigsForOrganizationsUrl = ({ context }: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/configs/${context}/organizations?${stringifiedParams}` : `/auth/v1/configs/${context}/organizations`
}

/**
 * @summary Resolve config values for a context in every organization the caller may act as
 */
export const getConfigsForOrganizations = async ({ context }: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams, options?: Parameters<typeof customFetch>[1]): Promise<getConfigsForOrganizationsResponse> => {

  return customFetch<getConfigsForOrganizationsResponse>(getGetConfigsForOrganizationsUrl({ context },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConfigsForOrganizationsQueryKey = ({ context }: GetConfigsForOrganizationsPathParameters,
    params?: GetConfigsForOrganizationsParams,) => {
    return [
    `/auth/v1/configs/${context}/organizations`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetConfigsForOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError = ErrorType<HumaAPIError>>({ context }: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigsForOrganizationsQueryKey({ context },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigsForOrganizations>>> = ({ signal }) => getConfigsForOrganizations({ context },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: context !== null && context !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigsForOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigsForOrganizations>>>
export type GetConfigsForOrganizationsQueryError = ErrorType<HumaAPIError>


export function useGetConfigsForOrganizations<TData = Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigsForOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getConfigsForOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigsForOrganizations<TData = Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigsForOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getConfigsForOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigsForOrganizations<TData = Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve config values for a context in every organization the caller may act as
 */

export function useGetConfigsForOrganizations<TData = Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError = ErrorType<HumaAPIError>>(
 { context }: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigsForOrganizationsQueryOptions({ context },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConfigsForOrganizationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError = ErrorType<HumaAPIError>>({ context }: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigsForOrganizationsQueryKey({ context },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigsForOrganizations>>> = ({ signal }) => getConfigsForOrganizations({ context },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigsForOrganizationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigsForOrganizations>>>
export type GetConfigsForOrganizationsSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetConfigsForOrganizationsSuspense<TData = Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigsForOrganizationsSuspense<TData = Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigsForOrganizationsSuspense<TData = Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve config values for a context in every organization the caller may act as
 */

export function useGetConfigsForOrganizationsSuspense<TData = Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError = ErrorType<HumaAPIError>>(
 { context }: GetConfigsForOrganizationsPathParameters,
    params: GetConfigsForOrganizationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfigsForOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigsForOrganizationsSuspenseQueryOptions({ context },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createConfigResponse201 = {
  data: ConfigEntry
  status: 201
}

export type createConfigResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createConfigResponseSuccess = (createConfigResponse201) & {
  headers: Headers;
};
export type createConfigResponseError = (createConfigResponseDefault) & {
  headers: Headers;
};

export type createConfigResponse = createConfigResponseSuccess

export const getCreateConfigUrl = ({ context, key }: CreateConfigPathParameters,) => {




  return `/auth/v1/configs/${context}/${key}`
}

/**
 * @summary Create a config assigned at the caller's user scope
 */
export const createConfig = async ({ context, key }: CreateConfigPathParameters,
    createConfigRequestBody: CreateConfigRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createConfigResponse> => {

  return customFetch<createConfigResponse>(getCreateConfigUrl({ context, key }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createConfigRequestBody)
  }
);}





export const getCreateConfigMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConfig>>, TError,{pathParams: CreateConfigPathParameters;data: CreateConfigRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createConfig>>, TError,{pathParams: CreateConfigPathParameters;data: CreateConfigRequestBody}, TContext> => {

const mutationKey = ['createConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConfig>>, {pathParams: CreateConfigPathParameters;data: CreateConfigRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  createConfig(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateConfigMutationResult = NonNullable<Awaited<ReturnType<typeof createConfig>>>
    export type CreateConfigMutationBody = CreateConfigRequestBody
    export type CreateConfigMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create a config assigned at the caller's user scope
 */
export const useCreateConfig = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConfig>>, TError,{pathParams: CreateConfigPathParameters;data: CreateConfigRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createConfig>>,
        TError,
        {pathParams: CreateConfigPathParameters;data: CreateConfigRequestBody},
        TContext
      > => {
      return useMutation(getCreateConfigMutationOptions(options), queryClient);
    }
    export type listCustomColumnsResponse200 = {
  data: ListCustomColumnsBody
  status: 200
}

export type listCustomColumnsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listCustomColumnsResponseSuccess = (listCustomColumnsResponse200) & {
  headers: Headers;
};
export type listCustomColumnsResponseError = (listCustomColumnsResponseDefault) & {
  headers: Headers;
};

export type listCustomColumnsResponse = listCustomColumnsResponseSuccess

export const getListCustomColumnsUrl = (params?: ListCustomColumnsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns?${stringifiedParams}` : `/auth/v1/custom-columns`
}

/**
 * Lists the organization's custom columns. Archived columns are excluded unless include_archived is set.
 * @summary List custom columns
 */
export const listCustomColumns = async (params?: ListCustomColumnsParams, options?: Parameters<typeof customFetch>[1]): Promise<listCustomColumnsResponse> => {

  return customFetch<listCustomColumnsResponse>(getListCustomColumnsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomColumnsQueryKey = (params?: ListCustomColumnsParams,) => {
    return [
    `/auth/v1/custom-columns`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomColumnsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomColumns>>, TError = ErrorType<HumaAPIError>>(params?: ListCustomColumnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomColumnsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomColumns>>> = ({ signal }) => listCustomColumns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCustomColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomColumns>>>
export type ListCustomColumnsQueryError = ErrorType<HumaAPIError>


export function useListCustomColumns<TData = Awaited<ReturnType<typeof listCustomColumns>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListCustomColumnsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomColumns>>,
          TError,
          Awaited<ReturnType<typeof listCustomColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumns<TData = Awaited<ReturnType<typeof listCustomColumns>>, TError = ErrorType<HumaAPIError>>(
 params?: ListCustomColumnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomColumns>>,
          TError,
          Awaited<ReturnType<typeof listCustomColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumns<TData = Awaited<ReturnType<typeof listCustomColumns>>, TError = ErrorType<HumaAPIError>>(
 params?: ListCustomColumnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List custom columns
 */

export function useListCustomColumns<TData = Awaited<ReturnType<typeof listCustomColumns>>, TError = ErrorType<HumaAPIError>>(
 params?: ListCustomColumnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCustomColumnsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListCustomColumnsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listCustomColumns>>, TError = ErrorType<HumaAPIError>>(params?: ListCustomColumnsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomColumnsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomColumns>>> = ({ signal }) => listCustomColumns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCustomColumnsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomColumns>>>
export type ListCustomColumnsSuspenseQueryError = ErrorType<HumaAPIError>


export function useListCustomColumnsSuspense<TData = Awaited<ReturnType<typeof listCustomColumns>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListCustomColumnsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumnsSuspense<TData = Awaited<ReturnType<typeof listCustomColumns>>, TError = ErrorType<HumaAPIError>>(
 params?: ListCustomColumnsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumnsSuspense<TData = Awaited<ReturnType<typeof listCustomColumns>>, TError = ErrorType<HumaAPIError>>(
 params?: ListCustomColumnsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List custom columns
 */

export function useListCustomColumnsSuspense<TData = Awaited<ReturnType<typeof listCustomColumns>>, TError = ErrorType<HumaAPIError>>(
 params?: ListCustomColumnsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCustomColumnsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createCustomColumnResponse201 = {
  data: CustomColumnBody
  status: 201
}

export type createCustomColumnResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createCustomColumnResponseSuccess = (createCustomColumnResponse201) & {
  headers: Headers;
};
export type createCustomColumnResponseError = (createCustomColumnResponseDefault) & {
  headers: Headers;
};

export type createCustomColumnResponse = createCustomColumnResponseSuccess

export const getCreateCustomColumnUrl = (params?: CreateCustomColumnParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns?${stringifiedParams}` : `/auth/v1/custom-columns`
}

/**
 * Adds a custom column to an entity. The organization's schema for the entity is created and activated transparently on the first column, so the column goes live immediately. When name is omitted it is generated from label.
 * @summary Create a custom column
 */
export const createCustomColumn = async (createCustomColumnBody: CreateCustomColumnBody,
    params?: CreateCustomColumnParams, options?: Parameters<typeof customFetch>[1]): Promise<createCustomColumnResponse> => {

  return customFetch<createCustomColumnResponse>(getCreateCustomColumnUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCustomColumnBody)
  }
);}





export const getCreateCustomColumnMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomColumn>>, TError,{data: CreateCustomColumnBody;params?: CreateCustomColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomColumn>>, TError,{data: CreateCustomColumnBody;params?: CreateCustomColumnParams}, TContext> => {

const mutationKey = ['createCustomColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomColumn>>, {data: CreateCustomColumnBody;params?: CreateCustomColumnParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createCustomColumn(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomColumnMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomColumn>>>
    export type CreateCustomColumnMutationBody = CreateCustomColumnBody
    export type CreateCustomColumnMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create a custom column
 */
export const useCreateCustomColumn = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomColumn>>, TError,{data: CreateCustomColumnBody;params?: CreateCustomColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCustomColumn>>,
        TError,
        {data: CreateCustomColumnBody;params?: CreateCustomColumnParams},
        TContext
      > => {
      return useMutation(getCreateCustomColumnMutationOptions(options), queryClient);
    }
    export type listCustomColumnEntitiesResponse200 = {
  data: ListCustomColumnEntitiesBody
  status: 200
}

export type listCustomColumnEntitiesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listCustomColumnEntitiesResponseSuccess = (listCustomColumnEntitiesResponse200) & {
  headers: Headers;
};
export type listCustomColumnEntitiesResponseError = (listCustomColumnEntitiesResponseDefault) & {
  headers: Headers;
};

export type listCustomColumnEntitiesResponse = listCustomColumnEntitiesResponseSuccess

export const getListCustomColumnEntitiesUrl = () => {




  return `/auth/v1/custom-columns/entities`
}

/**
 * Lists the entities (e.g. Security) a customer can add custom columns to.
 * @summary List authorable entities
 */
export const listCustomColumnEntities = async ( options?: Parameters<typeof customFetch>[1]): Promise<listCustomColumnEntitiesResponse> => {

  return customFetch<listCustomColumnEntitiesResponse>(getListCustomColumnEntitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomColumnEntitiesQueryKey = () => {
    return [
    `/auth/v1/custom-columns/entities`
    ] as const;
    }


export const getListCustomColumnEntitiesQueryOptions = <TData = Awaited<ReturnType<typeof listCustomColumnEntities>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomColumnEntitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomColumnEntities>>> = ({ signal }) => listCustomColumnEntities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCustomColumnEntitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomColumnEntities>>>
export type ListCustomColumnEntitiesQueryError = ErrorType<HumaAPIError>


export function useListCustomColumnEntities<TData = Awaited<ReturnType<typeof listCustomColumnEntities>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomColumnEntities>>,
          TError,
          Awaited<ReturnType<typeof listCustomColumnEntities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumnEntities<TData = Awaited<ReturnType<typeof listCustomColumnEntities>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomColumnEntities>>,
          TError,
          Awaited<ReturnType<typeof listCustomColumnEntities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumnEntities<TData = Awaited<ReturnType<typeof listCustomColumnEntities>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List authorable entities
 */

export function useListCustomColumnEntities<TData = Awaited<ReturnType<typeof listCustomColumnEntities>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCustomColumnEntitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListCustomColumnEntitiesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listCustomColumnEntities>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomColumnEntitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomColumnEntities>>> = ({ signal }) => listCustomColumnEntities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCustomColumnEntitiesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomColumnEntities>>>
export type ListCustomColumnEntitiesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListCustomColumnEntitiesSuspense<TData = Awaited<ReturnType<typeof listCustomColumnEntities>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumnEntitiesSuspense<TData = Awaited<ReturnType<typeof listCustomColumnEntities>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumnEntitiesSuspense<TData = Awaited<ReturnType<typeof listCustomColumnEntities>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List authorable entities
 */

export function useListCustomColumnEntitiesSuspense<TData = Awaited<ReturnType<typeof listCustomColumnEntities>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCustomColumnEntitiesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listCustomColumnTypesResponse200 = {
  data: ListCustomColumnTypesBody
  status: 200
}

export type listCustomColumnTypesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listCustomColumnTypesResponseSuccess = (listCustomColumnTypesResponse200) & {
  headers: Headers;
};
export type listCustomColumnTypesResponseError = (listCustomColumnTypesResponseDefault) & {
  headers: Headers;
};

export type listCustomColumnTypesResponse = listCustomColumnTypesResponseSuccess

export const getListCustomColumnTypesUrl = () => {




  return `/auth/v1/custom-columns/types`
}

/**
 * Lists the types a custom column may be given: pkg/schema primitives plus registered named types (enums/ordinals), each with a display label. Static for the process lifetime.
 * @summary List selectable column types
 */
export const listCustomColumnTypes = async ( options?: Parameters<typeof customFetch>[1]): Promise<listCustomColumnTypesResponse> => {

  return customFetch<listCustomColumnTypesResponse>(getListCustomColumnTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomColumnTypesQueryKey = () => {
    return [
    `/auth/v1/custom-columns/types`
    ] as const;
    }


export const getListCustomColumnTypesQueryOptions = <TData = Awaited<ReturnType<typeof listCustomColumnTypes>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomColumnTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomColumnTypes>>> = ({ signal }) => listCustomColumnTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCustomColumnTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomColumnTypes>>>
export type ListCustomColumnTypesQueryError = ErrorType<HumaAPIError>


export function useListCustomColumnTypes<TData = Awaited<ReturnType<typeof listCustomColumnTypes>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomColumnTypes>>,
          TError,
          Awaited<ReturnType<typeof listCustomColumnTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumnTypes<TData = Awaited<ReturnType<typeof listCustomColumnTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomColumnTypes>>,
          TError,
          Awaited<ReturnType<typeof listCustomColumnTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumnTypes<TData = Awaited<ReturnType<typeof listCustomColumnTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List selectable column types
 */

export function useListCustomColumnTypes<TData = Awaited<ReturnType<typeof listCustomColumnTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCustomColumnTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListCustomColumnTypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listCustomColumnTypes>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomColumnTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomColumnTypes>>> = ({ signal }) => listCustomColumnTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCustomColumnTypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomColumnTypes>>>
export type ListCustomColumnTypesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListCustomColumnTypesSuspense<TData = Awaited<ReturnType<typeof listCustomColumnTypes>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumnTypesSuspense<TData = Awaited<ReturnType<typeof listCustomColumnTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomColumnTypesSuspense<TData = Awaited<ReturnType<typeof listCustomColumnTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List selectable column types
 */

export function useListCustomColumnTypesSuspense<TData = Awaited<ReturnType<typeof listCustomColumnTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCustomColumnTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCustomColumnTypesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type patchOverlayCellsResponse200 = {
  data: OverlayWriteBody
  status: 200
}

export type patchOverlayCellsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchOverlayCellsResponseSuccess = (patchOverlayCellsResponse200) & {
  headers: Headers;
};
export type patchOverlayCellsResponseError = (patchOverlayCellsResponseDefault) & {
  headers: Headers;
};

export type patchOverlayCellsResponse = patchOverlayCellsResponseSuccess

export const getPatchOverlayCellsUrl = ({ entity }: PatchOverlayCellsPathParameters,
    params?: PatchOverlayCellsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns/${entity}/data/cells?${stringifiedParams}` : `/auth/v1/custom-columns/${entity}/data/cells`
}

/**
 * Applies per-cell set and clear edits. A set overrides the cell; a clear reverts it to the base value.
 * @summary Set and clear override cells
 */
export const patchOverlayCells = async ({ entity }: PatchOverlayCellsPathParameters,
    patchOverlayCellsBody: PatchOverlayCellsBody,
    params?: PatchOverlayCellsParams, options?: Parameters<typeof customFetch>[1]): Promise<patchOverlayCellsResponse> => {

  return customFetch<patchOverlayCellsResponse>(getPatchOverlayCellsUrl({ entity },params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchOverlayCellsBody)
  }
);}





export const getPatchOverlayCellsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOverlayCells>>, TError,{pathParams: PatchOverlayCellsPathParameters;data: PatchOverlayCellsBody;params?: PatchOverlayCellsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchOverlayCells>>, TError,{pathParams: PatchOverlayCellsPathParameters;data: PatchOverlayCellsBody;params?: PatchOverlayCellsParams}, TContext> => {

const mutationKey = ['patchOverlayCells'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchOverlayCells>>, {pathParams: PatchOverlayCellsPathParameters;data: PatchOverlayCellsBody;params?: PatchOverlayCellsParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  patchOverlayCells(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchOverlayCellsMutationResult = NonNullable<Awaited<ReturnType<typeof patchOverlayCells>>>
    export type PatchOverlayCellsMutationBody = PatchOverlayCellsBody
    export type PatchOverlayCellsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Set and clear override cells
 */
export const usePatchOverlayCells = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOverlayCells>>, TError,{pathParams: PatchOverlayCellsPathParameters;data: PatchOverlayCellsBody;params?: PatchOverlayCellsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchOverlayCells>>,
        TError,
        {pathParams: PatchOverlayCellsPathParameters;data: PatchOverlayCellsBody;params?: PatchOverlayCellsParams},
        TContext
      > => {
      return useMutation(getPatchOverlayCellsMutationOptions(options), queryClient);
    }
    export type lookupOverlayCellsResponse200 = {
  data: LookupOverlayCellsResponseBody
  status: 200
}

export type lookupOverlayCellsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type lookupOverlayCellsResponseSuccess = (lookupOverlayCellsResponse200) & {
  headers: Headers;
};
export type lookupOverlayCellsResponseError = (lookupOverlayCellsResponseDefault) & {
  headers: Headers;
};

export type lookupOverlayCellsResponse = lookupOverlayCellsResponseSuccess

export const getLookupOverlayCellsUrl = ({ entity }: LookupOverlayCellsPathParameters,
    params?: LookupOverlayCellsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns/${entity}/data/cells/lookup?${stringifiedParams}` : `/auth/v1/custom-columns/${entity}/data/cells/lookup`
}

/**
 * Batch query: for each requested cell, reports whether it carries an override, its value if so, and the key's version. A query only — reads the override table, composes no base. No write permission required, but the same org-tenancy scoping as the write endpoints.
 * @summary Look up cell override status
 */
export const lookupOverlayCells = async ({ entity }: LookupOverlayCellsPathParameters,
    lookupOverlayCellsBody: LookupOverlayCellsBody,
    params?: LookupOverlayCellsParams, options?: Parameters<typeof customFetch>[1]): Promise<lookupOverlayCellsResponse> => {

  return customFetch<lookupOverlayCellsResponse>(getLookupOverlayCellsUrl({ entity },params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lookupOverlayCellsBody)
  }
);}





export const getLookupOverlayCellsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lookupOverlayCells>>, TError,{pathParams: LookupOverlayCellsPathParameters;data: LookupOverlayCellsBody;params?: LookupOverlayCellsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof lookupOverlayCells>>, TError,{pathParams: LookupOverlayCellsPathParameters;data: LookupOverlayCellsBody;params?: LookupOverlayCellsParams}, TContext> => {

const mutationKey = ['lookupOverlayCells'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lookupOverlayCells>>, {pathParams: LookupOverlayCellsPathParameters;data: LookupOverlayCellsBody;params?: LookupOverlayCellsParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  lookupOverlayCells(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LookupOverlayCellsMutationResult = NonNullable<Awaited<ReturnType<typeof lookupOverlayCells>>>
    export type LookupOverlayCellsMutationBody = LookupOverlayCellsBody
    export type LookupOverlayCellsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Look up cell override status
 */
export const useLookupOverlayCells = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lookupOverlayCells>>, TError,{pathParams: LookupOverlayCellsPathParameters;data: LookupOverlayCellsBody;params?: LookupOverlayCellsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lookupOverlayCells>>,
        TError,
        {pathParams: LookupOverlayCellsPathParameters;data: LookupOverlayCellsBody;params?: LookupOverlayCellsParams},
        TContext
      > => {
      return useMutation(getLookupOverlayCellsMutationOptions(options), queryClient);
    }
    export type patchOverlayColumnResponse200 = {
  data: OverlayWriteBody
  status: 200
}

export type patchOverlayColumnResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchOverlayColumnResponseSuccess = (patchOverlayColumnResponse200) & {
  headers: Headers;
};
export type patchOverlayColumnResponseError = (patchOverlayColumnResponseDefault) & {
  headers: Headers;
};

export type patchOverlayColumnResponse = patchOverlayColumnResponseSuccess

export const getPatchOverlayColumnUrl = ({ entity }: PatchOverlayColumnPathParameters,
    params?: PatchOverlayColumnParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns/${entity}/data/column?${stringifiedParams}` : `/auth/v1/custom-columns/${entity}/data/column`
}

/**
 * Sets one column to the same value across many rows and/or clears it across many rows.
 * @summary Fill or clear one column across rows
 */
export const patchOverlayColumn = async ({ entity }: PatchOverlayColumnPathParameters,
    patchOverlayColumnBody: PatchOverlayColumnBody,
    params?: PatchOverlayColumnParams, options?: Parameters<typeof customFetch>[1]): Promise<patchOverlayColumnResponse> => {

  return customFetch<patchOverlayColumnResponse>(getPatchOverlayColumnUrl({ entity },params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchOverlayColumnBody)
  }
);}





export const getPatchOverlayColumnMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOverlayColumn>>, TError,{pathParams: PatchOverlayColumnPathParameters;data: PatchOverlayColumnBody;params?: PatchOverlayColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchOverlayColumn>>, TError,{pathParams: PatchOverlayColumnPathParameters;data: PatchOverlayColumnBody;params?: PatchOverlayColumnParams}, TContext> => {

const mutationKey = ['patchOverlayColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchOverlayColumn>>, {pathParams: PatchOverlayColumnPathParameters;data: PatchOverlayColumnBody;params?: PatchOverlayColumnParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  patchOverlayColumn(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchOverlayColumnMutationResult = NonNullable<Awaited<ReturnType<typeof patchOverlayColumn>>>
    export type PatchOverlayColumnMutationBody = PatchOverlayColumnBody
    export type PatchOverlayColumnMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Fill or clear one column across rows
 */
export const usePatchOverlayColumn = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOverlayColumn>>, TError,{pathParams: PatchOverlayColumnPathParameters;data: PatchOverlayColumnBody;params?: PatchOverlayColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchOverlayColumn>>,
        TError,
        {pathParams: PatchOverlayColumnPathParameters;data: PatchOverlayColumnBody;params?: PatchOverlayColumnParams},
        TContext
      > => {
      return useMutation(getPatchOverlayColumnMutationOptions(options), queryClient);
    }
    export type createOverlayRowsResponse200 = {
  data: OverlayWriteBody
  status: 200
}

export type createOverlayRowsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type createOverlayRowsResponseSuccess = (createOverlayRowsResponse200) & {
  headers: Headers;
};
export type createOverlayRowsResponseError = (createOverlayRowsResponseDefault) & {
  headers: Headers;
};

export type createOverlayRowsResponse = createOverlayRowsResponseSuccess

export const getCreateOverlayRowsUrl = ({ entity }: CreateOverlayRowsPathParameters,
    params?: CreateOverlayRowsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns/${entity}/data/rows?${stringifiedParams}` : `/auth/v1/custom-columns/${entity}/data/rows`
}

/**
 * Creates net-new override-only rows for an entity. Every logically-required field must be present, since an override-only row has no base to fall back to.
 * @summary Create override rows
 */
export const createOverlayRows = async ({ entity }: CreateOverlayRowsPathParameters,
    createOverlayRowsBody: CreateOverlayRowsBody,
    params?: CreateOverlayRowsParams, options?: Parameters<typeof customFetch>[1]): Promise<createOverlayRowsResponse> => {

  return customFetch<createOverlayRowsResponse>(getCreateOverlayRowsUrl({ entity },params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOverlayRowsBody)
  }
);}





export const getCreateOverlayRowsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOverlayRows>>, TError,{pathParams: CreateOverlayRowsPathParameters;data: CreateOverlayRowsBody;params?: CreateOverlayRowsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOverlayRows>>, TError,{pathParams: CreateOverlayRowsPathParameters;data: CreateOverlayRowsBody;params?: CreateOverlayRowsParams}, TContext> => {

const mutationKey = ['createOverlayRows'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOverlayRows>>, {pathParams: CreateOverlayRowsPathParameters;data: CreateOverlayRowsBody;params?: CreateOverlayRowsParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  createOverlayRows(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOverlayRowsMutationResult = NonNullable<Awaited<ReturnType<typeof createOverlayRows>>>
    export type CreateOverlayRowsMutationBody = CreateOverlayRowsBody
    export type CreateOverlayRowsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create override rows
 */
export const useCreateOverlayRows = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOverlayRows>>, TError,{pathParams: CreateOverlayRowsPathParameters;data: CreateOverlayRowsBody;params?: CreateOverlayRowsParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOverlayRows>>,
        TError,
        {pathParams: CreateOverlayRowsPathParameters;data: CreateOverlayRowsBody;params?: CreateOverlayRowsParams},
        TContext
      > => {
      return useMutation(getCreateOverlayRowsMutationOptions(options), queryClient);
    }
    export type listOverlayUploadsResponse200 = {
  data: ListUploadsOutputBody
  status: 200
}

export type listOverlayUploadsResponse401 = {
  data: HumaAPIError
  status: 401
}

export type listOverlayUploadsResponse403 = {
  data: HumaAPIError
  status: 403
}

export type listOverlayUploadsResponse404 = {
  data: HumaAPIError
  status: 404
}

export type listOverlayUploadsResponse422 = {
  data: HumaAPIError
  status: 422
}

export type listOverlayUploadsResponse500 = {
  data: HumaAPIError
  status: 500
}

export type listOverlayUploadsResponse503 = {
  data: HumaAPIError
  status: 503
}

export type listOverlayUploadsResponseSuccess = (listOverlayUploadsResponse200) & {
  headers: Headers;
};
export type listOverlayUploadsResponseError = (listOverlayUploadsResponse401 | listOverlayUploadsResponse403 | listOverlayUploadsResponse404 | listOverlayUploadsResponse422 | listOverlayUploadsResponse500 | listOverlayUploadsResponse503) & {
  headers: Headers;
};

export type listOverlayUploadsResponse = listOverlayUploadsResponseSuccess

export const getListOverlayUploadsUrl = ({ entity }: ListOverlayUploadsPathParameters,
    params?: ListOverlayUploadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns/${entity}/data/uploads?${stringifiedParams}` : `/auth/v1/custom-columns/${entity}/data/uploads`
}

/**
 * Returns one page of the entity's uploads for your organization, newest first.
 * @summary List CSV uploads for an entity
 */
export const listOverlayUploads = async ({ entity }: ListOverlayUploadsPathParameters,
    params?: ListOverlayUploadsParams, options?: Parameters<typeof customFetch>[1]): Promise<listOverlayUploadsResponse> => {

  return customFetch<listOverlayUploadsResponse>(getListOverlayUploadsUrl({ entity },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOverlayUploadsQueryKey = ({ entity }: ListOverlayUploadsPathParameters,
    params?: ListOverlayUploadsParams,) => {
    return [
    `/auth/v1/custom-columns/${entity}/data/uploads`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOverlayUploadsQueryOptions = <TData = Awaited<ReturnType<typeof listOverlayUploads>>, TError = ErrorType<HumaAPIError>>({ entity }: ListOverlayUploadsPathParameters,
    params?: ListOverlayUploadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOverlayUploadsQueryKey({ entity },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOverlayUploads>>> = ({ signal }) => listOverlayUploads({ entity },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: entity !== null && entity !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOverlayUploadsQueryResult = NonNullable<Awaited<ReturnType<typeof listOverlayUploads>>>
export type ListOverlayUploadsQueryError = ErrorType<HumaAPIError>


export function useListOverlayUploads<TData = Awaited<ReturnType<typeof listOverlayUploads>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOverlayUploadsPathParameters,
    params: undefined |  ListOverlayUploadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOverlayUploads>>,
          TError,
          Awaited<ReturnType<typeof listOverlayUploads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOverlayUploads<TData = Awaited<ReturnType<typeof listOverlayUploads>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOverlayUploadsPathParameters,
    params?: ListOverlayUploadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOverlayUploads>>,
          TError,
          Awaited<ReturnType<typeof listOverlayUploads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOverlayUploads<TData = Awaited<ReturnType<typeof listOverlayUploads>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOverlayUploadsPathParameters,
    params?: ListOverlayUploadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List CSV uploads for an entity
 */

export function useListOverlayUploads<TData = Awaited<ReturnType<typeof listOverlayUploads>>, TError = ErrorType<HumaAPIError>>(
 { entity }: ListOverlayUploadsPathParameters,
    params?: ListOverlayUploadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOverlayUploadsQueryOptions({ entity },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListOverlayUploadsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listOverlayUploads>>, TError = ErrorType<HumaAPIError>>({ entity }: ListOverlayUploadsPathParameters,
    params?: ListOverlayUploadsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOverlayUploadsQueryKey({ entity },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOverlayUploads>>> = ({ signal }) => listOverlayUploads({ entity },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOverlayUploadsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listOverlayUploads>>>
export type ListOverlayUploadsSuspenseQueryError = ErrorType<HumaAPIError>


export function useListOverlayUploadsSuspense<TData = Awaited<ReturnType<typeof listOverlayUploads>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOverlayUploadsPathParameters,
    params: undefined |  ListOverlayUploadsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOverlayUploadsSuspense<TData = Awaited<ReturnType<typeof listOverlayUploads>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOverlayUploadsPathParameters,
    params?: ListOverlayUploadsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOverlayUploadsSuspense<TData = Awaited<ReturnType<typeof listOverlayUploads>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOverlayUploadsPathParameters,
    params?: ListOverlayUploadsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List CSV uploads for an entity
 */

export function useListOverlayUploadsSuspense<TData = Awaited<ReturnType<typeof listOverlayUploads>>, TError = ErrorType<HumaAPIError>>(
 { entity }: ListOverlayUploadsPathParameters,
    params?: ListOverlayUploadsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOverlayUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOverlayUploadsSuspenseQueryOptions({ entity },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createOverlayUploadResponse201 = {
  data: CreateUploadOutputBody
  status: 201
}

export type createOverlayUploadResponse400 = {
  data: HumaAPIError
  status: 400
}

export type createOverlayUploadResponse401 = {
  data: HumaAPIError
  status: 401
}

export type createOverlayUploadResponse403 = {
  data: HumaAPIError
  status: 403
}

export type createOverlayUploadResponse404 = {
  data: HumaAPIError
  status: 404
}

export type createOverlayUploadResponse409 = {
  data: HumaAPIError
  status: 409
}

export type createOverlayUploadResponse422 = {
  data: HumaAPIError
  status: 422
}

export type createOverlayUploadResponse500 = {
  data: HumaAPIError
  status: 500
}

export type createOverlayUploadResponse503 = {
  data: HumaAPIError
  status: 503
}

export type createOverlayUploadResponseSuccess = (createOverlayUploadResponse201) & {
  headers: Headers;
};
export type createOverlayUploadResponseError = (createOverlayUploadResponse400 | createOverlayUploadResponse401 | createOverlayUploadResponse403 | createOverlayUploadResponse404 | createOverlayUploadResponse409 | createOverlayUploadResponse422 | createOverlayUploadResponse500 | createOverlayUploadResponse503) & {
  headers: Headers;
};

export type createOverlayUploadResponse = createOverlayUploadResponseSuccess

export const getCreateOverlayUploadUrl = ({ entity }: CreateOverlayUploadPathParameters,) => {




  return `/auth/v1/custom-columns/${entity}/data/uploads`
}

/**
 * Creates an upload and returns a presigned S3 URL. PUT the CSV to that URL sending exactly the returned headers, within the TTL; validation and application start automatically. Poll the get-upload endpoint for status. A key may appear more than once in the file: the rows are applied in submission order, each landing on top of the previous one cell by cell, exactly as if they had been uploaded one after another, and every row counts toward rows_accepted or rows_rejected. The file's columns are the entity's custom columns and the base columns your organization may override; uploading to an entity it has never customized creates its overlay on the spot, exactly as a first cell edit does.
 * @summary Create a CSV upload of override data
 */
export const createOverlayUpload = async ({ entity }: CreateOverlayUploadPathParameters,
    createUploadBody: CreateUploadBody, options?: Parameters<typeof customFetch>[1]): Promise<createOverlayUploadResponse> => {

  return customFetch<createOverlayUploadResponse>(getCreateOverlayUploadUrl({ entity }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createUploadBody)
  }
);}





export const getCreateOverlayUploadMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOverlayUpload>>, TError,{pathParams: CreateOverlayUploadPathParameters;data: CreateUploadBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOverlayUpload>>, TError,{pathParams: CreateOverlayUploadPathParameters;data: CreateUploadBody}, TContext> => {

const mutationKey = ['createOverlayUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOverlayUpload>>, {pathParams: CreateOverlayUploadPathParameters;data: CreateUploadBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  createOverlayUpload(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOverlayUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createOverlayUpload>>>
    export type CreateOverlayUploadMutationBody = CreateUploadBody
    export type CreateOverlayUploadMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create a CSV upload of override data
 */
export const useCreateOverlayUpload = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOverlayUpload>>, TError,{pathParams: CreateOverlayUploadPathParameters;data: CreateUploadBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOverlayUpload>>,
        TError,
        {pathParams: CreateOverlayUploadPathParameters;data: CreateUploadBody},
        TContext
      > => {
      return useMutation(getCreateOverlayUploadMutationOptions(options), queryClient);
    }
    export type getOverlayUploadResponse200 = {
  data: UploadDTO
  status: 200
}

export type getOverlayUploadResponse401 = {
  data: HumaAPIError
  status: 401
}

export type getOverlayUploadResponse403 = {
  data: HumaAPIError
  status: 403
}

export type getOverlayUploadResponse404 = {
  data: HumaAPIError
  status: 404
}

export type getOverlayUploadResponse422 = {
  data: HumaAPIError
  status: 422
}

export type getOverlayUploadResponse500 = {
  data: HumaAPIError
  status: 500
}

export type getOverlayUploadResponse503 = {
  data: HumaAPIError
  status: 503
}

export type getOverlayUploadResponseSuccess = (getOverlayUploadResponse200) & {
  headers: Headers;
};
export type getOverlayUploadResponseError = (getOverlayUploadResponse401 | getOverlayUploadResponse403 | getOverlayUploadResponse404 | getOverlayUploadResponse422 | getOverlayUploadResponse500 | getOverlayUploadResponse503) & {
  headers: Headers;
};

export type getOverlayUploadResponse = getOverlayUploadResponseSuccess

export const getGetOverlayUploadUrl = ({ entity, uploadId }: GetOverlayUploadPathParameters,) => {




  return `/auth/v1/custom-columns/${entity}/data/uploads/${uploadId}`
}

/**
 * @summary Get a CSV upload's status
 */
export const getOverlayUpload = async ({ entity, uploadId }: GetOverlayUploadPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getOverlayUploadResponse> => {

  return customFetch<getOverlayUploadResponse>(getGetOverlayUploadUrl({ entity, uploadId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOverlayUploadQueryKey = ({ entity, uploadId }: GetOverlayUploadPathParameters,) => {
    return [
    `/auth/v1/custom-columns/${entity}/data/uploads/${uploadId}`
    ] as const;
    }


export const getGetOverlayUploadQueryOptions = <TData = Awaited<ReturnType<typeof getOverlayUpload>>, TError = ErrorType<HumaAPIError>>({ entity, uploadId }: GetOverlayUploadPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverlayUploadQueryKey({ entity, uploadId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverlayUpload>>> = ({ signal }) => getOverlayUpload({ entity, uploadId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: entity !== null && entity !== undefined && uploadId !== null && uploadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverlayUploadQueryResult = NonNullable<Awaited<ReturnType<typeof getOverlayUpload>>>
export type GetOverlayUploadQueryError = ErrorType<HumaAPIError>


export function useGetOverlayUpload<TData = Awaited<ReturnType<typeof getOverlayUpload>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOverlayUploadPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverlayUpload>>,
          TError,
          Awaited<ReturnType<typeof getOverlayUpload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverlayUpload<TData = Awaited<ReturnType<typeof getOverlayUpload>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOverlayUploadPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverlayUpload>>,
          TError,
          Awaited<ReturnType<typeof getOverlayUpload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverlayUpload<TData = Awaited<ReturnType<typeof getOverlayUpload>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOverlayUploadPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a CSV upload's status
 */

export function useGetOverlayUpload<TData = Awaited<ReturnType<typeof getOverlayUpload>>, TError = ErrorType<HumaAPIError>>(
 { entity, uploadId }: GetOverlayUploadPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOverlayUploadQueryOptions({ entity, uploadId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOverlayUploadSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOverlayUpload>>, TError = ErrorType<HumaAPIError>>({ entity, uploadId }: GetOverlayUploadPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverlayUploadQueryKey({ entity, uploadId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverlayUpload>>> = ({ signal }) => getOverlayUpload({ entity, uploadId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverlayUploadSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOverlayUpload>>>
export type GetOverlayUploadSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetOverlayUploadSuspense<TData = Awaited<ReturnType<typeof getOverlayUpload>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOverlayUploadPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverlayUploadSuspense<TData = Awaited<ReturnType<typeof getOverlayUpload>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOverlayUploadPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverlayUploadSuspense<TData = Awaited<ReturnType<typeof getOverlayUpload>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOverlayUploadPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a CSV upload's status
 */

export function useGetOverlayUploadSuspense<TData = Awaited<ReturnType<typeof getOverlayUpload>>, TError = ErrorType<HumaAPIError>>(
 { entity, uploadId }: GetOverlayUploadPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverlayUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOverlayUploadSuspenseQueryOptions({ entity, uploadId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getCustomColumnResponse200 = {
  data: CustomColumnBody
  status: 200
}

export type getCustomColumnResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getCustomColumnResponseSuccess = (getCustomColumnResponse200) & {
  headers: Headers;
};
export type getCustomColumnResponseError = (getCustomColumnResponseDefault) & {
  headers: Headers;
};

export type getCustomColumnResponse = getCustomColumnResponseSuccess

export const getGetCustomColumnUrl = ({ entity, name }: GetCustomColumnPathParameters,
    params?: GetCustomColumnParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns/${entity}/${name}?${stringifiedParams}` : `/auth/v1/custom-columns/${entity}/${name}`
}

/**
 * @summary Get a custom column
 */
export const getCustomColumn = async ({ entity, name }: GetCustomColumnPathParameters,
    params?: GetCustomColumnParams, options?: Parameters<typeof customFetch>[1]): Promise<getCustomColumnResponse> => {

  return customFetch<getCustomColumnResponse>(getGetCustomColumnUrl({ entity, name },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomColumnQueryKey = ({ entity, name }: GetCustomColumnPathParameters,
    params?: GetCustomColumnParams,) => {
    return [
    `/auth/v1/custom-columns/${entity}/${name}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomColumnQueryOptions = <TData = Awaited<ReturnType<typeof getCustomColumn>>, TError = ErrorType<HumaAPIError>>({ entity, name }: GetCustomColumnPathParameters,
    params?: GetCustomColumnParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomColumnQueryKey({ entity, name },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomColumn>>> = ({ signal }) => getCustomColumn({ entity, name },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: entity !== null && entity !== undefined && name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomColumnQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomColumn>>>
export type GetCustomColumnQueryError = ErrorType<HumaAPIError>


export function useGetCustomColumn<TData = Awaited<ReturnType<typeof getCustomColumn>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnPathParameters,
    params: undefined |  GetCustomColumnParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomColumn>>,
          TError,
          Awaited<ReturnType<typeof getCustomColumn>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomColumn<TData = Awaited<ReturnType<typeof getCustomColumn>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnPathParameters,
    params?: GetCustomColumnParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomColumn>>,
          TError,
          Awaited<ReturnType<typeof getCustomColumn>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomColumn<TData = Awaited<ReturnType<typeof getCustomColumn>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnPathParameters,
    params?: GetCustomColumnParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a custom column
 */

export function useGetCustomColumn<TData = Awaited<ReturnType<typeof getCustomColumn>>, TError = ErrorType<HumaAPIError>>(
 { entity, name }: GetCustomColumnPathParameters,
    params?: GetCustomColumnParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomColumnQueryOptions({ entity, name },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCustomColumnSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCustomColumn>>, TError = ErrorType<HumaAPIError>>({ entity, name }: GetCustomColumnPathParameters,
    params?: GetCustomColumnParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomColumnQueryKey({ entity, name },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomColumn>>> = ({ signal }) => getCustomColumn({ entity, name },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomColumnSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomColumn>>>
export type GetCustomColumnSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetCustomColumnSuspense<TData = Awaited<ReturnType<typeof getCustomColumn>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnPathParameters,
    params: undefined |  GetCustomColumnParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomColumnSuspense<TData = Awaited<ReturnType<typeof getCustomColumn>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnPathParameters,
    params?: GetCustomColumnParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomColumnSuspense<TData = Awaited<ReturnType<typeof getCustomColumn>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnPathParameters,
    params?: GetCustomColumnParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a custom column
 */

export function useGetCustomColumnSuspense<TData = Awaited<ReturnType<typeof getCustomColumn>>, TError = ErrorType<HumaAPIError>>(
 { entity, name }: GetCustomColumnPathParameters,
    params?: GetCustomColumnParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumn>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomColumnSuspenseQueryOptions({ entity, name },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type patchCustomColumnResponse200 = {
  data: CustomColumnBody
  status: 200
}

export type patchCustomColumnResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchCustomColumnResponseSuccess = (patchCustomColumnResponse200) & {
  headers: Headers;
};
export type patchCustomColumnResponseError = (patchCustomColumnResponseDefault) & {
  headers: Headers;
};

export type patchCustomColumnResponse = patchCustomColumnResponseSuccess

export const getPatchCustomColumnUrl = ({ entity, name }: PatchCustomColumnPathParameters,
    params?: PatchCustomColumnParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns/${entity}/${name}?${stringifiedParams}` : `/auth/v1/custom-columns/${entity}/${name}`
}

/**
 * Replaces the column's mutable attributes (nullable, label, description, config). The name and type are immutable.
 * @summary Edit a custom column
 */
export const patchCustomColumn = async ({ entity, name }: PatchCustomColumnPathParameters,
    editCustomColumnBody: EditCustomColumnBody,
    params?: PatchCustomColumnParams, options?: Parameters<typeof customFetch>[1]): Promise<patchCustomColumnResponse> => {

  return customFetch<patchCustomColumnResponse>(getPatchCustomColumnUrl({ entity, name },params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(editCustomColumnBody)
  }
);}





export const getPatchCustomColumnMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCustomColumn>>, TError,{pathParams: PatchCustomColumnPathParameters;data: EditCustomColumnBody;params?: PatchCustomColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCustomColumn>>, TError,{pathParams: PatchCustomColumnPathParameters;data: EditCustomColumnBody;params?: PatchCustomColumnParams}, TContext> => {

const mutationKey = ['patchCustomColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCustomColumn>>, {pathParams: PatchCustomColumnPathParameters;data: EditCustomColumnBody;params?: PatchCustomColumnParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  patchCustomColumn(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchCustomColumnMutationResult = NonNullable<Awaited<ReturnType<typeof patchCustomColumn>>>
    export type PatchCustomColumnMutationBody = EditCustomColumnBody
    export type PatchCustomColumnMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Edit a custom column
 */
export const usePatchCustomColumn = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCustomColumn>>, TError,{pathParams: PatchCustomColumnPathParameters;data: EditCustomColumnBody;params?: PatchCustomColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCustomColumn>>,
        TError,
        {pathParams: PatchCustomColumnPathParameters;data: EditCustomColumnBody;params?: PatchCustomColumnParams},
        TContext
      > => {
      return useMutation(getPatchCustomColumnMutationOptions(options), queryClient);
    }
    export type archiveCustomColumnResponse204 = {
  data: void
  status: 204
}

export type archiveCustomColumnResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type archiveCustomColumnResponseSuccess = (archiveCustomColumnResponse204) & {
  headers: Headers;
};
export type archiveCustomColumnResponseError = (archiveCustomColumnResponseDefault) & {
  headers: Headers;
};

export type archiveCustomColumnResponse = archiveCustomColumnResponseSuccess

export const getArchiveCustomColumnUrl = ({ entity, name }: ArchiveCustomColumnPathParameters,
    params?: ArchiveCustomColumnParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns/${entity}/${name}/archive?${stringifiedParams}` : `/auth/v1/custom-columns/${entity}/${name}/archive`
}

/**
 * Hides the column from discovery by default. It stays fully resolvable — any system that already references it keeps working. Reversible via unarchive.
 * @summary Archive (deprecate) a custom column
 */
export const archiveCustomColumn = async ({ entity, name }: ArchiveCustomColumnPathParameters,
    params?: ArchiveCustomColumnParams, options?: Parameters<typeof customFetch>[1]): Promise<archiveCustomColumnResponse> => {

  return customFetch<archiveCustomColumnResponse>(getArchiveCustomColumnUrl({ entity, name },params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveCustomColumnMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveCustomColumn>>, TError,{pathParams: ArchiveCustomColumnPathParameters;params?: ArchiveCustomColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveCustomColumn>>, TError,{pathParams: ArchiveCustomColumnPathParameters;params?: ArchiveCustomColumnParams}, TContext> => {

const mutationKey = ['archiveCustomColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveCustomColumn>>, {pathParams: ArchiveCustomColumnPathParameters;params?: ArchiveCustomColumnParams}> = (props) => {
          const {pathParams,params} = props ?? {};

          return  archiveCustomColumn(pathParams,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveCustomColumnMutationResult = NonNullable<Awaited<ReturnType<typeof archiveCustomColumn>>>

    export type ArchiveCustomColumnMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Archive (deprecate) a custom column
 */
export const useArchiveCustomColumn = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveCustomColumn>>, TError,{pathParams: ArchiveCustomColumnPathParameters;params?: ArchiveCustomColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveCustomColumn>>,
        TError,
        {pathParams: ArchiveCustomColumnPathParameters;params?: ArchiveCustomColumnParams},
        TContext
      > => {
      return useMutation(getArchiveCustomColumnMutationOptions(options), queryClient);
    }
    export type getCustomColumnUploadTemplateResponse200 = {
  data: Blob
  status: 200
}

export type getCustomColumnUploadTemplateResponse401 = {
  data: HumaAPIError
  status: 401
}

export type getCustomColumnUploadTemplateResponse404 = {
  data: HumaAPIError
  status: 404
}

export type getCustomColumnUploadTemplateResponse409 = {
  data: HumaAPIError
  status: 409
}

export type getCustomColumnUploadTemplateResponse422 = {
  data: HumaAPIError
  status: 422
}

export type getCustomColumnUploadTemplateResponse500 = {
  data: HumaAPIError
  status: 500
}

export type getCustomColumnUploadTemplateResponse503 = {
  data: HumaAPIError
  status: 503
}

export type getCustomColumnUploadTemplateResponseSuccess = (getCustomColumnUploadTemplateResponse200) & {
  headers: Headers;
};
export type getCustomColumnUploadTemplateResponseError = (getCustomColumnUploadTemplateResponse401 | getCustomColumnUploadTemplateResponse404 | getCustomColumnUploadTemplateResponse409 | getCustomColumnUploadTemplateResponse422 | getCustomColumnUploadTemplateResponse500 | getCustomColumnUploadTemplateResponse503) & {
  headers: Headers;
};

export type getCustomColumnUploadTemplateResponse = getCustomColumnUploadTemplateResponseSuccess

export const getGetCustomColumnUploadTemplateUrl = ({ entity, name }: GetCustomColumnUploadTemplatePathParameters,
    params?: GetCustomColumnUploadTemplateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns/${entity}/${name}/data/template?${stringifiedParams}` : `/auth/v1/custom-columns/${entity}/${name}/data/template`
}

/**
 * Returns a CSV whose header is the column rows are keyed by (the entity's key column, or the lookup key named by key_column) followed by this column, the exact columns the column-scoped upload accepts, and one sample row showing the value format each column takes. The sample row's key cell reads "DELETE THIS ROW BEFORE UPLOADING - sample values only": delete the row before uploading. Left in, it matches no row and is rejected, which under on_error=reject_all fails the whole upload.
 * @summary Download a CSV template for one custom column upload
 */
export const getCustomColumnUploadTemplate = async ({ entity, name }: GetCustomColumnUploadTemplatePathParameters,
    params?: GetCustomColumnUploadTemplateParams, options?: Parameters<typeof customFetch>[1]): Promise<getCustomColumnUploadTemplateResponse> => {

  return customFetch<getCustomColumnUploadTemplateResponse>(getGetCustomColumnUploadTemplateUrl({ entity, name },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomColumnUploadTemplateQueryKey = ({ entity, name }: GetCustomColumnUploadTemplatePathParameters,
    params?: GetCustomColumnUploadTemplateParams,) => {
    return [
    `/auth/v1/custom-columns/${entity}/${name}/data/template`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomColumnUploadTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError = ErrorType<HumaAPIError>>({ entity, name }: GetCustomColumnUploadTemplatePathParameters,
    params?: GetCustomColumnUploadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomColumnUploadTemplateQueryKey({ entity, name },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>> = ({ signal }) => getCustomColumnUploadTemplate({ entity, name },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: entity !== null && entity !== undefined && name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomColumnUploadTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>>
export type GetCustomColumnUploadTemplateQueryError = ErrorType<HumaAPIError>


export function useGetCustomColumnUploadTemplate<TData = Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnUploadTemplatePathParameters,
    params: undefined |  GetCustomColumnUploadTemplateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>,
          TError,
          Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomColumnUploadTemplate<TData = Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnUploadTemplatePathParameters,
    params?: GetCustomColumnUploadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>,
          TError,
          Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomColumnUploadTemplate<TData = Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnUploadTemplatePathParameters,
    params?: GetCustomColumnUploadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download a CSV template for one custom column upload
 */

export function useGetCustomColumnUploadTemplate<TData = Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError = ErrorType<HumaAPIError>>(
 { entity, name }: GetCustomColumnUploadTemplatePathParameters,
    params?: GetCustomColumnUploadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomColumnUploadTemplateQueryOptions({ entity, name },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCustomColumnUploadTemplateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError = ErrorType<HumaAPIError>>({ entity, name }: GetCustomColumnUploadTemplatePathParameters,
    params?: GetCustomColumnUploadTemplateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomColumnUploadTemplateQueryKey({ entity, name },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>> = ({ signal }) => getCustomColumnUploadTemplate({ entity, name },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomColumnUploadTemplateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>>
export type GetCustomColumnUploadTemplateSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetCustomColumnUploadTemplateSuspense<TData = Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnUploadTemplatePathParameters,
    params: undefined |  GetCustomColumnUploadTemplateParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomColumnUploadTemplateSuspense<TData = Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnUploadTemplatePathParameters,
    params?: GetCustomColumnUploadTemplateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomColumnUploadTemplateSuspense<TData = Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetCustomColumnUploadTemplatePathParameters,
    params?: GetCustomColumnUploadTemplateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download a CSV template for one custom column upload
 */

export function useGetCustomColumnUploadTemplateSuspense<TData = Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError = ErrorType<HumaAPIError>>(
 { entity, name }: GetCustomColumnUploadTemplatePathParameters,
    params?: GetCustomColumnUploadTemplateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomColumnUploadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomColumnUploadTemplateSuspenseQueryOptions({ entity, name },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createCustomColumnUploadResponse201 = {
  data: CreateUploadOutputBody
  status: 201
}

export type createCustomColumnUploadResponse400 = {
  data: HumaAPIError
  status: 400
}

export type createCustomColumnUploadResponse401 = {
  data: HumaAPIError
  status: 401
}

export type createCustomColumnUploadResponse403 = {
  data: HumaAPIError
  status: 403
}

export type createCustomColumnUploadResponse404 = {
  data: HumaAPIError
  status: 404
}

export type createCustomColumnUploadResponse409 = {
  data: HumaAPIError
  status: 409
}

export type createCustomColumnUploadResponse422 = {
  data: HumaAPIError
  status: 422
}

export type createCustomColumnUploadResponse500 = {
  data: HumaAPIError
  status: 500
}

export type createCustomColumnUploadResponse503 = {
  data: HumaAPIError
  status: 503
}

export type createCustomColumnUploadResponseSuccess = (createCustomColumnUploadResponse201) & {
  headers: Headers;
};
export type createCustomColumnUploadResponseError = (createCustomColumnUploadResponse400 | createCustomColumnUploadResponse401 | createCustomColumnUploadResponse403 | createCustomColumnUploadResponse404 | createCustomColumnUploadResponse409 | createCustomColumnUploadResponse422 | createCustomColumnUploadResponse500 | createCustomColumnUploadResponse503) & {
  headers: Headers;
};

export type createCustomColumnUploadResponse = createCustomColumnUploadResponseSuccess

export const getCreateCustomColumnUploadUrl = ({ entity, name }: CreateCustomColumnUploadPathParameters,) => {




  return `/auth/v1/custom-columns/${entity}/${name}/data/uploads`
}

/**
 * Starts a CSV upload that may carry only the column rows are keyed by (the entity's key column, or the lookup key named by key_column) and this column; a file with any other column fails as a whole before any row is read. Creates an upload and returns a presigned S3 URL. PUT the CSV to that URL sending exactly the returned headers, within the TTL; validation and application start automatically. Poll the get-upload endpoint for status. A key may appear more than once in the file: the rows are applied in submission order, each landing on top of the previous one cell by cell, exactly as if they had been uploaded one after another, and every row counts toward rows_accepted or rows_rejected. Poll the entity's get-upload endpoint for status.
 * @summary Create a CSV upload for one custom column
 */
export const createCustomColumnUpload = async ({ entity, name }: CreateCustomColumnUploadPathParameters,
    createCustomColumnUploadBody: CreateCustomColumnUploadBody, options?: Parameters<typeof customFetch>[1]): Promise<createCustomColumnUploadResponse> => {

  return customFetch<createCustomColumnUploadResponse>(getCreateCustomColumnUploadUrl({ entity, name }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCustomColumnUploadBody)
  }
);}





export const getCreateCustomColumnUploadMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomColumnUpload>>, TError,{pathParams: CreateCustomColumnUploadPathParameters;data: CreateCustomColumnUploadBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomColumnUpload>>, TError,{pathParams: CreateCustomColumnUploadPathParameters;data: CreateCustomColumnUploadBody}, TContext> => {

const mutationKey = ['createCustomColumnUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomColumnUpload>>, {pathParams: CreateCustomColumnUploadPathParameters;data: CreateCustomColumnUploadBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  createCustomColumnUpload(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomColumnUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomColumnUpload>>>
    export type CreateCustomColumnUploadMutationBody = CreateCustomColumnUploadBody
    export type CreateCustomColumnUploadMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create a CSV upload for one custom column
 */
export const useCreateCustomColumnUpload = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomColumnUpload>>, TError,{pathParams: CreateCustomColumnUploadPathParameters;data: CreateCustomColumnUploadBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCustomColumnUpload>>,
        TError,
        {pathParams: CreateCustomColumnUploadPathParameters;data: CreateCustomColumnUploadBody},
        TContext
      > => {
      return useMutation(getCreateCustomColumnUploadMutationOptions(options), queryClient);
    }
    export type unarchiveCustomColumnResponse204 = {
  data: void
  status: 204
}

export type unarchiveCustomColumnResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type unarchiveCustomColumnResponseSuccess = (unarchiveCustomColumnResponse204) & {
  headers: Headers;
};
export type unarchiveCustomColumnResponseError = (unarchiveCustomColumnResponseDefault) & {
  headers: Headers;
};

export type unarchiveCustomColumnResponse = unarchiveCustomColumnResponseSuccess

export const getUnarchiveCustomColumnUrl = ({ entity, name }: UnarchiveCustomColumnPathParameters,
    params?: UnarchiveCustomColumnParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/custom-columns/${entity}/${name}/unarchive?${stringifiedParams}` : `/auth/v1/custom-columns/${entity}/${name}/unarchive`
}

/**
 * Restores an archived column to discovery.
 * @summary Unarchive a custom column
 */
export const unarchiveCustomColumn = async ({ entity, name }: UnarchiveCustomColumnPathParameters,
    params?: UnarchiveCustomColumnParams, options?: Parameters<typeof customFetch>[1]): Promise<unarchiveCustomColumnResponse> => {

  return customFetch<unarchiveCustomColumnResponse>(getUnarchiveCustomColumnUrl({ entity, name },params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUnarchiveCustomColumnMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveCustomColumn>>, TError,{pathParams: UnarchiveCustomColumnPathParameters;params?: UnarchiveCustomColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveCustomColumn>>, TError,{pathParams: UnarchiveCustomColumnPathParameters;params?: UnarchiveCustomColumnParams}, TContext> => {

const mutationKey = ['unarchiveCustomColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveCustomColumn>>, {pathParams: UnarchiveCustomColumnPathParameters;params?: UnarchiveCustomColumnParams}> = (props) => {
          const {pathParams,params} = props ?? {};

          return  unarchiveCustomColumn(pathParams,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveCustomColumnMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveCustomColumn>>>

    export type UnarchiveCustomColumnMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Unarchive a custom column
 */
export const useUnarchiveCustomColumn = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveCustomColumn>>, TError,{pathParams: UnarchiveCustomColumnPathParameters;params?: UnarchiveCustomColumnParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unarchiveCustomColumn>>,
        TError,
        {pathParams: UnarchiveCustomColumnPathParameters;params?: UnarchiveCustomColumnParams},
        TContext
      > => {
      return useMutation(getUnarchiveCustomColumnMutationOptions(options), queryClient);
    }
    export type createExternalQuotesUploadResponse200 = {
  data: CreateExternalQuotesUploadResponseBody
  status: 200
}

export type createExternalQuotesUploadResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type createExternalQuotesUploadResponseSuccess = (createExternalQuotesUploadResponse200) & {
  headers: Headers;
};
export type createExternalQuotesUploadResponseError = (createExternalQuotesUploadResponseDefault) & {
  headers: Headers;
};

export type createExternalQuotesUploadResponse = createExternalQuotesUploadResponseSuccess

export const getCreateExternalQuotesUploadUrl = () => {




  return `/auth/v1/custom-features/external-quotes/uploads`
}

/**
 * @summary Mint a presigned S3 upload URL for an external quotes CSV (Creative Planning BBG RUNZ)
 */
export const createExternalQuotesUpload = async (createExternalQuotesUploadRequestBody: CreateExternalQuotesUploadRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createExternalQuotesUploadResponse> => {

  return customFetch<createExternalQuotesUploadResponse>(getCreateExternalQuotesUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createExternalQuotesUploadRequestBody)
  }
);}





export const getCreateExternalQuotesUploadMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExternalQuotesUpload>>, TError,{data: CreateExternalQuotesUploadRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExternalQuotesUpload>>, TError,{data: CreateExternalQuotesUploadRequestBody}, TContext> => {

const mutationKey = ['createExternalQuotesUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExternalQuotesUpload>>, {data: CreateExternalQuotesUploadRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createExternalQuotesUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExternalQuotesUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createExternalQuotesUpload>>>
    export type CreateExternalQuotesUploadMutationBody = CreateExternalQuotesUploadRequestBody
    export type CreateExternalQuotesUploadMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Mint a presigned S3 upload URL for an external quotes CSV (Creative Planning BBG RUNZ)
 */
export const useCreateExternalQuotesUpload = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExternalQuotesUpload>>, TError,{data: CreateExternalQuotesUploadRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExternalQuotesUpload>>,
        TError,
        {data: CreateExternalQuotesUploadRequestBody},
        TContext
      > => {
      return useMutation(getCreateExternalQuotesUploadMutationOptions(options), queryClient);
    }
    export type getExternalQuotesUploadStatusResponse200 = {
  data: GetExternalQuotesUploadStatusResponseBody
  status: 200
}

export type getExternalQuotesUploadStatusResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getExternalQuotesUploadStatusResponseSuccess = (getExternalQuotesUploadStatusResponse200) & {
  headers: Headers;
};
export type getExternalQuotesUploadStatusResponseError = (getExternalQuotesUploadStatusResponseDefault) & {
  headers: Headers;
};

export type getExternalQuotesUploadStatusResponse = getExternalQuotesUploadStatusResponseSuccess

export const getGetExternalQuotesUploadStatusUrl = () => {




  return `/auth/v1/custom-features/external-quotes/uploads/status`
}

/**
 * @summary Get the outcome of the latest and last successful external quotes upload (Creative Planning BBG RUNZ)
 */
export const getExternalQuotesUploadStatus = async ( options?: Parameters<typeof customFetch>[1]): Promise<getExternalQuotesUploadStatusResponse> => {

  return customFetch<getExternalQuotesUploadStatusResponse>(getGetExternalQuotesUploadStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExternalQuotesUploadStatusQueryKey = () => {
    return [
    `/auth/v1/custom-features/external-quotes/uploads/status`
    ] as const;
    }


export const getGetExternalQuotesUploadStatusQueryOptions = <TData = Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExternalQuotesUploadStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>> = ({ signal }) => getExternalQuotesUploadStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExternalQuotesUploadStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>>
export type GetExternalQuotesUploadStatusQueryError = ErrorType<HumaAPIError>


export function useGetExternalQuotesUploadStatus<TData = Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>,
          TError,
          Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalQuotesUploadStatus<TData = Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>,
          TError,
          Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalQuotesUploadStatus<TData = Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the outcome of the latest and last successful external quotes upload (Creative Planning BBG RUNZ)
 */

export function useGetExternalQuotesUploadStatus<TData = Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExternalQuotesUploadStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetExternalQuotesUploadStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExternalQuotesUploadStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>> = ({ signal }) => getExternalQuotesUploadStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExternalQuotesUploadStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>>
export type GetExternalQuotesUploadStatusSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetExternalQuotesUploadStatusSuspense<TData = Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalQuotesUploadStatusSuspense<TData = Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalQuotesUploadStatusSuspense<TData = Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the outcome of the latest and last successful external quotes upload (Creative Planning BBG RUNZ)
 */

export function useGetExternalQuotesUploadStatusSuspense<TData = Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalQuotesUploadStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExternalQuotesUploadStatusSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createInvestmentSolutionsSyncUploadsResponse200 = {
  data: CreateSyncUploadsResponseBody
  status: 200
}

export type createInvestmentSolutionsSyncUploadsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type createInvestmentSolutionsSyncUploadsResponseSuccess = (createInvestmentSolutionsSyncUploadsResponse200) & {
  headers: Headers;
};
export type createInvestmentSolutionsSyncUploadsResponseError = (createInvestmentSolutionsSyncUploadsResponseDefault) & {
  headers: Headers;
};

export type createInvestmentSolutionsSyncUploadsResponse = createInvestmentSolutionsSyncUploadsResponseSuccess

export const getCreateInvestmentSolutionsSyncUploadsUrl = () => {




  return `/auth/v1/custom-features/investment-solutions/sync-uploads`
}

/**
 * @summary Mint presigned S3 upload URLs for the investment-solutions account + compliance sync
 */
export const createInvestmentSolutionsSyncUploads = async ( options?: Parameters<typeof customFetch>[1]): Promise<createInvestmentSolutionsSyncUploadsResponse> => {

  return customFetch<createInvestmentSolutionsSyncUploadsResponse>(getCreateInvestmentSolutionsSyncUploadsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateInvestmentSolutionsSyncUploadsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvestmentSolutionsSyncUploads>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvestmentSolutionsSyncUploads>>, TError,void, TContext> => {

const mutationKey = ['createInvestmentSolutionsSyncUploads'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvestmentSolutionsSyncUploads>>, void> = () => {


          return  createInvestmentSolutionsSyncUploads(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInvestmentSolutionsSyncUploadsMutationResult = NonNullable<Awaited<ReturnType<typeof createInvestmentSolutionsSyncUploads>>>

    export type CreateInvestmentSolutionsSyncUploadsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Mint presigned S3 upload URLs for the investment-solutions account + compliance sync
 */
export const useCreateInvestmentSolutionsSyncUploads = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvestmentSolutionsSyncUploads>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInvestmentSolutionsSyncUploads>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateInvestmentSolutionsSyncUploadsMutationOptions(options), queryClient);
    }
    export type getMarketPricesBatchResponse200 = {
  data: GetMarketPricesResponseBody
  status: 200
}

export type getMarketPricesBatchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getMarketPricesBatchResponseSuccess = (getMarketPricesBatchResponse200) & {
  headers: Headers;
};
export type getMarketPricesBatchResponseError = (getMarketPricesBatchResponseDefault) & {
  headers: Headers;
};

export type getMarketPricesBatchResponse = getMarketPricesBatchResponseSuccess

export const getGetMarketPricesBatchUrl = () => {




  return `/auth/v1/data/market-prices`
}

/**
 * Returns the latest best bid, best ask, and last trade price for a list of instruments as published by the market data feed. Equities and ETFs carry full bid/ask/last; mutual funds present in the feed are returned with their latest price and null bid/ask. Identifiers must be ISINs. Prices are raw market data with no fees applied, and are delayed by approximately 15 minutes. Identifiers with no market data are returned with an error and null prices rather than failing the whole request.
 * @summary Get market prices for multiple instruments
 */
export const getMarketPricesBatch = async (getMarketPricesRequestBody: GetMarketPricesRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<getMarketPricesBatchResponse> => {

  return customFetch<getMarketPricesBatchResponse>(getGetMarketPricesBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getMarketPricesRequestBody)
  }
);}





export const getGetMarketPricesBatchMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMarketPricesBatch>>, TError,{data: GetMarketPricesRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getMarketPricesBatch>>, TError,{data: GetMarketPricesRequestBody}, TContext> => {

const mutationKey = ['getMarketPricesBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getMarketPricesBatch>>, {data: GetMarketPricesRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  getMarketPricesBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetMarketPricesBatchMutationResult = NonNullable<Awaited<ReturnType<typeof getMarketPricesBatch>>>
    export type GetMarketPricesBatchMutationBody = GetMarketPricesRequestBody
    export type GetMarketPricesBatchMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Get market prices for multiple instruments
 */
export const useGetMarketPricesBatch = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMarketPricesBatch>>, TError,{data: GetMarketPricesRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getMarketPricesBatch>>,
        TError,
        {data: GetMarketPricesRequestBody},
        TContext
      > => {
      return useMutation(getGetMarketPricesBatchMutationOptions(options), queryClient);
    }
    export type getNbboResponse200 = {
  data: GetNBBOResponseBody
  status: 200
}

export type getNbboResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getNbboResponseSuccess = (getNbboResponse200) & {
  headers: Headers;
};
export type getNbboResponseError = (getNbboResponseDefault) & {
  headers: Headers;
};

export type getNbboResponse = getNbboResponseSuccess

export const getGetNbboUrl = ({ id }: GetNbboPathParameters,) => {




  return `/auth/v1/data/nbbo/${id}`
}

/**
 * Returns the latest best bid, best ask, and last trade price for an equity or ETF instrument as published by the market data feed. Prices are raw market data with no fees applied, and are delayed by approximately 15 minutes.
 * @summary Get NBBO and last price
 */
export const getNbbo = async ({ id }: GetNbboPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getNbboResponse> => {

  return customFetch<getNbboResponse>(getGetNbboUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNbboQueryKey = ({ id }: GetNbboPathParameters,) => {
    return [
    `/auth/v1/data/nbbo/${id}`
    ] as const;
    }


export const getGetNbboQueryOptions = <TData = Awaited<ReturnType<typeof getNbbo>>, TError = ErrorType<HumaAPIError>>({ id }: GetNbboPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNbboQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNbbo>>> = ({ signal }) => getNbbo({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNbboQueryResult = NonNullable<Awaited<ReturnType<typeof getNbbo>>>
export type GetNbboQueryError = ErrorType<HumaAPIError>


export function useGetNbbo<TData = Awaited<ReturnType<typeof getNbbo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNbboPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNbbo>>,
          TError,
          Awaited<ReturnType<typeof getNbbo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNbbo<TData = Awaited<ReturnType<typeof getNbbo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNbboPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNbbo>>,
          TError,
          Awaited<ReturnType<typeof getNbbo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNbbo<TData = Awaited<ReturnType<typeof getNbbo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNbboPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get NBBO and last price
 */

export function useGetNbbo<TData = Awaited<ReturnType<typeof getNbbo>>, TError = ErrorType<HumaAPIError>>(
 { id }: GetNbboPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNbboQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNbboSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNbbo>>, TError = ErrorType<HumaAPIError>>({ id }: GetNbboPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNbboQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNbbo>>> = ({ signal }) => getNbbo({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNbboSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNbbo>>>
export type GetNbboSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetNbboSuspense<TData = Awaited<ReturnType<typeof getNbbo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNbboPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNbboSuspense<TData = Awaited<ReturnType<typeof getNbbo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNbboPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNbboSuspense<TData = Awaited<ReturnType<typeof getNbbo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNbboPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get NBBO and last price
 */

export function useGetNbboSuspense<TData = Awaited<ReturnType<typeof getNbbo>>, TError = ErrorType<HumaAPIError>>(
 { id }: GetNbboPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNbbo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNbboSuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getEducationContentPlaybackUrlResponse200 = {
  data: PlaybackURLResponseBody
  status: 200
}

export type getEducationContentPlaybackUrlResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getEducationContentPlaybackUrlResponseSuccess = (getEducationContentPlaybackUrlResponse200) & {
  headers: Headers;
};
export type getEducationContentPlaybackUrlResponseError = (getEducationContentPlaybackUrlResponseDefault) & {
  headers: Headers;
};

export type getEducationContentPlaybackUrlResponse = getEducationContentPlaybackUrlResponseSuccess

export const getGetEducationContentPlaybackUrlUrl = ({ contentItemId }: GetEducationContentPlaybackUrlPathParameters,) => {




  return `/auth/v1/education/content/${contentItemId}/playback-url`
}

/**
 * Only a ready content object is served. The URL stops working at expires_at, including mid-seek.
 * @summary Mint a signed CloudFront URL for an education video or document
 */
export const getEducationContentPlaybackUrl = async ({ contentItemId }: GetEducationContentPlaybackUrlPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getEducationContentPlaybackUrlResponse> => {

  return customFetch<getEducationContentPlaybackUrlResponse>(getGetEducationContentPlaybackUrlUrl({ contentItemId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEducationContentPlaybackUrlQueryKey = ({ contentItemId }: GetEducationContentPlaybackUrlPathParameters,) => {
    return [
    `/auth/v1/education/content/${contentItemId}/playback-url`
    ] as const;
    }


export const getGetEducationContentPlaybackUrlQueryOptions = <TData = Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError = ErrorType<HumaAPIError>>({ contentItemId }: GetEducationContentPlaybackUrlPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEducationContentPlaybackUrlQueryKey({ contentItemId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>> = ({ signal }) => getEducationContentPlaybackUrl({ contentItemId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: contentItemId !== null && contentItemId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEducationContentPlaybackUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>>
export type GetEducationContentPlaybackUrlQueryError = ErrorType<HumaAPIError>


export function useGetEducationContentPlaybackUrl<TData = Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationContentPlaybackUrlPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>,
          TError,
          Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationContentPlaybackUrl<TData = Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationContentPlaybackUrlPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>,
          TError,
          Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationContentPlaybackUrl<TData = Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationContentPlaybackUrlPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mint a signed CloudFront URL for an education video or document
 */

export function useGetEducationContentPlaybackUrl<TData = Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError = ErrorType<HumaAPIError>>(
 { contentItemId }: GetEducationContentPlaybackUrlPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEducationContentPlaybackUrlQueryOptions({ contentItemId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEducationContentPlaybackUrlSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError = ErrorType<HumaAPIError>>({ contentItemId }: GetEducationContentPlaybackUrlPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEducationContentPlaybackUrlQueryKey({ contentItemId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>> = ({ signal }) => getEducationContentPlaybackUrl({ contentItemId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEducationContentPlaybackUrlSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>>
export type GetEducationContentPlaybackUrlSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetEducationContentPlaybackUrlSuspense<TData = Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationContentPlaybackUrlPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationContentPlaybackUrlSuspense<TData = Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationContentPlaybackUrlPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationContentPlaybackUrlSuspense<TData = Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationContentPlaybackUrlPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mint a signed CloudFront URL for an education video or document
 */

export function useGetEducationContentPlaybackUrlSuspense<TData = Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError = ErrorType<HumaAPIError>>(
 { contentItemId }: GetEducationContentPlaybackUrlPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationContentPlaybackUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEducationContentPlaybackUrlSuspenseQueryOptions({ contentItemId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getEducationCourseBySlugResponse200 = {
  data: CourseTree
  status: 200
}

export type getEducationCourseBySlugResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getEducationCourseBySlugResponseSuccess = (getEducationCourseBySlugResponse200) & {
  headers: Headers;
};
export type getEducationCourseBySlugResponseError = (getEducationCourseBySlugResponseDefault) & {
  headers: Headers;
};

export type getEducationCourseBySlugResponse = getEducationCourseBySlugResponseSuccess

export const getGetEducationCourseBySlugUrl = ({ slug }: GetEducationCourseBySlugPathParameters,) => {




  return `/auth/v1/education/course/slug/${slug}`
}

/**
 * @summary Get a course with its modules and lessons by slug
 */
export const getEducationCourseBySlug = async ({ slug }: GetEducationCourseBySlugPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getEducationCourseBySlugResponse> => {

  return customFetch<getEducationCourseBySlugResponse>(getGetEducationCourseBySlugUrl({ slug }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEducationCourseBySlugQueryKey = ({ slug }: GetEducationCourseBySlugPathParameters,) => {
    return [
    `/auth/v1/education/course/slug/${slug}`
    ] as const;
    }


export const getGetEducationCourseBySlugQueryOptions = <TData = Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError = ErrorType<HumaAPIError>>({ slug }: GetEducationCourseBySlugPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEducationCourseBySlugQueryKey({ slug });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEducationCourseBySlug>>> = ({ signal }) => getEducationCourseBySlug({ slug }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEducationCourseBySlugQueryResult = NonNullable<Awaited<ReturnType<typeof getEducationCourseBySlug>>>
export type GetEducationCourseBySlugQueryError = ErrorType<HumaAPIError>


export function useGetEducationCourseBySlug<TData = Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseBySlugPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEducationCourseBySlug>>,
          TError,
          Awaited<ReturnType<typeof getEducationCourseBySlug>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourseBySlug<TData = Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseBySlugPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEducationCourseBySlug>>,
          TError,
          Awaited<ReturnType<typeof getEducationCourseBySlug>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourseBySlug<TData = Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseBySlugPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a course with its modules and lessons by slug
 */

export function useGetEducationCourseBySlug<TData = Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError = ErrorType<HumaAPIError>>(
 { slug }: GetEducationCourseBySlugPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEducationCourseBySlugQueryOptions({ slug },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEducationCourseBySlugSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError = ErrorType<HumaAPIError>>({ slug }: GetEducationCourseBySlugPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEducationCourseBySlugQueryKey({ slug });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEducationCourseBySlug>>> = ({ signal }) => getEducationCourseBySlug({ slug }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEducationCourseBySlugSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEducationCourseBySlug>>>
export type GetEducationCourseBySlugSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetEducationCourseBySlugSuspense<TData = Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseBySlugPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourseBySlugSuspense<TData = Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseBySlugPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourseBySlugSuspense<TData = Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseBySlugPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a course with its modules and lessons by slug
 */

export function useGetEducationCourseBySlugSuspense<TData = Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError = ErrorType<HumaAPIError>>(
 { slug }: GetEducationCourseBySlugPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseBySlug>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEducationCourseBySlugSuspenseQueryOptions({ slug },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getEducationCourseResponse200 = {
  data: CourseTree
  status: 200
}

export type getEducationCourseResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getEducationCourseResponseSuccess = (getEducationCourseResponse200) & {
  headers: Headers;
};
export type getEducationCourseResponseError = (getEducationCourseResponseDefault) & {
  headers: Headers;
};

export type getEducationCourseResponse = getEducationCourseResponseSuccess

export const getGetEducationCourseUrl = ({ courseId }: GetEducationCoursePathParameters,) => {




  return `/auth/v1/education/course/${courseId}`
}

/**
 * @summary Get a published course with its modules and lessons
 */
export const getEducationCourse = async ({ courseId }: GetEducationCoursePathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getEducationCourseResponse> => {

  return customFetch<getEducationCourseResponse>(getGetEducationCourseUrl({ courseId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEducationCourseQueryKey = ({ courseId }: GetEducationCoursePathParameters,) => {
    return [
    `/auth/v1/education/course/${courseId}`
    ] as const;
    }


export const getGetEducationCourseQueryOptions = <TData = Awaited<ReturnType<typeof getEducationCourse>>, TError = ErrorType<HumaAPIError>>({ courseId }: GetEducationCoursePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEducationCourseQueryKey({ courseId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEducationCourse>>> = ({ signal }) => getEducationCourse({ courseId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: courseId !== null && courseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEducationCourseQueryResult = NonNullable<Awaited<ReturnType<typeof getEducationCourse>>>
export type GetEducationCourseQueryError = ErrorType<HumaAPIError>


export function useGetEducationCourse<TData = Awaited<ReturnType<typeof getEducationCourse>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCoursePathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEducationCourse>>,
          TError,
          Awaited<ReturnType<typeof getEducationCourse>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourse<TData = Awaited<ReturnType<typeof getEducationCourse>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCoursePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEducationCourse>>,
          TError,
          Awaited<ReturnType<typeof getEducationCourse>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourse<TData = Awaited<ReturnType<typeof getEducationCourse>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCoursePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a published course with its modules and lessons
 */

export function useGetEducationCourse<TData = Awaited<ReturnType<typeof getEducationCourse>>, TError = ErrorType<HumaAPIError>>(
 { courseId }: GetEducationCoursePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEducationCourseQueryOptions({ courseId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEducationCourseSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getEducationCourse>>, TError = ErrorType<HumaAPIError>>({ courseId }: GetEducationCoursePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEducationCourseQueryKey({ courseId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEducationCourse>>> = ({ signal }) => getEducationCourse({ courseId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEducationCourseSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEducationCourse>>>
export type GetEducationCourseSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetEducationCourseSuspense<TData = Awaited<ReturnType<typeof getEducationCourse>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCoursePathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourseSuspense<TData = Awaited<ReturnType<typeof getEducationCourse>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCoursePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourseSuspense<TData = Awaited<ReturnType<typeof getEducationCourse>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCoursePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a published course with its modules and lessons
 */

export function useGetEducationCourseSuspense<TData = Awaited<ReturnType<typeof getEducationCourse>>, TError = ErrorType<HumaAPIError>>(
 { courseId }: GetEducationCoursePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourse>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEducationCourseSuspenseQueryOptions({ courseId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getEducationCourseCompletionsResponse200 = {
  data: CourseCompletions
  status: 200
}

export type getEducationCourseCompletionsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getEducationCourseCompletionsResponseSuccess = (getEducationCourseCompletionsResponse200) & {
  headers: Headers;
};
export type getEducationCourseCompletionsResponseError = (getEducationCourseCompletionsResponseDefault) & {
  headers: Headers;
};

export type getEducationCourseCompletionsResponse = getEducationCourseCompletionsResponseSuccess

export const getGetEducationCourseCompletionsUrl = ({ courseId }: GetEducationCourseCompletionsPathParameters,) => {




  return `/auth/v1/education/course/${courseId}/completions`
}

/**
 * Reads the primary database, so a lesson completed a moment ago is already listed. Use it for the learner's own progress rather than the replicated LessonCompletion SORM entity, which lags writes.
 * @summary List the calling learner's lesson completions in a course
 */
export const getEducationCourseCompletions = async ({ courseId }: GetEducationCourseCompletionsPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getEducationCourseCompletionsResponse> => {

  return customFetch<getEducationCourseCompletionsResponse>(getGetEducationCourseCompletionsUrl({ courseId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEducationCourseCompletionsQueryKey = ({ courseId }: GetEducationCourseCompletionsPathParameters,) => {
    return [
    `/auth/v1/education/course/${courseId}/completions`
    ] as const;
    }


export const getGetEducationCourseCompletionsQueryOptions = <TData = Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError = ErrorType<HumaAPIError>>({ courseId }: GetEducationCourseCompletionsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEducationCourseCompletionsQueryKey({ courseId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEducationCourseCompletions>>> = ({ signal }) => getEducationCourseCompletions({ courseId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: courseId !== null && courseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEducationCourseCompletionsQueryResult = NonNullable<Awaited<ReturnType<typeof getEducationCourseCompletions>>>
export type GetEducationCourseCompletionsQueryError = ErrorType<HumaAPIError>


export function useGetEducationCourseCompletions<TData = Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseCompletionsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEducationCourseCompletions>>,
          TError,
          Awaited<ReturnType<typeof getEducationCourseCompletions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourseCompletions<TData = Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseCompletionsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEducationCourseCompletions>>,
          TError,
          Awaited<ReturnType<typeof getEducationCourseCompletions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourseCompletions<TData = Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseCompletionsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the calling learner's lesson completions in a course
 */

export function useGetEducationCourseCompletions<TData = Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError = ErrorType<HumaAPIError>>(
 { courseId }: GetEducationCourseCompletionsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEducationCourseCompletionsQueryOptions({ courseId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEducationCourseCompletionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError = ErrorType<HumaAPIError>>({ courseId }: GetEducationCourseCompletionsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEducationCourseCompletionsQueryKey({ courseId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEducationCourseCompletions>>> = ({ signal }) => getEducationCourseCompletions({ courseId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEducationCourseCompletionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEducationCourseCompletions>>>
export type GetEducationCourseCompletionsSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetEducationCourseCompletionsSuspense<TData = Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseCompletionsPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourseCompletionsSuspense<TData = Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseCompletionsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationCourseCompletionsSuspense<TData = Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationCourseCompletionsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the calling learner's lesson completions in a course
 */

export function useGetEducationCourseCompletionsSuspense<TData = Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError = ErrorType<HumaAPIError>>(
 { courseId }: GetEducationCourseCompletionsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationCourseCompletions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEducationCourseCompletionsSuspenseQueryOptions({ courseId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getEducationLessonResponse200 = {
  data: LessonDetail
  status: 200
}

export type getEducationLessonResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getEducationLessonResponseSuccess = (getEducationLessonResponse200) & {
  headers: Headers;
};
export type getEducationLessonResponseError = (getEducationLessonResponseDefault) & {
  headers: Headers;
};

export type getEducationLessonResponse = getEducationLessonResponseSuccess

export const getGetEducationLessonUrl = ({ lessonId }: GetEducationLessonPathParameters,) => {




  return `/auth/v1/education/lesson/${lessonId}`
}

/**
 * Content items are fetched per lesson rather than embedded in the course tree, which stays lean.
 * @summary Get a lesson with the content it plays
 */
export const getEducationLesson = async ({ lessonId }: GetEducationLessonPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getEducationLessonResponse> => {

  return customFetch<getEducationLessonResponse>(getGetEducationLessonUrl({ lessonId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEducationLessonQueryKey = ({ lessonId }: GetEducationLessonPathParameters,) => {
    return [
    `/auth/v1/education/lesson/${lessonId}`
    ] as const;
    }


export const getGetEducationLessonQueryOptions = <TData = Awaited<ReturnType<typeof getEducationLesson>>, TError = ErrorType<HumaAPIError>>({ lessonId }: GetEducationLessonPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEducationLessonQueryKey({ lessonId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEducationLesson>>> = ({ signal }) => getEducationLesson({ lessonId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: lessonId !== null && lessonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEducationLessonQueryResult = NonNullable<Awaited<ReturnType<typeof getEducationLesson>>>
export type GetEducationLessonQueryError = ErrorType<HumaAPIError>


export function useGetEducationLesson<TData = Awaited<ReturnType<typeof getEducationLesson>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationLessonPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEducationLesson>>,
          TError,
          Awaited<ReturnType<typeof getEducationLesson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationLesson<TData = Awaited<ReturnType<typeof getEducationLesson>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationLessonPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEducationLesson>>,
          TError,
          Awaited<ReturnType<typeof getEducationLesson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationLesson<TData = Awaited<ReturnType<typeof getEducationLesson>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationLessonPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a lesson with the content it plays
 */

export function useGetEducationLesson<TData = Awaited<ReturnType<typeof getEducationLesson>>, TError = ErrorType<HumaAPIError>>(
 { lessonId }: GetEducationLessonPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEducationLessonQueryOptions({ lessonId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEducationLessonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getEducationLesson>>, TError = ErrorType<HumaAPIError>>({ lessonId }: GetEducationLessonPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEducationLessonQueryKey({ lessonId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEducationLesson>>> = ({ signal }) => getEducationLesson({ lessonId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEducationLessonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEducationLesson>>>
export type GetEducationLessonSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetEducationLessonSuspense<TData = Awaited<ReturnType<typeof getEducationLesson>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationLessonPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationLessonSuspense<TData = Awaited<ReturnType<typeof getEducationLesson>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationLessonPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEducationLessonSuspense<TData = Awaited<ReturnType<typeof getEducationLesson>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEducationLessonPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a lesson with the content it plays
 */

export function useGetEducationLessonSuspense<TData = Awaited<ReturnType<typeof getEducationLesson>>, TError = ErrorType<HumaAPIError>>(
 { lessonId }: GetEducationLessonPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEducationLesson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEducationLessonSuspenseQueryOptions({ lessonId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type postEducationLessonCompleteResponse200 = {
  data: LessonCompletion
  status: 200
}

export type postEducationLessonCompleteResponse400 = {
  data: HumaAPIError
  status: 400
}

export type postEducationLessonCompleteResponse404 = {
  data: HumaAPIError
  status: 404
}

export type postEducationLessonCompleteResponse409 = {
  data: HumaAPIError
  status: 409
}

export type postEducationLessonCompleteResponse422 = {
  data: HumaAPIError
  status: 422
}

export type postEducationLessonCompleteResponse500 = {
  data: HumaAPIError
  status: 500
}

export type postEducationLessonCompleteResponseSuccess = (postEducationLessonCompleteResponse200) & {
  headers: Headers;
};
export type postEducationLessonCompleteResponseError = (postEducationLessonCompleteResponse400 | postEducationLessonCompleteResponse404 | postEducationLessonCompleteResponse409 | postEducationLessonCompleteResponse422 | postEducationLessonCompleteResponse500) & {
  headers: Headers;
};

export type postEducationLessonCompleteResponse = postEducationLessonCompleteResponseSuccess

export const getPostEducationLessonCompleteUrl = ({ lessonId }: PostEducationLessonCompletePathParameters,) => {




  return `/auth/v1/education/lesson/${lessonId}/complete`
}

/**
 * Idempotent: completing an already-complete lesson returns the original completion instant rather than moving it, so a double-clicked button is harmless. 409 means the lesson is a quiz lesson, which is completed by passing its quiz and not by asserting it here.
 * @summary Mark a lesson complete for the calling learner
 */
export const postEducationLessonComplete = async ({ lessonId }: PostEducationLessonCompletePathParameters,
    lessonCompletionInput?: LessonCompletionInput, options?: Parameters<typeof customFetch>[1]): Promise<postEducationLessonCompleteResponse> => {

  return customFetch<postEducationLessonCompleteResponse>(getPostEducationLessonCompleteUrl({ lessonId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lessonCompletionInput)
  }
);}





export const getPostEducationLessonCompleteMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEducationLessonComplete>>, TError,{pathParams: PostEducationLessonCompletePathParameters;data?: LessonCompletionInput}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEducationLessonComplete>>, TError,{pathParams: PostEducationLessonCompletePathParameters;data?: LessonCompletionInput}, TContext> => {

const mutationKey = ['postEducationLessonComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEducationLessonComplete>>, {pathParams: PostEducationLessonCompletePathParameters;data?: LessonCompletionInput}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  postEducationLessonComplete(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostEducationLessonCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof postEducationLessonComplete>>>
    export type PostEducationLessonCompleteMutationBody = LessonCompletionInput | undefined
    export type PostEducationLessonCompleteMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Mark a lesson complete for the calling learner
 */
export const usePostEducationLessonComplete = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEducationLessonComplete>>, TError,{pathParams: PostEducationLessonCompletePathParameters;data?: LessonCompletionInput}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEducationLessonComplete>>,
        TError,
        {pathParams: PostEducationLessonCompletePathParameters;data?: LessonCompletionInput},
        TContext
      > => {
      return useMutation(getPostEducationLessonCompleteMutationOptions(options), queryClient);
    }
    export type postEducationQuizAttemptResponse201 = {
  data: QuizAttempt
  status: 201
}

export type postEducationQuizAttemptResponse400 = {
  data: HumaAPIError
  status: 400
}

export type postEducationQuizAttemptResponse403 = {
  data: HumaAPIError
  status: 403
}

export type postEducationQuizAttemptResponse404 = {
  data: HumaAPIError
  status: 404
}

export type postEducationQuizAttemptResponse409 = {
  data: HumaAPIError
  status: 409
}

export type postEducationQuizAttemptResponse422 = {
  data: HumaAPIError
  status: 422
}

export type postEducationQuizAttemptResponse500 = {
  data: HumaAPIError
  status: 500
}

export type postEducationQuizAttemptResponseSuccess = (postEducationQuizAttemptResponse201) & {
  headers: Headers;
};
export type postEducationQuizAttemptResponseError = (postEducationQuizAttemptResponse400 | postEducationQuizAttemptResponse403 | postEducationQuizAttemptResponse404 | postEducationQuizAttemptResponse409 | postEducationQuizAttemptResponse422 | postEducationQuizAttemptResponse500) & {
  headers: Headers;
};

export type postEducationQuizAttemptResponse = postEducationQuizAttemptResponseSuccess

export const getPostEducationQuizAttemptUrl = ({ lessonId }: PostEducationQuizAttemptPathParameters,) => {




  return `/auth/v1/education/lesson/${lessonId}/quiz/attempts`
}

/**
 * Answers every question in one shot. The response is the only payload carrying the answer key, so it is what the post-submit review renders. 403 means no attempts are left, and is the only refusal a caller cannot fix by refetching the lesson.
 * @summary Submit answers to a lesson's quiz and have them graded
 */
export const postEducationQuizAttempt = async ({ lessonId }: PostEducationQuizAttemptPathParameters,
    quizAttemptInput: QuizAttemptInput, options?: Parameters<typeof customFetch>[1]): Promise<postEducationQuizAttemptResponse> => {

  return customFetch<postEducationQuizAttemptResponse>(getPostEducationQuizAttemptUrl({ lessonId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(quizAttemptInput)
  }
);}





export const getPostEducationQuizAttemptMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEducationQuizAttempt>>, TError,{pathParams: PostEducationQuizAttemptPathParameters;data: QuizAttemptInput}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEducationQuizAttempt>>, TError,{pathParams: PostEducationQuizAttemptPathParameters;data: QuizAttemptInput}, TContext> => {

const mutationKey = ['postEducationQuizAttempt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEducationQuizAttempt>>, {pathParams: PostEducationQuizAttemptPathParameters;data: QuizAttemptInput}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  postEducationQuizAttempt(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostEducationQuizAttemptMutationResult = NonNullable<Awaited<ReturnType<typeof postEducationQuizAttempt>>>
    export type PostEducationQuizAttemptMutationBody = QuizAttemptInput
    export type PostEducationQuizAttemptMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Submit answers to a lesson's quiz and have them graded
 */
export const usePostEducationQuizAttempt = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEducationQuizAttempt>>, TError,{pathParams: PostEducationQuizAttemptPathParameters;data: QuizAttemptInput}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEducationQuizAttempt>>,
        TError,
        {pathParams: PostEducationQuizAttemptPathParameters;data: QuizAttemptInput},
        TContext
      > => {
      return useMutation(getPostEducationQuizAttemptMutationOptions(options), queryClient);
    }
    export type platformListGrantsResponse200 = {
  data: ListObjectGroupGrantsResponseBody
  status: 200
}

export type platformListGrantsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformListGrantsResponseSuccess = (platformListGrantsResponse200) & {
  headers: Headers;
};
export type platformListGrantsResponseError = (platformListGrantsResponseDefault) & {
  headers: Headers;
};

export type platformListGrantsResponse = platformListGrantsResponseSuccess

export const getPlatformListGrantsUrl = (params: PlatformListGrantsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/group-management/grants?${stringifiedParams}` : `/auth/v1/group-management/grants`
}

/**
 * @summary List the view grants an organization issued on one target
 */
export const platformListGrants = async (params: PlatformListGrantsParams, options?: Parameters<typeof customFetch>[1]): Promise<platformListGrantsResponse> => {

  return customFetch<platformListGrantsResponse>(getPlatformListGrantsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListGrantsQueryKey = (params?: PlatformListGrantsParams,) => {
    return [
    `/auth/v1/group-management/grants`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListGrantsQueryOptions = <TData = Awaited<ReturnType<typeof platformListGrants>>, TError = ErrorType<HumaAPIError>>(params: PlatformListGrantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListGrantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListGrants>>> = ({ signal }) => platformListGrants(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListGrants>>>
export type PlatformListGrantsQueryError = ErrorType<HumaAPIError>


export function usePlatformListGrants<TData = Awaited<ReturnType<typeof platformListGrants>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListGrantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListGrants>>,
          TError,
          Awaited<ReturnType<typeof platformListGrants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListGrants<TData = Awaited<ReturnType<typeof platformListGrants>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListGrantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListGrants>>,
          TError,
          Awaited<ReturnType<typeof platformListGrants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListGrants<TData = Awaited<ReturnType<typeof platformListGrants>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListGrantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the view grants an organization issued on one target
 */

export function usePlatformListGrants<TData = Awaited<ReturnType<typeof platformListGrants>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListGrantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListGrantsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformListGrantsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformListGrants>>, TError = ErrorType<HumaAPIError>>(params: PlatformListGrantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListGrantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListGrants>>> = ({ signal }) => platformListGrants(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListGrantsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformListGrants>>>
export type PlatformListGrantsSuspenseQueryError = ErrorType<HumaAPIError>


export function usePlatformListGrantsSuspense<TData = Awaited<ReturnType<typeof platformListGrants>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListGrantsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListGrantsSuspense<TData = Awaited<ReturnType<typeof platformListGrants>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListGrantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListGrantsSuspense<TData = Awaited<ReturnType<typeof platformListGrants>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListGrantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the view grants an organization issued on one target
 */

export function usePlatformListGrantsSuspense<TData = Awaited<ReturnType<typeof platformListGrants>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListGrantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListGrantsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type platformUpsertGrantResponse200 = {
  data: GrantResponseBody
  status: 200
}

export type platformUpsertGrantResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformUpsertGrantResponseSuccess = (platformUpsertGrantResponse200) & {
  headers: Headers;
};
export type platformUpsertGrantResponseError = (platformUpsertGrantResponseDefault) & {
  headers: Headers;
};

export type platformUpsertGrantResponse = platformUpsertGrantResponseSuccess

export const getPlatformUpsertGrantUrl = () => {




  return `/auth/v1/group-management/grants`
}

/**
 * @summary Grant an object group, or views, to one user, organization or team
 */
export const platformUpsertGrant = async (platformUpsertGrantRequestBody: PlatformUpsertGrantRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformUpsertGrantResponse> => {

  return customFetch<platformUpsertGrantResponse>(getPlatformUpsertGrantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformUpsertGrantRequestBody)
  }
);}





export const getPlatformUpsertGrantMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpsertGrant>>, TError,{data: PlatformUpsertGrantRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpsertGrant>>, TError,{data: PlatformUpsertGrantRequestBody}, TContext> => {

const mutationKey = ['platformUpsertGrant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpsertGrant>>, {data: PlatformUpsertGrantRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  platformUpsertGrant(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpsertGrantMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpsertGrant>>>
    export type PlatformUpsertGrantMutationBody = PlatformUpsertGrantRequestBody
    export type PlatformUpsertGrantMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Grant an object group, or views, to one user, organization or team
 */
export const usePlatformUpsertGrant = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpsertGrant>>, TError,{data: PlatformUpsertGrantRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformUpsertGrant>>,
        TError,
        {data: PlatformUpsertGrantRequestBody},
        TContext
      > => {
      return useMutation(getPlatformUpsertGrantMutationOptions(options), queryClient);
    }
    export type platformDeleteGrantResponse200 = {
  data: DeleteResponseBody
  status: 200
}

export type platformDeleteGrantResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformDeleteGrantResponseSuccess = (platformDeleteGrantResponse200) & {
  headers: Headers;
};
export type platformDeleteGrantResponseError = (platformDeleteGrantResponseDefault) & {
  headers: Headers;
};

export type platformDeleteGrantResponse = platformDeleteGrantResponseSuccess

export const getPlatformDeleteGrantUrl = ({ id }: PlatformDeleteGrantPathParameters,
    params?: PlatformDeleteGrantParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/group-management/grants/${id}?${stringifiedParams}` : `/auth/v1/group-management/grants/${id}`
}

/**
 * @summary Revoke a grant by id; a grant a sync source created is refused with 409
 */
export const platformDeleteGrant = async ({ id }: PlatformDeleteGrantPathParameters,
    params?: PlatformDeleteGrantParams, options?: Parameters<typeof customFetch>[1]): Promise<platformDeleteGrantResponse> => {

  return customFetch<platformDeleteGrantResponse>(getPlatformDeleteGrantUrl({ id },params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPlatformDeleteGrantMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteGrant>>, TError,{pathParams: PlatformDeleteGrantPathParameters;params?: PlatformDeleteGrantParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteGrant>>, TError,{pathParams: PlatformDeleteGrantPathParameters;params?: PlatformDeleteGrantParams}, TContext> => {

const mutationKey = ['platformDeleteGrant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteGrant>>, {pathParams: PlatformDeleteGrantPathParameters;params?: PlatformDeleteGrantParams}> = (props) => {
          const {pathParams,params} = props ?? {};

          return  platformDeleteGrant(pathParams,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteGrantMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteGrant>>>

    export type PlatformDeleteGrantMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Revoke a grant by id; a grant a sync source created is refused with 409
 */
export const usePlatformDeleteGrant = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteGrant>>, TError,{pathParams: PlatformDeleteGrantPathParameters;params?: PlatformDeleteGrantParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteGrant>>,
        TError,
        {pathParams: PlatformDeleteGrantPathParameters;params?: PlatformDeleteGrantParams},
        TContext
      > => {
      return useMutation(getPlatformDeleteGrantMutationOptions(options), queryClient);
    }
    export type platformCreateObjectGroupResponse200 = {
  data: ObjectGroupBody
  status: 200
}

export type platformCreateObjectGroupResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformCreateObjectGroupResponseSuccess = (platformCreateObjectGroupResponse200) & {
  headers: Headers;
};
export type platformCreateObjectGroupResponseError = (platformCreateObjectGroupResponseDefault) & {
  headers: Headers;
};

export type platformCreateObjectGroupResponse = platformCreateObjectGroupResponseSuccess

export const getPlatformCreateObjectGroupUrl = () => {




  return `/auth/v1/group-management/object-groups`
}

/**
 * @summary Create an object group of a type operators manage
 */
export const platformCreateObjectGroup = async (platformCreateObjectGroupRequestBody: PlatformCreateObjectGroupRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformCreateObjectGroupResponse> => {

  return customFetch<platformCreateObjectGroupResponse>(getPlatformCreateObjectGroupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformCreateObjectGroupRequestBody)
  }
);}





export const getPlatformCreateObjectGroupMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateObjectGroup>>, TError,{data: PlatformCreateObjectGroupRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateObjectGroup>>, TError,{data: PlatformCreateObjectGroupRequestBody}, TContext> => {

const mutationKey = ['platformCreateObjectGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateObjectGroup>>, {data: PlatformCreateObjectGroupRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  platformCreateObjectGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateObjectGroupMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateObjectGroup>>>
    export type PlatformCreateObjectGroupMutationBody = PlatformCreateObjectGroupRequestBody
    export type PlatformCreateObjectGroupMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create an object group of a type operators manage
 */
export const usePlatformCreateObjectGroup = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateObjectGroup>>, TError,{data: PlatformCreateObjectGroupRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateObjectGroup>>,
        TError,
        {data: PlatformCreateObjectGroupRequestBody},
        TContext
      > => {
      return useMutation(getPlatformCreateObjectGroupMutationOptions(options), queryClient);
    }
    export type platformDeleteObjectGroupResponse200 = {
  data: DeleteResponseBody
  status: 200
}

export type platformDeleteObjectGroupResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformDeleteObjectGroupResponseSuccess = (platformDeleteObjectGroupResponse200) & {
  headers: Headers;
};
export type platformDeleteObjectGroupResponseError = (platformDeleteObjectGroupResponseDefault) & {
  headers: Headers;
};

export type platformDeleteObjectGroupResponse = platformDeleteObjectGroupResponseSuccess

export const getPlatformDeleteObjectGroupUrl = ({ id }: PlatformDeleteObjectGroupPathParameters,) => {




  return `/auth/v1/group-management/object-groups/${id}`
}

/**
 * @summary Delete an object group
 */
export const platformDeleteObjectGroup = async ({ id }: PlatformDeleteObjectGroupPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<platformDeleteObjectGroupResponse> => {

  return customFetch<platformDeleteObjectGroupResponse>(getPlatformDeleteObjectGroupUrl({ id }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPlatformDeleteObjectGroupMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteObjectGroup>>, TError,{pathParams: PlatformDeleteObjectGroupPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteObjectGroup>>, TError,{pathParams: PlatformDeleteObjectGroupPathParameters}, TContext> => {

const mutationKey = ['platformDeleteObjectGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteObjectGroup>>, {pathParams: PlatformDeleteObjectGroupPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  platformDeleteObjectGroup(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteObjectGroupMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteObjectGroup>>>

    export type PlatformDeleteObjectGroupMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Delete an object group
 */
export const usePlatformDeleteObjectGroup = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteObjectGroup>>, TError,{pathParams: PlatformDeleteObjectGroupPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteObjectGroup>>,
        TError,
        {pathParams: PlatformDeleteObjectGroupPathParameters},
        TContext
      > => {
      return useMutation(getPlatformDeleteObjectGroupMutationOptions(options), queryClient);
    }
    export type platformGetObjectGroupResponse200 = {
  data: PlatformObjectGroupBody
  status: 200
}

export type platformGetObjectGroupResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformGetObjectGroupResponseSuccess = (platformGetObjectGroupResponse200) & {
  headers: Headers;
};
export type platformGetObjectGroupResponseError = (platformGetObjectGroupResponseDefault) & {
  headers: Headers;
};

export type platformGetObjectGroupResponse = platformGetObjectGroupResponseSuccess

export const getPlatformGetObjectGroupUrl = ({ id }: PlatformGetObjectGroupPathParameters,) => {




  return `/auth/v1/group-management/object-groups/${id}`
}

/**
 * @summary Get an object group with the caller's capabilities on it
 */
export const platformGetObjectGroup = async ({ id }: PlatformGetObjectGroupPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<platformGetObjectGroupResponse> => {

  return customFetch<platformGetObjectGroupResponse>(getPlatformGetObjectGroupUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetObjectGroupQueryKey = ({ id }: PlatformGetObjectGroupPathParameters,) => {
    return [
    `/auth/v1/group-management/object-groups/${id}`
    ] as const;
    }


export const getPlatformGetObjectGroupQueryOptions = <TData = Awaited<ReturnType<typeof platformGetObjectGroup>>, TError = ErrorType<HumaAPIError>>({ id }: PlatformGetObjectGroupPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetObjectGroupQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetObjectGroup>>> = ({ signal }) => platformGetObjectGroup({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformGetObjectGroupQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetObjectGroup>>>
export type PlatformGetObjectGroupQueryError = ErrorType<HumaAPIError>


export function usePlatformGetObjectGroup<TData = Awaited<ReturnType<typeof platformGetObjectGroup>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetObjectGroupPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetObjectGroup>>,
          TError,
          Awaited<ReturnType<typeof platformGetObjectGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetObjectGroup<TData = Awaited<ReturnType<typeof platformGetObjectGroup>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetObjectGroupPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetObjectGroup>>,
          TError,
          Awaited<ReturnType<typeof platformGetObjectGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetObjectGroup<TData = Awaited<ReturnType<typeof platformGetObjectGroup>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetObjectGroupPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an object group with the caller's capabilities on it
 */

export function usePlatformGetObjectGroup<TData = Awaited<ReturnType<typeof platformGetObjectGroup>>, TError = ErrorType<HumaAPIError>>(
 { id }: PlatformGetObjectGroupPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformGetObjectGroupQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformGetObjectGroupSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformGetObjectGroup>>, TError = ErrorType<HumaAPIError>>({ id }: PlatformGetObjectGroupPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetObjectGroupQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetObjectGroup>>> = ({ signal }) => platformGetObjectGroup({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformGetObjectGroupSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetObjectGroup>>>
export type PlatformGetObjectGroupSuspenseQueryError = ErrorType<HumaAPIError>


export function usePlatformGetObjectGroupSuspense<TData = Awaited<ReturnType<typeof platformGetObjectGroup>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetObjectGroupPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetObjectGroupSuspense<TData = Awaited<ReturnType<typeof platformGetObjectGroup>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetObjectGroupPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetObjectGroupSuspense<TData = Awaited<ReturnType<typeof platformGetObjectGroup>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetObjectGroupPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an object group with the caller's capabilities on it
 */

export function usePlatformGetObjectGroupSuspense<TData = Awaited<ReturnType<typeof platformGetObjectGroup>>, TError = ErrorType<HumaAPIError>>(
 { id }: PlatformGetObjectGroupPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetObjectGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformGetObjectGroupSuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type platformRenameObjectGroupResponse200 = {
  data: ObjectGroupBody
  status: 200
}

export type platformRenameObjectGroupResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformRenameObjectGroupResponseSuccess = (platformRenameObjectGroupResponse200) & {
  headers: Headers;
};
export type platformRenameObjectGroupResponseError = (platformRenameObjectGroupResponseDefault) & {
  headers: Headers;
};

export type platformRenameObjectGroupResponse = platformRenameObjectGroupResponseSuccess

export const getPlatformRenameObjectGroupUrl = ({ id }: PlatformRenameObjectGroupPathParameters,) => {




  return `/auth/v1/group-management/object-groups/${id}`
}

/**
 * @summary Rename an object group
 */
export const platformRenameObjectGroup = async ({ id }: PlatformRenameObjectGroupPathParameters,
    platformRenameObjectGroupRequestBody: PlatformRenameObjectGroupRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformRenameObjectGroupResponse> => {

  return customFetch<platformRenameObjectGroupResponse>(getPlatformRenameObjectGroupUrl({ id }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformRenameObjectGroupRequestBody)
  }
);}





export const getPlatformRenameObjectGroupMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRenameObjectGroup>>, TError,{pathParams: PlatformRenameObjectGroupPathParameters;data: PlatformRenameObjectGroupRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformRenameObjectGroup>>, TError,{pathParams: PlatformRenameObjectGroupPathParameters;data: PlatformRenameObjectGroupRequestBody}, TContext> => {

const mutationKey = ['platformRenameObjectGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformRenameObjectGroup>>, {pathParams: PlatformRenameObjectGroupPathParameters;data: PlatformRenameObjectGroupRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  platformRenameObjectGroup(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformRenameObjectGroupMutationResult = NonNullable<Awaited<ReturnType<typeof platformRenameObjectGroup>>>
    export type PlatformRenameObjectGroupMutationBody = PlatformRenameObjectGroupRequestBody
    export type PlatformRenameObjectGroupMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Rename an object group
 */
export const usePlatformRenameObjectGroup = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRenameObjectGroup>>, TError,{pathParams: PlatformRenameObjectGroupPathParameters;data: PlatformRenameObjectGroupRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformRenameObjectGroup>>,
        TError,
        {pathParams: PlatformRenameObjectGroupPathParameters;data: PlatformRenameObjectGroupRequestBody},
        TContext
      > => {
      return useMutation(getPlatformRenameObjectGroupMutationOptions(options), queryClient);
    }
    export type platformListObjectGroupGrantsResponse200 = {
  data: ListObjectGroupGrantsResponseBody
  status: 200
}

export type platformListObjectGroupGrantsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformListObjectGroupGrantsResponseSuccess = (platformListObjectGroupGrantsResponse200) & {
  headers: Headers;
};
export type platformListObjectGroupGrantsResponseError = (platformListObjectGroupGrantsResponseDefault) & {
  headers: Headers;
};

export type platformListObjectGroupGrantsResponse = platformListObjectGroupGrantsResponseSuccess

export const getPlatformListObjectGroupGrantsUrl = ({ id }: PlatformListObjectGroupGrantsPathParameters,) => {




  return `/auth/v1/group-management/object-groups/${id}/grants`
}

/**
 * @summary List an object group's live grants
 */
export const platformListObjectGroupGrants = async ({ id }: PlatformListObjectGroupGrantsPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<platformListObjectGroupGrantsResponse> => {

  return customFetch<platformListObjectGroupGrantsResponse>(getPlatformListObjectGroupGrantsUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListObjectGroupGrantsQueryKey = ({ id }: PlatformListObjectGroupGrantsPathParameters,) => {
    return [
    `/auth/v1/group-management/object-groups/${id}/grants`
    ] as const;
    }


export const getPlatformListObjectGroupGrantsQueryOptions = <TData = Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError = ErrorType<HumaAPIError>>({ id }: PlatformListObjectGroupGrantsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListObjectGroupGrantsQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListObjectGroupGrants>>> = ({ signal }) => platformListObjectGroupGrants({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListObjectGroupGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListObjectGroupGrants>>>
export type PlatformListObjectGroupGrantsQueryError = ErrorType<HumaAPIError>


export function usePlatformListObjectGroupGrants<TData = Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListObjectGroupGrantsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListObjectGroupGrants>>,
          TError,
          Awaited<ReturnType<typeof platformListObjectGroupGrants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListObjectGroupGrants<TData = Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListObjectGroupGrantsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListObjectGroupGrants>>,
          TError,
          Awaited<ReturnType<typeof platformListObjectGroupGrants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListObjectGroupGrants<TData = Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListObjectGroupGrantsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List an object group's live grants
 */

export function usePlatformListObjectGroupGrants<TData = Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError = ErrorType<HumaAPIError>>(
 { id }: PlatformListObjectGroupGrantsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListObjectGroupGrantsQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformListObjectGroupGrantsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError = ErrorType<HumaAPIError>>({ id }: PlatformListObjectGroupGrantsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListObjectGroupGrantsQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListObjectGroupGrants>>> = ({ signal }) => platformListObjectGroupGrants({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListObjectGroupGrantsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformListObjectGroupGrants>>>
export type PlatformListObjectGroupGrantsSuspenseQueryError = ErrorType<HumaAPIError>


export function usePlatformListObjectGroupGrantsSuspense<TData = Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListObjectGroupGrantsPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListObjectGroupGrantsSuspense<TData = Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListObjectGroupGrantsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListObjectGroupGrantsSuspense<TData = Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListObjectGroupGrantsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List an object group's live grants
 */

export function usePlatformListObjectGroupGrantsSuspense<TData = Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError = ErrorType<HumaAPIError>>(
 { id }: PlatformListObjectGroupGrantsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectGroupGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListObjectGroupGrantsSuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type platformAddObjectGroupMembersResponse200 = {
  data: ObjectMembersResponseBody
  status: 200
}

export type platformAddObjectGroupMembersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformAddObjectGroupMembersResponseSuccess = (platformAddObjectGroupMembersResponse200) & {
  headers: Headers;
};
export type platformAddObjectGroupMembersResponseError = (platformAddObjectGroupMembersResponseDefault) & {
  headers: Headers;
};

export type platformAddObjectGroupMembersResponse = platformAddObjectGroupMembersResponseSuccess

export const getPlatformAddObjectGroupMembersUrl = ({ id }: PlatformAddObjectGroupMembersPathParameters,) => {




  return `/auth/v1/group-management/object-groups/${id}/members/add`
}

/**
 * @summary Add objects to an object group
 */
export const platformAddObjectGroupMembers = async ({ id }: PlatformAddObjectGroupMembersPathParameters,
    platformObjectMembersRequestBody: PlatformObjectMembersRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformAddObjectGroupMembersResponse> => {

  return customFetch<platformAddObjectGroupMembersResponse>(getPlatformAddObjectGroupMembersUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformObjectMembersRequestBody)
  }
);}





export const getPlatformAddObjectGroupMembersMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAddObjectGroupMembers>>, TError,{pathParams: PlatformAddObjectGroupMembersPathParameters;data: PlatformObjectMembersRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAddObjectGroupMembers>>, TError,{pathParams: PlatformAddObjectGroupMembersPathParameters;data: PlatformObjectMembersRequestBody}, TContext> => {

const mutationKey = ['platformAddObjectGroupMembers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAddObjectGroupMembers>>, {pathParams: PlatformAddObjectGroupMembersPathParameters;data: PlatformObjectMembersRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  platformAddObjectGroupMembers(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAddObjectGroupMembersMutationResult = NonNullable<Awaited<ReturnType<typeof platformAddObjectGroupMembers>>>
    export type PlatformAddObjectGroupMembersMutationBody = PlatformObjectMembersRequestBody
    export type PlatformAddObjectGroupMembersMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Add objects to an object group
 */
export const usePlatformAddObjectGroupMembers = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAddObjectGroupMembers>>, TError,{pathParams: PlatformAddObjectGroupMembersPathParameters;data: PlatformObjectMembersRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformAddObjectGroupMembers>>,
        TError,
        {pathParams: PlatformAddObjectGroupMembersPathParameters;data: PlatformObjectMembersRequestBody},
        TContext
      > => {
      return useMutation(getPlatformAddObjectGroupMembersMutationOptions(options), queryClient);
    }
    export type platformRemoveObjectGroupMembersResponse200 = {
  data: ObjectMembersResponseBody
  status: 200
}

export type platformRemoveObjectGroupMembersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformRemoveObjectGroupMembersResponseSuccess = (platformRemoveObjectGroupMembersResponse200) & {
  headers: Headers;
};
export type platformRemoveObjectGroupMembersResponseError = (platformRemoveObjectGroupMembersResponseDefault) & {
  headers: Headers;
};

export type platformRemoveObjectGroupMembersResponse = platformRemoveObjectGroupMembersResponseSuccess

export const getPlatformRemoveObjectGroupMembersUrl = ({ id }: PlatformRemoveObjectGroupMembersPathParameters,) => {




  return `/auth/v1/group-management/object-groups/${id}/members/remove`
}

/**
 * @summary Remove objects from an object group
 */
export const platformRemoveObjectGroupMembers = async ({ id }: PlatformRemoveObjectGroupMembersPathParameters,
    platformObjectMembersRequestBody: PlatformObjectMembersRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformRemoveObjectGroupMembersResponse> => {

  return customFetch<platformRemoveObjectGroupMembersResponse>(getPlatformRemoveObjectGroupMembersUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformObjectMembersRequestBody)
  }
);}





export const getPlatformRemoveObjectGroupMembersMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemoveObjectGroupMembers>>, TError,{pathParams: PlatformRemoveObjectGroupMembersPathParameters;data: PlatformObjectMembersRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformRemoveObjectGroupMembers>>, TError,{pathParams: PlatformRemoveObjectGroupMembersPathParameters;data: PlatformObjectMembersRequestBody}, TContext> => {

const mutationKey = ['platformRemoveObjectGroupMembers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformRemoveObjectGroupMembers>>, {pathParams: PlatformRemoveObjectGroupMembersPathParameters;data: PlatformObjectMembersRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  platformRemoveObjectGroupMembers(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformRemoveObjectGroupMembersMutationResult = NonNullable<Awaited<ReturnType<typeof platformRemoveObjectGroupMembers>>>
    export type PlatformRemoveObjectGroupMembersMutationBody = PlatformObjectMembersRequestBody
    export type PlatformRemoveObjectGroupMembersMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Remove objects from an object group
 */
export const usePlatformRemoveObjectGroupMembers = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemoveObjectGroupMembers>>, TError,{pathParams: PlatformRemoveObjectGroupMembersPathParameters;data: PlatformObjectMembersRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformRemoveObjectGroupMembers>>,
        TError,
        {pathParams: PlatformRemoveObjectGroupMembersPathParameters;data: PlatformObjectMembersRequestBody},
        TContext
      > => {
      return useMutation(getPlatformRemoveObjectGroupMembersMutationOptions(options), queryClient);
    }
    export type platformListObjectTypesResponse200 = {
  data: ListObjectTypesResponseBody
  status: 200
}

export type platformListObjectTypesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformListObjectTypesResponseSuccess = (platformListObjectTypesResponse200) & {
  headers: Headers;
};
export type platformListObjectTypesResponseError = (platformListObjectTypesResponseDefault) & {
  headers: Headers;
};

export type platformListObjectTypesResponse = platformListObjectTypesResponseSuccess

export const getPlatformListObjectTypesUrl = () => {




  return `/auth/v1/group-management/object-types`
}

/**
 * @summary List the grantable object types, who creates their groups and the grants they take
 */
export const platformListObjectTypes = async ( options?: Parameters<typeof customFetch>[1]): Promise<platformListObjectTypesResponse> => {

  return customFetch<platformListObjectTypesResponse>(getPlatformListObjectTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListObjectTypesQueryKey = () => {
    return [
    `/auth/v1/group-management/object-types`
    ] as const;
    }


export const getPlatformListObjectTypesQueryOptions = <TData = Awaited<ReturnType<typeof platformListObjectTypes>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListObjectTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListObjectTypes>>> = ({ signal }) => platformListObjectTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListObjectTypesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListObjectTypes>>>
export type PlatformListObjectTypesQueryError = ErrorType<HumaAPIError>


export function usePlatformListObjectTypes<TData = Awaited<ReturnType<typeof platformListObjectTypes>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListObjectTypes>>,
          TError,
          Awaited<ReturnType<typeof platformListObjectTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListObjectTypes<TData = Awaited<ReturnType<typeof platformListObjectTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListObjectTypes>>,
          TError,
          Awaited<ReturnType<typeof platformListObjectTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListObjectTypes<TData = Awaited<ReturnType<typeof platformListObjectTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the grantable object types, who creates their groups and the grants they take
 */

export function usePlatformListObjectTypes<TData = Awaited<ReturnType<typeof platformListObjectTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListObjectTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformListObjectTypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformListObjectTypes>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListObjectTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListObjectTypes>>> = ({ signal }) => platformListObjectTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListObjectTypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformListObjectTypes>>>
export type PlatformListObjectTypesSuspenseQueryError = ErrorType<HumaAPIError>


export function usePlatformListObjectTypesSuspense<TData = Awaited<ReturnType<typeof platformListObjectTypes>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListObjectTypesSuspense<TData = Awaited<ReturnType<typeof platformListObjectTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListObjectTypesSuspense<TData = Awaited<ReturnType<typeof platformListObjectTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the grantable object types, who creates their groups and the grants they take
 */

export function usePlatformListObjectTypesSuspense<TData = Awaited<ReturnType<typeof platformListObjectTypes>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListObjectTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListObjectTypesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type platformListActionSetsResponse200 = {
  data: ListActionSetsResponseBody
  status: 200
}

export type platformListActionSetsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformListActionSetsResponseSuccess = (platformListActionSetsResponse200) & {
  headers: Headers;
};
export type platformListActionSetsResponseError = (platformListActionSetsResponseDefault) & {
  headers: Headers;
};

export type platformListActionSetsResponse = platformListActionSetsResponseSuccess

export const getPlatformListActionSetsUrl = ({ objectType }: PlatformListActionSetsPathParameters,) => {




  return `/auth/v1/group-management/object-types/${objectType}/action-sets`
}

/**
 * @summary List the action sets a grant on an object type may carry
 */
export const platformListActionSets = async ({ objectType }: PlatformListActionSetsPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<platformListActionSetsResponse> => {

  return customFetch<platformListActionSetsResponse>(getPlatformListActionSetsUrl({ objectType }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListActionSetsQueryKey = ({ objectType }: PlatformListActionSetsPathParameters,) => {
    return [
    `/auth/v1/group-management/object-types/${objectType}/action-sets`
    ] as const;
    }


export const getPlatformListActionSetsQueryOptions = <TData = Awaited<ReturnType<typeof platformListActionSets>>, TError = ErrorType<HumaAPIError>>({ objectType }: PlatformListActionSetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListActionSetsQueryKey({ objectType });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListActionSets>>> = ({ signal }) => platformListActionSets({ objectType }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: objectType !== null && objectType !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListActionSetsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListActionSets>>>
export type PlatformListActionSetsQueryError = ErrorType<HumaAPIError>


export function usePlatformListActionSets<TData = Awaited<ReturnType<typeof platformListActionSets>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListActionSetsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListActionSets>>,
          TError,
          Awaited<ReturnType<typeof platformListActionSets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListActionSets<TData = Awaited<ReturnType<typeof platformListActionSets>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListActionSetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListActionSets>>,
          TError,
          Awaited<ReturnType<typeof platformListActionSets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListActionSets<TData = Awaited<ReturnType<typeof platformListActionSets>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListActionSetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the action sets a grant on an object type may carry
 */

export function usePlatformListActionSets<TData = Awaited<ReturnType<typeof platformListActionSets>>, TError = ErrorType<HumaAPIError>>(
 { objectType }: PlatformListActionSetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListActionSetsQueryOptions({ objectType },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformListActionSetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformListActionSets>>, TError = ErrorType<HumaAPIError>>({ objectType }: PlatformListActionSetsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListActionSetsQueryKey({ objectType });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListActionSets>>> = ({ signal }) => platformListActionSets({ objectType }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListActionSetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformListActionSets>>>
export type PlatformListActionSetsSuspenseQueryError = ErrorType<HumaAPIError>


export function usePlatformListActionSetsSuspense<TData = Awaited<ReturnType<typeof platformListActionSets>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListActionSetsPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListActionSetsSuspense<TData = Awaited<ReturnType<typeof platformListActionSets>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListActionSetsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListActionSetsSuspense<TData = Awaited<ReturnType<typeof platformListActionSets>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListActionSetsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the action sets a grant on an object type may carry
 */

export function usePlatformListActionSetsSuspense<TData = Awaited<ReturnType<typeof platformListActionSets>>, TError = ErrorType<HumaAPIError>>(
 { objectType }: PlatformListActionSetsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListActionSets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListActionSetsSuspenseQueryOptions({ objectType },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type platformUnshareResponse200 = {
  data: UnshareResponseBody
  status: 200
}

export type platformUnshareResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformUnshareResponseSuccess = (platformUnshareResponse200) & {
  headers: Headers;
};
export type platformUnshareResponseError = (platformUnshareResponseDefault) & {
  headers: Headers;
};

export type platformUnshareResponse = platformUnshareResponseSuccess

export const getPlatformUnshareUrl = () => {




  return `/auth/v1/group-management/shares`
}

/**
 * @summary Remove one user's or team's share of a model or filter list
 */
export const platformUnshare = async (platformShareTarget: PlatformShareTarget, options?: Parameters<typeof customFetch>[1]): Promise<platformUnshareResponse> => {

  return customFetch<platformUnshareResponse>(getPlatformUnshareUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformShareTarget)
  }
);}





export const getPlatformUnshareMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUnshare>>, TError,{data: PlatformShareTarget}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUnshare>>, TError,{data: PlatformShareTarget}, TContext> => {

const mutationKey = ['platformUnshare'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUnshare>>, {data: PlatformShareTarget}> = (props) => {
          const {data} = props ?? {};

          return  platformUnshare(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUnshareMutationResult = NonNullable<Awaited<ReturnType<typeof platformUnshare>>>
    export type PlatformUnshareMutationBody = PlatformShareTarget
    export type PlatformUnshareMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Remove one user's or team's share of a model or filter list
 */
export const usePlatformUnshare = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUnshare>>, TError,{data: PlatformShareTarget}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformUnshare>>,
        TError,
        {data: PlatformShareTarget},
        TContext
      > => {
      return useMutation(getPlatformUnshareMutationOptions(options), queryClient);
    }
    export type platformListSharesResponse200 = {
  data: ListSharesResponseBody
  status: 200
}

export type platformListSharesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformListSharesResponseSuccess = (platformListSharesResponse200) & {
  headers: Headers;
};
export type platformListSharesResponseError = (platformListSharesResponseDefault) & {
  headers: Headers;
};

export type platformListSharesResponse = platformListSharesResponseSuccess

export const getPlatformListSharesUrl = (params: PlatformListSharesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/group-management/shares?${stringifiedParams}` : `/auth/v1/group-management/shares`
}

/**
 * @summary List who one model or filter list is shared with
 */
export const platformListShares = async (params: PlatformListSharesParams, options?: Parameters<typeof customFetch>[1]): Promise<platformListSharesResponse> => {

  return customFetch<platformListSharesResponse>(getPlatformListSharesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListSharesQueryKey = (params?: PlatformListSharesParams,) => {
    return [
    `/auth/v1/group-management/shares`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListSharesQueryOptions = <TData = Awaited<ReturnType<typeof platformListShares>>, TError = ErrorType<HumaAPIError>>(params: PlatformListSharesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSharesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListShares>>> = ({ signal }) => platformListShares(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListSharesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListShares>>>
export type PlatformListSharesQueryError = ErrorType<HumaAPIError>


export function usePlatformListShares<TData = Awaited<ReturnType<typeof platformListShares>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListSharesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListShares>>,
          TError,
          Awaited<ReturnType<typeof platformListShares>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListShares<TData = Awaited<ReturnType<typeof platformListShares>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListSharesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListShares>>,
          TError,
          Awaited<ReturnType<typeof platformListShares>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListShares<TData = Awaited<ReturnType<typeof platformListShares>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListSharesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List who one model or filter list is shared with
 */

export function usePlatformListShares<TData = Awaited<ReturnType<typeof platformListShares>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListSharesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListSharesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformListSharesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformListShares>>, TError = ErrorType<HumaAPIError>>(params: PlatformListSharesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSharesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListShares>>> = ({ signal }) => platformListShares(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListSharesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformListShares>>>
export type PlatformListSharesSuspenseQueryError = ErrorType<HumaAPIError>


export function usePlatformListSharesSuspense<TData = Awaited<ReturnType<typeof platformListShares>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListSharesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListSharesSuspense<TData = Awaited<ReturnType<typeof platformListShares>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListSharesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListSharesSuspense<TData = Awaited<ReturnType<typeof platformListShares>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListSharesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List who one model or filter list is shared with
 */

export function usePlatformListSharesSuspense<TData = Awaited<ReturnType<typeof platformListShares>>, TError = ErrorType<HumaAPIError>>(
 params: PlatformListSharesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListSharesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type platformShareResponse200 = {
  data: ShareResponseBody
  status: 200
}

export type platformShareResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformShareResponseSuccess = (platformShareResponse200) & {
  headers: Headers;
};
export type platformShareResponseError = (platformShareResponseDefault) & {
  headers: Headers;
};

export type platformShareResponse = platformShareResponseSuccess

export const getPlatformShareUrl = () => {




  return `/auth/v1/group-management/shares`
}

/**
 * @summary Share one model or filter list with a user or team
 */
export const platformShare = async (platformShareRequestBody: PlatformShareRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformShareResponse> => {

  return customFetch<platformShareResponse>(getPlatformShareUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformShareRequestBody)
  }
);}





export const getPlatformShareMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformShare>>, TError,{data: PlatformShareRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformShare>>, TError,{data: PlatformShareRequestBody}, TContext> => {

const mutationKey = ['platformShare'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformShare>>, {data: PlatformShareRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  platformShare(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformShareMutationResult = NonNullable<Awaited<ReturnType<typeof platformShare>>>
    export type PlatformShareMutationBody = PlatformShareRequestBody
    export type PlatformShareMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Share one model or filter list with a user or team
 */
export const usePlatformShare = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformShare>>, TError,{data: PlatformShareRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformShare>>,
        TError,
        {data: PlatformShareRequestBody},
        TContext
      > => {
      return useMutation(getPlatformShareMutationOptions(options), queryClient);
    }
    export type platformCreateTeamResponse201 = {
  data: TeamBody
  status: 201
}

export type platformCreateTeamResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type platformCreateTeamResponseSuccess = (platformCreateTeamResponse201) & {
  headers: Headers;
};
export type platformCreateTeamResponseError = (platformCreateTeamResponseDefault) & {
  headers: Headers;
};

export type platformCreateTeamResponse = platformCreateTeamResponseSuccess

export const getPlatformCreateTeamUrl = () => {




  return `/auth/v1/group-management/team`
}

/**
 * @summary Create a team owned by the caller, in the caller's organization or one beneath it
 */
export const platformCreateTeam = async (platformCreateTeamRequestBody: PlatformCreateTeamRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformCreateTeamResponse> => {

  return customFetch<platformCreateTeamResponse>(getPlatformCreateTeamUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformCreateTeamRequestBody)
  }
);}





export const getPlatformCreateTeamMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeam>>, TError,{data: PlatformCreateTeamRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeam>>, TError,{data: PlatformCreateTeamRequestBody}, TContext> => {

const mutationKey = ['platformCreateTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateTeam>>, {data: PlatformCreateTeamRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  platformCreateTeam(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateTeam>>>
    export type PlatformCreateTeamMutationBody = PlatformCreateTeamRequestBody
    export type PlatformCreateTeamMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create a team owned by the caller, in the caller's organization or one beneath it
 */
export const usePlatformCreateTeam = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeam>>, TError,{data: PlatformCreateTeamRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateTeam>>,
        TError,
        {data: PlatformCreateTeamRequestBody},
        TContext
      > => {
      return useMutation(getPlatformCreateTeamMutationOptions(options), queryClient);
    }
    export type platformDeleteTeamResponse204 = {
  data: void
  status: 204
}

export type platformDeleteTeamResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type platformDeleteTeamResponseSuccess = (platformDeleteTeamResponse204) & {
  headers: Headers;
};
export type platformDeleteTeamResponseError = (platformDeleteTeamResponseDefault) & {
  headers: Headers;
};

export type platformDeleteTeamResponse = platformDeleteTeamResponseSuccess

export const getPlatformDeleteTeamUrl = ({ id }: PlatformDeleteTeamPathParameters,) => {




  return `/auth/v1/group-management/team/${id}`
}

/**
 * @summary Delete a team the caller manages
 */
export const platformDeleteTeam = async ({ id }: PlatformDeleteTeamPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<platformDeleteTeamResponse> => {

  return customFetch<platformDeleteTeamResponse>(getPlatformDeleteTeamUrl({ id }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPlatformDeleteTeamMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeam>>, TError,{pathParams: PlatformDeleteTeamPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeam>>, TError,{pathParams: PlatformDeleteTeamPathParameters}, TContext> => {

const mutationKey = ['platformDeleteTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteTeam>>, {pathParams: PlatformDeleteTeamPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  platformDeleteTeam(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteTeam>>>

    export type PlatformDeleteTeamMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Delete a team the caller manages
 */
export const usePlatformDeleteTeam = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeam>>, TError,{pathParams: PlatformDeleteTeamPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteTeam>>,
        TError,
        {pathParams: PlatformDeleteTeamPathParameters},
        TContext
      > => {
      return useMutation(getPlatformDeleteTeamMutationOptions(options), queryClient);
    }
    export type platformGetTeamResponse200 = {
  data: TeamBody
  status: 200
}

export type platformGetTeamResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformGetTeamResponseSuccess = (platformGetTeamResponse200) & {
  headers: Headers;
};
export type platformGetTeamResponseError = (platformGetTeamResponseDefault) & {
  headers: Headers;
};

export type platformGetTeamResponse = platformGetTeamResponseSuccess

export const getPlatformGetTeamUrl = ({ id }: PlatformGetTeamPathParameters,) => {




  return `/auth/v1/group-management/team/${id}`
}

/**
 * @summary Get a team the caller can view
 */
export const platformGetTeam = async ({ id }: PlatformGetTeamPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<platformGetTeamResponse> => {

  return customFetch<platformGetTeamResponse>(getPlatformGetTeamUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformGetTeamQueryKey = ({ id }: PlatformGetTeamPathParameters,) => {
    return [
    `/auth/v1/group-management/team/${id}`
    ] as const;
    }


export const getPlatformGetTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTeam>>, TError = ErrorType<HumaAPIError>>({ id }: PlatformGetTeamPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTeamQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTeam>>> = ({ signal }) => platformGetTeam({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformGetTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTeam>>>
export type PlatformGetTeamQueryError = ErrorType<HumaAPIError>


export function usePlatformGetTeam<TData = Awaited<ReturnType<typeof platformGetTeam>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetTeamPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetTeam>>,
          TError,
          Awaited<ReturnType<typeof platformGetTeam>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetTeam<TData = Awaited<ReturnType<typeof platformGetTeam>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetTeamPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetTeam>>,
          TError,
          Awaited<ReturnType<typeof platformGetTeam>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetTeam<TData = Awaited<ReturnType<typeof platformGetTeam>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetTeamPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a team the caller can view
 */

export function usePlatformGetTeam<TData = Awaited<ReturnType<typeof platformGetTeam>>, TError = ErrorType<HumaAPIError>>(
 { id }: PlatformGetTeamPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformGetTeamQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformGetTeamSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTeam>>, TError = ErrorType<HumaAPIError>>({ id }: PlatformGetTeamPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTeamQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTeam>>> = ({ signal }) => platformGetTeam({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformGetTeamSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTeam>>>
export type PlatformGetTeamSuspenseQueryError = ErrorType<HumaAPIError>


export function usePlatformGetTeamSuspense<TData = Awaited<ReturnType<typeof platformGetTeam>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetTeamPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetTeamSuspense<TData = Awaited<ReturnType<typeof platformGetTeam>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetTeamPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformGetTeamSuspense<TData = Awaited<ReturnType<typeof platformGetTeam>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformGetTeamPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a team the caller can view
 */

export function usePlatformGetTeamSuspense<TData = Awaited<ReturnType<typeof platformGetTeam>>, TError = ErrorType<HumaAPIError>>(
 { id }: PlatformGetTeamPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformGetTeam>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformGetTeamSuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type platformUpdateTeamResponse200 = {
  data: TeamBody
  status: 200
}

export type platformUpdateTeamResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformUpdateTeamResponseSuccess = (platformUpdateTeamResponse200) & {
  headers: Headers;
};
export type platformUpdateTeamResponseError = (platformUpdateTeamResponseDefault) & {
  headers: Headers;
};

export type platformUpdateTeamResponse = platformUpdateTeamResponseSuccess

export const getPlatformUpdateTeamUrl = ({ id }: PlatformUpdateTeamPathParameters,) => {




  return `/auth/v1/group-management/team/${id}`
}

/**
 * @summary Rename a team
 */
export const platformUpdateTeam = async ({ id }: PlatformUpdateTeamPathParameters,
    platformUpdateTeamRequestBody: PlatformUpdateTeamRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformUpdateTeamResponse> => {

  return customFetch<platformUpdateTeamResponse>(getPlatformUpdateTeamUrl({ id }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformUpdateTeamRequestBody)
  }
);}





export const getPlatformUpdateTeamMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateTeam>>, TError,{pathParams: PlatformUpdateTeamPathParameters;data: PlatformUpdateTeamRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateTeam>>, TError,{pathParams: PlatformUpdateTeamPathParameters;data: PlatformUpdateTeamRequestBody}, TContext> => {

const mutationKey = ['platformUpdateTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateTeam>>, {pathParams: PlatformUpdateTeamPathParameters;data: PlatformUpdateTeamRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  platformUpdateTeam(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateTeam>>>
    export type PlatformUpdateTeamMutationBody = PlatformUpdateTeamRequestBody
    export type PlatformUpdateTeamMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Rename a team
 */
export const usePlatformUpdateTeam = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateTeam>>, TError,{pathParams: PlatformUpdateTeamPathParameters;data: PlatformUpdateTeamRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateTeam>>,
        TError,
        {pathParams: PlatformUpdateTeamPathParameters;data: PlatformUpdateTeamRequestBody},
        TContext
      > => {
      return useMutation(getPlatformUpdateTeamMutationOptions(options), queryClient);
    }
    export type platformListTeamGrantedResponse200 = {
  data: ListTeamGrantedResponseBody
  status: 200
}

export type platformListTeamGrantedResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformListTeamGrantedResponseSuccess = (platformListTeamGrantedResponse200) & {
  headers: Headers;
};
export type platformListTeamGrantedResponseError = (platformListTeamGrantedResponseDefault) & {
  headers: Headers;
};

export type platformListTeamGrantedResponse = platformListTeamGrantedResponseSuccess

export const getPlatformListTeamGrantedUrl = ({ id }: PlatformListTeamGrantedPathParameters,) => {




  return `/auth/v1/group-management/team/${id}/granted`
}

/**
 * @summary List the grants held by a team the caller belongs to or manages
 */
export const platformListTeamGranted = async ({ id }: PlatformListTeamGrantedPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<platformListTeamGrantedResponse> => {

  return customFetch<platformListTeamGrantedResponse>(getPlatformListTeamGrantedUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListTeamGrantedQueryKey = ({ id }: PlatformListTeamGrantedPathParameters,) => {
    return [
    `/auth/v1/group-management/team/${id}/granted`
    ] as const;
    }


export const getPlatformListTeamGrantedQueryOptions = <TData = Awaited<ReturnType<typeof platformListTeamGranted>>, TError = ErrorType<HumaAPIError>>({ id }: PlatformListTeamGrantedPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTeamGrantedQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTeamGranted>>> = ({ signal }) => platformListTeamGranted({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListTeamGrantedQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTeamGranted>>>
export type PlatformListTeamGrantedQueryError = ErrorType<HumaAPIError>


export function usePlatformListTeamGranted<TData = Awaited<ReturnType<typeof platformListTeamGranted>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantedPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListTeamGranted>>,
          TError,
          Awaited<ReturnType<typeof platformListTeamGranted>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListTeamGranted<TData = Awaited<ReturnType<typeof platformListTeamGranted>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantedPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListTeamGranted>>,
          TError,
          Awaited<ReturnType<typeof platformListTeamGranted>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListTeamGranted<TData = Awaited<ReturnType<typeof platformListTeamGranted>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantedPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the grants held by a team the caller belongs to or manages
 */

export function usePlatformListTeamGranted<TData = Awaited<ReturnType<typeof platformListTeamGranted>>, TError = ErrorType<HumaAPIError>>(
 { id }: PlatformListTeamGrantedPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListTeamGrantedQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformListTeamGrantedSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformListTeamGranted>>, TError = ErrorType<HumaAPIError>>({ id }: PlatformListTeamGrantedPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTeamGrantedQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTeamGranted>>> = ({ signal }) => platformListTeamGranted({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListTeamGrantedSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTeamGranted>>>
export type PlatformListTeamGrantedSuspenseQueryError = ErrorType<HumaAPIError>


export function usePlatformListTeamGrantedSuspense<TData = Awaited<ReturnType<typeof platformListTeamGranted>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantedPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListTeamGrantedSuspense<TData = Awaited<ReturnType<typeof platformListTeamGranted>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantedPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListTeamGrantedSuspense<TData = Awaited<ReturnType<typeof platformListTeamGranted>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantedPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the grants held by a team the caller belongs to or manages
 */

export function usePlatformListTeamGrantedSuspense<TData = Awaited<ReturnType<typeof platformListTeamGranted>>, TError = ErrorType<HumaAPIError>>(
 { id }: PlatformListTeamGrantedPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGranted>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListTeamGrantedSuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type platformListTeamGrantsResponse200 = {
  data: ListTeamGrantsResponseBody
  status: 200
}

export type platformListTeamGrantsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformListTeamGrantsResponseSuccess = (platformListTeamGrantsResponse200) & {
  headers: Headers;
};
export type platformListTeamGrantsResponseError = (platformListTeamGrantsResponseDefault) & {
  headers: Headers;
};

export type platformListTeamGrantsResponse = platformListTeamGrantsResponseSuccess

export const getPlatformListTeamGrantsUrl = ({ id }: PlatformListTeamGrantsPathParameters,) => {




  return `/auth/v1/group-management/team/${id}/grants`
}

/**
 * @summary List the grants on a team the caller can view
 */
export const platformListTeamGrants = async ({ id }: PlatformListTeamGrantsPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<platformListTeamGrantsResponse> => {

  return customFetch<platformListTeamGrantsResponse>(getPlatformListTeamGrantsUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListTeamGrantsQueryKey = ({ id }: PlatformListTeamGrantsPathParameters,) => {
    return [
    `/auth/v1/group-management/team/${id}/grants`
    ] as const;
    }


export const getPlatformListTeamGrantsQueryOptions = <TData = Awaited<ReturnType<typeof platformListTeamGrants>>, TError = ErrorType<HumaAPIError>>({ id }: PlatformListTeamGrantsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTeamGrantsQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTeamGrants>>> = ({ signal }) => platformListTeamGrants({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListTeamGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTeamGrants>>>
export type PlatformListTeamGrantsQueryError = ErrorType<HumaAPIError>


export function usePlatformListTeamGrants<TData = Awaited<ReturnType<typeof platformListTeamGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListTeamGrants>>,
          TError,
          Awaited<ReturnType<typeof platformListTeamGrants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListTeamGrants<TData = Awaited<ReturnType<typeof platformListTeamGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListTeamGrants>>,
          TError,
          Awaited<ReturnType<typeof platformListTeamGrants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListTeamGrants<TData = Awaited<ReturnType<typeof platformListTeamGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the grants on a team the caller can view
 */

export function usePlatformListTeamGrants<TData = Awaited<ReturnType<typeof platformListTeamGrants>>, TError = ErrorType<HumaAPIError>>(
 { id }: PlatformListTeamGrantsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListTeamGrantsQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformListTeamGrantsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformListTeamGrants>>, TError = ErrorType<HumaAPIError>>({ id }: PlatformListTeamGrantsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTeamGrantsQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTeamGrants>>> = ({ signal }) => platformListTeamGrants({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListTeamGrantsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTeamGrants>>>
export type PlatformListTeamGrantsSuspenseQueryError = ErrorType<HumaAPIError>


export function usePlatformListTeamGrantsSuspense<TData = Awaited<ReturnType<typeof platformListTeamGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantsPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListTeamGrantsSuspense<TData = Awaited<ReturnType<typeof platformListTeamGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListTeamGrantsSuspense<TData = Awaited<ReturnType<typeof platformListTeamGrants>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListTeamGrantsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the grants on a team the caller can view
 */

export function usePlatformListTeamGrantsSuspense<TData = Awaited<ReturnType<typeof platformListTeamGrants>>, TError = ErrorType<HumaAPIError>>(
 { id }: PlatformListTeamGrantsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListTeamGrants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListTeamGrantsSuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type platformGrantTeamResponse200 = {
  data: TeamGrantResponseBody
  status: 200
}

export type platformGrantTeamResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformGrantTeamResponseSuccess = (platformGrantTeamResponse200) & {
  headers: Headers;
};
export type platformGrantTeamResponseError = (platformGrantTeamResponseDefault) & {
  headers: Headers;
};

export type platformGrantTeamResponse = platformGrantTeamResponseSuccess

export const getPlatformGrantTeamUrl = ({ id }: PlatformGrantTeamPathParameters,) => {




  return `/auth/v1/group-management/team/${id}/grants`
}

/**
 * @summary Share a team the caller manages with a user, another team, or everyone in an organization
 */
export const platformGrantTeam = async ({ id }: PlatformGrantTeamPathParameters,
    platformGrantTeamRequestBody: PlatformGrantTeamRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformGrantTeamResponse> => {

  return customFetch<platformGrantTeamResponse>(getPlatformGrantTeamUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformGrantTeamRequestBody)
  }
);}





export const getPlatformGrantTeamMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformGrantTeam>>, TError,{pathParams: PlatformGrantTeamPathParameters;data: PlatformGrantTeamRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformGrantTeam>>, TError,{pathParams: PlatformGrantTeamPathParameters;data: PlatformGrantTeamRequestBody}, TContext> => {

const mutationKey = ['platformGrantTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformGrantTeam>>, {pathParams: PlatformGrantTeamPathParameters;data: PlatformGrantTeamRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  platformGrantTeam(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformGrantTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformGrantTeam>>>
    export type PlatformGrantTeamMutationBody = PlatformGrantTeamRequestBody
    export type PlatformGrantTeamMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Share a team the caller manages with a user, another team, or everyone in an organization
 */
export const usePlatformGrantTeam = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformGrantTeam>>, TError,{pathParams: PlatformGrantTeamPathParameters;data: PlatformGrantTeamRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformGrantTeam>>,
        TError,
        {pathParams: PlatformGrantTeamPathParameters;data: PlatformGrantTeamRequestBody},
        TContext
      > => {
      return useMutation(getPlatformGrantTeamMutationOptions(options), queryClient);
    }
    export type platformRevokeTeamGrantResponse204 = {
  data: void
  status: 204
}

export type platformRevokeTeamGrantResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type platformRevokeTeamGrantResponseSuccess = (platformRevokeTeamGrantResponse204) & {
  headers: Headers;
};
export type platformRevokeTeamGrantResponseError = (platformRevokeTeamGrantResponseDefault) & {
  headers: Headers;
};

export type platformRevokeTeamGrantResponse = platformRevokeTeamGrantResponseSuccess

export const getPlatformRevokeTeamGrantUrl = ({ id, grantId }: PlatformRevokeTeamGrantPathParameters,) => {




  return `/auth/v1/group-management/team/${id}/grants/${grantId}`
}

/**
 * @summary Revoke a grant on a team the caller manages
 */
export const platformRevokeTeamGrant = async ({ id, grantId }: PlatformRevokeTeamGrantPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<platformRevokeTeamGrantResponse> => {

  return customFetch<platformRevokeTeamGrantResponse>(getPlatformRevokeTeamGrantUrl({ id, grantId }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPlatformRevokeTeamGrantMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRevokeTeamGrant>>, TError,{pathParams: PlatformRevokeTeamGrantPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformRevokeTeamGrant>>, TError,{pathParams: PlatformRevokeTeamGrantPathParameters}, TContext> => {

const mutationKey = ['platformRevokeTeamGrant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformRevokeTeamGrant>>, {pathParams: PlatformRevokeTeamGrantPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  platformRevokeTeamGrant(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformRevokeTeamGrantMutationResult = NonNullable<Awaited<ReturnType<typeof platformRevokeTeamGrant>>>

    export type PlatformRevokeTeamGrantMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Revoke a grant on a team the caller manages
 */
export const usePlatformRevokeTeamGrant = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRevokeTeamGrant>>, TError,{pathParams: PlatformRevokeTeamGrantPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformRevokeTeamGrant>>,
        TError,
        {pathParams: PlatformRevokeTeamGrantPathParameters},
        TContext
      > => {
      return useMutation(getPlatformRevokeTeamGrantMutationOptions(options), queryClient);
    }
    export type platformSetTeamMembersResponse200 = {
  data: PrincipalMembersResponseBody
  status: 200
}

export type platformSetTeamMembersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformSetTeamMembersResponseSuccess = (platformSetTeamMembersResponse200) & {
  headers: Headers;
};
export type platformSetTeamMembersResponseError = (platformSetTeamMembersResponseDefault) & {
  headers: Headers;
};

export type platformSetTeamMembersResponse = platformSetTeamMembersResponseSuccess

export const getPlatformSetTeamMembersUrl = ({ id }: PlatformSetTeamMembersPathParameters,) => {




  return `/auth/v1/group-management/team/${id}/members`
}

/**
 * @summary Replace the members of a team the caller manages
 */
export const platformSetTeamMembers = async ({ id }: PlatformSetTeamMembersPathParameters,
    platformTeamMembersRequestBody: PlatformTeamMembersRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformSetTeamMembersResponse> => {

  return customFetch<platformSetTeamMembersResponse>(getPlatformSetTeamMembersUrl({ id }),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformTeamMembersRequestBody)
  }
);}





export const getPlatformSetTeamMembersMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSetTeamMembers>>, TError,{pathParams: PlatformSetTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformSetTeamMembers>>, TError,{pathParams: PlatformSetTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}, TContext> => {

const mutationKey = ['platformSetTeamMembers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformSetTeamMembers>>, {pathParams: PlatformSetTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  platformSetTeamMembers(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformSetTeamMembersMutationResult = NonNullable<Awaited<ReturnType<typeof platformSetTeamMembers>>>
    export type PlatformSetTeamMembersMutationBody = PlatformTeamMembersRequestBody
    export type PlatformSetTeamMembersMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Replace the members of a team the caller manages
 */
export const usePlatformSetTeamMembers = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSetTeamMembers>>, TError,{pathParams: PlatformSetTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformSetTeamMembers>>,
        TError,
        {pathParams: PlatformSetTeamMembersPathParameters;data: PlatformTeamMembersRequestBody},
        TContext
      > => {
      return useMutation(getPlatformSetTeamMembersMutationOptions(options), queryClient);
    }
    export type platformAddTeamMembersResponse200 = {
  data: PrincipalMembersResponseBody
  status: 200
}

export type platformAddTeamMembersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformAddTeamMembersResponseSuccess = (platformAddTeamMembersResponse200) & {
  headers: Headers;
};
export type platformAddTeamMembersResponseError = (platformAddTeamMembersResponseDefault) & {
  headers: Headers;
};

export type platformAddTeamMembersResponse = platformAddTeamMembersResponseSuccess

export const getPlatformAddTeamMembersUrl = ({ id }: PlatformAddTeamMembersPathParameters,) => {




  return `/auth/v1/group-management/team/${id}/members/add`
}

/**
 * @summary Add users to a team the caller manages
 */
export const platformAddTeamMembers = async ({ id }: PlatformAddTeamMembersPathParameters,
    platformTeamMembersRequestBody: PlatformTeamMembersRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformAddTeamMembersResponse> => {

  return customFetch<platformAddTeamMembersResponse>(getPlatformAddTeamMembersUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformTeamMembersRequestBody)
  }
);}





export const getPlatformAddTeamMembersMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAddTeamMembers>>, TError,{pathParams: PlatformAddTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAddTeamMembers>>, TError,{pathParams: PlatformAddTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}, TContext> => {

const mutationKey = ['platformAddTeamMembers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAddTeamMembers>>, {pathParams: PlatformAddTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  platformAddTeamMembers(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformAddTeamMembersMutationResult = NonNullable<Awaited<ReturnType<typeof platformAddTeamMembers>>>
    export type PlatformAddTeamMembersMutationBody = PlatformTeamMembersRequestBody
    export type PlatformAddTeamMembersMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Add users to a team the caller manages
 */
export const usePlatformAddTeamMembers = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAddTeamMembers>>, TError,{pathParams: PlatformAddTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformAddTeamMembers>>,
        TError,
        {pathParams: PlatformAddTeamMembersPathParameters;data: PlatformTeamMembersRequestBody},
        TContext
      > => {
      return useMutation(getPlatformAddTeamMembersMutationOptions(options), queryClient);
    }
    export type platformRemoveTeamMembersResponse200 = {
  data: PrincipalMembersResponseBody
  status: 200
}

export type platformRemoveTeamMembersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformRemoveTeamMembersResponseSuccess = (platformRemoveTeamMembersResponse200) & {
  headers: Headers;
};
export type platformRemoveTeamMembersResponseError = (platformRemoveTeamMembersResponseDefault) & {
  headers: Headers;
};

export type platformRemoveTeamMembersResponse = platformRemoveTeamMembersResponseSuccess

export const getPlatformRemoveTeamMembersUrl = ({ id }: PlatformRemoveTeamMembersPathParameters,) => {




  return `/auth/v1/group-management/team/${id}/members/remove`
}

/**
 * @summary Remove users from a team the caller manages
 */
export const platformRemoveTeamMembers = async ({ id }: PlatformRemoveTeamMembersPathParameters,
    platformTeamMembersRequestBody: PlatformTeamMembersRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<platformRemoveTeamMembersResponse> => {

  return customFetch<platformRemoveTeamMembersResponse>(getPlatformRemoveTeamMembersUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformTeamMembersRequestBody)
  }
);}





export const getPlatformRemoveTeamMembersMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemoveTeamMembers>>, TError,{pathParams: PlatformRemoveTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformRemoveTeamMembers>>, TError,{pathParams: PlatformRemoveTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}, TContext> => {

const mutationKey = ['platformRemoveTeamMembers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformRemoveTeamMembers>>, {pathParams: PlatformRemoveTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  platformRemoveTeamMembers(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlatformRemoveTeamMembersMutationResult = NonNullable<Awaited<ReturnType<typeof platformRemoveTeamMembers>>>
    export type PlatformRemoveTeamMembersMutationBody = PlatformTeamMembersRequestBody
    export type PlatformRemoveTeamMembersMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Remove users from a team the caller manages
 */
export const usePlatformRemoveTeamMembers = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemoveTeamMembers>>, TError,{pathParams: PlatformRemoveTeamMembersPathParameters;data: PlatformTeamMembersRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformRemoveTeamMembers>>,
        TError,
        {pathParams: PlatformRemoveTeamMembersPathParameters;data: PlatformTeamMembersRequestBody},
        TContext
      > => {
      return useMutation(getPlatformRemoveTeamMembersMutationOptions(options), queryClient);
    }
    export type platformListUserTeamAccessResponse200 = {
  data: ListUserTeamAccessResponseBody
  status: 200
}

export type platformListUserTeamAccessResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type platformListUserTeamAccessResponseSuccess = (platformListUserTeamAccessResponse200) & {
  headers: Headers;
};
export type platformListUserTeamAccessResponseError = (platformListUserTeamAccessResponseDefault) & {
  headers: Headers;
};

export type platformListUserTeamAccessResponse = platformListUserTeamAccessResponseSuccess

export const getPlatformListUserTeamAccessUrl = ({ userId }: PlatformListUserTeamAccessPathParameters,
    params?: PlatformListUserTeamAccessParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/group-management/user/${userId}/teams?${stringifiedParams}` : `/auth/v1/group-management/user/${userId}/teams`
}

/**
 * @summary List the teams a user can view that the caller can view, with the grants that reach the user
 */
export const platformListUserTeamAccess = async ({ userId }: PlatformListUserTeamAccessPathParameters,
    params?: PlatformListUserTeamAccessParams, options?: Parameters<typeof customFetch>[1]): Promise<platformListUserTeamAccessResponse> => {

  return customFetch<platformListUserTeamAccessResponse>(getPlatformListUserTeamAccessUrl({ userId },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlatformListUserTeamAccessQueryKey = ({ userId }: PlatformListUserTeamAccessPathParameters,
    params?: PlatformListUserTeamAccessParams,) => {
    return [
    `/auth/v1/group-management/user/${userId}/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlatformListUserTeamAccessQueryOptions = <TData = Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError = ErrorType<HumaAPIError>>({ userId }: PlatformListUserTeamAccessPathParameters,
    params?: PlatformListUserTeamAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListUserTeamAccessQueryKey({ userId },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListUserTeamAccess>>> = ({ signal }) => platformListUserTeamAccess({ userId },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListUserTeamAccessQueryResult = NonNullable<Awaited<ReturnType<typeof platformListUserTeamAccess>>>
export type PlatformListUserTeamAccessQueryError = ErrorType<HumaAPIError>


export function usePlatformListUserTeamAccess<TData = Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListUserTeamAccessPathParameters,
    params: undefined |  PlatformListUserTeamAccessParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListUserTeamAccess>>,
          TError,
          Awaited<ReturnType<typeof platformListUserTeamAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListUserTeamAccess<TData = Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListUserTeamAccessPathParameters,
    params?: PlatformListUserTeamAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListUserTeamAccess>>,
          TError,
          Awaited<ReturnType<typeof platformListUserTeamAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListUserTeamAccess<TData = Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListUserTeamAccessPathParameters,
    params?: PlatformListUserTeamAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the teams a user can view that the caller can view, with the grants that reach the user
 */

export function usePlatformListUserTeamAccess<TData = Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError = ErrorType<HumaAPIError>>(
 { userId }: PlatformListUserTeamAccessPathParameters,
    params?: PlatformListUserTeamAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListUserTeamAccessQueryOptions({ userId },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlatformListUserTeamAccessSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError = ErrorType<HumaAPIError>>({ userId }: PlatformListUserTeamAccessPathParameters,
    params?: PlatformListUserTeamAccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListUserTeamAccessQueryKey({ userId },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListUserTeamAccess>>> = ({ signal }) => platformListUserTeamAccess({ userId },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformListUserTeamAccessSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof platformListUserTeamAccess>>>
export type PlatformListUserTeamAccessSuspenseQueryError = ErrorType<HumaAPIError>


export function usePlatformListUserTeamAccessSuspense<TData = Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListUserTeamAccessPathParameters,
    params: undefined |  PlatformListUserTeamAccessParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListUserTeamAccessSuspense<TData = Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListUserTeamAccessPathParameters,
    params?: PlatformListUserTeamAccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformListUserTeamAccessSuspense<TData = Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PlatformListUserTeamAccessPathParameters,
    params?: PlatformListUserTeamAccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the teams a user can view that the caller can view, with the grants that reach the user
 */

export function usePlatformListUserTeamAccessSuspense<TData = Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError = ErrorType<HumaAPIError>>(
 { userId }: PlatformListUserTeamAccessPathParameters,
    params?: PlatformListUserTeamAccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof platformListUserTeamAccess>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformListUserTeamAccessSuspenseQueryOptions({ userId },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getInstrumentDescriptionResponse200 = {
  data: DescriptionBody
  status: 200
}

export type getInstrumentDescriptionResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getInstrumentDescriptionResponseSuccess = (getInstrumentDescriptionResponse200) & {
  headers: Headers;
};
export type getInstrumentDescriptionResponseError = (getInstrumentDescriptionResponseDefault) & {
  headers: Headers;
};

export type getInstrumentDescriptionResponse = getInstrumentDescriptionResponseSuccess

export const getGetInstrumentDescriptionUrl = ({ instrumentId }: GetInstrumentDescriptionPathParameters,) => {




  return `/auth/v1/issuer/descriptions/${instrumentId}`
}

/**
 * @summary Get instrument description
 */
export const getInstrumentDescription = async ({ instrumentId }: GetInstrumentDescriptionPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getInstrumentDescriptionResponse> => {

  return customFetch<getInstrumentDescriptionResponse>(getGetInstrumentDescriptionUrl({ instrumentId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInstrumentDescriptionQueryKey = ({ instrumentId }: GetInstrumentDescriptionPathParameters,) => {
    return [
    `/auth/v1/issuer/descriptions/${instrumentId}`
    ] as const;
    }


export const getGetInstrumentDescriptionQueryOptions = <TData = Awaited<ReturnType<typeof getInstrumentDescription>>, TError = ErrorType<HumaAPIError>>({ instrumentId }: GetInstrumentDescriptionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInstrumentDescriptionQueryKey({ instrumentId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInstrumentDescription>>> = ({ signal }) => getInstrumentDescription({ instrumentId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: instrumentId !== null && instrumentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInstrumentDescriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getInstrumentDescription>>>
export type GetInstrumentDescriptionQueryError = ErrorType<HumaAPIError>


export function useGetInstrumentDescription<TData = Awaited<ReturnType<typeof getInstrumentDescription>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentDescriptionPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstrumentDescription>>,
          TError,
          Awaited<ReturnType<typeof getInstrumentDescription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentDescription<TData = Awaited<ReturnType<typeof getInstrumentDescription>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentDescriptionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstrumentDescription>>,
          TError,
          Awaited<ReturnType<typeof getInstrumentDescription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentDescription<TData = Awaited<ReturnType<typeof getInstrumentDescription>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentDescriptionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get instrument description
 */

export function useGetInstrumentDescription<TData = Awaited<ReturnType<typeof getInstrumentDescription>>, TError = ErrorType<HumaAPIError>>(
 { instrumentId }: GetInstrumentDescriptionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInstrumentDescriptionQueryOptions({ instrumentId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInstrumentDescriptionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInstrumentDescription>>, TError = ErrorType<HumaAPIError>>({ instrumentId }: GetInstrumentDescriptionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInstrumentDescriptionQueryKey({ instrumentId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInstrumentDescription>>> = ({ signal }) => getInstrumentDescription({ instrumentId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInstrumentDescriptionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInstrumentDescription>>>
export type GetInstrumentDescriptionSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetInstrumentDescriptionSuspense<TData = Awaited<ReturnType<typeof getInstrumentDescription>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentDescriptionPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentDescriptionSuspense<TData = Awaited<ReturnType<typeof getInstrumentDescription>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentDescriptionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentDescriptionSuspense<TData = Awaited<ReturnType<typeof getInstrumentDescription>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentDescriptionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get instrument description
 */

export function useGetInstrumentDescriptionSuspense<TData = Awaited<ReturnType<typeof getInstrumentDescription>>, TError = ErrorType<HumaAPIError>>(
 { instrumentId }: GetInstrumentDescriptionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentDescription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInstrumentDescriptionSuspenseQueryOptions({ instrumentId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type filterlistListListsResponse200 = {
  data: ListListsResponse
  status: 200
}

export type filterlistListListsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type filterlistListListsResponseSuccess = (filterlistListListsResponse200) & {
  headers: Headers;
};
export type filterlistListListsResponseError = (filterlistListListsResponseDefault) & {
  headers: Headers;
};

export type filterlistListListsResponse = filterlistListListsResponseSuccess

export const getFilterlistListListsUrl = () => {




  return `/auth/v1/list`
}

/**
 * @summary List active filter lists for the calling organization and the organizations it is granted on
 */
export const filterlistListLists = async ( options?: Parameters<typeof customFetch>[1]): Promise<filterlistListListsResponse> => {

  return customFetch<filterlistListListsResponse>(getFilterlistListListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFilterlistListListsQueryKey = () => {
    return [
    `/auth/v1/list`
    ] as const;
    }


export const getFilterlistListListsQueryOptions = <TData = Awaited<ReturnType<typeof filterlistListLists>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilterlistListListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filterlistListLists>>> = ({ signal }) => filterlistListLists({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilterlistListListsQueryResult = NonNullable<Awaited<ReturnType<typeof filterlistListLists>>>
export type FilterlistListListsQueryError = ErrorType<HumaAPIError>


export function useFilterlistListLists<TData = Awaited<ReturnType<typeof filterlistListLists>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filterlistListLists>>,
          TError,
          Awaited<ReturnType<typeof filterlistListLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistListLists<TData = Awaited<ReturnType<typeof filterlistListLists>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filterlistListLists>>,
          TError,
          Awaited<ReturnType<typeof filterlistListLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistListLists<TData = Awaited<ReturnType<typeof filterlistListLists>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active filter lists for the calling organization and the organizations it is granted on
 */

export function useFilterlistListLists<TData = Awaited<ReturnType<typeof filterlistListLists>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilterlistListListsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getFilterlistListListsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof filterlistListLists>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilterlistListListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filterlistListLists>>> = ({ signal }) => filterlistListLists({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilterlistListListsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof filterlistListLists>>>
export type FilterlistListListsSuspenseQueryError = ErrorType<HumaAPIError>


export function useFilterlistListListsSuspense<TData = Awaited<ReturnType<typeof filterlistListLists>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistListListsSuspense<TData = Awaited<ReturnType<typeof filterlistListLists>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistListListsSuspense<TData = Awaited<ReturnType<typeof filterlistListLists>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active filter lists for the calling organization and the organizations it is granted on
 */

export function useFilterlistListListsSuspense<TData = Awaited<ReturnType<typeof filterlistListLists>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilterlistListListsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type filterlistCreateListResponse200 = {
  data: FilterList
  status: 200
}

export type filterlistCreateListResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type filterlistCreateListResponseSuccess = (filterlistCreateListResponse200) & {
  headers: Headers;
};
export type filterlistCreateListResponseError = (filterlistCreateListResponseDefault) & {
  headers: Headers;
};

export type filterlistCreateListResponse = filterlistCreateListResponseSuccess

export const getFilterlistCreateListUrl = () => {




  return `/auth/v1/list`
}

/**
 * @summary Create a new filter list (v0)
 */
export const filterlistCreateList = async (createListRequest: CreateListRequest, options?: Parameters<typeof customFetch>[1]): Promise<filterlistCreateListResponse> => {

  return customFetch<filterlistCreateListResponse>(getFilterlistCreateListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createListRequest)
  }
);}





export const getFilterlistCreateListMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filterlistCreateList>>, TError,{data: CreateListRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof filterlistCreateList>>, TError,{data: CreateListRequest}, TContext> => {

const mutationKey = ['filterlistCreateList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof filterlistCreateList>>, {data: CreateListRequest}> = (props) => {
          const {data} = props ?? {};

          return  filterlistCreateList(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FilterlistCreateListMutationResult = NonNullable<Awaited<ReturnType<typeof filterlistCreateList>>>
    export type FilterlistCreateListMutationBody = CreateListRequest
    export type FilterlistCreateListMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create a new filter list (v0)
 */
export const useFilterlistCreateList = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filterlistCreateList>>, TError,{data: CreateListRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof filterlistCreateList>>,
        TError,
        {data: CreateListRequest},
        TContext
      > => {
      return useMutation(getFilterlistCreateListMutationOptions(options), queryClient);
    }
    export type filterlistDeleteListResponse200 = {
  data: string
  status: 200
}

export type filterlistDeleteListResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type filterlistDeleteListResponseSuccess = (filterlistDeleteListResponse200) & {
  headers: Headers;
};
export type filterlistDeleteListResponseError = (filterlistDeleteListResponseDefault) & {
  headers: Headers;
};

export type filterlistDeleteListResponse = filterlistDeleteListResponseSuccess

export const getFilterlistDeleteListUrl = ({ listId }: FilterlistDeleteListPathParameters,) => {




  return `/auth/v1/list/${listId}`
}

/**
 * @summary Soft-delete a filter list, which may belong to a granted organization
 */
export const filterlistDeleteList = async ({ listId }: FilterlistDeleteListPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<filterlistDeleteListResponse> => {

  return customFetch<filterlistDeleteListResponse>(getFilterlistDeleteListUrl({ listId }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getFilterlistDeleteListMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filterlistDeleteList>>, TError,{pathParams: FilterlistDeleteListPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof filterlistDeleteList>>, TError,{pathParams: FilterlistDeleteListPathParameters}, TContext> => {

const mutationKey = ['filterlistDeleteList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof filterlistDeleteList>>, {pathParams: FilterlistDeleteListPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  filterlistDeleteList(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FilterlistDeleteListMutationResult = NonNullable<Awaited<ReturnType<typeof filterlistDeleteList>>>

    export type FilterlistDeleteListMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Soft-delete a filter list, which may belong to a granted organization
 */
export const useFilterlistDeleteList = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filterlistDeleteList>>, TError,{pathParams: FilterlistDeleteListPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof filterlistDeleteList>>,
        TError,
        {pathParams: FilterlistDeleteListPathParameters},
        TContext
      > => {
      return useMutation(getFilterlistDeleteListMutationOptions(options), queryClient);
    }
    export type filterlistCreateVersionResponse200 = {
  data: FilterList
  status: 200
}

export type filterlistCreateVersionResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type filterlistCreateVersionResponseSuccess = (filterlistCreateVersionResponse200) & {
  headers: Headers;
};
export type filterlistCreateVersionResponseError = (filterlistCreateVersionResponseDefault) & {
  headers: Headers;
};

export type filterlistCreateVersionResponse = filterlistCreateVersionResponseSuccess

export const getFilterlistCreateVersionUrl = ({ listId }: FilterlistCreateVersionPathParameters,) => {




  return `/auth/v1/list/${listId}`
}

/**
 * @summary Append a new version to a filter list, which may belong to a granted organization
 */
export const filterlistCreateVersion = async ({ listId }: FilterlistCreateVersionPathParameters,
    updateListRequest: UpdateListRequest, options?: Parameters<typeof customFetch>[1]): Promise<filterlistCreateVersionResponse> => {

  return customFetch<filterlistCreateVersionResponse>(getFilterlistCreateVersionUrl({ listId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateListRequest)
  }
);}





export const getFilterlistCreateVersionMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filterlistCreateVersion>>, TError,{pathParams: FilterlistCreateVersionPathParameters;data: UpdateListRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof filterlistCreateVersion>>, TError,{pathParams: FilterlistCreateVersionPathParameters;data: UpdateListRequest}, TContext> => {

const mutationKey = ['filterlistCreateVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof filterlistCreateVersion>>, {pathParams: FilterlistCreateVersionPathParameters;data: UpdateListRequest}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  filterlistCreateVersion(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FilterlistCreateVersionMutationResult = NonNullable<Awaited<ReturnType<typeof filterlistCreateVersion>>>
    export type FilterlistCreateVersionMutationBody = UpdateListRequest
    export type FilterlistCreateVersionMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Append a new version to a filter list, which may belong to a granted organization
 */
export const useFilterlistCreateVersion = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filterlistCreateVersion>>, TError,{pathParams: FilterlistCreateVersionPathParameters;data: UpdateListRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof filterlistCreateVersion>>,
        TError,
        {pathParams: FilterlistCreateVersionPathParameters;data: UpdateListRequest},
        TContext
      > => {
      return useMutation(getFilterlistCreateVersionMutationOptions(options), queryClient);
    }
    export type filterlistListVersionsResponse200 = {
  data: ListVersionsResponse
  status: 200
}

export type filterlistListVersionsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type filterlistListVersionsResponseSuccess = (filterlistListVersionsResponse200) & {
  headers: Headers;
};
export type filterlistListVersionsResponseError = (filterlistListVersionsResponseDefault) & {
  headers: Headers;
};

export type filterlistListVersionsResponse = filterlistListVersionsResponseSuccess

export const getFilterlistListVersionsUrl = ({ listId }: FilterlistListVersionsPathParameters,) => {




  return `/auth/v1/list/${listId}/version`
}

/**
 * @summary List versions of a filter list
 */
export const filterlistListVersions = async ({ listId }: FilterlistListVersionsPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<filterlistListVersionsResponse> => {

  return customFetch<filterlistListVersionsResponse>(getFilterlistListVersionsUrl({ listId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFilterlistListVersionsQueryKey = ({ listId }: FilterlistListVersionsPathParameters,) => {
    return [
    `/auth/v1/list/${listId}/version`
    ] as const;
    }


export const getFilterlistListVersionsQueryOptions = <TData = Awaited<ReturnType<typeof filterlistListVersions>>, TError = ErrorType<HumaAPIError>>({ listId }: FilterlistListVersionsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilterlistListVersionsQueryKey({ listId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filterlistListVersions>>> = ({ signal }) => filterlistListVersions({ listId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: listId !== null && listId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilterlistListVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof filterlistListVersions>>>
export type FilterlistListVersionsQueryError = ErrorType<HumaAPIError>


export function useFilterlistListVersions<TData = Awaited<ReturnType<typeof filterlistListVersions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistListVersionsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filterlistListVersions>>,
          TError,
          Awaited<ReturnType<typeof filterlistListVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistListVersions<TData = Awaited<ReturnType<typeof filterlistListVersions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistListVersionsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filterlistListVersions>>,
          TError,
          Awaited<ReturnType<typeof filterlistListVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistListVersions<TData = Awaited<ReturnType<typeof filterlistListVersions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistListVersionsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List versions of a filter list
 */

export function useFilterlistListVersions<TData = Awaited<ReturnType<typeof filterlistListVersions>>, TError = ErrorType<HumaAPIError>>(
 { listId }: FilterlistListVersionsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilterlistListVersionsQueryOptions({ listId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getFilterlistListVersionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof filterlistListVersions>>, TError = ErrorType<HumaAPIError>>({ listId }: FilterlistListVersionsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilterlistListVersionsQueryKey({ listId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filterlistListVersions>>> = ({ signal }) => filterlistListVersions({ listId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilterlistListVersionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof filterlistListVersions>>>
export type FilterlistListVersionsSuspenseQueryError = ErrorType<HumaAPIError>


export function useFilterlistListVersionsSuspense<TData = Awaited<ReturnType<typeof filterlistListVersions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistListVersionsPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistListVersionsSuspense<TData = Awaited<ReturnType<typeof filterlistListVersions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistListVersionsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistListVersionsSuspense<TData = Awaited<ReturnType<typeof filterlistListVersions>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistListVersionsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List versions of a filter list
 */

export function useFilterlistListVersionsSuspense<TData = Awaited<ReturnType<typeof filterlistListVersions>>, TError = ErrorType<HumaAPIError>>(
 { listId }: FilterlistListVersionsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistListVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilterlistListVersionsSuspenseQueryOptions({ listId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type filterlistGetVersionResponse200 = {
  data: FilterList
  status: 200
}

export type filterlistGetVersionResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type filterlistGetVersionResponseSuccess = (filterlistGetVersionResponse200) & {
  headers: Headers;
};
export type filterlistGetVersionResponseError = (filterlistGetVersionResponseDefault) & {
  headers: Headers;
};

export type filterlistGetVersionResponse = filterlistGetVersionResponseSuccess

export const getFilterlistGetVersionUrl = ({ listId, versionId }: FilterlistGetVersionPathParameters,) => {




  return `/auth/v1/list/${listId}/version/${versionId}`
}

/**
 * @summary Get one version of a filter list (with values)
 */
export const filterlistGetVersion = async ({ listId, versionId }: FilterlistGetVersionPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<filterlistGetVersionResponse> => {

  return customFetch<filterlistGetVersionResponse>(getFilterlistGetVersionUrl({ listId, versionId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFilterlistGetVersionQueryKey = ({ listId, versionId }: FilterlistGetVersionPathParameters,) => {
    return [
    `/auth/v1/list/${listId}/version/${versionId}`
    ] as const;
    }


export const getFilterlistGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof filterlistGetVersion>>, TError = ErrorType<HumaAPIError>>({ listId, versionId }: FilterlistGetVersionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilterlistGetVersionQueryKey({ listId, versionId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filterlistGetVersion>>> = ({ signal }) => filterlistGetVersion({ listId, versionId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: listId !== null && listId !== undefined && versionId !== null && versionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilterlistGetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof filterlistGetVersion>>>
export type FilterlistGetVersionQueryError = ErrorType<HumaAPIError>


export function useFilterlistGetVersion<TData = Awaited<ReturnType<typeof filterlistGetVersion>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistGetVersionPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filterlistGetVersion>>,
          TError,
          Awaited<ReturnType<typeof filterlistGetVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistGetVersion<TData = Awaited<ReturnType<typeof filterlistGetVersion>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistGetVersionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filterlistGetVersion>>,
          TError,
          Awaited<ReturnType<typeof filterlistGetVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistGetVersion<TData = Awaited<ReturnType<typeof filterlistGetVersion>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistGetVersionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one version of a filter list (with values)
 */

export function useFilterlistGetVersion<TData = Awaited<ReturnType<typeof filterlistGetVersion>>, TError = ErrorType<HumaAPIError>>(
 { listId, versionId }: FilterlistGetVersionPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilterlistGetVersionQueryOptions({ listId, versionId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getFilterlistGetVersionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof filterlistGetVersion>>, TError = ErrorType<HumaAPIError>>({ listId, versionId }: FilterlistGetVersionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilterlistGetVersionQueryKey({ listId, versionId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filterlistGetVersion>>> = ({ signal }) => filterlistGetVersion({ listId, versionId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilterlistGetVersionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof filterlistGetVersion>>>
export type FilterlistGetVersionSuspenseQueryError = ErrorType<HumaAPIError>


export function useFilterlistGetVersionSuspense<TData = Awaited<ReturnType<typeof filterlistGetVersion>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistGetVersionPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistGetVersionSuspense<TData = Awaited<ReturnType<typeof filterlistGetVersion>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistGetVersionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterlistGetVersionSuspense<TData = Awaited<ReturnType<typeof filterlistGetVersion>>, TError = ErrorType<HumaAPIError>>(
 pathParams: FilterlistGetVersionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one version of a filter list (with values)
 */

export function useFilterlistGetVersionSuspense<TData = Awaited<ReturnType<typeof filterlistGetVersion>>, TError = ErrorType<HumaAPIError>>(
 { listId, versionId }: FilterlistGetVersionPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof filterlistGetVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilterlistGetVersionSuspenseQueryOptions({ listId, versionId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getIssuerParentEntityLogoResponse200 = {
  data: LogoBody
  status: 200
}

export type getIssuerParentEntityLogoResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getIssuerParentEntityLogoResponseSuccess = (getIssuerParentEntityLogoResponse200) & {
  headers: Headers;
};
export type getIssuerParentEntityLogoResponseError = (getIssuerParentEntityLogoResponseDefault) & {
  headers: Headers;
};

export type getIssuerParentEntityLogoResponse = getIssuerParentEntityLogoResponseSuccess

export const getGetIssuerParentEntityLogoUrl = (params: GetIssuerParentEntityLogoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/logos/by-issuer-parent-entity?${stringifiedParams}` : `/auth/v1/logos/by-issuer-parent-entity`
}

/**
 * @summary Get structured product issuer logo by issuer parent entity
 */
export const getIssuerParentEntityLogo = async (params: GetIssuerParentEntityLogoParams, options?: Parameters<typeof customFetch>[1]): Promise<getIssuerParentEntityLogoResponse> => {

  return customFetch<getIssuerParentEntityLogoResponse>(getGetIssuerParentEntityLogoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIssuerParentEntityLogoQueryKey = (params?: GetIssuerParentEntityLogoParams,) => {
    return [
    `/auth/v1/logos/by-issuer-parent-entity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetIssuerParentEntityLogoQueryOptions = <TData = Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError = ErrorType<HumaAPIError>>(params: GetIssuerParentEntityLogoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIssuerParentEntityLogoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>> = ({ signal }) => getIssuerParentEntityLogo(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIssuerParentEntityLogoQueryResult = NonNullable<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>>
export type GetIssuerParentEntityLogoQueryError = ErrorType<HumaAPIError>


export function useGetIssuerParentEntityLogo<TData = Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError = ErrorType<HumaAPIError>>(
 params: GetIssuerParentEntityLogoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIssuerParentEntityLogo>>,
          TError,
          Awaited<ReturnType<typeof getIssuerParentEntityLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIssuerParentEntityLogo<TData = Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError = ErrorType<HumaAPIError>>(
 params: GetIssuerParentEntityLogoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIssuerParentEntityLogo>>,
          TError,
          Awaited<ReturnType<typeof getIssuerParentEntityLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIssuerParentEntityLogo<TData = Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError = ErrorType<HumaAPIError>>(
 params: GetIssuerParentEntityLogoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get structured product issuer logo by issuer parent entity
 */

export function useGetIssuerParentEntityLogo<TData = Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError = ErrorType<HumaAPIError>>(
 params: GetIssuerParentEntityLogoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIssuerParentEntityLogoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetIssuerParentEntityLogoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError = ErrorType<HumaAPIError>>(params: GetIssuerParentEntityLogoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIssuerParentEntityLogoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>> = ({ signal }) => getIssuerParentEntityLogo(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIssuerParentEntityLogoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>>
export type GetIssuerParentEntityLogoSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetIssuerParentEntityLogoSuspense<TData = Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError = ErrorType<HumaAPIError>>(
 params: GetIssuerParentEntityLogoParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIssuerParentEntityLogoSuspense<TData = Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError = ErrorType<HumaAPIError>>(
 params: GetIssuerParentEntityLogoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIssuerParentEntityLogoSuspense<TData = Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError = ErrorType<HumaAPIError>>(
 params: GetIssuerParentEntityLogoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get structured product issuer logo by issuer parent entity
 */

export function useGetIssuerParentEntityLogoSuspense<TData = Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError = ErrorType<HumaAPIError>>(
 params: GetIssuerParentEntityLogoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIssuerParentEntityLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIssuerParentEntityLogoSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getInstrumentLogoResponse200 = {
  data: LogoBody
  status: 200
}

export type getInstrumentLogoResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getInstrumentLogoResponseSuccess = (getInstrumentLogoResponse200) & {
  headers: Headers;
};
export type getInstrumentLogoResponseError = (getInstrumentLogoResponseDefault) & {
  headers: Headers;
};

export type getInstrumentLogoResponse = getInstrumentLogoResponseSuccess

export const getGetInstrumentLogoUrl = ({ instrumentId }: GetInstrumentLogoPathParameters,) => {




  return `/auth/v1/logos/${instrumentId}`
}

/**
 * @summary Get instrument logo
 */
export const getInstrumentLogo = async ({ instrumentId }: GetInstrumentLogoPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getInstrumentLogoResponse> => {

  return customFetch<getInstrumentLogoResponse>(getGetInstrumentLogoUrl({ instrumentId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInstrumentLogoQueryKey = ({ instrumentId }: GetInstrumentLogoPathParameters,) => {
    return [
    `/auth/v1/logos/${instrumentId}`
    ] as const;
    }


export const getGetInstrumentLogoQueryOptions = <TData = Awaited<ReturnType<typeof getInstrumentLogo>>, TError = ErrorType<HumaAPIError>>({ instrumentId }: GetInstrumentLogoPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInstrumentLogoQueryKey({ instrumentId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInstrumentLogo>>> = ({ signal }) => getInstrumentLogo({ instrumentId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: instrumentId !== null && instrumentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInstrumentLogoQueryResult = NonNullable<Awaited<ReturnType<typeof getInstrumentLogo>>>
export type GetInstrumentLogoQueryError = ErrorType<HumaAPIError>


export function useGetInstrumentLogo<TData = Awaited<ReturnType<typeof getInstrumentLogo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentLogoPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstrumentLogo>>,
          TError,
          Awaited<ReturnType<typeof getInstrumentLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentLogo<TData = Awaited<ReturnType<typeof getInstrumentLogo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentLogoPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstrumentLogo>>,
          TError,
          Awaited<ReturnType<typeof getInstrumentLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentLogo<TData = Awaited<ReturnType<typeof getInstrumentLogo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentLogoPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get instrument logo
 */

export function useGetInstrumentLogo<TData = Awaited<ReturnType<typeof getInstrumentLogo>>, TError = ErrorType<HumaAPIError>>(
 { instrumentId }: GetInstrumentLogoPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInstrumentLogoQueryOptions({ instrumentId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInstrumentLogoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInstrumentLogo>>, TError = ErrorType<HumaAPIError>>({ instrumentId }: GetInstrumentLogoPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInstrumentLogoQueryKey({ instrumentId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInstrumentLogo>>> = ({ signal }) => getInstrumentLogo({ instrumentId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInstrumentLogoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInstrumentLogo>>>
export type GetInstrumentLogoSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetInstrumentLogoSuspense<TData = Awaited<ReturnType<typeof getInstrumentLogo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentLogoPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentLogoSuspense<TData = Awaited<ReturnType<typeof getInstrumentLogo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentLogoPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentLogoSuspense<TData = Awaited<ReturnType<typeof getInstrumentLogo>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInstrumentLogoPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get instrument logo
 */

export function useGetInstrumentLogoSuspense<TData = Awaited<ReturnType<typeof getInstrumentLogo>>, TError = ErrorType<HumaAPIError>>(
 { instrumentId }: GetInstrumentLogoPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrumentLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInstrumentLogoSuspenseQueryOptions({ instrumentId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listMosaicPagesResponse200 = {
  data: PageList
  status: 200
}

export type listMosaicPagesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listMosaicPagesResponseSuccess = (listMosaicPagesResponse200) & {
  headers: Headers;
};
export type listMosaicPagesResponseError = (listMosaicPagesResponseDefault) & {
  headers: Headers;
};

export type listMosaicPagesResponse = listMosaicPagesResponseSuccess

export const getListMosaicPagesUrl = (params?: ListMosaicPagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/mosaic/pages?${stringifiedParams}` : `/auth/v1/mosaic/pages`
}

/**
 * @summary List the Mosaic pages the caller can see
 */
export const listMosaicPages = async (params?: ListMosaicPagesParams, options?: Parameters<typeof customFetch>[1]): Promise<listMosaicPagesResponse> => {

  return customFetch<listMosaicPagesResponse>(getListMosaicPagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMosaicPagesQueryKey = (params?: ListMosaicPagesParams,) => {
    return [
    `/auth/v1/mosaic/pages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMosaicPagesQueryOptions = <TData = Awaited<ReturnType<typeof listMosaicPages>>, TError = ErrorType<HumaAPIError>>(params?: ListMosaicPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMosaicPagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMosaicPages>>> = ({ signal }) => listMosaicPages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMosaicPagesQueryResult = NonNullable<Awaited<ReturnType<typeof listMosaicPages>>>
export type ListMosaicPagesQueryError = ErrorType<HumaAPIError>


export function useListMosaicPages<TData = Awaited<ReturnType<typeof listMosaicPages>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListMosaicPagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMosaicPages>>,
          TError,
          Awaited<ReturnType<typeof listMosaicPages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMosaicPages<TData = Awaited<ReturnType<typeof listMosaicPages>>, TError = ErrorType<HumaAPIError>>(
 params?: ListMosaicPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMosaicPages>>,
          TError,
          Awaited<ReturnType<typeof listMosaicPages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMosaicPages<TData = Awaited<ReturnType<typeof listMosaicPages>>, TError = ErrorType<HumaAPIError>>(
 params?: ListMosaicPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the Mosaic pages the caller can see
 */

export function useListMosaicPages<TData = Awaited<ReturnType<typeof listMosaicPages>>, TError = ErrorType<HumaAPIError>>(
 params?: ListMosaicPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMosaicPagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListMosaicPagesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listMosaicPages>>, TError = ErrorType<HumaAPIError>>(params?: ListMosaicPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMosaicPagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMosaicPages>>> = ({ signal }) => listMosaicPages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMosaicPagesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listMosaicPages>>>
export type ListMosaicPagesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListMosaicPagesSuspense<TData = Awaited<ReturnType<typeof listMosaicPages>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListMosaicPagesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMosaicPagesSuspense<TData = Awaited<ReturnType<typeof listMosaicPages>>, TError = ErrorType<HumaAPIError>>(
 params?: ListMosaicPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMosaicPagesSuspense<TData = Awaited<ReturnType<typeof listMosaicPages>>, TError = ErrorType<HumaAPIError>>(
 params?: ListMosaicPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the Mosaic pages the caller can see
 */

export function useListMosaicPagesSuspense<TData = Awaited<ReturnType<typeof listMosaicPages>>, TError = ErrorType<HumaAPIError>>(
 params?: ListMosaicPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMosaicPages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMosaicPagesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createMosaicPageResponse201 = {
  data: PageRecord
  status: 201
}

export type createMosaicPageResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createMosaicPageResponseSuccess = (createMosaicPageResponse201) & {
  headers: Headers;
};
export type createMosaicPageResponseError = (createMosaicPageResponseDefault) & {
  headers: Headers;
};

export type createMosaicPageResponse = createMosaicPageResponseSuccess

export const getCreateMosaicPageUrl = () => {




  return `/auth/v1/mosaic/pages`
}

/**
 * @summary Create a Mosaic page and its views
 */
export const createMosaicPage = async (createPageBody: CreatePageBody, options?: Parameters<typeof customFetch>[1]): Promise<createMosaicPageResponse> => {

  return customFetch<createMosaicPageResponse>(getCreateMosaicPageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPageBody)
  }
);}





export const getCreateMosaicPageMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMosaicPage>>, TError,{data: CreatePageBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMosaicPage>>, TError,{data: CreatePageBody}, TContext> => {

const mutationKey = ['createMosaicPage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMosaicPage>>, {data: CreatePageBody}> = (props) => {
          const {data} = props ?? {};

          return  createMosaicPage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMosaicPageMutationResult = NonNullable<Awaited<ReturnType<typeof createMosaicPage>>>
    export type CreateMosaicPageMutationBody = CreatePageBody
    export type CreateMosaicPageMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create a Mosaic page and its views
 */
export const useCreateMosaicPage = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMosaicPage>>, TError,{data: CreatePageBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMosaicPage>>,
        TError,
        {data: CreatePageBody},
        TContext
      > => {
      return useMutation(getCreateMosaicPageMutationOptions(options), queryClient);
    }
    export type deleteMosaicPageResponse200 = {
  data: PageVersion
  status: 200
}

export type deleteMosaicPageResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteMosaicPageResponseSuccess = (deleteMosaicPageResponse200) & {
  headers: Headers;
};
export type deleteMosaicPageResponseError = (deleteMosaicPageResponseDefault) & {
  headers: Headers;
};

export type deleteMosaicPageResponse = deleteMosaicPageResponseSuccess

export const getDeleteMosaicPageUrl = ({ pageId }: DeleteMosaicPagePathParameters,
    params: DeleteMosaicPageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/mosaic/pages/${pageId}?${stringifiedParams}` : `/auth/v1/mosaic/pages/${pageId}`
}

/**
 * @summary Delete a Mosaic page
 */
export const deleteMosaicPage = async ({ pageId }: DeleteMosaicPagePathParameters,
    params: DeleteMosaicPageParams, options?: Parameters<typeof customFetch>[1]): Promise<deleteMosaicPageResponse> => {

  return customFetch<deleteMosaicPageResponse>(getDeleteMosaicPageUrl({ pageId },params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteMosaicPageMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMosaicPage>>, TError,{pathParams: DeleteMosaicPagePathParameters;params: DeleteMosaicPageParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMosaicPage>>, TError,{pathParams: DeleteMosaicPagePathParameters;params: DeleteMosaicPageParams}, TContext> => {

const mutationKey = ['deleteMosaicPage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMosaicPage>>, {pathParams: DeleteMosaicPagePathParameters;params: DeleteMosaicPageParams}> = (props) => {
          const {pathParams,params} = props ?? {};

          return  deleteMosaicPage(pathParams,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMosaicPageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMosaicPage>>>

    export type DeleteMosaicPageMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Delete a Mosaic page
 */
export const useDeleteMosaicPage = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMosaicPage>>, TError,{pathParams: DeleteMosaicPagePathParameters;params: DeleteMosaicPageParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMosaicPage>>,
        TError,
        {pathParams: DeleteMosaicPagePathParameters;params: DeleteMosaicPageParams},
        TContext
      > => {
      return useMutation(getDeleteMosaicPageMutationOptions(options), queryClient);
    }
    export type getMosaicPageResponse200 = {
  data: PageRecord
  status: 200
}

export type getMosaicPageResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getMosaicPageResponseSuccess = (getMosaicPageResponse200) & {
  headers: Headers;
};
export type getMosaicPageResponseError = (getMosaicPageResponseDefault) & {
  headers: Headers;
};

export type getMosaicPageResponse = getMosaicPageResponseSuccess

export const getGetMosaicPageUrl = ({ pageId }: GetMosaicPagePathParameters,) => {




  return `/auth/v1/mosaic/pages/${pageId}`
}

/**
 * @summary Get a Mosaic page with its views
 */
export const getMosaicPage = async ({ pageId }: GetMosaicPagePathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getMosaicPageResponse> => {

  return customFetch<getMosaicPageResponse>(getGetMosaicPageUrl({ pageId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMosaicPageQueryKey = ({ pageId }: GetMosaicPagePathParameters,) => {
    return [
    `/auth/v1/mosaic/pages/${pageId}`
    ] as const;
    }


export const getGetMosaicPageQueryOptions = <TData = Awaited<ReturnType<typeof getMosaicPage>>, TError = ErrorType<HumaAPIError>>({ pageId }: GetMosaicPagePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMosaicPageQueryKey({ pageId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMosaicPage>>> = ({ signal }) => getMosaicPage({ pageId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMosaicPageQueryResult = NonNullable<Awaited<ReturnType<typeof getMosaicPage>>>
export type GetMosaicPageQueryError = ErrorType<HumaAPIError>


export function useGetMosaicPage<TData = Awaited<ReturnType<typeof getMosaicPage>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicPagePathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMosaicPage>>,
          TError,
          Awaited<ReturnType<typeof getMosaicPage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMosaicPage<TData = Awaited<ReturnType<typeof getMosaicPage>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicPagePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMosaicPage>>,
          TError,
          Awaited<ReturnType<typeof getMosaicPage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMosaicPage<TData = Awaited<ReturnType<typeof getMosaicPage>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicPagePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a Mosaic page with its views
 */

export function useGetMosaicPage<TData = Awaited<ReturnType<typeof getMosaicPage>>, TError = ErrorType<HumaAPIError>>(
 { pageId }: GetMosaicPagePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMosaicPageQueryOptions({ pageId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMosaicPageSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMosaicPage>>, TError = ErrorType<HumaAPIError>>({ pageId }: GetMosaicPagePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMosaicPageQueryKey({ pageId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMosaicPage>>> = ({ signal }) => getMosaicPage({ pageId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMosaicPageSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMosaicPage>>>
export type GetMosaicPageSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetMosaicPageSuspense<TData = Awaited<ReturnType<typeof getMosaicPage>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicPagePathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMosaicPageSuspense<TData = Awaited<ReturnType<typeof getMosaicPage>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicPagePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMosaicPageSuspense<TData = Awaited<ReturnType<typeof getMosaicPage>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicPagePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a Mosaic page with its views
 */

export function useGetMosaicPageSuspense<TData = Awaited<ReturnType<typeof getMosaicPage>>, TError = ErrorType<HumaAPIError>>(
 { pageId }: GetMosaicPagePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicPage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMosaicPageSuspenseQueryOptions({ pageId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateMosaicPageResponse200 = {
  data: PageRecord
  status: 200
}

export type updateMosaicPageResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateMosaicPageResponseSuccess = (updateMosaicPageResponse200) & {
  headers: Headers;
};
export type updateMosaicPageResponseError = (updateMosaicPageResponseDefault) & {
  headers: Headers;
};

export type updateMosaicPageResponse = updateMosaicPageResponseSuccess

export const getUpdateMosaicPageUrl = ({ pageId }: UpdateMosaicPagePathParameters,) => {




  return `/auth/v1/mosaic/pages/${pageId}`
}

/**
 * @summary Change a Mosaic page's title or visibility
 */
export const updateMosaicPage = async ({ pageId }: UpdateMosaicPagePathParameters,
    updatePageBody: UpdatePageBody, options?: Parameters<typeof customFetch>[1]): Promise<updateMosaicPageResponse> => {

  return customFetch<updateMosaicPageResponse>(getUpdateMosaicPageUrl({ pageId }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePageBody)
  }
);}





export const getUpdateMosaicPageMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMosaicPage>>, TError,{pathParams: UpdateMosaicPagePathParameters;data: UpdatePageBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMosaicPage>>, TError,{pathParams: UpdateMosaicPagePathParameters;data: UpdatePageBody}, TContext> => {

const mutationKey = ['updateMosaicPage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMosaicPage>>, {pathParams: UpdateMosaicPagePathParameters;data: UpdatePageBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  updateMosaicPage(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMosaicPageMutationResult = NonNullable<Awaited<ReturnType<typeof updateMosaicPage>>>
    export type UpdateMosaicPageMutationBody = UpdatePageBody
    export type UpdateMosaicPageMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Change a Mosaic page's title or visibility
 */
export const useUpdateMosaicPage = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMosaicPage>>, TError,{pathParams: UpdateMosaicPagePathParameters;data: UpdatePageBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMosaicPage>>,
        TError,
        {pathParams: UpdateMosaicPagePathParameters;data: UpdatePageBody},
        TContext
      > => {
      return useMutation(getUpdateMosaicPageMutationOptions(options), queryClient);
    }
    export type addMosaicPageViewResponse201 = {
  data: AddedView
  status: 201
}

export type addMosaicPageViewResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type addMosaicPageViewResponseSuccess = (addMosaicPageViewResponse201) & {
  headers: Headers;
};
export type addMosaicPageViewResponseError = (addMosaicPageViewResponseDefault) & {
  headers: Headers;
};

export type addMosaicPageViewResponse = addMosaicPageViewResponseSuccess

export const getAddMosaicPageViewUrl = ({ pageId }: AddMosaicPageViewPathParameters,) => {




  return `/auth/v1/mosaic/pages/${pageId}/views`
}

/**
 * @summary Add a view to a Mosaic page
 */
export const addMosaicPageView = async ({ pageId }: AddMosaicPageViewPathParameters,
    addViewBody: AddViewBody, options?: Parameters<typeof customFetch>[1]): Promise<addMosaicPageViewResponse> => {

  return customFetch<addMosaicPageViewResponse>(getAddMosaicPageViewUrl({ pageId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addViewBody)
  }
);}





export const getAddMosaicPageViewMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addMosaicPageView>>, TError,{pathParams: AddMosaicPageViewPathParameters;data: AddViewBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addMosaicPageView>>, TError,{pathParams: AddMosaicPageViewPathParameters;data: AddViewBody}, TContext> => {

const mutationKey = ['addMosaicPageView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addMosaicPageView>>, {pathParams: AddMosaicPageViewPathParameters;data: AddViewBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  addMosaicPageView(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddMosaicPageViewMutationResult = NonNullable<Awaited<ReturnType<typeof addMosaicPageView>>>
    export type AddMosaicPageViewMutationBody = AddViewBody
    export type AddMosaicPageViewMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Add a view to a Mosaic page
 */
export const useAddMosaicPageView = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addMosaicPageView>>, TError,{pathParams: AddMosaicPageViewPathParameters;data: AddViewBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addMosaicPageView>>,
        TError,
        {pathParams: AddMosaicPageViewPathParameters;data: AddViewBody},
        TContext
      > => {
      return useMutation(getAddMosaicPageViewMutationOptions(options), queryClient);
    }
    export type reorderMosaicPageViewsResponse200 = {
  data: PageVersion
  status: 200
}

export type reorderMosaicPageViewsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type reorderMosaicPageViewsResponseSuccess = (reorderMosaicPageViewsResponse200) & {
  headers: Headers;
};
export type reorderMosaicPageViewsResponseError = (reorderMosaicPageViewsResponseDefault) & {
  headers: Headers;
};

export type reorderMosaicPageViewsResponse = reorderMosaicPageViewsResponseSuccess

export const getReorderMosaicPageViewsUrl = ({ pageId }: ReorderMosaicPageViewsPathParameters,) => {




  return `/auth/v1/mosaic/pages/${pageId}/views/order`
}

/**
 * @summary Set the order of a Mosaic page's views
 */
export const reorderMosaicPageViews = async ({ pageId }: ReorderMosaicPageViewsPathParameters,
    reorderViewsBody: ReorderViewsBody, options?: Parameters<typeof customFetch>[1]): Promise<reorderMosaicPageViewsResponse> => {

  return customFetch<reorderMosaicPageViewsResponse>(getReorderMosaicPageViewsUrl({ pageId }),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reorderViewsBody)
  }
);}





export const getReorderMosaicPageViewsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderMosaicPageViews>>, TError,{pathParams: ReorderMosaicPageViewsPathParameters;data: ReorderViewsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderMosaicPageViews>>, TError,{pathParams: ReorderMosaicPageViewsPathParameters;data: ReorderViewsBody}, TContext> => {

const mutationKey = ['reorderMosaicPageViews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderMosaicPageViews>>, {pathParams: ReorderMosaicPageViewsPathParameters;data: ReorderViewsBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  reorderMosaicPageViews(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderMosaicPageViewsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderMosaicPageViews>>>
    export type ReorderMosaicPageViewsMutationBody = ReorderViewsBody
    export type ReorderMosaicPageViewsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Set the order of a Mosaic page's views
 */
export const useReorderMosaicPageViews = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderMosaicPageViews>>, TError,{pathParams: ReorderMosaicPageViewsPathParameters;data: ReorderViewsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderMosaicPageViews>>,
        TError,
        {pathParams: ReorderMosaicPageViewsPathParameters;data: ReorderViewsBody},
        TContext
      > => {
      return useMutation(getReorderMosaicPageViewsMutationOptions(options), queryClient);
    }
    export type removeMosaicPageViewResponse200 = {
  data: PageVersion
  status: 200
}

export type removeMosaicPageViewResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type removeMosaicPageViewResponseSuccess = (removeMosaicPageViewResponse200) & {
  headers: Headers;
};
export type removeMosaicPageViewResponseError = (removeMosaicPageViewResponseDefault) & {
  headers: Headers;
};

export type removeMosaicPageViewResponse = removeMosaicPageViewResponseSuccess

export const getRemoveMosaicPageViewUrl = ({ pageId, viewId }: RemoveMosaicPageViewPathParameters,
    params: RemoveMosaicPageViewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/mosaic/pages/${pageId}/views/${viewId}?${stringifiedParams}` : `/auth/v1/mosaic/pages/${pageId}/views/${viewId}`
}

/**
 * @summary Remove a view from a Mosaic page
 */
export const removeMosaicPageView = async ({ pageId, viewId }: RemoveMosaicPageViewPathParameters,
    params: RemoveMosaicPageViewParams, options?: Parameters<typeof customFetch>[1]): Promise<removeMosaicPageViewResponse> => {

  return customFetch<removeMosaicPageViewResponse>(getRemoveMosaicPageViewUrl({ pageId, viewId },params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveMosaicPageViewMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeMosaicPageView>>, TError,{pathParams: RemoveMosaicPageViewPathParameters;params: RemoveMosaicPageViewParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeMosaicPageView>>, TError,{pathParams: RemoveMosaicPageViewPathParameters;params: RemoveMosaicPageViewParams}, TContext> => {

const mutationKey = ['removeMosaicPageView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeMosaicPageView>>, {pathParams: RemoveMosaicPageViewPathParameters;params: RemoveMosaicPageViewParams}> = (props) => {
          const {pathParams,params} = props ?? {};

          return  removeMosaicPageView(pathParams,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveMosaicPageViewMutationResult = NonNullable<Awaited<ReturnType<typeof removeMosaicPageView>>>

    export type RemoveMosaicPageViewMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Remove a view from a Mosaic page
 */
export const useRemoveMosaicPageView = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeMosaicPageView>>, TError,{pathParams: RemoveMosaicPageViewPathParameters;params: RemoveMosaicPageViewParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeMosaicPageView>>,
        TError,
        {pathParams: RemoveMosaicPageViewPathParameters;params: RemoveMosaicPageViewParams},
        TContext
      > => {
      return useMutation(getRemoveMosaicPageViewMutationOptions(options), queryClient);
    }
    export type getMosaicViewResponse200 = {
  data: ViewRecord
  status: 200
}

export type getMosaicViewResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getMosaicViewResponseSuccess = (getMosaicViewResponse200) & {
  headers: Headers;
};
export type getMosaicViewResponseError = (getMosaicViewResponseDefault) & {
  headers: Headers;
};

export type getMosaicViewResponse = getMosaicViewResponseSuccess

export const getGetMosaicViewUrl = ({ viewId }: GetMosaicViewPathParameters,) => {




  return `/auth/v1/mosaic/views/${viewId}`
}

/**
 * @summary Get a Mosaic view
 */
export const getMosaicView = async ({ viewId }: GetMosaicViewPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getMosaicViewResponse> => {

  return customFetch<getMosaicViewResponse>(getGetMosaicViewUrl({ viewId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMosaicViewQueryKey = ({ viewId }: GetMosaicViewPathParameters,) => {
    return [
    `/auth/v1/mosaic/views/${viewId}`
    ] as const;
    }


export const getGetMosaicViewQueryOptions = <TData = Awaited<ReturnType<typeof getMosaicView>>, TError = ErrorType<HumaAPIError>>({ viewId }: GetMosaicViewPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMosaicViewQueryKey({ viewId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMosaicView>>> = ({ signal }) => getMosaicView({ viewId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: viewId !== null && viewId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMosaicViewQueryResult = NonNullable<Awaited<ReturnType<typeof getMosaicView>>>
export type GetMosaicViewQueryError = ErrorType<HumaAPIError>


export function useGetMosaicView<TData = Awaited<ReturnType<typeof getMosaicView>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicViewPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMosaicView>>,
          TError,
          Awaited<ReturnType<typeof getMosaicView>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMosaicView<TData = Awaited<ReturnType<typeof getMosaicView>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicViewPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMosaicView>>,
          TError,
          Awaited<ReturnType<typeof getMosaicView>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMosaicView<TData = Awaited<ReturnType<typeof getMosaicView>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicViewPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a Mosaic view
 */

export function useGetMosaicView<TData = Awaited<ReturnType<typeof getMosaicView>>, TError = ErrorType<HumaAPIError>>(
 { viewId }: GetMosaicViewPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMosaicViewQueryOptions({ viewId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMosaicViewSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMosaicView>>, TError = ErrorType<HumaAPIError>>({ viewId }: GetMosaicViewPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMosaicViewQueryKey({ viewId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMosaicView>>> = ({ signal }) => getMosaicView({ viewId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMosaicViewSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMosaicView>>>
export type GetMosaicViewSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetMosaicViewSuspense<TData = Awaited<ReturnType<typeof getMosaicView>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicViewPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMosaicViewSuspense<TData = Awaited<ReturnType<typeof getMosaicView>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicViewPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMosaicViewSuspense<TData = Awaited<ReturnType<typeof getMosaicView>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetMosaicViewPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a Mosaic view
 */

export function useGetMosaicViewSuspense<TData = Awaited<ReturnType<typeof getMosaicView>>, TError = ErrorType<HumaAPIError>>(
 { viewId }: GetMosaicViewPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMosaicView>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMosaicViewSuspenseQueryOptions({ viewId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateMosaicViewResponse200 = {
  data: SavedView
  status: 200
}

export type updateMosaicViewResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateMosaicViewResponseSuccess = (updateMosaicViewResponse200) & {
  headers: Headers;
};
export type updateMosaicViewResponseError = (updateMosaicViewResponseDefault) & {
  headers: Headers;
};

export type updateMosaicViewResponse = updateMosaicViewResponseSuccess

export const getUpdateMosaicViewUrl = ({ viewId }: UpdateMosaicViewPathParameters,) => {




  return `/auth/v1/mosaic/views/${viewId}`
}

/**
 * @summary Save a Mosaic view's title or document
 */
export const updateMosaicView = async ({ viewId }: UpdateMosaicViewPathParameters,
    updateViewBody: UpdateViewBody, options?: Parameters<typeof customFetch>[1]): Promise<updateMosaicViewResponse> => {

  return customFetch<updateMosaicViewResponse>(getUpdateMosaicViewUrl({ viewId }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateViewBody)
  }
);}





export const getUpdateMosaicViewMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMosaicView>>, TError,{pathParams: UpdateMosaicViewPathParameters;data: UpdateViewBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMosaicView>>, TError,{pathParams: UpdateMosaicViewPathParameters;data: UpdateViewBody}, TContext> => {

const mutationKey = ['updateMosaicView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMosaicView>>, {pathParams: UpdateMosaicViewPathParameters;data: UpdateViewBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  updateMosaicView(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMosaicViewMutationResult = NonNullable<Awaited<ReturnType<typeof updateMosaicView>>>
    export type UpdateMosaicViewMutationBody = UpdateViewBody
    export type UpdateMosaicViewMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Save a Mosaic view's title or document
 */
export const useUpdateMosaicView = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMosaicView>>, TError,{pathParams: UpdateMosaicViewPathParameters;data: UpdateViewBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMosaicView>>,
        TError,
        {pathParams: UpdateMosaicViewPathParameters;data: UpdateViewBody},
        TContext
      > => {
      return useMutation(getUpdateMosaicViewMutationOptions(options), queryClient);
    }
    export type listNewIssuesResponse200 = {
  data: ListNewIssuesResponseBody
  status: 200
}

export type listNewIssuesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listNewIssuesResponseSuccess = (listNewIssuesResponse200) & {
  headers: Headers;
};
export type listNewIssuesResponseError = (listNewIssuesResponseDefault) & {
  headers: Headers;
};

export type listNewIssuesResponse = listNewIssuesResponseSuccess

export const getListNewIssuesUrl = (params?: ListNewIssuesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/new-issues?${stringifiedParams}` : `/auth/v1/new-issues`
}

/**
 * @summary List shared new-issue metadata across all asset classes
 */
export const listNewIssues = async (params?: ListNewIssuesParams, options?: Parameters<typeof customFetch>[1]): Promise<listNewIssuesResponse> => {

  return customFetch<listNewIssuesResponse>(getListNewIssuesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNewIssuesQueryKey = (params?: ListNewIssuesParams,) => {
    return [
    `/auth/v1/new-issues`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNewIssuesQueryOptions = <TData = Awaited<ReturnType<typeof listNewIssues>>, TError = ErrorType<HumaAPIError>>(params?: ListNewIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNewIssuesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNewIssues>>> = ({ signal }) => listNewIssues(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNewIssuesQueryResult = NonNullable<Awaited<ReturnType<typeof listNewIssues>>>
export type ListNewIssuesQueryError = ErrorType<HumaAPIError>


export function useListNewIssues<TData = Awaited<ReturnType<typeof listNewIssues>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListNewIssuesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNewIssues>>,
          TError,
          Awaited<ReturnType<typeof listNewIssues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNewIssues<TData = Awaited<ReturnType<typeof listNewIssues>>, TError = ErrorType<HumaAPIError>>(
 params?: ListNewIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNewIssues>>,
          TError,
          Awaited<ReturnType<typeof listNewIssues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNewIssues<TData = Awaited<ReturnType<typeof listNewIssues>>, TError = ErrorType<HumaAPIError>>(
 params?: ListNewIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List shared new-issue metadata across all asset classes
 */

export function useListNewIssues<TData = Awaited<ReturnType<typeof listNewIssues>>, TError = ErrorType<HumaAPIError>>(
 params?: ListNewIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNewIssuesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListNewIssuesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listNewIssues>>, TError = ErrorType<HumaAPIError>>(params?: ListNewIssuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNewIssuesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNewIssues>>> = ({ signal }) => listNewIssues(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNewIssuesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listNewIssues>>>
export type ListNewIssuesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListNewIssuesSuspense<TData = Awaited<ReturnType<typeof listNewIssues>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListNewIssuesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNewIssuesSuspense<TData = Awaited<ReturnType<typeof listNewIssues>>, TError = ErrorType<HumaAPIError>>(
 params?: ListNewIssuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNewIssuesSuspense<TData = Awaited<ReturnType<typeof listNewIssues>>, TError = ErrorType<HumaAPIError>>(
 params?: ListNewIssuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List shared new-issue metadata across all asset classes
 */

export function useListNewIssuesSuspense<TData = Awaited<ReturnType<typeof listNewIssues>>, TError = ErrorType<HumaAPIError>>(
 params?: ListNewIssuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNewIssuesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getNewIssueDocResponse200 = {
  data: OfferingDocBody
  status: 200
}

export type getNewIssueDocResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getNewIssueDocResponseSuccess = (getNewIssueDocResponse200) & {
  headers: Headers;
};
export type getNewIssueDocResponseError = (getNewIssueDocResponseDefault) & {
  headers: Headers;
};

export type getNewIssueDocResponse = getNewIssueDocResponseSuccess

export const getGetNewIssueDocUrl = ({ id }: GetNewIssueDocPathParameters,) => {




  return `/auth/v1/new-issues/documents/${id}`
}

/**
 * @summary Get a new-issue document's processing status and extraction
 */
export const getNewIssueDoc = async ({ id }: GetNewIssueDocPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getNewIssueDocResponse> => {

  return customFetch<getNewIssueDocResponse>(getGetNewIssueDocUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNewIssueDocQueryKey = ({ id }: GetNewIssueDocPathParameters,) => {
    return [
    `/auth/v1/new-issues/documents/${id}`
    ] as const;
    }


export const getGetNewIssueDocQueryOptions = <TData = Awaited<ReturnType<typeof getNewIssueDoc>>, TError = ErrorType<HumaAPIError>>({ id }: GetNewIssueDocPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewIssueDocQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewIssueDoc>>> = ({ signal }) => getNewIssueDoc({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewIssueDocQueryResult = NonNullable<Awaited<ReturnType<typeof getNewIssueDoc>>>
export type GetNewIssueDocQueryError = ErrorType<HumaAPIError>


export function useGetNewIssueDoc<TData = Awaited<ReturnType<typeof getNewIssueDoc>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssueDocPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewIssueDoc>>,
          TError,
          Awaited<ReturnType<typeof getNewIssueDoc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssueDoc<TData = Awaited<ReturnType<typeof getNewIssueDoc>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssueDocPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewIssueDoc>>,
          TError,
          Awaited<ReturnType<typeof getNewIssueDoc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssueDoc<TData = Awaited<ReturnType<typeof getNewIssueDoc>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssueDocPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a new-issue document's processing status and extraction
 */

export function useGetNewIssueDoc<TData = Awaited<ReturnType<typeof getNewIssueDoc>>, TError = ErrorType<HumaAPIError>>(
 { id }: GetNewIssueDocPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewIssueDocQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNewIssueDocSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNewIssueDoc>>, TError = ErrorType<HumaAPIError>>({ id }: GetNewIssueDocPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewIssueDocQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewIssueDoc>>> = ({ signal }) => getNewIssueDoc({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewIssueDocSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNewIssueDoc>>>
export type GetNewIssueDocSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetNewIssueDocSuspense<TData = Awaited<ReturnType<typeof getNewIssueDoc>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssueDocPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssueDocSuspense<TData = Awaited<ReturnType<typeof getNewIssueDoc>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssueDocPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssueDocSuspense<TData = Awaited<ReturnType<typeof getNewIssueDoc>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssueDocPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a new-issue document's processing status and extraction
 */

export function useGetNewIssueDocSuspense<TData = Awaited<ReturnType<typeof getNewIssueDoc>>, TError = ErrorType<HumaAPIError>>(
 { id }: GetNewIssueDocPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueDoc>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewIssueDocSuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type processNewIssueDocResponse202 = {
  data: ProcessNewIssueDocResponseBody
  status: 202
}

export type processNewIssueDocResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 202>
}

export type processNewIssueDocResponseSuccess = (processNewIssueDocResponse202) & {
  headers: Headers;
};
export type processNewIssueDocResponseError = (processNewIssueDocResponseDefault) & {
  headers: Headers;
};

export type processNewIssueDocResponse = processNewIssueDocResponseSuccess

export const getProcessNewIssueDocUrl = ({ id }: ProcessNewIssueDocPathParameters,) => {




  return `/auth/v1/new-issues/documents/${id}/process`
}

/**
 * @summary Kick off async processing of an uploaded new-issue document
 */
export const processNewIssueDoc = async ({ id }: ProcessNewIssueDocPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<processNewIssueDocResponse> => {

  return customFetch<processNewIssueDocResponse>(getProcessNewIssueDocUrl({ id }),
  {
    ...options,
    method: 'POST'


  }
);}





export const getProcessNewIssueDocMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processNewIssueDoc>>, TError,{pathParams: ProcessNewIssueDocPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof processNewIssueDoc>>, TError,{pathParams: ProcessNewIssueDocPathParameters}, TContext> => {

const mutationKey = ['processNewIssueDoc'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processNewIssueDoc>>, {pathParams: ProcessNewIssueDocPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  processNewIssueDoc(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProcessNewIssueDocMutationResult = NonNullable<Awaited<ReturnType<typeof processNewIssueDoc>>>

    export type ProcessNewIssueDocMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Kick off async processing of an uploaded new-issue document
 */
export const useProcessNewIssueDoc = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processNewIssueDoc>>, TError,{pathParams: ProcessNewIssueDocPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof processNewIssueDoc>>,
        TError,
        {pathParams: ProcessNewIssueDocPathParameters},
        TContext
      > => {
      return useMutation(getProcessNewIssueDocMutationOptions(options), queryClient);
    }
    export type getNewIssueSchemaResponse200 = {
  data: GetNewIssueSchemaResponseBody
  status: 200
}

export type getNewIssueSchemaResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getNewIssueSchemaResponseSuccess = (getNewIssueSchemaResponse200) & {
  headers: Headers;
};
export type getNewIssueSchemaResponseError = (getNewIssueSchemaResponseDefault) & {
  headers: Headers;
};

export type getNewIssueSchemaResponse = getNewIssueSchemaResponseSuccess

export const getGetNewIssueSchemaUrl = () => {




  return `/auth/v1/new-issues/schema`
}

/**
 * @summary Get the shared new-issue JSON Schema
 */
export const getNewIssueSchema = async ( options?: Parameters<typeof customFetch>[1]): Promise<getNewIssueSchemaResponse> => {

  return customFetch<getNewIssueSchemaResponse>(getGetNewIssueSchemaUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNewIssueSchemaQueryKey = () => {
    return [
    `/auth/v1/new-issues/schema`
    ] as const;
    }


export const getGetNewIssueSchemaQueryOptions = <TData = Awaited<ReturnType<typeof getNewIssueSchema>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewIssueSchemaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewIssueSchema>>> = ({ signal }) => getNewIssueSchema({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewIssueSchemaQueryResult = NonNullable<Awaited<ReturnType<typeof getNewIssueSchema>>>
export type GetNewIssueSchemaQueryError = ErrorType<HumaAPIError>


export function useGetNewIssueSchema<TData = Awaited<ReturnType<typeof getNewIssueSchema>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewIssueSchema>>,
          TError,
          Awaited<ReturnType<typeof getNewIssueSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssueSchema<TData = Awaited<ReturnType<typeof getNewIssueSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewIssueSchema>>,
          TError,
          Awaited<ReturnType<typeof getNewIssueSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssueSchema<TData = Awaited<ReturnType<typeof getNewIssueSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the shared new-issue JSON Schema
 */

export function useGetNewIssueSchema<TData = Awaited<ReturnType<typeof getNewIssueSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewIssueSchemaQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNewIssueSchemaSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNewIssueSchema>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewIssueSchemaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewIssueSchema>>> = ({ signal }) => getNewIssueSchema({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewIssueSchemaSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNewIssueSchema>>>
export type GetNewIssueSchemaSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetNewIssueSchemaSuspense<TData = Awaited<ReturnType<typeof getNewIssueSchema>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssueSchemaSuspense<TData = Awaited<ReturnType<typeof getNewIssueSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssueSchemaSuspense<TData = Awaited<ReturnType<typeof getNewIssueSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the shared new-issue JSON Schema
 */

export function useGetNewIssueSchemaSuspense<TData = Awaited<ReturnType<typeof getNewIssueSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssueSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewIssueSchemaSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listStructuredInvestmentFormReferenceDataResponse200 = {
  data: StructuredInvestmentFormReferenceData
  status: 200
}

export type listStructuredInvestmentFormReferenceDataResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listStructuredInvestmentFormReferenceDataResponseSuccess = (listStructuredInvestmentFormReferenceDataResponse200) & {
  headers: Headers;
};
export type listStructuredInvestmentFormReferenceDataResponseError = (listStructuredInvestmentFormReferenceDataResponseDefault) & {
  headers: Headers;
};

export type listStructuredInvestmentFormReferenceDataResponse = listStructuredInvestmentFormReferenceDataResponseSuccess

export const getListStructuredInvestmentFormReferenceDataUrl = () => {




  return `/auth/v1/new-issues/structured-investment/form-reference-data`
}

/**
 * @summary List the reference data the structured investment origination form needs
 */
export const listStructuredInvestmentFormReferenceData = async ( options?: Parameters<typeof customFetch>[1]): Promise<listStructuredInvestmentFormReferenceDataResponse> => {

  return customFetch<listStructuredInvestmentFormReferenceDataResponse>(getListStructuredInvestmentFormReferenceDataUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStructuredInvestmentFormReferenceDataQueryKey = () => {
    return [
    `/auth/v1/new-issues/structured-investment/form-reference-data`
    ] as const;
    }


export const getListStructuredInvestmentFormReferenceDataQueryOptions = <TData = Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStructuredInvestmentFormReferenceDataQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>> = ({ signal }) => listStructuredInvestmentFormReferenceData({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStructuredInvestmentFormReferenceDataQueryResult = NonNullable<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>>
export type ListStructuredInvestmentFormReferenceDataQueryError = ErrorType<HumaAPIError>


export function useListStructuredInvestmentFormReferenceData<TData = Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>,
          TError,
          Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStructuredInvestmentFormReferenceData<TData = Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>,
          TError,
          Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStructuredInvestmentFormReferenceData<TData = Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the reference data the structured investment origination form needs
 */

export function useListStructuredInvestmentFormReferenceData<TData = Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStructuredInvestmentFormReferenceDataQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListStructuredInvestmentFormReferenceDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStructuredInvestmentFormReferenceDataQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>> = ({ signal }) => listStructuredInvestmentFormReferenceData({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStructuredInvestmentFormReferenceDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>>
export type ListStructuredInvestmentFormReferenceDataSuspenseQueryError = ErrorType<HumaAPIError>


export function useListStructuredInvestmentFormReferenceDataSuspense<TData = Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStructuredInvestmentFormReferenceDataSuspense<TData = Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStructuredInvestmentFormReferenceDataSuspense<TData = Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the reference data the structured investment origination form needs
 */

export function useListStructuredInvestmentFormReferenceDataSuspense<TData = Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listStructuredInvestmentFormReferenceData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStructuredInvestmentFormReferenceDataSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createNewIssueResponse200 = {
  data: NewIssueSummary
  status: 200
}

export type createNewIssueResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type createNewIssueResponseSuccess = (createNewIssueResponse200) & {
  headers: Headers;
};
export type createNewIssueResponseError = (createNewIssueResponseDefault) & {
  headers: Headers;
};

export type createNewIssueResponse = createNewIssueResponseSuccess

export const getCreateNewIssueUrl = ({ assetClass }: CreateNewIssuePathParameters,
    params?: CreateNewIssueParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/new-issues/${assetClass}/create?${stringifiedParams}` : `/auth/v1/new-issues/${assetClass}/create`
}

/**
 * @summary Create a new issue
 */
export const createNewIssue = async ({ assetClass }: CreateNewIssuePathParameters,
    createNewIssueRequestBody: CreateNewIssueRequestBody,
    params?: CreateNewIssueParams, options?: Parameters<typeof customFetch>[1]): Promise<createNewIssueResponse> => {

  return customFetch<createNewIssueResponse>(getCreateNewIssueUrl({ assetClass },params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createNewIssueRequestBody)
  }
);}





export const getCreateNewIssueMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewIssue>>, TError,{pathParams: CreateNewIssuePathParameters;data: CreateNewIssueRequestBody;params?: CreateNewIssueParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNewIssue>>, TError,{pathParams: CreateNewIssuePathParameters;data: CreateNewIssueRequestBody;params?: CreateNewIssueParams}, TContext> => {

const mutationKey = ['createNewIssue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNewIssue>>, {pathParams: CreateNewIssuePathParameters;data: CreateNewIssueRequestBody;params?: CreateNewIssueParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  createNewIssue(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNewIssueMutationResult = NonNullable<Awaited<ReturnType<typeof createNewIssue>>>
    export type CreateNewIssueMutationBody = CreateNewIssueRequestBody
    export type CreateNewIssueMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create a new issue
 */
export const useCreateNewIssue = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewIssue>>, TError,{pathParams: CreateNewIssuePathParameters;data: CreateNewIssueRequestBody;params?: CreateNewIssueParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNewIssue>>,
        TError,
        {pathParams: CreateNewIssuePathParameters;data: CreateNewIssueRequestBody;params?: CreateNewIssueParams},
        TContext
      > => {
      return useMutation(getCreateNewIssueMutationOptions(options), queryClient);
    }
    export type getAssetClassSchemaResponse200 = {
  data: GetAssetClassSchemaResponseBody
  status: 200
}

export type getAssetClassSchemaResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getAssetClassSchemaResponseSuccess = (getAssetClassSchemaResponse200) & {
  headers: Headers;
};
export type getAssetClassSchemaResponseError = (getAssetClassSchemaResponseDefault) & {
  headers: Headers;
};

export type getAssetClassSchemaResponse = getAssetClassSchemaResponseSuccess

export const getGetAssetClassSchemaUrl = ({ assetClass }: GetAssetClassSchemaPathParameters,
    params?: GetAssetClassSchemaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/new-issues/${assetClass}/schema?${stringifiedParams}` : `/auth/v1/new-issues/${assetClass}/schema`
}

/**
 * @summary Get JSON Schema for an asset class
 */
export const getAssetClassSchema = async ({ assetClass }: GetAssetClassSchemaPathParameters,
    params?: GetAssetClassSchemaParams, options?: Parameters<typeof customFetch>[1]): Promise<getAssetClassSchemaResponse> => {

  return customFetch<getAssetClassSchemaResponse>(getGetAssetClassSchemaUrl({ assetClass },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetClassSchemaQueryKey = ({ assetClass }: GetAssetClassSchemaPathParameters,
    params?: GetAssetClassSchemaParams,) => {
    return [
    `/auth/v1/new-issues/${assetClass}/schema`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAssetClassSchemaQueryOptions = <TData = Awaited<ReturnType<typeof getAssetClassSchema>>, TError = ErrorType<HumaAPIError>>({ assetClass }: GetAssetClassSchemaPathParameters,
    params?: GetAssetClassSchemaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetClassSchemaQueryKey({ assetClass },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetClassSchema>>> = ({ signal }) => getAssetClassSchema({ assetClass },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: assetClass !== null && assetClass !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetClassSchemaQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetClassSchema>>>
export type GetAssetClassSchemaQueryError = ErrorType<HumaAPIError>


export function useGetAssetClassSchema<TData = Awaited<ReturnType<typeof getAssetClassSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetAssetClassSchemaPathParameters,
    params: undefined |  GetAssetClassSchemaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetClassSchema>>,
          TError,
          Awaited<ReturnType<typeof getAssetClassSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetClassSchema<TData = Awaited<ReturnType<typeof getAssetClassSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetAssetClassSchemaPathParameters,
    params?: GetAssetClassSchemaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetClassSchema>>,
          TError,
          Awaited<ReturnType<typeof getAssetClassSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetClassSchema<TData = Awaited<ReturnType<typeof getAssetClassSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetAssetClassSchemaPathParameters,
    params?: GetAssetClassSchemaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get JSON Schema for an asset class
 */

export function useGetAssetClassSchema<TData = Awaited<ReturnType<typeof getAssetClassSchema>>, TError = ErrorType<HumaAPIError>>(
 { assetClass }: GetAssetClassSchemaPathParameters,
    params?: GetAssetClassSchemaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetClassSchemaQueryOptions({ assetClass },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAssetClassSchemaSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAssetClassSchema>>, TError = ErrorType<HumaAPIError>>({ assetClass }: GetAssetClassSchemaPathParameters,
    params?: GetAssetClassSchemaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetClassSchemaQueryKey({ assetClass },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetClassSchema>>> = ({ signal }) => getAssetClassSchema({ assetClass },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetClassSchemaSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetClassSchema>>>
export type GetAssetClassSchemaSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetAssetClassSchemaSuspense<TData = Awaited<ReturnType<typeof getAssetClassSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetAssetClassSchemaPathParameters,
    params: undefined |  GetAssetClassSchemaParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetClassSchemaSuspense<TData = Awaited<ReturnType<typeof getAssetClassSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetAssetClassSchemaPathParameters,
    params?: GetAssetClassSchemaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetClassSchemaSuspense<TData = Awaited<ReturnType<typeof getAssetClassSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetAssetClassSchemaPathParameters,
    params?: GetAssetClassSchemaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get JSON Schema for an asset class
 */

export function useGetAssetClassSchemaSuspense<TData = Awaited<ReturnType<typeof getAssetClassSchema>>, TError = ErrorType<HumaAPIError>>(
 { assetClass }: GetAssetClassSchemaPathParameters,
    params?: GetAssetClassSchemaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssetClassSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetClassSchemaSuspenseQueryOptions({ assetClass },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deleteNewIssueResponse204 = {
  data: void
  status: 204
}

export type deleteNewIssueResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type deleteNewIssueResponseSuccess = (deleteNewIssueResponse204) & {
  headers: Headers;
};
export type deleteNewIssueResponseError = (deleteNewIssueResponseDefault) & {
  headers: Headers;
};

export type deleteNewIssueResponse = deleteNewIssueResponseSuccess

export const getDeleteNewIssueUrl = ({ newIssueId }: DeleteNewIssuePathParameters,) => {




  return `/auth/v1/new-issues/${newIssueId}`
}

/**
 * @summary Delete a new issue
 */
export const deleteNewIssue = async ({ newIssueId }: DeleteNewIssuePathParameters, options?: Parameters<typeof customFetch>[1]): Promise<deleteNewIssueResponse> => {

  return customFetch<deleteNewIssueResponse>(getDeleteNewIssueUrl({ newIssueId }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteNewIssueMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNewIssue>>, TError,{pathParams: DeleteNewIssuePathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNewIssue>>, TError,{pathParams: DeleteNewIssuePathParameters}, TContext> => {

const mutationKey = ['deleteNewIssue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNewIssue>>, {pathParams: DeleteNewIssuePathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  deleteNewIssue(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNewIssueMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNewIssue>>>

    export type DeleteNewIssueMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Delete a new issue
 */
export const useDeleteNewIssue = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNewIssue>>, TError,{pathParams: DeleteNewIssuePathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNewIssue>>,
        TError,
        {pathParams: DeleteNewIssuePathParameters},
        TContext
      > => {
      return useMutation(getDeleteNewIssueMutationOptions(options), queryClient);
    }
    export type getNewIssueResponse200 = {
  data: GetNewIssueResponseBody
  status: 200
}

export type getNewIssueResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getNewIssueResponseSuccess = (getNewIssueResponse200) & {
  headers: Headers;
};
export type getNewIssueResponseError = (getNewIssueResponseDefault) & {
  headers: Headers;
};

export type getNewIssueResponse = getNewIssueResponseSuccess

export const getGetNewIssueUrl = ({ newIssueId }: GetNewIssuePathParameters,) => {




  return `/auth/v1/new-issues/${newIssueId}`
}

/**
 * @summary Get a new issue
 */
export const getNewIssue = async ({ newIssueId }: GetNewIssuePathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getNewIssueResponse> => {

  return customFetch<getNewIssueResponse>(getGetNewIssueUrl({ newIssueId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNewIssueQueryKey = ({ newIssueId }: GetNewIssuePathParameters,) => {
    return [
    `/auth/v1/new-issues/${newIssueId}`
    ] as const;
    }


export const getGetNewIssueQueryOptions = <TData = Awaited<ReturnType<typeof getNewIssue>>, TError = ErrorType<HumaAPIError>>({ newIssueId }: GetNewIssuePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewIssueQueryKey({ newIssueId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewIssue>>> = ({ signal }) => getNewIssue({ newIssueId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: newIssueId !== null && newIssueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewIssueQueryResult = NonNullable<Awaited<ReturnType<typeof getNewIssue>>>
export type GetNewIssueQueryError = ErrorType<HumaAPIError>


export function useGetNewIssue<TData = Awaited<ReturnType<typeof getNewIssue>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssuePathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewIssue>>,
          TError,
          Awaited<ReturnType<typeof getNewIssue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssue<TData = Awaited<ReturnType<typeof getNewIssue>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssuePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewIssue>>,
          TError,
          Awaited<ReturnType<typeof getNewIssue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssue<TData = Awaited<ReturnType<typeof getNewIssue>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssuePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a new issue
 */

export function useGetNewIssue<TData = Awaited<ReturnType<typeof getNewIssue>>, TError = ErrorType<HumaAPIError>>(
 { newIssueId }: GetNewIssuePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewIssueQueryOptions({ newIssueId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNewIssueSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNewIssue>>, TError = ErrorType<HumaAPIError>>({ newIssueId }: GetNewIssuePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewIssueQueryKey({ newIssueId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewIssue>>> = ({ signal }) => getNewIssue({ newIssueId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewIssueSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNewIssue>>>
export type GetNewIssueSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetNewIssueSuspense<TData = Awaited<ReturnType<typeof getNewIssue>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssuePathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssueSuspense<TData = Awaited<ReturnType<typeof getNewIssue>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssuePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewIssueSuspense<TData = Awaited<ReturnType<typeof getNewIssue>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetNewIssuePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a new issue
 */

export function useGetNewIssueSuspense<TData = Awaited<ReturnType<typeof getNewIssue>>, TError = ErrorType<HumaAPIError>>(
 { newIssueId }: GetNewIssuePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNewIssue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewIssueSuspenseQueryOptions({ newIssueId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateNewIssueResponse200 = {
  data: NewIssueSummary
  status: 200
}

export type updateNewIssueResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateNewIssueResponseSuccess = (updateNewIssueResponse200) & {
  headers: Headers;
};
export type updateNewIssueResponseError = (updateNewIssueResponseDefault) & {
  headers: Headers;
};

export type updateNewIssueResponse = updateNewIssueResponseSuccess

export const getUpdateNewIssueUrl = ({ newIssueId }: UpdateNewIssuePathParameters,
    params?: UpdateNewIssueParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/new-issues/${newIssueId}?${stringifiedParams}` : `/auth/v1/new-issues/${newIssueId}`
}

/**
 * Deprecated for structured investments: a finalized structured investment returns 409; use edit-finalized-new-issue. IPO new issues are unaffected.
 * @summary Update a new issue
 */
export const updateNewIssue = async ({ newIssueId }: UpdateNewIssuePathParameters,
    updateNewIssueRequestBody: UpdateNewIssueRequestBody,
    params?: UpdateNewIssueParams, options?: Parameters<typeof customFetch>[1]): Promise<updateNewIssueResponse> => {

  return customFetch<updateNewIssueResponse>(getUpdateNewIssueUrl({ newIssueId },params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateNewIssueRequestBody)
  }
);}





export const getUpdateNewIssueMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNewIssue>>, TError,{pathParams: UpdateNewIssuePathParameters;data: UpdateNewIssueRequestBody;params?: UpdateNewIssueParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNewIssue>>, TError,{pathParams: UpdateNewIssuePathParameters;data: UpdateNewIssueRequestBody;params?: UpdateNewIssueParams}, TContext> => {

const mutationKey = ['updateNewIssue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNewIssue>>, {pathParams: UpdateNewIssuePathParameters;data: UpdateNewIssueRequestBody;params?: UpdateNewIssueParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  updateNewIssue(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNewIssueMutationResult = NonNullable<Awaited<ReturnType<typeof updateNewIssue>>>
    export type UpdateNewIssueMutationBody = UpdateNewIssueRequestBody
    export type UpdateNewIssueMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Update a new issue
 */
export const useUpdateNewIssue = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNewIssue>>, TError,{pathParams: UpdateNewIssuePathParameters;data: UpdateNewIssueRequestBody;params?: UpdateNewIssueParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNewIssue>>,
        TError,
        {pathParams: UpdateNewIssuePathParameters;data: UpdateNewIssueRequestBody;params?: UpdateNewIssueParams},
        TContext
      > => {
      return useMutation(getUpdateNewIssueMutationOptions(options), queryClient);
    }
    export type postNewIssueActionResponse200 = {
  data: GetNewIssueResponseBody
  status: 200
}

export type postNewIssueActionResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type postNewIssueActionResponseSuccess = (postNewIssueActionResponse200) & {
  headers: Headers;
};
export type postNewIssueActionResponseError = (postNewIssueActionResponseDefault) & {
  headers: Headers;
};

export type postNewIssueActionResponse = postNewIssueActionResponseSuccess

export const getPostNewIssueActionUrl = ({ newIssueId }: PostNewIssueActionPathParameters,) => {




  return `/auth/v1/new-issues/${newIssueId}/action`
}

/**
 * Suspend sets suspended_at on the new issue and every offering on it, keeping any existing timestamp. Resume clears it on the new issue and on offerings suspended at or after it, keeping earlier individual suspensions. Returns the new issue as get-new-issue does.
 * @summary Suspend or resume indications of interest on a whole structured-investment new issue, as its issuer
 */
export const postNewIssueAction = async ({ newIssueId }: PostNewIssueActionPathParameters,
    postNewIssueActionBody: PostNewIssueActionBody, options?: Parameters<typeof customFetch>[1]): Promise<postNewIssueActionResponse> => {

  return customFetch<postNewIssueActionResponse>(getPostNewIssueActionUrl({ newIssueId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postNewIssueActionBody)
  }
);}





export const getPostNewIssueActionMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNewIssueAction>>, TError,{pathParams: PostNewIssueActionPathParameters;data: PostNewIssueActionBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postNewIssueAction>>, TError,{pathParams: PostNewIssueActionPathParameters;data: PostNewIssueActionBody}, TContext> => {

const mutationKey = ['postNewIssueAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNewIssueAction>>, {pathParams: PostNewIssueActionPathParameters;data: PostNewIssueActionBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  postNewIssueAction(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostNewIssueActionMutationResult = NonNullable<Awaited<ReturnType<typeof postNewIssueAction>>>
    export type PostNewIssueActionMutationBody = PostNewIssueActionBody
    export type PostNewIssueActionMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Suspend or resume indications of interest on a whole structured-investment new issue, as its issuer
 */
export const usePostNewIssueAction = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNewIssueAction>>, TError,{pathParams: PostNewIssueActionPathParameters;data: PostNewIssueActionBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postNewIssueAction>>,
        TError,
        {pathParams: PostNewIssueActionPathParameters;data: PostNewIssueActionBody},
        TContext
      > => {
      return useMutation(getPostNewIssueActionMutationOptions(options), queryClient);
    }
    export type cancelNewIssueResponse200 = {
  data: CancelNewIssueResponseBody
  status: 200
}

export type cancelNewIssueResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type cancelNewIssueResponseSuccess = (cancelNewIssueResponse200) & {
  headers: Headers;
};
export type cancelNewIssueResponseError = (cancelNewIssueResponseDefault) & {
  headers: Headers;
};

export type cancelNewIssueResponse = cancelNewIssueResponseSuccess

export const getCancelNewIssueUrl = ({ newIssueId }: CancelNewIssuePathParameters,) => {




  return `/auth/v1/new-issues/${newIssueId}/cancel`
}

/**
 * @summary Cancel a new issue, as its issuer
 */
export const cancelNewIssue = async ({ newIssueId }: CancelNewIssuePathParameters, options?: Parameters<typeof customFetch>[1]): Promise<cancelNewIssueResponse> => {

  return customFetch<cancelNewIssueResponse>(getCancelNewIssueUrl({ newIssueId }),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelNewIssueMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelNewIssue>>, TError,{pathParams: CancelNewIssuePathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelNewIssue>>, TError,{pathParams: CancelNewIssuePathParameters}, TContext> => {

const mutationKey = ['cancelNewIssue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelNewIssue>>, {pathParams: CancelNewIssuePathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  cancelNewIssue(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelNewIssueMutationResult = NonNullable<Awaited<ReturnType<typeof cancelNewIssue>>>

    export type CancelNewIssueMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Cancel a new issue, as its issuer
 */
export const useCancelNewIssue = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelNewIssue>>, TError,{pathParams: CancelNewIssuePathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelNewIssue>>,
        TError,
        {pathParams: CancelNewIssuePathParameters},
        TContext
      > => {
      return useMutation(getCancelNewIssueMutationOptions(options), queryClient);
    }
    export type listNewIssueDocsResponse200 = {
  data: ListNewIssueDocsResponseBody
  status: 200
}

export type listNewIssueDocsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listNewIssueDocsResponseSuccess = (listNewIssueDocsResponse200) & {
  headers: Headers;
};
export type listNewIssueDocsResponseError = (listNewIssueDocsResponseDefault) & {
  headers: Headers;
};

export type listNewIssueDocsResponse = listNewIssueDocsResponseSuccess

export const getListNewIssueDocsUrl = ({ newIssueId }: ListNewIssueDocsPathParameters,) => {




  return `/auth/v1/new-issues/${newIssueId}/documents`
}

/**
 * @summary List the documents belonging to a new issue
 */
export const listNewIssueDocs = async ({ newIssueId }: ListNewIssueDocsPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<listNewIssueDocsResponse> => {

  return customFetch<listNewIssueDocsResponse>(getListNewIssueDocsUrl({ newIssueId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNewIssueDocsQueryKey = ({ newIssueId }: ListNewIssueDocsPathParameters,) => {
    return [
    `/auth/v1/new-issues/${newIssueId}/documents`
    ] as const;
    }


export const getListNewIssueDocsQueryOptions = <TData = Awaited<ReturnType<typeof listNewIssueDocs>>, TError = ErrorType<HumaAPIError>>({ newIssueId }: ListNewIssueDocsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNewIssueDocsQueryKey({ newIssueId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNewIssueDocs>>> = ({ signal }) => listNewIssueDocs({ newIssueId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: newIssueId !== null && newIssueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNewIssueDocsQueryResult = NonNullable<Awaited<ReturnType<typeof listNewIssueDocs>>>
export type ListNewIssueDocsQueryError = ErrorType<HumaAPIError>


export function useListNewIssueDocs<TData = Awaited<ReturnType<typeof listNewIssueDocs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListNewIssueDocsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNewIssueDocs>>,
          TError,
          Awaited<ReturnType<typeof listNewIssueDocs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNewIssueDocs<TData = Awaited<ReturnType<typeof listNewIssueDocs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListNewIssueDocsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNewIssueDocs>>,
          TError,
          Awaited<ReturnType<typeof listNewIssueDocs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNewIssueDocs<TData = Awaited<ReturnType<typeof listNewIssueDocs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListNewIssueDocsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the documents belonging to a new issue
 */

export function useListNewIssueDocs<TData = Awaited<ReturnType<typeof listNewIssueDocs>>, TError = ErrorType<HumaAPIError>>(
 { newIssueId }: ListNewIssueDocsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNewIssueDocsQueryOptions({ newIssueId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListNewIssueDocsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listNewIssueDocs>>, TError = ErrorType<HumaAPIError>>({ newIssueId }: ListNewIssueDocsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNewIssueDocsQueryKey({ newIssueId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNewIssueDocs>>> = ({ signal }) => listNewIssueDocs({ newIssueId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNewIssueDocsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listNewIssueDocs>>>
export type ListNewIssueDocsSuspenseQueryError = ErrorType<HumaAPIError>


export function useListNewIssueDocsSuspense<TData = Awaited<ReturnType<typeof listNewIssueDocs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListNewIssueDocsPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNewIssueDocsSuspense<TData = Awaited<ReturnType<typeof listNewIssueDocs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListNewIssueDocsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNewIssueDocsSuspense<TData = Awaited<ReturnType<typeof listNewIssueDocs>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListNewIssueDocsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the documents belonging to a new issue
 */

export function useListNewIssueDocsSuspense<TData = Awaited<ReturnType<typeof listNewIssueDocs>>, TError = ErrorType<HumaAPIError>>(
 { newIssueId }: ListNewIssueDocsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNewIssueDocs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNewIssueDocsSuspenseQueryOptions({ newIssueId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createNewIssueDocUploadsResponse201 = {
  data: OfferingDocUploadsResponseBody
  status: 201
}

export type createNewIssueDocUploadsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createNewIssueDocUploadsResponseSuccess = (createNewIssueDocUploadsResponse201) & {
  headers: Headers;
};
export type createNewIssueDocUploadsResponseError = (createNewIssueDocUploadsResponseDefault) & {
  headers: Headers;
};

export type createNewIssueDocUploadsResponse = createNewIssueDocUploadsResponseSuccess

export const getCreateNewIssueDocUploadsUrl = ({ newIssueId }: CreateNewIssueDocUploadsPathParameters,) => {




  return `/auth/v1/new-issues/${newIssueId}/documents/upload`
}

/**
 * @summary Mint presigned S3 URLs for one or more new-issue-document uploads
 */
export const createNewIssueDocUploads = async ({ newIssueId }: CreateNewIssueDocUploadsPathParameters,
    createNewIssueDocUploadsRequestBody: CreateNewIssueDocUploadsRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createNewIssueDocUploadsResponse> => {

  return customFetch<createNewIssueDocUploadsResponse>(getCreateNewIssueDocUploadsUrl({ newIssueId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createNewIssueDocUploadsRequestBody)
  }
);}





export const getCreateNewIssueDocUploadsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewIssueDocUploads>>, TError,{pathParams: CreateNewIssueDocUploadsPathParameters;data: CreateNewIssueDocUploadsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNewIssueDocUploads>>, TError,{pathParams: CreateNewIssueDocUploadsPathParameters;data: CreateNewIssueDocUploadsRequestBody}, TContext> => {

const mutationKey = ['createNewIssueDocUploads'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNewIssueDocUploads>>, {pathParams: CreateNewIssueDocUploadsPathParameters;data: CreateNewIssueDocUploadsRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  createNewIssueDocUploads(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNewIssueDocUploadsMutationResult = NonNullable<Awaited<ReturnType<typeof createNewIssueDocUploads>>>
    export type CreateNewIssueDocUploadsMutationBody = CreateNewIssueDocUploadsRequestBody
    export type CreateNewIssueDocUploadsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Mint presigned S3 URLs for one or more new-issue-document uploads
 */
export const useCreateNewIssueDocUploads = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewIssueDocUploads>>, TError,{pathParams: CreateNewIssueDocUploadsPathParameters;data: CreateNewIssueDocUploadsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNewIssueDocUploads>>,
        TError,
        {pathParams: CreateNewIssueDocUploadsPathParameters;data: CreateNewIssueDocUploadsRequestBody},
        TContext
      > => {
      return useMutation(getCreateNewIssueDocUploadsMutationOptions(options), queryClient);
    }
    export type editFinalizedNewIssueResponse200 = {
  data: NewIssueSummary
  status: 200
}

export type editFinalizedNewIssueResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type editFinalizedNewIssueResponseSuccess = (editFinalizedNewIssueResponse200) & {
  headers: Headers;
};
export type editFinalizedNewIssueResponseError = (editFinalizedNewIssueResponseDefault) & {
  headers: Headers;
};

export type editFinalizedNewIssueResponse = editFinalizedNewIssueResponseSuccess

export const getEditFinalizedNewIssueUrl = ({ newIssueId }: EditFinalizedNewIssuePathParameters,
    params?: EditFinalizedNewIssueParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/new-issues/${newIssueId}/edit-finalized?${stringifiedParams}` : `/auth/v1/new-issues/${newIssueId}/edit-finalized`
}

/**
 * @summary Edit a finalized new issue
 */
export const editFinalizedNewIssue = async ({ newIssueId }: EditFinalizedNewIssuePathParameters,
    updateNewIssueRequestBody: UpdateNewIssueRequestBody,
    params?: EditFinalizedNewIssueParams, options?: Parameters<typeof customFetch>[1]): Promise<editFinalizedNewIssueResponse> => {

  return customFetch<editFinalizedNewIssueResponse>(getEditFinalizedNewIssueUrl({ newIssueId },params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateNewIssueRequestBody)
  }
);}





export const getEditFinalizedNewIssueMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editFinalizedNewIssue>>, TError,{pathParams: EditFinalizedNewIssuePathParameters;data: UpdateNewIssueRequestBody;params?: EditFinalizedNewIssueParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editFinalizedNewIssue>>, TError,{pathParams: EditFinalizedNewIssuePathParameters;data: UpdateNewIssueRequestBody;params?: EditFinalizedNewIssueParams}, TContext> => {

const mutationKey = ['editFinalizedNewIssue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editFinalizedNewIssue>>, {pathParams: EditFinalizedNewIssuePathParameters;data: UpdateNewIssueRequestBody;params?: EditFinalizedNewIssueParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  editFinalizedNewIssue(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditFinalizedNewIssueMutationResult = NonNullable<Awaited<ReturnType<typeof editFinalizedNewIssue>>>
    export type EditFinalizedNewIssueMutationBody = UpdateNewIssueRequestBody
    export type EditFinalizedNewIssueMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Edit a finalized new issue
 */
export const useEditFinalizedNewIssue = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editFinalizedNewIssue>>, TError,{pathParams: EditFinalizedNewIssuePathParameters;data: UpdateNewIssueRequestBody;params?: EditFinalizedNewIssueParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editFinalizedNewIssue>>,
        TError,
        {pathParams: EditFinalizedNewIssuePathParameters;data: UpdateNewIssueRequestBody;params?: EditFinalizedNewIssueParams},
        TContext
      > => {
      return useMutation(getEditFinalizedNewIssueMutationOptions(options), queryClient);
    }
    export type updateNewIssueFinalSizeResponse200 = {
  data: GetNewIssueResponseBody
  status: 200
}

export type updateNewIssueFinalSizeResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateNewIssueFinalSizeResponseSuccess = (updateNewIssueFinalSizeResponse200) & {
  headers: Headers;
};
export type updateNewIssueFinalSizeResponseError = (updateNewIssueFinalSizeResponseDefault) & {
  headers: Headers;
};

export type updateNewIssueFinalSizeResponse = updateNewIssueFinalSizeResponseSuccess

export const getUpdateNewIssueFinalSizeUrl = ({ newIssueId }: UpdateNewIssueFinalSizePathParameters,) => {




  return `/auth/v1/new-issues/${newIssueId}/final-size`
}

/**
 * Partial update: an omitted or null field is left as-is. Returns the new issue as get-new-issue does.
 * @summary Update a finalized new issue's notional cap and final size deadline, as its issuer
 */
export const updateNewIssueFinalSize = async ({ newIssueId }: UpdateNewIssueFinalSizePathParameters,
    updateNewIssueFinalSizeRequestBody: UpdateNewIssueFinalSizeRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<updateNewIssueFinalSizeResponse> => {

  return customFetch<updateNewIssueFinalSizeResponse>(getUpdateNewIssueFinalSizeUrl({ newIssueId }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateNewIssueFinalSizeRequestBody)
  }
);}





export const getUpdateNewIssueFinalSizeMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNewIssueFinalSize>>, TError,{pathParams: UpdateNewIssueFinalSizePathParameters;data: UpdateNewIssueFinalSizeRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNewIssueFinalSize>>, TError,{pathParams: UpdateNewIssueFinalSizePathParameters;data: UpdateNewIssueFinalSizeRequestBody}, TContext> => {

const mutationKey = ['updateNewIssueFinalSize'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNewIssueFinalSize>>, {pathParams: UpdateNewIssueFinalSizePathParameters;data: UpdateNewIssueFinalSizeRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  updateNewIssueFinalSize(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNewIssueFinalSizeMutationResult = NonNullable<Awaited<ReturnType<typeof updateNewIssueFinalSize>>>
    export type UpdateNewIssueFinalSizeMutationBody = UpdateNewIssueFinalSizeRequestBody
    export type UpdateNewIssueFinalSizeMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Update a finalized new issue's notional cap and final size deadline, as its issuer
 */
export const useUpdateNewIssueFinalSize = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNewIssueFinalSize>>, TError,{pathParams: UpdateNewIssueFinalSizePathParameters;data: UpdateNewIssueFinalSizeRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNewIssueFinalSize>>,
        TError,
        {pathParams: UpdateNewIssueFinalSizePathParameters;data: UpdateNewIssueFinalSizeRequestBody},
        TContext
      > => {
      return useMutation(getUpdateNewIssueFinalSizeMutationOptions(options), queryClient);
    }
    export type confirmNewIssueFinalTermsResponse200 = {
  data: ConfirmNewIssueFinalTermsBody
  status: 200
}

export type confirmNewIssueFinalTermsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type confirmNewIssueFinalTermsResponseSuccess = (confirmNewIssueFinalTermsResponse200) & {
  headers: Headers;
};
export type confirmNewIssueFinalTermsResponseError = (confirmNewIssueFinalTermsResponseDefault) & {
  headers: Headers;
};

export type confirmNewIssueFinalTermsResponse = confirmNewIssueFinalTermsResponseSuccess

export const getConfirmNewIssueFinalTermsUrl = ({ newIssueId }: ConfirmNewIssueFinalTermsPathParameters,) => {




  return `/auth/v1/new-issues/${newIssueId}/final-terms/confirm`
}

/**
 * In one transaction: saves data when given (as edit-finalized does, after dropping any _min/_max under a gate that is off), refuses with 400 while a _min/_max remains on a visible field, refuses with 409 unless at least one offering is approved and every approved offering's final size is confirmed, then stamps final_terms_confirmed_at and publishes the new issue. Refuses with 409 once final terms are confirmed.
 * @summary Confirm a new issue's final terms, as its issuer
 */
export const confirmNewIssueFinalTerms = async ({ newIssueId }: ConfirmNewIssueFinalTermsPathParameters,
    confirmNewIssueFinalTermsRequestBody: ConfirmNewIssueFinalTermsRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<confirmNewIssueFinalTermsResponse> => {

  return customFetch<confirmNewIssueFinalTermsResponse>(getConfirmNewIssueFinalTermsUrl({ newIssueId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(confirmNewIssueFinalTermsRequestBody)
  }
);}





export const getConfirmNewIssueFinalTermsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmNewIssueFinalTerms>>, TError,{pathParams: ConfirmNewIssueFinalTermsPathParameters;data: ConfirmNewIssueFinalTermsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmNewIssueFinalTerms>>, TError,{pathParams: ConfirmNewIssueFinalTermsPathParameters;data: ConfirmNewIssueFinalTermsRequestBody}, TContext> => {

const mutationKey = ['confirmNewIssueFinalTerms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmNewIssueFinalTerms>>, {pathParams: ConfirmNewIssueFinalTermsPathParameters;data: ConfirmNewIssueFinalTermsRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  confirmNewIssueFinalTerms(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmNewIssueFinalTermsMutationResult = NonNullable<Awaited<ReturnType<typeof confirmNewIssueFinalTerms>>>
    export type ConfirmNewIssueFinalTermsMutationBody = ConfirmNewIssueFinalTermsRequestBody
    export type ConfirmNewIssueFinalTermsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Confirm a new issue's final terms, as its issuer
 */
export const useConfirmNewIssueFinalTerms = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmNewIssueFinalTerms>>, TError,{pathParams: ConfirmNewIssueFinalTermsPathParameters;data: ConfirmNewIssueFinalTermsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmNewIssueFinalTerms>>,
        TError,
        {pathParams: ConfirmNewIssueFinalTermsPathParameters;data: ConfirmNewIssueFinalTermsRequestBody},
        TContext
      > => {
      return useMutation(getConfirmNewIssueFinalTermsMutationOptions(options), queryClient);
    }
    export type finalizeNewIssueResponse200 = {
  data: FinalizeNewIssueResponseBody
  status: 200
}

export type finalizeNewIssueResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type finalizeNewIssueResponseSuccess = (finalizeNewIssueResponse200) & {
  headers: Headers;
};
export type finalizeNewIssueResponseError = (finalizeNewIssueResponseDefault) & {
  headers: Headers;
};

export type finalizeNewIssueResponse = finalizeNewIssueResponseSuccess

export const getFinalizeNewIssueUrl = ({ newIssueId }: FinalizeNewIssuePathParameters,) => {




  return `/auth/v1/new-issues/${newIssueId}/finalize`
}

/**
 * @summary Finalize a new issue
 */
export const finalizeNewIssue = async ({ newIssueId }: FinalizeNewIssuePathParameters, options?: Parameters<typeof customFetch>[1]): Promise<finalizeNewIssueResponse> => {

  return customFetch<finalizeNewIssueResponse>(getFinalizeNewIssueUrl({ newIssueId }),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFinalizeNewIssueMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizeNewIssue>>, TError,{pathParams: FinalizeNewIssuePathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof finalizeNewIssue>>, TError,{pathParams: FinalizeNewIssuePathParameters}, TContext> => {

const mutationKey = ['finalizeNewIssue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finalizeNewIssue>>, {pathParams: FinalizeNewIssuePathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  finalizeNewIssue(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinalizeNewIssueMutationResult = NonNullable<Awaited<ReturnType<typeof finalizeNewIssue>>>

    export type FinalizeNewIssueMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Finalize a new issue
 */
export const useFinalizeNewIssue = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizeNewIssue>>, TError,{pathParams: FinalizeNewIssuePathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finalizeNewIssue>>,
        TError,
        {pathParams: FinalizeNewIssuePathParameters},
        TContext
      > => {
      return useMutation(getFinalizeNewIssueMutationOptions(options), queryClient);
    }
    export type checkNewIssueFinalizeResponse200 = {
  data: CheckNewIssueFinalizeResponseBody
  status: 200
}

export type checkNewIssueFinalizeResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type checkNewIssueFinalizeResponseSuccess = (checkNewIssueFinalizeResponse200) & {
  headers: Headers;
};
export type checkNewIssueFinalizeResponseError = (checkNewIssueFinalizeResponseDefault) & {
  headers: Headers;
};

export type checkNewIssueFinalizeResponse = checkNewIssueFinalizeResponseSuccess

export const getCheckNewIssueFinalizeUrl = ({ newIssueId }: CheckNewIssueFinalizePathParameters,) => {




  return `/auth/v1/new-issues/${newIssueId}/finalize-check`
}

/**
 * Runs the checks finalize runs, without finalizing or writing anything, and returns every problem finalize would reject the data for. Checks the data in the request body when given, else the stored draft. With final_terms, checks a finalized structured investment the way final-terms confirm would, reporting every _min/_max left on a visible field and every final-terms-required field left blank.
 * @summary Check whether finalize would accept a structured investment draft
 */
export const checkNewIssueFinalize = async ({ newIssueId }: CheckNewIssueFinalizePathParameters,
    checkNewIssueFinalizeRequestBody?: CheckNewIssueFinalizeRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<checkNewIssueFinalizeResponse> => {

  return customFetch<checkNewIssueFinalizeResponse>(getCheckNewIssueFinalizeUrl({ newIssueId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(checkNewIssueFinalizeRequestBody)
  }
);}





export const getCheckNewIssueFinalizeMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkNewIssueFinalize>>, TError,{pathParams: CheckNewIssueFinalizePathParameters;data?: CheckNewIssueFinalizeRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof checkNewIssueFinalize>>, TError,{pathParams: CheckNewIssueFinalizePathParameters;data?: CheckNewIssueFinalizeRequestBody}, TContext> => {

const mutationKey = ['checkNewIssueFinalize'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkNewIssueFinalize>>, {pathParams: CheckNewIssueFinalizePathParameters;data?: CheckNewIssueFinalizeRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  checkNewIssueFinalize(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckNewIssueFinalizeMutationResult = NonNullable<Awaited<ReturnType<typeof checkNewIssueFinalize>>>
    export type CheckNewIssueFinalizeMutationBody = CheckNewIssueFinalizeRequestBody | undefined
    export type CheckNewIssueFinalizeMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Check whether finalize would accept a structured investment draft
 */
export const useCheckNewIssueFinalize = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkNewIssueFinalize>>, TError,{pathParams: CheckNewIssueFinalizePathParameters;data?: CheckNewIssueFinalizeRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkNewIssueFinalize>>,
        TError,
        {pathParams: CheckNewIssueFinalizePathParameters;data?: CheckNewIssueFinalizeRequestBody},
        TContext
      > => {
      return useMutation(getCheckNewIssueFinalizeMutationOptions(options), queryClient);
    }
    export type listOfferingsResponse200 = {
  data: ListOfferingsResponseBody
  status: 200
}

export type listOfferingsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listOfferingsResponseSuccess = (listOfferingsResponse200) & {
  headers: Headers;
};
export type listOfferingsResponseError = (listOfferingsResponseDefault) & {
  headers: Headers;
};

export type listOfferingsResponse = listOfferingsResponseSuccess

export const getListOfferingsUrl = (params?: ListOfferingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/offerings?${stringifiedParams}` : `/auth/v1/offerings`
}

/**
 * @summary List the offerings the caller's org has been entitled to
 */
export const listOfferings = async (params?: ListOfferingsParams, options?: Parameters<typeof customFetch>[1]): Promise<listOfferingsResponse> => {

  return customFetch<listOfferingsResponse>(getListOfferingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOfferingsQueryKey = (params?: ListOfferingsParams,) => {
    return [
    `/auth/v1/offerings`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOfferingsQueryOptions = <TData = Awaited<ReturnType<typeof listOfferings>>, TError = ErrorType<HumaAPIError>>(params?: ListOfferingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOfferingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOfferings>>> = ({ signal }) => listOfferings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOfferingsQueryResult = NonNullable<Awaited<ReturnType<typeof listOfferings>>>
export type ListOfferingsQueryError = ErrorType<HumaAPIError>


export function useListOfferings<TData = Awaited<ReturnType<typeof listOfferings>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListOfferingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfferings>>,
          TError,
          Awaited<ReturnType<typeof listOfferings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfferings<TData = Awaited<ReturnType<typeof listOfferings>>, TError = ErrorType<HumaAPIError>>(
 params?: ListOfferingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfferings>>,
          TError,
          Awaited<ReturnType<typeof listOfferings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfferings<TData = Awaited<ReturnType<typeof listOfferings>>, TError = ErrorType<HumaAPIError>>(
 params?: ListOfferingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the offerings the caller's org has been entitled to
 */

export function useListOfferings<TData = Awaited<ReturnType<typeof listOfferings>>, TError = ErrorType<HumaAPIError>>(
 params?: ListOfferingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOfferingsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListOfferingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listOfferings>>, TError = ErrorType<HumaAPIError>>(params?: ListOfferingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOfferingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOfferings>>> = ({ signal }) => listOfferings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOfferingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listOfferings>>>
export type ListOfferingsSuspenseQueryError = ErrorType<HumaAPIError>


export function useListOfferingsSuspense<TData = Awaited<ReturnType<typeof listOfferings>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListOfferingsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfferingsSuspense<TData = Awaited<ReturnType<typeof listOfferings>>, TError = ErrorType<HumaAPIError>>(
 params?: ListOfferingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfferingsSuspense<TData = Awaited<ReturnType<typeof listOfferings>>, TError = ErrorType<HumaAPIError>>(
 params?: ListOfferingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the offerings the caller's org has been entitled to
 */

export function useListOfferingsSuspense<TData = Awaited<ReturnType<typeof listOfferings>>, TError = ErrorType<HumaAPIError>>(
 params?: ListOfferingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOfferingsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createOfferingResponse200 = {
  data: CreateOfferingResponseBody
  status: 200
}

export type createOfferingResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type createOfferingResponseSuccess = (createOfferingResponse200) & {
  headers: Headers;
};
export type createOfferingResponseError = (createOfferingResponseDefault) & {
  headers: Headers;
};

export type createOfferingResponse = createOfferingResponseSuccess

export const getCreateOfferingUrl = () => {




  return `/auth/v1/offerings`
}

/**
 * Self-led IPO: the issuer opens the offering with itself as distributor, approved on creation.
 * @summary Open an offering on a new issue the caller's org owns
 */
export const createOffering = async (createOfferingRequestBody: CreateOfferingRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createOfferingResponse> => {

  return customFetch<createOfferingResponse>(getCreateOfferingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOfferingRequestBody)
  }
);}





export const getCreateOfferingMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOffering>>, TError,{data: CreateOfferingRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOffering>>, TError,{data: CreateOfferingRequestBody}, TContext> => {

const mutationKey = ['createOffering'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOffering>>, {data: CreateOfferingRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createOffering(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOfferingMutationResult = NonNullable<Awaited<ReturnType<typeof createOffering>>>
    export type CreateOfferingMutationBody = CreateOfferingRequestBody
    export type CreateOfferingMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Open an offering on a new issue the caller's org owns
 */
export const useCreateOffering = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOffering>>, TError,{data: CreateOfferingRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOffering>>,
        TError,
        {data: CreateOfferingRequestBody},
        TContext
      > => {
      return useMutation(getCreateOfferingMutationOptions(options), queryClient);
    }
    export type listOfferingEntitlementsResponse200 = {
  data: ListOfferingEntitlementsResponseBody
  status: 200
}

export type listOfferingEntitlementsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listOfferingEntitlementsResponseSuccess = (listOfferingEntitlementsResponse200) & {
  headers: Headers;
};
export type listOfferingEntitlementsResponseError = (listOfferingEntitlementsResponseDefault) & {
  headers: Headers;
};

export type listOfferingEntitlementsResponse = listOfferingEntitlementsResponseSuccess

export const getListOfferingEntitlementsUrl = () => {




  return `/auth/v1/offerings/entitlements`
}

/**
 * @summary List a new issue's offering entitlements
 */
export const listOfferingEntitlements = async ( options?: Parameters<typeof customFetch>[1]): Promise<listOfferingEntitlementsResponse> => {

  return customFetch<listOfferingEntitlementsResponse>(getListOfferingEntitlementsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOfferingEntitlementsQueryKey = () => {
    return [
    `/auth/v1/offerings/entitlements`
    ] as const;
    }


export const getListOfferingEntitlementsQueryOptions = <TData = Awaited<ReturnType<typeof listOfferingEntitlements>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOfferingEntitlementsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOfferingEntitlements>>> = ({ signal }) => listOfferingEntitlements({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOfferingEntitlementsQueryResult = NonNullable<Awaited<ReturnType<typeof listOfferingEntitlements>>>
export type ListOfferingEntitlementsQueryError = ErrorType<HumaAPIError>


export function useListOfferingEntitlements<TData = Awaited<ReturnType<typeof listOfferingEntitlements>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfferingEntitlements>>,
          TError,
          Awaited<ReturnType<typeof listOfferingEntitlements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfferingEntitlements<TData = Awaited<ReturnType<typeof listOfferingEntitlements>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfferingEntitlements>>,
          TError,
          Awaited<ReturnType<typeof listOfferingEntitlements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfferingEntitlements<TData = Awaited<ReturnType<typeof listOfferingEntitlements>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a new issue's offering entitlements
 */

export function useListOfferingEntitlements<TData = Awaited<ReturnType<typeof listOfferingEntitlements>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOfferingEntitlementsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListOfferingEntitlementsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listOfferingEntitlements>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOfferingEntitlementsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOfferingEntitlements>>> = ({ signal }) => listOfferingEntitlements({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOfferingEntitlementsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listOfferingEntitlements>>>
export type ListOfferingEntitlementsSuspenseQueryError = ErrorType<HumaAPIError>


export function useListOfferingEntitlementsSuspense<TData = Awaited<ReturnType<typeof listOfferingEntitlements>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfferingEntitlementsSuspense<TData = Awaited<ReturnType<typeof listOfferingEntitlements>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfferingEntitlementsSuspense<TData = Awaited<ReturnType<typeof listOfferingEntitlements>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a new issue's offering entitlements
 */

export function useListOfferingEntitlementsSuspense<TData = Awaited<ReturnType<typeof listOfferingEntitlements>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOfferingEntitlements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOfferingEntitlementsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createOfferingEntitlementsResponse200 = {
  data: CreateOfferingEntitlementsResponseBody
  status: 200
}

export type createOfferingEntitlementsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type createOfferingEntitlementsResponseSuccess = (createOfferingEntitlementsResponse200) & {
  headers: Headers;
};
export type createOfferingEntitlementsResponseError = (createOfferingEntitlementsResponseDefault) & {
  headers: Headers;
};

export type createOfferingEntitlementsResponse = createOfferingEntitlementsResponseSuccess

export const getCreateOfferingEntitlementsUrl = () => {




  return `/auth/v1/offerings/entitlements`
}

/**
 * Structured-investment distribution, issuer only: the caller's org must own the new issue, and every grantee must be on the issuer's distributor allowlist (422 otherwise). Each offering starts pending until its distributor reviews it. advisor_concession_percent is required; total_notional must be greater than 0, or omitted for no cap. On an IPO new issue both terms are dropped.
 * @summary Entitle organizations to a finalized new issue
 */
export const createOfferingEntitlements = async (createOfferingEntitlementsRequestBody: CreateOfferingEntitlementsRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createOfferingEntitlementsResponse> => {

  return customFetch<createOfferingEntitlementsResponse>(getCreateOfferingEntitlementsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOfferingEntitlementsRequestBody)
  }
);}





export const getCreateOfferingEntitlementsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOfferingEntitlements>>, TError,{data: CreateOfferingEntitlementsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOfferingEntitlements>>, TError,{data: CreateOfferingEntitlementsRequestBody}, TContext> => {

const mutationKey = ['createOfferingEntitlements'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOfferingEntitlements>>, {data: CreateOfferingEntitlementsRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createOfferingEntitlements(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOfferingEntitlementsMutationResult = NonNullable<Awaited<ReturnType<typeof createOfferingEntitlements>>>
    export type CreateOfferingEntitlementsMutationBody = CreateOfferingEntitlementsRequestBody
    export type CreateOfferingEntitlementsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Entitle organizations to a finalized new issue
 */
export const useCreateOfferingEntitlements = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOfferingEntitlements>>, TError,{data: CreateOfferingEntitlementsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOfferingEntitlements>>,
        TError,
        {data: CreateOfferingEntitlementsRequestBody},
        TContext
      > => {
      return useMutation(getCreateOfferingEntitlementsMutationOptions(options), queryClient);
    }
    export type listEntitlementOrganizationsResponse200 = {
  data: ListEntitlementOrganizationsResponseBody
  status: 200
}

export type listEntitlementOrganizationsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listEntitlementOrganizationsResponseSuccess = (listEntitlementOrganizationsResponse200) & {
  headers: Headers;
};
export type listEntitlementOrganizationsResponseError = (listEntitlementOrganizationsResponseDefault) & {
  headers: Headers;
};

export type listEntitlementOrganizationsResponse = listEntitlementOrganizationsResponseSuccess

export const getListEntitlementOrganizationsUrl = () => {




  return `/auth/v1/offerings/entitlements/organizations`
}

/**
 * @summary List the caller's entitle-able counterparty organizations
 */
export const listEntitlementOrganizations = async ( options?: Parameters<typeof customFetch>[1]): Promise<listEntitlementOrganizationsResponse> => {

  return customFetch<listEntitlementOrganizationsResponse>(getListEntitlementOrganizationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEntitlementOrganizationsQueryKey = () => {
    return [
    `/auth/v1/offerings/entitlements/organizations`
    ] as const;
    }


export const getListEntitlementOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEntitlementOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEntitlementOrganizations>>> = ({ signal }) => listEntitlementOrganizations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEntitlementOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof listEntitlementOrganizations>>>
export type ListEntitlementOrganizationsQueryError = ErrorType<HumaAPIError>


export function useListEntitlementOrganizations<TData = Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEntitlementOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listEntitlementOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEntitlementOrganizations<TData = Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEntitlementOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listEntitlementOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEntitlementOrganizations<TData = Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the caller's entitle-able counterparty organizations
 */

export function useListEntitlementOrganizations<TData = Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEntitlementOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListEntitlementOrganizationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEntitlementOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEntitlementOrganizations>>> = ({ signal }) => listEntitlementOrganizations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEntitlementOrganizationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listEntitlementOrganizations>>>
export type ListEntitlementOrganizationsSuspenseQueryError = ErrorType<HumaAPIError>


export function useListEntitlementOrganizationsSuspense<TData = Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEntitlementOrganizationsSuspense<TData = Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEntitlementOrganizationsSuspense<TData = Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the caller's entitle-able counterparty organizations
 */

export function useListEntitlementOrganizationsSuspense<TData = Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntitlementOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEntitlementOrganizationsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getOfferingSchemaResponse200 = {
  data: GetOfferingSchemaResponseBody
  status: 200
}

export type getOfferingSchemaResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getOfferingSchemaResponseSuccess = (getOfferingSchemaResponse200) & {
  headers: Headers;
};
export type getOfferingSchemaResponseError = (getOfferingSchemaResponseDefault) & {
  headers: Headers;
};

export type getOfferingSchemaResponse = getOfferingSchemaResponseSuccess

export const getGetOfferingSchemaUrl = () => {




  return `/auth/v1/offerings/schema`
}

/**
 * @summary Get the grantee-side offering JSON Schema
 */
export const getOfferingSchema = async ( options?: Parameters<typeof customFetch>[1]): Promise<getOfferingSchemaResponse> => {

  return customFetch<getOfferingSchemaResponse>(getGetOfferingSchemaUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOfferingSchemaQueryKey = () => {
    return [
    `/auth/v1/offerings/schema`
    ] as const;
    }


export const getGetOfferingSchemaQueryOptions = <TData = Awaited<ReturnType<typeof getOfferingSchema>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOfferingSchemaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOfferingSchema>>> = ({ signal }) => getOfferingSchema({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOfferingSchemaQueryResult = NonNullable<Awaited<ReturnType<typeof getOfferingSchema>>>
export type GetOfferingSchemaQueryError = ErrorType<HumaAPIError>


export function useGetOfferingSchema<TData = Awaited<ReturnType<typeof getOfferingSchema>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferingSchema>>,
          TError,
          Awaited<ReturnType<typeof getOfferingSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOfferingSchema<TData = Awaited<ReturnType<typeof getOfferingSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferingSchema>>,
          TError,
          Awaited<ReturnType<typeof getOfferingSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOfferingSchema<TData = Awaited<ReturnType<typeof getOfferingSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the grantee-side offering JSON Schema
 */

export function useGetOfferingSchema<TData = Awaited<ReturnType<typeof getOfferingSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOfferingSchemaQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOfferingSchemaSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOfferingSchema>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOfferingSchemaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOfferingSchema>>> = ({ signal }) => getOfferingSchema({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOfferingSchemaSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOfferingSchema>>>
export type GetOfferingSchemaSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetOfferingSchemaSuspense<TData = Awaited<ReturnType<typeof getOfferingSchema>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOfferingSchemaSuspense<TData = Awaited<ReturnType<typeof getOfferingSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOfferingSchemaSuspense<TData = Awaited<ReturnType<typeof getOfferingSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the grantee-side offering JSON Schema
 */

export function useGetOfferingSchemaSuspense<TData = Awaited<ReturnType<typeof getOfferingSchema>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOfferingSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOfferingSchemaSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getOfferingResponse200 = {
  data: GetOfferingResponseBody
  status: 200
}

export type getOfferingResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getOfferingResponseSuccess = (getOfferingResponse200) & {
  headers: Headers;
};
export type getOfferingResponseError = (getOfferingResponseDefault) & {
  headers: Headers;
};

export type getOfferingResponse = getOfferingResponseSuccess

export const getGetOfferingUrl = ({ offeringId }: GetOfferingPathParameters,) => {




  return `/auth/v1/offerings/${offeringId}`
}

/**
 * @summary Get one offering, as either its distributor or its issuer
 */
export const getOffering = async ({ offeringId }: GetOfferingPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getOfferingResponse> => {

  return customFetch<getOfferingResponse>(getGetOfferingUrl({ offeringId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOfferingQueryKey = ({ offeringId }: GetOfferingPathParameters,) => {
    return [
    `/auth/v1/offerings/${offeringId}`
    ] as const;
    }


export const getGetOfferingQueryOptions = <TData = Awaited<ReturnType<typeof getOffering>>, TError = ErrorType<HumaAPIError>>({ offeringId }: GetOfferingPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOfferingQueryKey({ offeringId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOffering>>> = ({ signal }) => getOffering({ offeringId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: offeringId !== null && offeringId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOfferingQueryResult = NonNullable<Awaited<ReturnType<typeof getOffering>>>
export type GetOfferingQueryError = ErrorType<HumaAPIError>


export function useGetOffering<TData = Awaited<ReturnType<typeof getOffering>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOfferingPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOffering>>,
          TError,
          Awaited<ReturnType<typeof getOffering>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOffering<TData = Awaited<ReturnType<typeof getOffering>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOfferingPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOffering>>,
          TError,
          Awaited<ReturnType<typeof getOffering>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOffering<TData = Awaited<ReturnType<typeof getOffering>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOfferingPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one offering, as either its distributor or its issuer
 */

export function useGetOffering<TData = Awaited<ReturnType<typeof getOffering>>, TError = ErrorType<HumaAPIError>>(
 { offeringId }: GetOfferingPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOfferingQueryOptions({ offeringId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOfferingSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOffering>>, TError = ErrorType<HumaAPIError>>({ offeringId }: GetOfferingPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOfferingQueryKey({ offeringId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOffering>>> = ({ signal }) => getOffering({ offeringId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOfferingSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOffering>>>
export type GetOfferingSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetOfferingSuspense<TData = Awaited<ReturnType<typeof getOffering>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOfferingPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOfferingSuspense<TData = Awaited<ReturnType<typeof getOffering>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOfferingPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOfferingSuspense<TData = Awaited<ReturnType<typeof getOffering>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOfferingPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one offering, as either its distributor or its issuer
 */

export function useGetOfferingSuspense<TData = Awaited<ReturnType<typeof getOffering>>, TError = ErrorType<HumaAPIError>>(
 { offeringId }: GetOfferingPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOffering>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOfferingSuspenseQueryOptions({ offeringId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateOfferingResponse200 = {
  data: UpdateOfferingResponseBody
  status: 200
}

export type updateOfferingResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateOfferingResponseSuccess = (updateOfferingResponse200) & {
  headers: Headers;
};
export type updateOfferingResponseError = (updateOfferingResponseDefault) & {
  headers: Headers;
};

export type updateOfferingResponse = updateOfferingResponseSuccess

export const getUpdateOfferingUrl = ({ offeringId }: UpdateOfferingPathParameters,) => {




  return `/auth/v1/offerings/${offeringId}`
}

/**
 * IPO and structured investment. The creator sets price, concessions and timing; advisor_concession_percent and total_notional are structured-investment only (422 on an IPO) and return 409 once the offering is rejected or its new issue's final terms are confirmed. The distributor may send only status and books_close_time.
 * @summary Update an offering's status, timing, and pricing terms
 */
export const updateOffering = async ({ offeringId }: UpdateOfferingPathParameters,
    updateOfferingRequestBody: UpdateOfferingRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<updateOfferingResponse> => {

  return customFetch<updateOfferingResponse>(getUpdateOfferingUrl({ offeringId }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateOfferingRequestBody)
  }
);}





export const getUpdateOfferingMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOffering>>, TError,{pathParams: UpdateOfferingPathParameters;data: UpdateOfferingRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOffering>>, TError,{pathParams: UpdateOfferingPathParameters;data: UpdateOfferingRequestBody}, TContext> => {

const mutationKey = ['updateOffering'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOffering>>, {pathParams: UpdateOfferingPathParameters;data: UpdateOfferingRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  updateOffering(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOfferingMutationResult = NonNullable<Awaited<ReturnType<typeof updateOffering>>>
    export type UpdateOfferingMutationBody = UpdateOfferingRequestBody
    export type UpdateOfferingMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Update an offering's status, timing, and pricing terms
 */
export const useUpdateOffering = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOffering>>, TError,{pathParams: UpdateOfferingPathParameters;data: UpdateOfferingRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOffering>>,
        TError,
        {pathParams: UpdateOfferingPathParameters;data: UpdateOfferingRequestBody},
        TContext
      > => {
      return useMutation(getUpdateOfferingMutationOptions(options), queryClient);
    }
    export type postOfferingActionResponse200 = {
  data: OfferingEntitlement
  status: 200
}

export type postOfferingActionResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type postOfferingActionResponseSuccess = (postOfferingActionResponse200) & {
  headers: Headers;
};
export type postOfferingActionResponseError = (postOfferingActionResponseDefault) & {
  headers: Headers;
};

export type postOfferingActionResponse = postOfferingActionResponseSuccess

export const getPostOfferingActionUrl = ({ offeringId }: PostOfferingActionPathParameters,) => {




  return `/auth/v1/offerings/${offeringId}/action`
}

/**
 * Idempotent: suspending a suspended offering, resuming an active one or re-confirming keeps the stored state, and confirm keeps the first timestamp.
 * @summary Suspend or resume an offering, or confirm its final size, as its issuer
 */
export const postOfferingAction = async ({ offeringId }: PostOfferingActionPathParameters,
    postOfferingActionBody: PostOfferingActionBody, options?: Parameters<typeof customFetch>[1]): Promise<postOfferingActionResponse> => {

  return customFetch<postOfferingActionResponse>(getPostOfferingActionUrl({ offeringId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postOfferingActionBody)
  }
);}





export const getPostOfferingActionMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOfferingAction>>, TError,{pathParams: PostOfferingActionPathParameters;data: PostOfferingActionBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postOfferingAction>>, TError,{pathParams: PostOfferingActionPathParameters;data: PostOfferingActionBody}, TContext> => {

const mutationKey = ['postOfferingAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postOfferingAction>>, {pathParams: PostOfferingActionPathParameters;data: PostOfferingActionBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  postOfferingAction(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostOfferingActionMutationResult = NonNullable<Awaited<ReturnType<typeof postOfferingAction>>>
    export type PostOfferingActionMutationBody = PostOfferingActionBody
    export type PostOfferingActionMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Suspend or resume an offering, or confirm its final size, as its issuer
 */
export const usePostOfferingAction = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOfferingAction>>, TError,{pathParams: PostOfferingActionPathParameters;data: PostOfferingActionBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postOfferingAction>>,
        TError,
        {pathParams: PostOfferingActionPathParameters;data: PostOfferingActionBody},
        TContext
      > => {
      return useMutation(getPostOfferingActionMutationOptions(options), queryClient);
    }
    export type updateDistributorReviewResponse200 = {
  data: DistributorReview
  status: 200
}

export type updateDistributorReviewResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateDistributorReviewResponseSuccess = (updateDistributorReviewResponse200) & {
  headers: Headers;
};
export type updateDistributorReviewResponseError = (updateDistributorReviewResponseDefault) & {
  headers: Headers;
};

export type updateDistributorReviewResponse = updateDistributorReviewResponseSuccess

export const getUpdateDistributorReviewUrl = ({ offeringId }: UpdateDistributorReviewPathParameters,) => {




  return `/auth/v1/offerings/${offeringId}/distributor-review`
}

/**
 * Partial update: an omitted field keeps its stored value, so the decision and books can be changed later.
 * @summary Approve or reject an offering and set its books window, as its entitled distributor
 */
export const updateDistributorReview = async ({ offeringId }: UpdateDistributorReviewPathParameters,
    distributorReviewBody: DistributorReviewBody, options?: Parameters<typeof customFetch>[1]): Promise<updateDistributorReviewResponse> => {

  return customFetch<updateDistributorReviewResponse>(getUpdateDistributorReviewUrl({ offeringId }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(distributorReviewBody)
  }
);}





export const getUpdateDistributorReviewMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDistributorReview>>, TError,{pathParams: UpdateDistributorReviewPathParameters;data: DistributorReviewBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDistributorReview>>, TError,{pathParams: UpdateDistributorReviewPathParameters;data: DistributorReviewBody}, TContext> => {

const mutationKey = ['updateDistributorReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDistributorReview>>, {pathParams: UpdateDistributorReviewPathParameters;data: DistributorReviewBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  updateDistributorReview(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDistributorReviewMutationResult = NonNullable<Awaited<ReturnType<typeof updateDistributorReview>>>
    export type UpdateDistributorReviewMutationBody = DistributorReviewBody
    export type UpdateDistributorReviewMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Approve or reject an offering and set its books window, as its entitled distributor
 */
export const useUpdateDistributorReview = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDistributorReview>>, TError,{pathParams: UpdateDistributorReviewPathParameters;data: DistributorReviewBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDistributorReview>>,
        TError,
        {pathParams: UpdateDistributorReviewPathParameters;data: DistributorReviewBody},
        TContext
      > => {
      return useMutation(getUpdateDistributorReviewMutationOptions(options), queryClient);
    }
    export type getPageConfigResponse200 = {
  data: SingleViewConfigBody
  status: 200
}

export type getPageConfigResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getPageConfigResponseSuccess = (getPageConfigResponse200) & {
  headers: Headers;
};
export type getPageConfigResponseError = (getPageConfigResponseDefault) & {
  headers: Headers;
};

export type getPageConfigResponse = getPageConfigResponseSuccess

export const getGetPageConfigUrl = ({ pageKey }: GetPageConfigPathParameters,
    params: GetPageConfigParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/page-config/${pageKey}?${stringifiedParams}` : `/auth/v1/page-config/${pageKey}`
}

/**
 * @summary Get page configuration
 */
export const getPageConfig = async ({ pageKey }: GetPageConfigPathParameters,
    params: GetPageConfigParams, options?: Parameters<typeof customFetch>[1]): Promise<getPageConfigResponse> => {

  return customFetch<getPageConfigResponse>(getGetPageConfigUrl({ pageKey },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPageConfigQueryKey = ({ pageKey }: GetPageConfigPathParameters,
    params?: GetPageConfigParams,) => {
    return [
    `/auth/v1/page-config/${pageKey}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPageConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPageConfig>>, TError = ErrorType<HumaAPIError>>({ pageKey }: GetPageConfigPathParameters,
    params: GetPageConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPageConfigQueryKey({ pageKey },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageConfig>>> = ({ signal }) => getPageConfig({ pageKey },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pageKey !== null && pageKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPageConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPageConfig>>>
export type GetPageConfigQueryError = ErrorType<HumaAPIError>


export function useGetPageConfig<TData = Awaited<ReturnType<typeof getPageConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPageConfigPathParameters,
    params: GetPageConfigParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPageConfig>>,
          TError,
          Awaited<ReturnType<typeof getPageConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPageConfig<TData = Awaited<ReturnType<typeof getPageConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPageConfigPathParameters,
    params: GetPageConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPageConfig>>,
          TError,
          Awaited<ReturnType<typeof getPageConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPageConfig<TData = Awaited<ReturnType<typeof getPageConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPageConfigPathParameters,
    params: GetPageConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get page configuration
 */

export function useGetPageConfig<TData = Awaited<ReturnType<typeof getPageConfig>>, TError = ErrorType<HumaAPIError>>(
 { pageKey }: GetPageConfigPathParameters,
    params: GetPageConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPageConfigQueryOptions({ pageKey },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPageConfigSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPageConfig>>, TError = ErrorType<HumaAPIError>>({ pageKey }: GetPageConfigPathParameters,
    params: GetPageConfigParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPageConfigQueryKey({ pageKey },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageConfig>>> = ({ signal }) => getPageConfig({ pageKey },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPageConfigSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPageConfig>>>
export type GetPageConfigSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetPageConfigSuspense<TData = Awaited<ReturnType<typeof getPageConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPageConfigPathParameters,
    params: GetPageConfigParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPageConfigSuspense<TData = Awaited<ReturnType<typeof getPageConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPageConfigPathParameters,
    params: GetPageConfigParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPageConfigSuspense<TData = Awaited<ReturnType<typeof getPageConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPageConfigPathParameters,
    params: GetPageConfigParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get page configuration
 */

export function useGetPageConfigSuspense<TData = Awaited<ReturnType<typeof getPageConfig>>, TError = ErrorType<HumaAPIError>>(
 { pageKey }: GetPageConfigPathParameters,
    params: GetPageConfigParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPageConfigSuspenseQueryOptions({ pageKey },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updatePageConfigResponse200 = {
  data: SingleViewConfigBody
  status: 200
}

export type updatePageConfigResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type updatePageConfigResponseSuccess = (updatePageConfigResponse200) & {
  headers: Headers;
};
export type updatePageConfigResponseError = (updatePageConfigResponseDefault) & {
  headers: Headers;
};

export type updatePageConfigResponse = updatePageConfigResponseSuccess

export const getUpdatePageConfigUrl = ({ pageKey }: UpdatePageConfigPathParameters,
    params: UpdatePageConfigParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/page-config/${pageKey}?${stringifiedParams}` : `/auth/v1/page-config/${pageKey}`
}

/**
 * @summary Update or create a page configuration view
 */
export const updatePageConfig = async ({ pageKey }: UpdatePageConfigPathParameters,
    updatePageConfigRequestBody: UpdatePageConfigRequestBody,
    params: UpdatePageConfigParams, options?: Parameters<typeof customFetch>[1]): Promise<updatePageConfigResponse> => {

  return customFetch<updatePageConfigResponse>(getUpdatePageConfigUrl({ pageKey },params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePageConfigRequestBody)
  }
);}





export const getUpdatePageConfigMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePageConfig>>, TError,{pathParams: UpdatePageConfigPathParameters;data: UpdatePageConfigRequestBody;params: UpdatePageConfigParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePageConfig>>, TError,{pathParams: UpdatePageConfigPathParameters;data: UpdatePageConfigRequestBody;params: UpdatePageConfigParams}, TContext> => {

const mutationKey = ['updatePageConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePageConfig>>, {pathParams: UpdatePageConfigPathParameters;data: UpdatePageConfigRequestBody;params: UpdatePageConfigParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  updatePageConfig(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePageConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updatePageConfig>>>
    export type UpdatePageConfigMutationBody = UpdatePageConfigRequestBody
    export type UpdatePageConfigMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Update or create a page configuration view
 */
export const useUpdatePageConfig = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePageConfig>>, TError,{pathParams: UpdatePageConfigPathParameters;data: UpdatePageConfigRequestBody;params: UpdatePageConfigParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePageConfig>>,
        TError,
        {pathParams: UpdatePageConfigPathParameters;data: UpdatePageConfigRequestBody;params: UpdatePageConfigParams},
        TContext
      > => {
      return useMutation(getUpdatePageConfigMutationOptions(options), queryClient);
    }
    export type searchReferenceDataResponse200 = {
  data: SearchRefDataResponseBody
  status: 200
}

export type searchReferenceDataResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type searchReferenceDataResponseSuccess = (searchReferenceDataResponse200) & {
  headers: Headers;
};
export type searchReferenceDataResponseError = (searchReferenceDataResponseDefault) & {
  headers: Headers;
};

export type searchReferenceDataResponse = searchReferenceDataResponseSuccess

export const getSearchReferenceDataUrl = () => {




  return `/auth/v1/reference-data/search`
}

/**
 * @summary Search distinct reference-data column values for the bond screener
 */
export const searchReferenceData = async (searchRefDataRequestBody: SearchRefDataRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<searchReferenceDataResponse> => {

  return customFetch<searchReferenceDataResponse>(getSearchReferenceDataUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(searchRefDataRequestBody)
  }
);}





export const getSearchReferenceDataMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchReferenceData>>, TError,{data: SearchRefDataRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof searchReferenceData>>, TError,{data: SearchRefDataRequestBody}, TContext> => {

const mutationKey = ['searchReferenceData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchReferenceData>>, {data: SearchRefDataRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  searchReferenceData(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchReferenceDataMutationResult = NonNullable<Awaited<ReturnType<typeof searchReferenceData>>>
    export type SearchReferenceDataMutationBody = SearchRefDataRequestBody
    export type SearchReferenceDataMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Search distinct reference-data column values for the bond screener
 */
export const useSearchReferenceData = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchReferenceData>>, TError,{data: SearchRefDataRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchReferenceData>>,
        TError,
        {data: SearchRefDataRequestBody},
        TContext
      > => {
      return useMutation(getSearchReferenceDataMutationOptions(options), queryClient);
    }
    export type getSampleOrderResponse200 = {
  data: GetSampleOrderResponseBody
  status: 200
}

export type getSampleOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getSampleOrderResponseSuccess = (getSampleOrderResponse200) & {
  headers: Headers;
};
export type getSampleOrderResponseError = (getSampleOrderResponseDefault) & {
  headers: Headers;
};

export type getSampleOrderResponse = getSampleOrderResponseSuccess

export const getGetSampleOrderUrl = ({ orderId }: GetSampleOrderPathParameters,) => {




  return `/auth/v1/sample/orders/${orderId}`
}

/**
 * @summary Get a sample order by ID
 */
export const getSampleOrder = async ({ orderId }: GetSampleOrderPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getSampleOrderResponse> => {

  return customFetch<getSampleOrderResponse>(getGetSampleOrderUrl({ orderId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSampleOrderQueryKey = ({ orderId }: GetSampleOrderPathParameters,) => {
    return [
    `/auth/v1/sample/orders/${orderId}`
    ] as const;
    }


export const getGetSampleOrderQueryOptions = <TData = Awaited<ReturnType<typeof getSampleOrder>>, TError = ErrorType<HumaAPIError>>({ orderId }: GetSampleOrderPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSampleOrderQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSampleOrder>>> = ({ signal }) => getSampleOrder({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSampleOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getSampleOrder>>>
export type GetSampleOrderQueryError = ErrorType<HumaAPIError>


export function useGetSampleOrder<TData = Awaited<ReturnType<typeof getSampleOrder>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSampleOrderPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSampleOrder>>,
          TError,
          Awaited<ReturnType<typeof getSampleOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSampleOrder<TData = Awaited<ReturnType<typeof getSampleOrder>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSampleOrderPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSampleOrder>>,
          TError,
          Awaited<ReturnType<typeof getSampleOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSampleOrder<TData = Awaited<ReturnType<typeof getSampleOrder>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSampleOrderPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a sample order by ID
 */

export function useGetSampleOrder<TData = Awaited<ReturnType<typeof getSampleOrder>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: GetSampleOrderPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSampleOrderQueryOptions({ orderId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSampleOrderSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSampleOrder>>, TError = ErrorType<HumaAPIError>>({ orderId }: GetSampleOrderPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSampleOrderQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSampleOrder>>> = ({ signal }) => getSampleOrder({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSampleOrderSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSampleOrder>>>
export type GetSampleOrderSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetSampleOrderSuspense<TData = Awaited<ReturnType<typeof getSampleOrder>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSampleOrderPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSampleOrderSuspense<TData = Awaited<ReturnType<typeof getSampleOrder>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSampleOrderPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSampleOrderSuspense<TData = Awaited<ReturnType<typeof getSampleOrder>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSampleOrderPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a sample order by ID
 */

export function useGetSampleOrderSuspense<TData = Awaited<ReturnType<typeof getSampleOrder>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: GetSampleOrderPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSampleOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSampleOrderSuspenseQueryOptions({ orderId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listUsersResponse200 = {
  data: ListUsersResponseBody
  status: 200
}

export type listUsersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listUsersResponseSuccess = (listUsersResponse200) & {
  headers: Headers;
};
export type listUsersResponseError = (listUsersResponseDefault) & {
  headers: Headers;
};

export type listUsersResponse = listUsersResponseSuccess

export const getListUsersUrl = (params?: ListUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/sample/users?${stringifiedParams}` : `/auth/v1/sample/users`
}

/**
 * @summary List users
 */
export const listUsers = async (params?: ListUsersParams, options?: Parameters<typeof customFetch>[1]): Promise<listUsersResponse> => {

  return customFetch<listUsersResponse>(getListUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersQueryKey = (params?: ListUsersParams,) => {
    return [
    `/auth/v1/sample/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<HumaAPIError>>(params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<HumaAPIError>


export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<HumaAPIError>>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<HumaAPIError>>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List users
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<HumaAPIError>>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<HumaAPIError>>(params?: ListUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersSuspenseQueryError = ErrorType<HumaAPIError>


export function useListUsersSuspense<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersSuspense<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<HumaAPIError>>(
 params?: ListUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersSuspense<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<HumaAPIError>>(
 params?: ListUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List users
 */

export function useListUsersSuspense<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<HumaAPIError>>(
 params?: ListUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createUserResponse200 = {
  data: SampleUser
  status: 200
}

export type createUserResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type createUserResponseSuccess = (createUserResponse200) & {
  headers: Headers;
};
export type createUserResponseError = (createUserResponseDefault) & {
  headers: Headers;
};

export type createUserResponse = createUserResponseSuccess

export const getCreateUserUrl = () => {




  return `/auth/v1/sample/users`
}

/**
 * @summary Create a new user
 */
export const createUser = async (createUserRequestBody: CreateUserRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createUserResponse> => {

  return customFetch<createUserResponse>(getCreateUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createUserRequestBody)
  }
);}





export const getCreateUserMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserRequestBody}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: CreateUserRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = CreateUserRequestBody
    export type CreateUserMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create a new user
 */
export const useCreateUser = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: CreateUserRequestBody},
        TContext
      > => {
      return useMutation(getCreateUserMutationOptions(options), queryClient);
    }
    export type getUserResponse200 = {
  data: SampleUser
  status: 200
}

export type getUserResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getUserResponseSuccess = (getUserResponse200) & {
  headers: Headers;
};
export type getUserResponseError = (getUserResponseDefault) & {
  headers: Headers;
};

export type getUserResponse = getUserResponseSuccess

export const getGetUserUrl = ({ userId }: GetUserPathParameters,) => {




  return `/auth/v1/sample/users/${userId}`
}

/**
 * @summary Get a user by ID
 */
export const getUser = async ({ userId }: GetUserPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getUserResponse> => {

  return customFetch<getUserResponse>(getGetUserUrl({ userId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserQueryKey = ({ userId }: GetUserPathParameters,) => {
    return [
    `/auth/v1/sample/users/${userId}`
    ] as const;
    }


export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<HumaAPIError>>({ userId }: GetUserPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey({ userId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser({ userId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = ErrorType<HumaAPIError>


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user by ID
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<HumaAPIError>>(
 { userId }: GetUserPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions({ userId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<HumaAPIError>>({ userId }: GetUserPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey({ userId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser({ userId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user by ID
 */

export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<HumaAPIError>>(
 { userId }: GetUserPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserSuspenseQueryOptions({ userId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getSavedSearchLayoutResponse200 = {
  data: SavedSearchLayoutResponseBody
  status: 200
}

export type getSavedSearchLayoutResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getSavedSearchLayoutResponseSuccess = (getSavedSearchLayoutResponse200) & {
  headers: Headers;
};
export type getSavedSearchLayoutResponseError = (getSavedSearchLayoutResponseDefault) & {
  headers: Headers;
};

export type getSavedSearchLayoutResponse = getSavedSearchLayoutResponseSuccess

export const getGetSavedSearchLayoutUrl = ({ contextKey }: GetSavedSearchLayoutPathParameters,) => {




  return `/auth/v1/saved-search-layout/${contextKey}`
}

/**
 * @summary Get the caller's saved search layout for a context
 */
export const getSavedSearchLayout = async ({ contextKey }: GetSavedSearchLayoutPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getSavedSearchLayoutResponse> => {

  return customFetch<getSavedSearchLayoutResponse>(getGetSavedSearchLayoutUrl({ contextKey }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSavedSearchLayoutQueryKey = ({ contextKey }: GetSavedSearchLayoutPathParameters,) => {
    return [
    `/auth/v1/saved-search-layout/${contextKey}`
    ] as const;
    }


export const getGetSavedSearchLayoutQueryOptions = <TData = Awaited<ReturnType<typeof getSavedSearchLayout>>, TError = ErrorType<HumaAPIError>>({ contextKey }: GetSavedSearchLayoutPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedSearchLayoutQueryKey({ contextKey });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedSearchLayout>>> = ({ signal }) => getSavedSearchLayout({ contextKey }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: contextKey !== null && contextKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSavedSearchLayoutQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedSearchLayout>>>
export type GetSavedSearchLayoutQueryError = ErrorType<HumaAPIError>


export function useGetSavedSearchLayout<TData = Awaited<ReturnType<typeof getSavedSearchLayout>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchLayoutPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedSearchLayout>>,
          TError,
          Awaited<ReturnType<typeof getSavedSearchLayout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearchLayout<TData = Awaited<ReturnType<typeof getSavedSearchLayout>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchLayoutPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedSearchLayout>>,
          TError,
          Awaited<ReturnType<typeof getSavedSearchLayout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearchLayout<TData = Awaited<ReturnType<typeof getSavedSearchLayout>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchLayoutPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the caller's saved search layout for a context
 */

export function useGetSavedSearchLayout<TData = Awaited<ReturnType<typeof getSavedSearchLayout>>, TError = ErrorType<HumaAPIError>>(
 { contextKey }: GetSavedSearchLayoutPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSavedSearchLayoutQueryOptions({ contextKey },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSavedSearchLayoutSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSavedSearchLayout>>, TError = ErrorType<HumaAPIError>>({ contextKey }: GetSavedSearchLayoutPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedSearchLayoutQueryKey({ contextKey });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedSearchLayout>>> = ({ signal }) => getSavedSearchLayout({ contextKey }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSavedSearchLayoutSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedSearchLayout>>>
export type GetSavedSearchLayoutSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetSavedSearchLayoutSuspense<TData = Awaited<ReturnType<typeof getSavedSearchLayout>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchLayoutPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearchLayoutSuspense<TData = Awaited<ReturnType<typeof getSavedSearchLayout>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchLayoutPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearchLayoutSuspense<TData = Awaited<ReturnType<typeof getSavedSearchLayout>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchLayoutPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the caller's saved search layout for a context
 */

export function useGetSavedSearchLayoutSuspense<TData = Awaited<ReturnType<typeof getSavedSearchLayout>>, TError = ErrorType<HumaAPIError>>(
 { contextKey }: GetSavedSearchLayoutPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearchLayout>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSavedSearchLayoutSuspenseQueryOptions({ contextKey },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateSavedSearchLayoutResponse200 = {
  data: SavedSearchLayoutResponseBody
  status: 200
}

export type updateSavedSearchLayoutResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateSavedSearchLayoutResponseSuccess = (updateSavedSearchLayoutResponse200) & {
  headers: Headers;
};
export type updateSavedSearchLayoutResponseError = (updateSavedSearchLayoutResponseDefault) & {
  headers: Headers;
};

export type updateSavedSearchLayoutResponse = updateSavedSearchLayoutResponseSuccess

export const getUpdateSavedSearchLayoutUrl = ({ contextKey }: UpdateSavedSearchLayoutPathParameters,) => {




  return `/auth/v1/saved-search-layout/${contextKey}`
}

/**
 * @summary Replace the caller's saved search layout for a context
 */
export const updateSavedSearchLayout = async ({ contextKey }: UpdateSavedSearchLayoutPathParameters,
    savedSearchLayoutBody: SavedSearchLayoutBody, options?: Parameters<typeof customFetch>[1]): Promise<updateSavedSearchLayoutResponse> => {

  return customFetch<updateSavedSearchLayoutResponse>(getUpdateSavedSearchLayoutUrl({ contextKey }),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(savedSearchLayoutBody)
  }
);}





export const getUpdateSavedSearchLayoutMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSavedSearchLayout>>, TError,{pathParams: UpdateSavedSearchLayoutPathParameters;data: SavedSearchLayoutBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSavedSearchLayout>>, TError,{pathParams: UpdateSavedSearchLayoutPathParameters;data: SavedSearchLayoutBody}, TContext> => {

const mutationKey = ['updateSavedSearchLayout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSavedSearchLayout>>, {pathParams: UpdateSavedSearchLayoutPathParameters;data: SavedSearchLayoutBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  updateSavedSearchLayout(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSavedSearchLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof updateSavedSearchLayout>>>
    export type UpdateSavedSearchLayoutMutationBody = SavedSearchLayoutBody
    export type UpdateSavedSearchLayoutMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Replace the caller's saved search layout for a context
 */
export const useUpdateSavedSearchLayout = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSavedSearchLayout>>, TError,{pathParams: UpdateSavedSearchLayoutPathParameters;data: SavedSearchLayoutBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSavedSearchLayout>>,
        TError,
        {pathParams: UpdateSavedSearchLayoutPathParameters;data: SavedSearchLayoutBody},
        TContext
      > => {
      return useMutation(getUpdateSavedSearchLayoutMutationOptions(options), queryClient);
    }
    export type listSavedSearchesResponse200 = {
  data: ListSavedSearchesResponseBody
  status: 200
}

export type listSavedSearchesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listSavedSearchesResponseSuccess = (listSavedSearchesResponse200) & {
  headers: Headers;
};
export type listSavedSearchesResponseError = (listSavedSearchesResponseDefault) & {
  headers: Headers;
};

export type listSavedSearchesResponse = listSavedSearchesResponseSuccess

export const getListSavedSearchesUrl = ({ contextKey }: ListSavedSearchesPathParameters,
    params?: ListSavedSearchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/saved-search/context/${contextKey}?${stringifiedParams}` : `/auth/v1/saved-search/context/${contextKey}`
}

/**
 * @summary List saved searches by context
 */
export const listSavedSearches = async ({ contextKey }: ListSavedSearchesPathParameters,
    params?: ListSavedSearchesParams, options?: Parameters<typeof customFetch>[1]): Promise<listSavedSearchesResponse> => {

  return customFetch<listSavedSearchesResponse>(getListSavedSearchesUrl({ contextKey },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSavedSearchesQueryKey = ({ contextKey }: ListSavedSearchesPathParameters,
    params?: ListSavedSearchesParams,) => {
    return [
    `/auth/v1/saved-search/context/${contextKey}`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSavedSearchesQueryOptions = <TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = ErrorType<HumaAPIError>>({ contextKey }: ListSavedSearchesPathParameters,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedSearchesQueryKey({ contextKey },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedSearches>>> = ({ signal }) => listSavedSearches({ contextKey },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: contextKey !== null && contextKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSavedSearchesQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedSearches>>>
export type ListSavedSearchesQueryError = ErrorType<HumaAPIError>


export function useListSavedSearches<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchesPathParameters,
    params: undefined |  ListSavedSearchesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedSearches>>,
          TError,
          Awaited<ReturnType<typeof listSavedSearches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearches<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchesPathParameters,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedSearches>>,
          TError,
          Awaited<ReturnType<typeof listSavedSearches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearches<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchesPathParameters,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List saved searches by context
 */

export function useListSavedSearches<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = ErrorType<HumaAPIError>>(
 { contextKey }: ListSavedSearchesPathParameters,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSavedSearchesQueryOptions({ contextKey },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSavedSearchesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = ErrorType<HumaAPIError>>({ contextKey }: ListSavedSearchesPathParameters,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedSearchesQueryKey({ contextKey },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedSearches>>> = ({ signal }) => listSavedSearches({ contextKey },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSavedSearchesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedSearches>>>
export type ListSavedSearchesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchesPathParameters,
    params: undefined |  ListSavedSearchesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchesPathParameters,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchesPathParameters,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List saved searches by context
 */

export function useListSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listSavedSearches>>, TError = ErrorType<HumaAPIError>>(
 { contextKey }: ListSavedSearchesPathParameters,
    params?: ListSavedSearchesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSavedSearchesSuspenseQueryOptions({ contextKey },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createSavedSearchResponse201 = {
  data: SavedSearchResponse
  status: 201
}

export type createSavedSearchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createSavedSearchResponseSuccess = (createSavedSearchResponse201) & {
  headers: Headers;
};
export type createSavedSearchResponseError = (createSavedSearchResponseDefault) & {
  headers: Headers;
};

export type createSavedSearchResponse = createSavedSearchResponseSuccess

export const getCreateSavedSearchUrl = ({ contextKey }: CreateSavedSearchPathParameters,) => {




  return `/auth/v1/saved-search/context/${contextKey}`
}

/**
 * @summary Create a saved search
 */
export const createSavedSearch = async ({ contextKey }: CreateSavedSearchPathParameters,
    createSavedSearchRequestBody: CreateSavedSearchRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createSavedSearchResponse> => {

  return customFetch<createSavedSearchResponse>(getCreateSavedSearchUrl({ contextKey }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSavedSearchRequestBody)
  }
);}





export const getCreateSavedSearchMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSavedSearch>>, TError,{pathParams: CreateSavedSearchPathParameters;data: CreateSavedSearchRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSavedSearch>>, TError,{pathParams: CreateSavedSearchPathParameters;data: CreateSavedSearchRequestBody}, TContext> => {

const mutationKey = ['createSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSavedSearch>>, {pathParams: CreateSavedSearchPathParameters;data: CreateSavedSearchRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  createSavedSearch(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof createSavedSearch>>>
    export type CreateSavedSearchMutationBody = CreateSavedSearchRequestBody
    export type CreateSavedSearchMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create a saved search
 */
export const useCreateSavedSearch = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSavedSearch>>, TError,{pathParams: CreateSavedSearchPathParameters;data: CreateSavedSearchRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSavedSearch>>,
        TError,
        {pathParams: CreateSavedSearchPathParameters;data: CreateSavedSearchRequestBody},
        TContext
      > => {
      return useMutation(getCreateSavedSearchMutationOptions(options), queryClient);
    }
    export type clearDefaultSavedSearchResponse204 = {
  data: void
  status: 204
}

export type clearDefaultSavedSearchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type clearDefaultSavedSearchResponseSuccess = (clearDefaultSavedSearchResponse204) & {
  headers: Headers;
};
export type clearDefaultSavedSearchResponseError = (clearDefaultSavedSearchResponseDefault) & {
  headers: Headers;
};

export type clearDefaultSavedSearchResponse = clearDefaultSavedSearchResponseSuccess

export const getClearDefaultSavedSearchUrl = ({ contextKey }: ClearDefaultSavedSearchPathParameters,
    params?: ClearDefaultSavedSearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/saved-search/context/${contextKey}/default?${stringifiedParams}` : `/auth/v1/saved-search/context/${contextKey}/default`
}

/**
 * @summary Clear the caller's default saved search for a context
 */
export const clearDefaultSavedSearch = async ({ contextKey }: ClearDefaultSavedSearchPathParameters,
    params?: ClearDefaultSavedSearchParams, options?: Parameters<typeof customFetch>[1]): Promise<clearDefaultSavedSearchResponse> => {

  return customFetch<clearDefaultSavedSearchResponse>(getClearDefaultSavedSearchUrl({ contextKey },params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearDefaultSavedSearchMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearDefaultSavedSearch>>, TError,{pathParams: ClearDefaultSavedSearchPathParameters;params?: ClearDefaultSavedSearchParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearDefaultSavedSearch>>, TError,{pathParams: ClearDefaultSavedSearchPathParameters;params?: ClearDefaultSavedSearchParams}, TContext> => {

const mutationKey = ['clearDefaultSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearDefaultSavedSearch>>, {pathParams: ClearDefaultSavedSearchPathParameters;params?: ClearDefaultSavedSearchParams}> = (props) => {
          const {pathParams,params} = props ?? {};

          return  clearDefaultSavedSearch(pathParams,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearDefaultSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof clearDefaultSavedSearch>>>

    export type ClearDefaultSavedSearchMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Clear the caller's default saved search for a context
 */
export const useClearDefaultSavedSearch = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearDefaultSavedSearch>>, TError,{pathParams: ClearDefaultSavedSearchPathParameters;params?: ClearDefaultSavedSearchParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearDefaultSavedSearch>>,
        TError,
        {pathParams: ClearDefaultSavedSearchPathParameters;params?: ClearDefaultSavedSearchParams},
        TContext
      > => {
      return useMutation(getClearDefaultSavedSearchMutationOptions(options), queryClient);
    }
    export type resolveDefaultSavedSearchResponse200 = {
  data: SavedSearchResponse
  status: 200
}

export type resolveDefaultSavedSearchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type resolveDefaultSavedSearchResponseSuccess = (resolveDefaultSavedSearchResponse200) & {
  headers: Headers;
};
export type resolveDefaultSavedSearchResponseError = (resolveDefaultSavedSearchResponseDefault) & {
  headers: Headers;
};

export type resolveDefaultSavedSearchResponse = resolveDefaultSavedSearchResponseSuccess

export const getResolveDefaultSavedSearchUrl = ({ contextKey }: ResolveDefaultSavedSearchPathParameters,
    params?: ResolveDefaultSavedSearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/saved-search/context/${contextKey}/default?${stringifiedParams}` : `/auth/v1/saved-search/context/${contextKey}/default`
}

/**
 * @summary Resolve the effective default saved search for a context
 */
export const resolveDefaultSavedSearch = async ({ contextKey }: ResolveDefaultSavedSearchPathParameters,
    params?: ResolveDefaultSavedSearchParams, options?: Parameters<typeof customFetch>[1]): Promise<resolveDefaultSavedSearchResponse> => {

  return customFetch<resolveDefaultSavedSearchResponse>(getResolveDefaultSavedSearchUrl({ contextKey },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getResolveDefaultSavedSearchQueryKey = ({ contextKey }: ResolveDefaultSavedSearchPathParameters,
    params?: ResolveDefaultSavedSearchParams,) => {
    return [
    `/auth/v1/saved-search/context/${contextKey}/default`, ...(params ? [params] : [])
    ] as const;
    }


export const getResolveDefaultSavedSearchQueryOptions = <TData = Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError = ErrorType<HumaAPIError>>({ contextKey }: ResolveDefaultSavedSearchPathParameters,
    params?: ResolveDefaultSavedSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolveDefaultSavedSearchQueryKey({ contextKey },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>> = ({ signal }) => resolveDefaultSavedSearch({ contextKey },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: contextKey !== null && contextKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ResolveDefaultSavedSearchQueryResult = NonNullable<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>>
export type ResolveDefaultSavedSearchQueryError = ErrorType<HumaAPIError>


export function useResolveDefaultSavedSearch<TData = Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ResolveDefaultSavedSearchPathParameters,
    params: undefined |  ResolveDefaultSavedSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveDefaultSavedSearch>>,
          TError,
          Awaited<ReturnType<typeof resolveDefaultSavedSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveDefaultSavedSearch<TData = Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ResolveDefaultSavedSearchPathParameters,
    params?: ResolveDefaultSavedSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveDefaultSavedSearch>>,
          TError,
          Awaited<ReturnType<typeof resolveDefaultSavedSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveDefaultSavedSearch<TData = Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ResolveDefaultSavedSearchPathParameters,
    params?: ResolveDefaultSavedSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve the effective default saved search for a context
 */

export function useResolveDefaultSavedSearch<TData = Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 { contextKey }: ResolveDefaultSavedSearchPathParameters,
    params?: ResolveDefaultSavedSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResolveDefaultSavedSearchQueryOptions({ contextKey },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getResolveDefaultSavedSearchSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError = ErrorType<HumaAPIError>>({ contextKey }: ResolveDefaultSavedSearchPathParameters,
    params?: ResolveDefaultSavedSearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolveDefaultSavedSearchQueryKey({ contextKey },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>> = ({ signal }) => resolveDefaultSavedSearch({ contextKey },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ResolveDefaultSavedSearchSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>>
export type ResolveDefaultSavedSearchSuspenseQueryError = ErrorType<HumaAPIError>


export function useResolveDefaultSavedSearchSuspense<TData = Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ResolveDefaultSavedSearchPathParameters,
    params: undefined |  ResolveDefaultSavedSearchParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveDefaultSavedSearchSuspense<TData = Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ResolveDefaultSavedSearchPathParameters,
    params?: ResolveDefaultSavedSearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveDefaultSavedSearchSuspense<TData = Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ResolveDefaultSavedSearchPathParameters,
    params?: ResolveDefaultSavedSearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve the effective default saved search for a context
 */

export function useResolveDefaultSavedSearchSuspense<TData = Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 { contextKey }: ResolveDefaultSavedSearchPathParameters,
    params?: ResolveDefaultSavedSearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveDefaultSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResolveDefaultSavedSearchSuspenseQueryOptions({ contextKey },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type setDefaultSavedSearchResponse200 = {
  data: SavedSearchResponse
  status: 200
}

export type setDefaultSavedSearchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type setDefaultSavedSearchResponseSuccess = (setDefaultSavedSearchResponse200) & {
  headers: Headers;
};
export type setDefaultSavedSearchResponseError = (setDefaultSavedSearchResponseDefault) & {
  headers: Headers;
};

export type setDefaultSavedSearchResponse = setDefaultSavedSearchResponseSuccess

export const getSetDefaultSavedSearchUrl = ({ contextKey }: SetDefaultSavedSearchPathParameters,
    params?: SetDefaultSavedSearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/saved-search/context/${contextKey}/default?${stringifiedParams}` : `/auth/v1/saved-search/context/${contextKey}/default`
}

/**
 * @summary Set the caller's default saved search for a context
 */
export const setDefaultSavedSearch = async ({ contextKey }: SetDefaultSavedSearchPathParameters,
    setDefaultSavedSearchRequestBody: SetDefaultSavedSearchRequestBody,
    params?: SetDefaultSavedSearchParams, options?: Parameters<typeof customFetch>[1]): Promise<setDefaultSavedSearchResponse> => {

  return customFetch<setDefaultSavedSearchResponse>(getSetDefaultSavedSearchUrl({ contextKey },params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setDefaultSavedSearchRequestBody)
  }
);}





export const getSetDefaultSavedSearchMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultSavedSearch>>, TError,{pathParams: SetDefaultSavedSearchPathParameters;data: SetDefaultSavedSearchRequestBody;params?: SetDefaultSavedSearchParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultSavedSearch>>, TError,{pathParams: SetDefaultSavedSearchPathParameters;data: SetDefaultSavedSearchRequestBody;params?: SetDefaultSavedSearchParams}, TContext> => {

const mutationKey = ['setDefaultSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultSavedSearch>>, {pathParams: SetDefaultSavedSearchPathParameters;data: SetDefaultSavedSearchRequestBody;params?: SetDefaultSavedSearchParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  setDefaultSavedSearch(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultSavedSearch>>>
    export type SetDefaultSavedSearchMutationBody = SetDefaultSavedSearchRequestBody
    export type SetDefaultSavedSearchMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Set the caller's default saved search for a context
 */
export const useSetDefaultSavedSearch = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultSavedSearch>>, TError,{pathParams: SetDefaultSavedSearchPathParameters;data: SetDefaultSavedSearchRequestBody;params?: SetDefaultSavedSearchParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultSavedSearch>>,
        TError,
        {pathParams: SetDefaultSavedSearchPathParameters;data: SetDefaultSavedSearchRequestBody;params?: SetDefaultSavedSearchParams},
        TContext
      > => {
      return useMutation(getSetDefaultSavedSearchMutationOptions(options), queryClient);
    }
    export type listReceivedSavedSearchesResponse200 = {
  data: ListReceivedSavedViewsResponseBody
  status: 200
}

export type listReceivedSavedSearchesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listReceivedSavedSearchesResponseSuccess = (listReceivedSavedSearchesResponse200) & {
  headers: Headers;
};
export type listReceivedSavedSearchesResponseError = (listReceivedSavedSearchesResponseDefault) & {
  headers: Headers;
};

export type listReceivedSavedSearchesResponse = listReceivedSavedSearchesResponseSuccess

export const getListReceivedSavedSearchesUrl = () => {




  return `/auth/v1/saved-search/received`
}

/**
 * @summary List saved searches shared to the caller's organizations
 */
export const listReceivedSavedSearches = async ( options?: Parameters<typeof customFetch>[1]): Promise<listReceivedSavedSearchesResponse> => {

  return customFetch<listReceivedSavedSearchesResponse>(getListReceivedSavedSearchesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReceivedSavedSearchesQueryKey = () => {
    return [
    `/auth/v1/saved-search/received`
    ] as const;
    }


export const getListReceivedSavedSearchesQueryOptions = <TData = Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReceivedSavedSearchesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReceivedSavedSearches>>> = ({ signal }) => listReceivedSavedSearches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListReceivedSavedSearchesQueryResult = NonNullable<Awaited<ReturnType<typeof listReceivedSavedSearches>>>
export type ListReceivedSavedSearchesQueryError = ErrorType<HumaAPIError>


export function useListReceivedSavedSearches<TData = Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReceivedSavedSearches>>,
          TError,
          Awaited<ReturnType<typeof listReceivedSavedSearches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReceivedSavedSearches<TData = Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReceivedSavedSearches>>,
          TError,
          Awaited<ReturnType<typeof listReceivedSavedSearches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReceivedSavedSearches<TData = Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List saved searches shared to the caller's organizations
 */

export function useListReceivedSavedSearches<TData = Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListReceivedSavedSearchesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListReceivedSavedSearchesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReceivedSavedSearchesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReceivedSavedSearches>>> = ({ signal }) => listReceivedSavedSearches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListReceivedSavedSearchesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listReceivedSavedSearches>>>
export type ListReceivedSavedSearchesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListReceivedSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReceivedSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReceivedSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List saved searches shared to the caller's organizations
 */

export function useListReceivedSavedSearchesSuspense<TData = Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listReceivedSavedSearches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListReceivedSavedSearchesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deleteSavedSearchResponse204 = {
  data: void
  status: 204
}

export type deleteSavedSearchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type deleteSavedSearchResponseSuccess = (deleteSavedSearchResponse204) & {
  headers: Headers;
};
export type deleteSavedSearchResponseError = (deleteSavedSearchResponseDefault) & {
  headers: Headers;
};

export type deleteSavedSearchResponse = deleteSavedSearchResponseSuccess

export const getDeleteSavedSearchUrl = ({ id }: DeleteSavedSearchPathParameters,) => {




  return `/auth/v1/saved-search/${id}`
}

/**
 * @summary Delete a saved search
 */
export const deleteSavedSearch = async ({ id }: DeleteSavedSearchPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<deleteSavedSearchResponse> => {

  return customFetch<deleteSavedSearchResponse>(getDeleteSavedSearchUrl({ id }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSavedSearchMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedSearch>>, TError,{pathParams: DeleteSavedSearchPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSavedSearch>>, TError,{pathParams: DeleteSavedSearchPathParameters}, TContext> => {

const mutationKey = ['deleteSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSavedSearch>>, {pathParams: DeleteSavedSearchPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  deleteSavedSearch(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSavedSearch>>>

    export type DeleteSavedSearchMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Delete a saved search
 */
export const useDeleteSavedSearch = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedSearch>>, TError,{pathParams: DeleteSavedSearchPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSavedSearch>>,
        TError,
        {pathParams: DeleteSavedSearchPathParameters},
        TContext
      > => {
      return useMutation(getDeleteSavedSearchMutationOptions(options), queryClient);
    }
    export type getSavedSearchResponse200 = {
  data: SavedSearchResponse
  status: 200
}

export type getSavedSearchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getSavedSearchResponseSuccess = (getSavedSearchResponse200) & {
  headers: Headers;
};
export type getSavedSearchResponseError = (getSavedSearchResponseDefault) & {
  headers: Headers;
};

export type getSavedSearchResponse = getSavedSearchResponseSuccess

export const getGetSavedSearchUrl = ({ id }: GetSavedSearchPathParameters,) => {




  return `/auth/v1/saved-search/${id}`
}

/**
 * @summary Get a saved search by ID
 */
export const getSavedSearch = async ({ id }: GetSavedSearchPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getSavedSearchResponse> => {

  return customFetch<getSavedSearchResponse>(getGetSavedSearchUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSavedSearchQueryKey = ({ id }: GetSavedSearchPathParameters,) => {
    return [
    `/auth/v1/saved-search/${id}`
    ] as const;
    }


export const getGetSavedSearchQueryOptions = <TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = ErrorType<HumaAPIError>>({ id }: GetSavedSearchPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedSearchQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedSearch>>> = ({ signal }) => getSavedSearch({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSavedSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedSearch>>>
export type GetSavedSearchQueryError = ErrorType<HumaAPIError>


export function useGetSavedSearch<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedSearch>>,
          TError,
          Awaited<ReturnType<typeof getSavedSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearch<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSavedSearch>>,
          TError,
          Awaited<ReturnType<typeof getSavedSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearch<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a saved search by ID
 */

export function useGetSavedSearch<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 { id }: GetSavedSearchPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSavedSearchQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSavedSearchSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = ErrorType<HumaAPIError>>({ id }: GetSavedSearchPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedSearchQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedSearch>>> = ({ signal }) => getSavedSearch({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSavedSearchSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedSearch>>>
export type GetSavedSearchSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetSavedSearchSuspense<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearchSuspense<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSavedSearchSuspense<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSavedSearchPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a saved search by ID
 */

export function useGetSavedSearchSuspense<TData = Awaited<ReturnType<typeof getSavedSearch>>, TError = ErrorType<HumaAPIError>>(
 { id }: GetSavedSearchPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSavedSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSavedSearchSuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateSavedSearchResponse200 = {
  data: SavedSearchResponse
  status: 200
}

export type updateSavedSearchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateSavedSearchResponseSuccess = (updateSavedSearchResponse200) & {
  headers: Headers;
};
export type updateSavedSearchResponseError = (updateSavedSearchResponseDefault) & {
  headers: Headers;
};

export type updateSavedSearchResponse = updateSavedSearchResponseSuccess

export const getUpdateSavedSearchUrl = ({ id }: UpdateSavedSearchPathParameters,) => {




  return `/auth/v1/saved-search/${id}`
}

/**
 * @summary Update a saved search
 */
export const updateSavedSearch = async ({ id }: UpdateSavedSearchPathParameters,
    updateSavedSearchRequestBody: UpdateSavedSearchRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<updateSavedSearchResponse> => {

  return customFetch<updateSavedSearchResponse>(getUpdateSavedSearchUrl({ id }),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSavedSearchRequestBody)
  }
);}





export const getUpdateSavedSearchMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSavedSearch>>, TError,{pathParams: UpdateSavedSearchPathParameters;data: UpdateSavedSearchRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSavedSearch>>, TError,{pathParams: UpdateSavedSearchPathParameters;data: UpdateSavedSearchRequestBody}, TContext> => {

const mutationKey = ['updateSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSavedSearch>>, {pathParams: UpdateSavedSearchPathParameters;data: UpdateSavedSearchRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  updateSavedSearch(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof updateSavedSearch>>>
    export type UpdateSavedSearchMutationBody = UpdateSavedSearchRequestBody
    export type UpdateSavedSearchMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Update a saved search
 */
export const useUpdateSavedSearch = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSavedSearch>>, TError,{pathParams: UpdateSavedSearchPathParameters;data: UpdateSavedSearchRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSavedSearch>>,
        TError,
        {pathParams: UpdateSavedSearchPathParameters;data: UpdateSavedSearchRequestBody},
        TContext
      > => {
      return useMutation(getUpdateSavedSearchMutationOptions(options), queryClient);
    }
    export type listSavedSearchOrgShareCandidatesResponse200 = {
  data: ListSavedViewOrgShareCandidatesResponseBody
  status: 200
}

export type listSavedSearchOrgShareCandidatesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listSavedSearchOrgShareCandidatesResponseSuccess = (listSavedSearchOrgShareCandidatesResponse200) & {
  headers: Headers;
};
export type listSavedSearchOrgShareCandidatesResponseError = (listSavedSearchOrgShareCandidatesResponseDefault) & {
  headers: Headers;
};

export type listSavedSearchOrgShareCandidatesResponse = listSavedSearchOrgShareCandidatesResponseSuccess

export const getListSavedSearchOrgShareCandidatesUrl = ({ id }: ListSavedSearchOrgShareCandidatesPathParameters,) => {




  return `/auth/v1/saved-search/${id}/org-share-candidates`
}

/**
 * @summary List the direct child organizations a saved search can be shared to
 */
export const listSavedSearchOrgShareCandidates = async ({ id }: ListSavedSearchOrgShareCandidatesPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<listSavedSearchOrgShareCandidatesResponse> => {

  return customFetch<listSavedSearchOrgShareCandidatesResponse>(getListSavedSearchOrgShareCandidatesUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSavedSearchOrgShareCandidatesQueryKey = ({ id }: ListSavedSearchOrgShareCandidatesPathParameters,) => {
    return [
    `/auth/v1/saved-search/${id}/org-share-candidates`
    ] as const;
    }


export const getListSavedSearchOrgShareCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError = ErrorType<HumaAPIError>>({ id }: ListSavedSearchOrgShareCandidatesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedSearchOrgShareCandidatesQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>> = ({ signal }) => listSavedSearchOrgShareCandidates({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSavedSearchOrgShareCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>>
export type ListSavedSearchOrgShareCandidatesQueryError = ErrorType<HumaAPIError>


export function useListSavedSearchOrgShareCandidates<TData = Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgShareCandidatesPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>,
          TError,
          Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchOrgShareCandidates<TData = Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgShareCandidatesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>,
          TError,
          Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchOrgShareCandidates<TData = Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgShareCandidatesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the direct child organizations a saved search can be shared to
 */

export function useListSavedSearchOrgShareCandidates<TData = Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError = ErrorType<HumaAPIError>>(
 { id }: ListSavedSearchOrgShareCandidatesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSavedSearchOrgShareCandidatesQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSavedSearchOrgShareCandidatesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError = ErrorType<HumaAPIError>>({ id }: ListSavedSearchOrgShareCandidatesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedSearchOrgShareCandidatesQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>> = ({ signal }) => listSavedSearchOrgShareCandidates({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSavedSearchOrgShareCandidatesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>>
export type ListSavedSearchOrgShareCandidatesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListSavedSearchOrgShareCandidatesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgShareCandidatesPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchOrgShareCandidatesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgShareCandidatesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchOrgShareCandidatesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgShareCandidatesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the direct child organizations a saved search can be shared to
 */

export function useListSavedSearchOrgShareCandidatesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError = ErrorType<HumaAPIError>>(
 { id }: ListSavedSearchOrgShareCandidatesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShareCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSavedSearchOrgShareCandidatesSuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listSavedSearchOrgSharesResponse200 = {
  data: ListSavedViewOrgSharesResponseBody
  status: 200
}

export type listSavedSearchOrgSharesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listSavedSearchOrgSharesResponseSuccess = (listSavedSearchOrgSharesResponse200) & {
  headers: Headers;
};
export type listSavedSearchOrgSharesResponseError = (listSavedSearchOrgSharesResponseDefault) & {
  headers: Headers;
};

export type listSavedSearchOrgSharesResponse = listSavedSearchOrgSharesResponseSuccess

export const getListSavedSearchOrgSharesUrl = ({ id }: ListSavedSearchOrgSharesPathParameters,) => {




  return `/auth/v1/saved-search/${id}/org-shares`
}

/**
 * @summary List the child organizations a saved search is shared to
 */
export const listSavedSearchOrgShares = async ({ id }: ListSavedSearchOrgSharesPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<listSavedSearchOrgSharesResponse> => {

  return customFetch<listSavedSearchOrgSharesResponse>(getListSavedSearchOrgSharesUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSavedSearchOrgSharesQueryKey = ({ id }: ListSavedSearchOrgSharesPathParameters,) => {
    return [
    `/auth/v1/saved-search/${id}/org-shares`
    ] as const;
    }


export const getListSavedSearchOrgSharesQueryOptions = <TData = Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError = ErrorType<HumaAPIError>>({ id }: ListSavedSearchOrgSharesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedSearchOrgSharesQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedSearchOrgShares>>> = ({ signal }) => listSavedSearchOrgShares({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSavedSearchOrgSharesQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedSearchOrgShares>>>
export type ListSavedSearchOrgSharesQueryError = ErrorType<HumaAPIError>


export function useListSavedSearchOrgShares<TData = Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgSharesPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedSearchOrgShares>>,
          TError,
          Awaited<ReturnType<typeof listSavedSearchOrgShares>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchOrgShares<TData = Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgSharesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedSearchOrgShares>>,
          TError,
          Awaited<ReturnType<typeof listSavedSearchOrgShares>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchOrgShares<TData = Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgSharesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the child organizations a saved search is shared to
 */

export function useListSavedSearchOrgShares<TData = Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError = ErrorType<HumaAPIError>>(
 { id }: ListSavedSearchOrgSharesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSavedSearchOrgSharesQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSavedSearchOrgSharesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError = ErrorType<HumaAPIError>>({ id }: ListSavedSearchOrgSharesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedSearchOrgSharesQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedSearchOrgShares>>> = ({ signal }) => listSavedSearchOrgShares({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSavedSearchOrgSharesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedSearchOrgShares>>>
export type ListSavedSearchOrgSharesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListSavedSearchOrgSharesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgSharesPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchOrgSharesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgSharesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchOrgSharesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchOrgSharesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the child organizations a saved search is shared to
 */

export function useListSavedSearchOrgSharesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError = ErrorType<HumaAPIError>>(
 { id }: ListSavedSearchOrgSharesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchOrgShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSavedSearchOrgSharesSuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shareSavedSearchToOrgResponse200 = {
  data: SavedViewOrgShareBody
  status: 200
}

export type shareSavedSearchToOrgResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type shareSavedSearchToOrgResponseSuccess = (shareSavedSearchToOrgResponse200) & {
  headers: Headers;
};
export type shareSavedSearchToOrgResponseError = (shareSavedSearchToOrgResponseDefault) & {
  headers: Headers;
};

export type shareSavedSearchToOrgResponse = shareSavedSearchToOrgResponseSuccess

export const getShareSavedSearchToOrgUrl = ({ id }: ShareSavedSearchToOrgPathParameters,) => {




  return `/auth/v1/saved-search/${id}/org-shares`
}

/**
 * @summary Share a saved search to a direct child organization
 */
export const shareSavedSearchToOrg = async ({ id }: ShareSavedSearchToOrgPathParameters,
    shareSavedViewToOrgRequestBody: ShareSavedViewToOrgRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<shareSavedSearchToOrgResponse> => {

  return customFetch<shareSavedSearchToOrgResponse>(getShareSavedSearchToOrgUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shareSavedViewToOrgRequestBody)
  }
);}





export const getShareSavedSearchToOrgMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareSavedSearchToOrg>>, TError,{pathParams: ShareSavedSearchToOrgPathParameters;data: ShareSavedViewToOrgRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shareSavedSearchToOrg>>, TError,{pathParams: ShareSavedSearchToOrgPathParameters;data: ShareSavedViewToOrgRequestBody}, TContext> => {

const mutationKey = ['shareSavedSearchToOrg'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareSavedSearchToOrg>>, {pathParams: ShareSavedSearchToOrgPathParameters;data: ShareSavedViewToOrgRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  shareSavedSearchToOrg(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShareSavedSearchToOrgMutationResult = NonNullable<Awaited<ReturnType<typeof shareSavedSearchToOrg>>>
    export type ShareSavedSearchToOrgMutationBody = ShareSavedViewToOrgRequestBody
    export type ShareSavedSearchToOrgMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Share a saved search to a direct child organization
 */
export const useShareSavedSearchToOrg = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareSavedSearchToOrg>>, TError,{pathParams: ShareSavedSearchToOrgPathParameters;data: ShareSavedViewToOrgRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shareSavedSearchToOrg>>,
        TError,
        {pathParams: ShareSavedSearchToOrgPathParameters;data: ShareSavedViewToOrgRequestBody},
        TContext
      > => {
      return useMutation(getShareSavedSearchToOrgMutationOptions(options), queryClient);
    }
    export type unshareSavedSearchFromOrgResponse204 = {
  data: void
  status: 204
}

export type unshareSavedSearchFromOrgResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type unshareSavedSearchFromOrgResponseSuccess = (unshareSavedSearchFromOrgResponse204) & {
  headers: Headers;
};
export type unshareSavedSearchFromOrgResponseError = (unshareSavedSearchFromOrgResponseDefault) & {
  headers: Headers;
};

export type unshareSavedSearchFromOrgResponse = unshareSavedSearchFromOrgResponseSuccess

export const getUnshareSavedSearchFromOrgUrl = ({ id, orgId }: UnshareSavedSearchFromOrgPathParameters,) => {




  return `/auth/v1/saved-search/${id}/org-shares/${orgId}`
}

/**
 * @summary Revoke a saved search's share to an organization
 */
export const unshareSavedSearchFromOrg = async ({ id, orgId }: UnshareSavedSearchFromOrgPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<unshareSavedSearchFromOrgResponse> => {

  return customFetch<unshareSavedSearchFromOrgResponse>(getUnshareSavedSearchFromOrgUrl({ id, orgId }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnshareSavedSearchFromOrgMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unshareSavedSearchFromOrg>>, TError,{pathParams: UnshareSavedSearchFromOrgPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unshareSavedSearchFromOrg>>, TError,{pathParams: UnshareSavedSearchFromOrgPathParameters}, TContext> => {

const mutationKey = ['unshareSavedSearchFromOrg'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unshareSavedSearchFromOrg>>, {pathParams: UnshareSavedSearchFromOrgPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  unshareSavedSearchFromOrg(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnshareSavedSearchFromOrgMutationResult = NonNullable<Awaited<ReturnType<typeof unshareSavedSearchFromOrg>>>

    export type UnshareSavedSearchFromOrgMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Revoke a saved search's share to an organization
 */
export const useUnshareSavedSearchFromOrg = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unshareSavedSearchFromOrg>>, TError,{pathParams: UnshareSavedSearchFromOrgPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unshareSavedSearchFromOrg>>,
        TError,
        {pathParams: UnshareSavedSearchFromOrgPathParameters},
        TContext
      > => {
      return useMutation(getUnshareSavedSearchFromOrgMutationOptions(options), queryClient);
    }
    export type unpublishSavedSearchResponse204 = {
  data: void
  status: 204
}

export type unpublishSavedSearchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type unpublishSavedSearchResponseSuccess = (unpublishSavedSearchResponse204) & {
  headers: Headers;
};
export type unpublishSavedSearchResponseError = (unpublishSavedSearchResponseDefault) & {
  headers: Headers;
};

export type unpublishSavedSearchResponse = unpublishSavedSearchResponseSuccess

export const getUnpublishSavedSearchUrl = ({ id }: UnpublishSavedSearchPathParameters,) => {




  return `/auth/v1/saved-search/${id}/publish`
}

/**
 * @summary Unpublish a saved search
 */
export const unpublishSavedSearch = async ({ id }: UnpublishSavedSearchPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<unpublishSavedSearchResponse> => {

  return customFetch<unpublishSavedSearchResponse>(getUnpublishSavedSearchUrl({ id }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnpublishSavedSearchMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unpublishSavedSearch>>, TError,{pathParams: UnpublishSavedSearchPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unpublishSavedSearch>>, TError,{pathParams: UnpublishSavedSearchPathParameters}, TContext> => {

const mutationKey = ['unpublishSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unpublishSavedSearch>>, {pathParams: UnpublishSavedSearchPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  unpublishSavedSearch(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnpublishSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof unpublishSavedSearch>>>

    export type UnpublishSavedSearchMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Unpublish a saved search
 */
export const useUnpublishSavedSearch = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unpublishSavedSearch>>, TError,{pathParams: UnpublishSavedSearchPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unpublishSavedSearch>>,
        TError,
        {pathParams: UnpublishSavedSearchPathParameters},
        TContext
      > => {
      return useMutation(getUnpublishSavedSearchMutationOptions(options), queryClient);
    }
    export type publishSavedSearchResponse204 = {
  data: void
  status: 204
}

export type publishSavedSearchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type publishSavedSearchResponseSuccess = (publishSavedSearchResponse204) & {
  headers: Headers;
};
export type publishSavedSearchResponseError = (publishSavedSearchResponseDefault) & {
  headers: Headers;
};

export type publishSavedSearchResponse = publishSavedSearchResponseSuccess

export const getPublishSavedSearchUrl = ({ id }: PublishSavedSearchPathParameters,) => {




  return `/auth/v1/saved-search/${id}/publish`
}

/**
 * @summary Publish a saved search to its organization
 */
export const publishSavedSearch = async ({ id }: PublishSavedSearchPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<publishSavedSearchResponse> => {

  return customFetch<publishSavedSearchResponse>(getPublishSavedSearchUrl({ id }),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPublishSavedSearchMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishSavedSearch>>, TError,{pathParams: PublishSavedSearchPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishSavedSearch>>, TError,{pathParams: PublishSavedSearchPathParameters}, TContext> => {

const mutationKey = ['publishSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishSavedSearch>>, {pathParams: PublishSavedSearchPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  publishSavedSearch(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof publishSavedSearch>>>

    export type PublishSavedSearchMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Publish a saved search to its organization
 */
export const usePublishSavedSearch = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishSavedSearch>>, TError,{pathParams: PublishSavedSearchPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publishSavedSearch>>,
        TError,
        {pathParams: PublishSavedSearchPathParameters},
        TContext
      > => {
      return useMutation(getPublishSavedSearchMutationOptions(options), queryClient);
    }
    export type listSavedSearchSharesResponse200 = {
  data: ListSavedViewSharesResponseBody
  status: 200
}

export type listSavedSearchSharesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listSavedSearchSharesResponseSuccess = (listSavedSearchSharesResponse200) & {
  headers: Headers;
};
export type listSavedSearchSharesResponseError = (listSavedSearchSharesResponseDefault) & {
  headers: Headers;
};

export type listSavedSearchSharesResponse = listSavedSearchSharesResponseSuccess

export const getListSavedSearchSharesUrl = ({ id }: ListSavedSearchSharesPathParameters,) => {




  return `/auth/v1/saved-search/${id}/shares`
}

/**
 * @summary List the users and teams a saved search is shared with
 */
export const listSavedSearchShares = async ({ id }: ListSavedSearchSharesPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<listSavedSearchSharesResponse> => {

  return customFetch<listSavedSearchSharesResponse>(getListSavedSearchSharesUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSavedSearchSharesQueryKey = ({ id }: ListSavedSearchSharesPathParameters,) => {
    return [
    `/auth/v1/saved-search/${id}/shares`
    ] as const;
    }


export const getListSavedSearchSharesQueryOptions = <TData = Awaited<ReturnType<typeof listSavedSearchShares>>, TError = ErrorType<HumaAPIError>>({ id }: ListSavedSearchSharesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedSearchSharesQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedSearchShares>>> = ({ signal }) => listSavedSearchShares({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSavedSearchSharesQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedSearchShares>>>
export type ListSavedSearchSharesQueryError = ErrorType<HumaAPIError>


export function useListSavedSearchShares<TData = Awaited<ReturnType<typeof listSavedSearchShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchSharesPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedSearchShares>>,
          TError,
          Awaited<ReturnType<typeof listSavedSearchShares>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchShares<TData = Awaited<ReturnType<typeof listSavedSearchShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchSharesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSavedSearchShares>>,
          TError,
          Awaited<ReturnType<typeof listSavedSearchShares>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchShares<TData = Awaited<ReturnType<typeof listSavedSearchShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchSharesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the users and teams a saved search is shared with
 */

export function useListSavedSearchShares<TData = Awaited<ReturnType<typeof listSavedSearchShares>>, TError = ErrorType<HumaAPIError>>(
 { id }: ListSavedSearchSharesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSavedSearchSharesQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSavedSearchSharesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listSavedSearchShares>>, TError = ErrorType<HumaAPIError>>({ id }: ListSavedSearchSharesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedSearchSharesQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedSearchShares>>> = ({ signal }) => listSavedSearchShares({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSavedSearchSharesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedSearchShares>>>
export type ListSavedSearchSharesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListSavedSearchSharesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchSharesPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchSharesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchSharesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSavedSearchSharesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchShares>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListSavedSearchSharesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the users and teams a saved search is shared with
 */

export function useListSavedSearchSharesSuspense<TData = Awaited<ReturnType<typeof listSavedSearchShares>>, TError = ErrorType<HumaAPIError>>(
 { id }: ListSavedSearchSharesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSavedSearchShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSavedSearchSharesSuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shareSavedSearchResponse200 = {
  data: SavedViewShareBody
  status: 200
}

export type shareSavedSearchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type shareSavedSearchResponseSuccess = (shareSavedSearchResponse200) & {
  headers: Headers;
};
export type shareSavedSearchResponseError = (shareSavedSearchResponseDefault) & {
  headers: Headers;
};

export type shareSavedSearchResponse = shareSavedSearchResponseSuccess

export const getShareSavedSearchUrl = ({ id }: ShareSavedSearchPathParameters,) => {




  return `/auth/v1/saved-search/${id}/shares`
}

/**
 * @summary Share a saved search with a user or team
 */
export const shareSavedSearch = async ({ id }: ShareSavedSearchPathParameters,
    shareSavedViewRequestBody: ShareSavedViewRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<shareSavedSearchResponse> => {

  return customFetch<shareSavedSearchResponse>(getShareSavedSearchUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shareSavedViewRequestBody)
  }
);}





export const getShareSavedSearchMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareSavedSearch>>, TError,{pathParams: ShareSavedSearchPathParameters;data: ShareSavedViewRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shareSavedSearch>>, TError,{pathParams: ShareSavedSearchPathParameters;data: ShareSavedViewRequestBody}, TContext> => {

const mutationKey = ['shareSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareSavedSearch>>, {pathParams: ShareSavedSearchPathParameters;data: ShareSavedViewRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  shareSavedSearch(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShareSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof shareSavedSearch>>>
    export type ShareSavedSearchMutationBody = ShareSavedViewRequestBody
    export type ShareSavedSearchMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Share a saved search with a user or team
 */
export const useShareSavedSearch = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareSavedSearch>>, TError,{pathParams: ShareSavedSearchPathParameters;data: ShareSavedViewRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shareSavedSearch>>,
        TError,
        {pathParams: ShareSavedSearchPathParameters;data: ShareSavedViewRequestBody},
        TContext
      > => {
      return useMutation(getShareSavedSearchMutationOptions(options), queryClient);
    }
    export type unshareSavedSearchResponse204 = {
  data: void
  status: 204
}

export type unshareSavedSearchResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type unshareSavedSearchResponseSuccess = (unshareSavedSearchResponse204) & {
  headers: Headers;
};
export type unshareSavedSearchResponseError = (unshareSavedSearchResponseDefault) & {
  headers: Headers;
};

export type unshareSavedSearchResponse = unshareSavedSearchResponseSuccess

export const getUnshareSavedSearchUrl = ({ id, grantId }: UnshareSavedSearchPathParameters,) => {




  return `/auth/v1/saved-search/${id}/shares/${grantId}`
}

/**
 * @summary Remove a share of a saved search
 */
export const unshareSavedSearch = async ({ id, grantId }: UnshareSavedSearchPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<unshareSavedSearchResponse> => {

  return customFetch<unshareSavedSearchResponse>(getUnshareSavedSearchUrl({ id, grantId }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnshareSavedSearchMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unshareSavedSearch>>, TError,{pathParams: UnshareSavedSearchPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unshareSavedSearch>>, TError,{pathParams: UnshareSavedSearchPathParameters}, TContext> => {

const mutationKey = ['unshareSavedSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unshareSavedSearch>>, {pathParams: UnshareSavedSearchPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  unshareSavedSearch(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnshareSavedSearchMutationResult = NonNullable<Awaited<ReturnType<typeof unshareSavedSearch>>>

    export type UnshareSavedSearchMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Remove a share of a saved search
 */
export const useUnshareSavedSearch = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unshareSavedSearch>>, TError,{pathParams: UnshareSavedSearchPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unshareSavedSearch>>,
        TError,
        {pathParams: UnshareSavedSearchPathParameters},
        TContext
      > => {
      return useMutation(getUnshareSavedSearchMutationOptions(options), queryClient);
    }
    export type listSchemasResponse200 = {
  data: RegistryListSchemasResponseBody
  status: 200
}

export type listSchemasResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listSchemasResponseSuccess = (listSchemasResponse200) & {
  headers: Headers;
};
export type listSchemasResponseError = (listSchemasResponseDefault) & {
  headers: Headers;
};

export type listSchemasResponse = listSchemasResponseSuccess

export const getListSchemasUrl = (params?: ListSchemasParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/schema?${stringifiedParams}` : `/auth/v1/schema`
}

/**
 * @summary List derived schemas owned by the caller's org
 */
export const listSchemas = async (params?: ListSchemasParams, options?: Parameters<typeof customFetch>[1]): Promise<listSchemasResponse> => {

  return customFetch<listSchemasResponse>(getListSchemasUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSchemasQueryKey = (params?: ListSchemasParams,) => {
    return [
    `/auth/v1/schema`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSchemasQueryOptions = <TData = Awaited<ReturnType<typeof listSchemas>>, TError = ErrorType<HumaAPIError>>(params?: ListSchemasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchemasQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchemas>>> = ({ signal }) => listSchemas(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSchemasQueryResult = NonNullable<Awaited<ReturnType<typeof listSchemas>>>
export type ListSchemasQueryError = ErrorType<HumaAPIError>


export function useListSchemas<TData = Awaited<ReturnType<typeof listSchemas>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListSchemasParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchemas>>,
          TError,
          Awaited<ReturnType<typeof listSchemas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchemas<TData = Awaited<ReturnType<typeof listSchemas>>, TError = ErrorType<HumaAPIError>>(
 params?: ListSchemasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchemas>>,
          TError,
          Awaited<ReturnType<typeof listSchemas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchemas<TData = Awaited<ReturnType<typeof listSchemas>>, TError = ErrorType<HumaAPIError>>(
 params?: ListSchemasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List derived schemas owned by the caller's org
 */

export function useListSchemas<TData = Awaited<ReturnType<typeof listSchemas>>, TError = ErrorType<HumaAPIError>>(
 params?: ListSchemasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSchemasQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSchemasSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listSchemas>>, TError = ErrorType<HumaAPIError>>(params?: ListSchemasParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchemasQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchemas>>> = ({ signal }) => listSchemas(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSchemasSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSchemas>>>
export type ListSchemasSuspenseQueryError = ErrorType<HumaAPIError>


export function useListSchemasSuspense<TData = Awaited<ReturnType<typeof listSchemas>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListSchemasParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchemasSuspense<TData = Awaited<ReturnType<typeof listSchemas>>, TError = ErrorType<HumaAPIError>>(
 params?: ListSchemasParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchemasSuspense<TData = Awaited<ReturnType<typeof listSchemas>>, TError = ErrorType<HumaAPIError>>(
 params?: ListSchemasParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List derived schemas owned by the caller's org
 */

export function useListSchemasSuspense<TData = Awaited<ReturnType<typeof listSchemas>>, TError = ErrorType<HumaAPIError>>(
 params?: ListSchemasParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSchemasSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createSchemaResponse201 = {
  data: RegistrySchemaDetailBody
  status: 201
}

export type createSchemaResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createSchemaResponseSuccess = (createSchemaResponse201) & {
  headers: Headers;
};
export type createSchemaResponseError = (createSchemaResponseDefault) & {
  headers: Headers;
};

export type createSchemaResponse = createSchemaResponseSuccess

export const getCreateSchemaUrl = () => {




  return `/auth/v1/schema`
}

/**
 * Creates a derived schema over a base, owned by the caller's organization, optionally with initial fields. The schema is created unlinked: it has no effect on any organization's resolved schema until it is explicitly activated via POST /auth/v1/schema/{id}/links.
 * @summary Create a derived schema
 */
export const createSchema = async (registryCreateSchemaBody: RegistryCreateSchemaBody, options?: Parameters<typeof customFetch>[1]): Promise<createSchemaResponse> => {

  return customFetch<createSchemaResponse>(getCreateSchemaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registryCreateSchemaBody)
  }
);}





export const getCreateSchemaMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchema>>, TError,{data: RegistryCreateSchemaBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchema>>, TError,{data: RegistryCreateSchemaBody}, TContext> => {

const mutationKey = ['createSchema'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchema>>, {data: RegistryCreateSchemaBody}> = (props) => {
          const {data} = props ?? {};

          return  createSchema(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSchemaMutationResult = NonNullable<Awaited<ReturnType<typeof createSchema>>>
    export type CreateSchemaMutationBody = RegistryCreateSchemaBody
    export type CreateSchemaMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create a derived schema
 */
export const useCreateSchema = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchema>>, TError,{data: RegistryCreateSchemaBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSchema>>,
        TError,
        {data: RegistryCreateSchemaBody},
        TContext
      > => {
      return useMutation(getCreateSchemaMutationOptions(options), queryClient);
    }
    export type listBaseSchemasResponse200 = {
  data: RegistryListBaseSchemasResponseBody
  status: 200
}

export type listBaseSchemasResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listBaseSchemasResponseSuccess = (listBaseSchemasResponse200) & {
  headers: Headers;
};
export type listBaseSchemasResponseError = (listBaseSchemasResponseDefault) & {
  headers: Headers;
};

export type listBaseSchemasResponse = listBaseSchemasResponseSuccess

export const getListBaseSchemasUrl = () => {




  return `/auth/v1/schema/bases`
}

/**
 * Lists the seeded base schemas that derived schemas can be authored over (the base picker).
 * @summary List base schemas
 */
export const listBaseSchemas = async ( options?: Parameters<typeof customFetch>[1]): Promise<listBaseSchemasResponse> => {

  return customFetch<listBaseSchemasResponse>(getListBaseSchemasUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBaseSchemasQueryKey = () => {
    return [
    `/auth/v1/schema/bases`
    ] as const;
    }


export const getListBaseSchemasQueryOptions = <TData = Awaited<ReturnType<typeof listBaseSchemas>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBaseSchemasQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBaseSchemas>>> = ({ signal }) => listBaseSchemas({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBaseSchemasQueryResult = NonNullable<Awaited<ReturnType<typeof listBaseSchemas>>>
export type ListBaseSchemasQueryError = ErrorType<HumaAPIError>


export function useListBaseSchemas<TData = Awaited<ReturnType<typeof listBaseSchemas>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBaseSchemas>>,
          TError,
          Awaited<ReturnType<typeof listBaseSchemas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBaseSchemas<TData = Awaited<ReturnType<typeof listBaseSchemas>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBaseSchemas>>,
          TError,
          Awaited<ReturnType<typeof listBaseSchemas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBaseSchemas<TData = Awaited<ReturnType<typeof listBaseSchemas>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List base schemas
 */

export function useListBaseSchemas<TData = Awaited<ReturnType<typeof listBaseSchemas>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBaseSchemasQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListBaseSchemasSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listBaseSchemas>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBaseSchemasQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBaseSchemas>>> = ({ signal }) => listBaseSchemas({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBaseSchemasSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listBaseSchemas>>>
export type ListBaseSchemasSuspenseQueryError = ErrorType<HumaAPIError>


export function useListBaseSchemasSuspense<TData = Awaited<ReturnType<typeof listBaseSchemas>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBaseSchemasSuspense<TData = Awaited<ReturnType<typeof listBaseSchemas>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBaseSchemasSuspense<TData = Awaited<ReturnType<typeof listBaseSchemas>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List base schemas
 */

export function useListBaseSchemasSuspense<TData = Awaited<ReturnType<typeof listBaseSchemas>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBaseSchemas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBaseSchemasSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deleteSchemaResponse204 = {
  data: void
  status: 204
}

export type deleteSchemaResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type deleteSchemaResponseSuccess = (deleteSchemaResponse204) & {
  headers: Headers;
};
export type deleteSchemaResponseError = (deleteSchemaResponseDefault) & {
  headers: Headers;
};

export type deleteSchemaResponse = deleteSchemaResponseSuccess

export const getDeleteSchemaUrl = ({ id }: DeleteSchemaPathParameters,) => {




  return `/auth/v1/schema/${id}`
}

/**
 * Soft delete: the schema becomes read-only. It stays readable and listable via ?status=archived. There is no unarchive.
 * @summary Archive a derived schema
 */
export const deleteSchema = async ({ id }: DeleteSchemaPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<deleteSchemaResponse> => {

  return customFetch<deleteSchemaResponse>(getDeleteSchemaUrl({ id }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSchemaMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchema>>, TError,{pathParams: DeleteSchemaPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSchema>>, TError,{pathParams: DeleteSchemaPathParameters}, TContext> => {

const mutationKey = ['deleteSchema'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSchema>>, {pathParams: DeleteSchemaPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  deleteSchema(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSchemaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSchema>>>

    export type DeleteSchemaMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Archive a derived schema
 */
export const useDeleteSchema = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchema>>, TError,{pathParams: DeleteSchemaPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSchema>>,
        TError,
        {pathParams: DeleteSchemaPathParameters},
        TContext
      > => {
      return useMutation(getDeleteSchemaMutationOptions(options), queryClient);
    }
    export type getSchemaResponse200 = {
  data: RegistrySchemaDetailBody
  status: 200
}

export type getSchemaResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getSchemaResponseSuccess = (getSchemaResponse200) & {
  headers: Headers;
};
export type getSchemaResponseError = (getSchemaResponseDefault) & {
  headers: Headers;
};

export type getSchemaResponse = getSchemaResponseSuccess

export const getGetSchemaUrl = ({ id }: GetSchemaPathParameters,
    params?: GetSchemaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/schema/${id}?${stringifiedParams}` : `/auth/v1/schema/${id}`
}

/**
 * Returns the full authoring view: metadata, fields, and live-linked organizations. Owner-only; archived schemas remain readable. Archived fields are excluded unless include_archived is set.
 * @summary Get a derived schema by id
 */
export const getSchema = async ({ id }: GetSchemaPathParameters,
    params?: GetSchemaParams, options?: Parameters<typeof customFetch>[1]): Promise<getSchemaResponse> => {

  return customFetch<getSchemaResponse>(getGetSchemaUrl({ id },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSchemaQueryKey = ({ id }: GetSchemaPathParameters,
    params?: GetSchemaParams,) => {
    return [
    `/auth/v1/schema/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSchemaQueryOptions = <TData = Awaited<ReturnType<typeof getSchema>>, TError = ErrorType<HumaAPIError>>({ id }: GetSchemaPathParameters,
    params?: GetSchemaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchemaQueryKey({ id },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchema>>> = ({ signal }) => getSchema({ id },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSchemaQueryResult = NonNullable<Awaited<ReturnType<typeof getSchema>>>
export type GetSchemaQueryError = ErrorType<HumaAPIError>


export function useGetSchema<TData = Awaited<ReturnType<typeof getSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSchemaPathParameters,
    params: undefined |  GetSchemaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchema>>,
          TError,
          Awaited<ReturnType<typeof getSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchema<TData = Awaited<ReturnType<typeof getSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSchemaPathParameters,
    params?: GetSchemaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchema>>,
          TError,
          Awaited<ReturnType<typeof getSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchema<TData = Awaited<ReturnType<typeof getSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSchemaPathParameters,
    params?: GetSchemaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a derived schema by id
 */

export function useGetSchema<TData = Awaited<ReturnType<typeof getSchema>>, TError = ErrorType<HumaAPIError>>(
 { id }: GetSchemaPathParameters,
    params?: GetSchemaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchemaQueryOptions({ id },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSchemaSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSchema>>, TError = ErrorType<HumaAPIError>>({ id }: GetSchemaPathParameters,
    params?: GetSchemaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchemaQueryKey({ id },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchema>>> = ({ signal }) => getSchema({ id },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSchemaSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSchema>>>
export type GetSchemaSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetSchemaSuspense<TData = Awaited<ReturnType<typeof getSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSchemaPathParameters,
    params: undefined |  GetSchemaParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchemaSuspense<TData = Awaited<ReturnType<typeof getSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSchemaPathParameters,
    params?: GetSchemaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchemaSuspense<TData = Awaited<ReturnType<typeof getSchema>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSchemaPathParameters,
    params?: GetSchemaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a derived schema by id
 */

export function useGetSchemaSuspense<TData = Awaited<ReturnType<typeof getSchema>>, TError = ErrorType<HumaAPIError>>(
 { id }: GetSchemaPathParameters,
    params?: GetSchemaParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSchema>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchemaSuspenseQueryOptions({ id },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type patchSchemaResponse200 = {
  data: RegistrySchemaDetailBody
  status: 200
}

export type patchSchemaResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchSchemaResponseSuccess = (patchSchemaResponse200) & {
  headers: Headers;
};
export type patchSchemaResponseError = (patchSchemaResponseDefault) & {
  headers: Headers;
};

export type patchSchemaResponse = patchSchemaResponseSuccess

export const getPatchSchemaUrl = ({ id }: PatchSchemaPathParameters,) => {




  return `/auth/v1/schema/${id}`
}

/**
 * Name is the only mutable schema metadata; fields are edited via the field endpoints.
 * @summary Rename a derived schema
 */
export const patchSchema = async ({ id }: PatchSchemaPathParameters,
    registryPatchSchemaBody: RegistryPatchSchemaBody, options?: Parameters<typeof customFetch>[1]): Promise<patchSchemaResponse> => {

  return customFetch<patchSchemaResponse>(getPatchSchemaUrl({ id }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registryPatchSchemaBody)
  }
);}





export const getPatchSchemaMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSchema>>, TError,{pathParams: PatchSchemaPathParameters;data: RegistryPatchSchemaBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchSchema>>, TError,{pathParams: PatchSchemaPathParameters;data: RegistryPatchSchemaBody}, TContext> => {

const mutationKey = ['patchSchema'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSchema>>, {pathParams: PatchSchemaPathParameters;data: RegistryPatchSchemaBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  patchSchema(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchSchemaMutationResult = NonNullable<Awaited<ReturnType<typeof patchSchema>>>
    export type PatchSchemaMutationBody = RegistryPatchSchemaBody
    export type PatchSchemaMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Rename a derived schema
 */
export const usePatchSchema = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSchema>>, TError,{pathParams: PatchSchemaPathParameters;data: RegistryPatchSchemaBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchSchema>>,
        TError,
        {pathParams: PatchSchemaPathParameters;data: RegistryPatchSchemaBody},
        TContext
      > => {
      return useMutation(getPatchSchemaMutationOptions(options), queryClient);
    }
    export type addSchemaFieldResponse201 = {
  data: RegistrySchemaDetailBody
  status: 201
}

export type addSchemaFieldResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type addSchemaFieldResponseSuccess = (addSchemaFieldResponse201) & {
  headers: Headers;
};
export type addSchemaFieldResponseError = (addSchemaFieldResponseDefault) & {
  headers: Headers;
};

export type addSchemaFieldResponse = addSchemaFieldResponseSuccess

export const getAddSchemaFieldUrl = ({ id }: AddSchemaFieldPathParameters,) => {




  return `/auth/v1/schema/${id}/fields`
}

/**
 * Fields are add-only: there is no field delete. Returns the full schema detail.
 * @summary Add a field to a derived schema
 */
export const addSchemaField = async ({ id }: AddSchemaFieldPathParameters,
    registryFieldBody: RegistryFieldBody, options?: Parameters<typeof customFetch>[1]): Promise<addSchemaFieldResponse> => {

  return customFetch<addSchemaFieldResponse>(getAddSchemaFieldUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registryFieldBody)
  }
);}





export const getAddSchemaFieldMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSchemaField>>, TError,{pathParams: AddSchemaFieldPathParameters;data: RegistryFieldBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addSchemaField>>, TError,{pathParams: AddSchemaFieldPathParameters;data: RegistryFieldBody}, TContext> => {

const mutationKey = ['addSchemaField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addSchemaField>>, {pathParams: AddSchemaFieldPathParameters;data: RegistryFieldBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  addSchemaField(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddSchemaFieldMutationResult = NonNullable<Awaited<ReturnType<typeof addSchemaField>>>
    export type AddSchemaFieldMutationBody = RegistryFieldBody
    export type AddSchemaFieldMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Add a field to a derived schema
 */
export const useAddSchemaField = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSchemaField>>, TError,{pathParams: AddSchemaFieldPathParameters;data: RegistryFieldBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addSchemaField>>,
        TError,
        {pathParams: AddSchemaFieldPathParameters;data: RegistryFieldBody},
        TContext
      > => {
      return useMutation(getAddSchemaFieldMutationOptions(options), queryClient);
    }
    export type editSchemaFieldResponse200 = {
  data: RegistrySchemaDetailBody
  status: 200
}

export type editSchemaFieldResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type editSchemaFieldResponseSuccess = (editSchemaFieldResponse200) & {
  headers: Headers;
};
export type editSchemaFieldResponseError = (editSchemaFieldResponseDefault) & {
  headers: Headers;
};

export type editSchemaFieldResponse = editSchemaFieldResponseSuccess

export const getEditSchemaFieldUrl = ({ id, name }: EditSchemaFieldPathParameters,) => {




  return `/auth/v1/schema/${id}/fields/${name}`
}

/**
 * Replaces the field's mutable attributes (nullable, label, description, config). A field's type is immutable once authored and is deliberately absent from the body. Returns the full schema detail.
 * @summary Edit a field on a derived schema
 */
export const editSchemaField = async ({ id, name }: EditSchemaFieldPathParameters,
    registryEditFieldBody: RegistryEditFieldBody, options?: Parameters<typeof customFetch>[1]): Promise<editSchemaFieldResponse> => {

  return customFetch<editSchemaFieldResponse>(getEditSchemaFieldUrl({ id, name }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registryEditFieldBody)
  }
);}





export const getEditSchemaFieldMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editSchemaField>>, TError,{pathParams: EditSchemaFieldPathParameters;data: RegistryEditFieldBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editSchemaField>>, TError,{pathParams: EditSchemaFieldPathParameters;data: RegistryEditFieldBody}, TContext> => {

const mutationKey = ['editSchemaField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editSchemaField>>, {pathParams: EditSchemaFieldPathParameters;data: RegistryEditFieldBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  editSchemaField(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditSchemaFieldMutationResult = NonNullable<Awaited<ReturnType<typeof editSchemaField>>>
    export type EditSchemaFieldMutationBody = RegistryEditFieldBody
    export type EditSchemaFieldMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Edit a field on a derived schema
 */
export const useEditSchemaField = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editSchemaField>>, TError,{pathParams: EditSchemaFieldPathParameters;data: RegistryEditFieldBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editSchemaField>>,
        TError,
        {pathParams: EditSchemaFieldPathParameters;data: RegistryEditFieldBody},
        TContext
      > => {
      return useMutation(getEditSchemaFieldMutationOptions(options), queryClient);
    }
    export type linkSchemaToOrgResponse201 = {
  data: RegistryLinkSchemaResponseBody
  status: 201
}

export type linkSchemaToOrgResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type linkSchemaToOrgResponseSuccess = (linkSchemaToOrgResponse201) & {
  headers: Headers;
};
export type linkSchemaToOrgResponseError = (linkSchemaToOrgResponseDefault) & {
  headers: Headers;
};

export type linkSchemaToOrgResponse = linkSchemaToOrgResponseSuccess

export const getLinkSchemaToOrgUrl = ({ id }: LinkSchemaToOrgPathParameters,) => {




  return `/auth/v1/schema/${id}/links`
}

/**
 * Creates the live binding that makes this schema the organization's resolved schema for the base. Linking is deliberate — even the owner org must link explicitly. A prior live binding for the same (organization, base) is flipped to this schema; history is retained. Owner-only; the target must be the caller's organization or one it manages.
 * @summary Activate a derived schema for an organization
 */
export const linkSchemaToOrg = async ({ id }: LinkSchemaToOrgPathParameters,
    registryLinkSchemaBody: RegistryLinkSchemaBody, options?: Parameters<typeof customFetch>[1]): Promise<linkSchemaToOrgResponse> => {

  return customFetch<linkSchemaToOrgResponse>(getLinkSchemaToOrgUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registryLinkSchemaBody)
  }
);}





export const getLinkSchemaToOrgMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkSchemaToOrg>>, TError,{pathParams: LinkSchemaToOrgPathParameters;data: RegistryLinkSchemaBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof linkSchemaToOrg>>, TError,{pathParams: LinkSchemaToOrgPathParameters;data: RegistryLinkSchemaBody}, TContext> => {

const mutationKey = ['linkSchemaToOrg'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkSchemaToOrg>>, {pathParams: LinkSchemaToOrgPathParameters;data: RegistryLinkSchemaBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  linkSchemaToOrg(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkSchemaToOrgMutationResult = NonNullable<Awaited<ReturnType<typeof linkSchemaToOrg>>>
    export type LinkSchemaToOrgMutationBody = RegistryLinkSchemaBody
    export type LinkSchemaToOrgMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Activate a derived schema for an organization
 */
export const useLinkSchemaToOrg = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkSchemaToOrg>>, TError,{pathParams: LinkSchemaToOrgPathParameters;data: RegistryLinkSchemaBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkSchemaToOrg>>,
        TError,
        {pathParams: LinkSchemaToOrgPathParameters;data: RegistryLinkSchemaBody},
        TContext
      > => {
      return useMutation(getLinkSchemaToOrgMutationOptions(options), queryClient);
    }
    export type unlinkSchemaFromOrgResponse204 = {
  data: void
  status: 204
}

export type unlinkSchemaFromOrgResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type unlinkSchemaFromOrgResponseSuccess = (unlinkSchemaFromOrgResponse204) & {
  headers: Headers;
};
export type unlinkSchemaFromOrgResponseError = (unlinkSchemaFromOrgResponseDefault) & {
  headers: Headers;
};

export type unlinkSchemaFromOrgResponse = unlinkSchemaFromOrgResponseSuccess

export const getUnlinkSchemaFromOrgUrl = ({ id, orgId }: UnlinkSchemaFromOrgPathParameters,) => {




  return `/auth/v1/schema/${id}/links/${orgId}`
}

/**
 * Removes the organization's live binding to this schema. Idempotent. Owner-only.
 * @summary Deactivate a derived schema for an organization
 */
export const unlinkSchemaFromOrg = async ({ id, orgId }: UnlinkSchemaFromOrgPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<unlinkSchemaFromOrgResponse> => {

  return customFetch<unlinkSchemaFromOrgResponse>(getUnlinkSchemaFromOrgUrl({ id, orgId }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnlinkSchemaFromOrgMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkSchemaFromOrg>>, TError,{pathParams: UnlinkSchemaFromOrgPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlinkSchemaFromOrg>>, TError,{pathParams: UnlinkSchemaFromOrgPathParameters}, TContext> => {

const mutationKey = ['unlinkSchemaFromOrg'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkSchemaFromOrg>>, {pathParams: UnlinkSchemaFromOrgPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  unlinkSchemaFromOrg(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkSchemaFromOrgMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkSchemaFromOrg>>>

    export type UnlinkSchemaFromOrgMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Deactivate a derived schema for an organization
 */
export const useUnlinkSchemaFromOrg = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkSchemaFromOrg>>, TError,{pathParams: UnlinkSchemaFromOrgPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlinkSchemaFromOrg>>,
        TError,
        {pathParams: UnlinkSchemaFromOrgPathParameters},
        TContext
      > => {
      return useMutation(getUnlinkSchemaFromOrgMutationOptions(options), queryClient);
    }
    export type cancelAllocationResponse204 = {
  data: void
  status: 204
}

export type cancelAllocationResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type cancelAllocationResponseSuccess = (cancelAllocationResponse204) & {
  headers: Headers;
};
export type cancelAllocationResponseError = (cancelAllocationResponseDefault) & {
  headers: Headers;
};

export type cancelAllocationResponse = cancelAllocationResponseSuccess

export const getCancelAllocationUrl = ({ allocationId }: CancelAllocationPathParameters,) => {




  return `/auth/v1/trading/allocations/${allocationId}/cancel`
}

/**
 * Cancels an equity order's allocation — the plan that distributes the order's filled shares across accounts — by proxying to orders-api (which publishes it to the OEMS sequencer). This does not cancel the order's open quantity (use the cancel-order endpoint for that): the fills stand, but they are no longer auto-allocated to accounts and must be booked manually. The cancel is asynchronous: a success response means orders-api accepted it, and a cancel-reject (if the allocation is no longer cancelable) arrives later on the orders stream — so orders-api and the OEMS remain the authority and this endpoint does not pre-validate cancelability.
 * @summary Cancel Allocation
 */
export const cancelAllocation = async ({ allocationId }: CancelAllocationPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<cancelAllocationResponse> => {

  return customFetch<cancelAllocationResponse>(getCancelAllocationUrl({ allocationId }),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelAllocationMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAllocation>>, TError,{pathParams: CancelAllocationPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelAllocation>>, TError,{pathParams: CancelAllocationPathParameters}, TContext> => {

const mutationKey = ['cancelAllocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAllocation>>, {pathParams: CancelAllocationPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  cancelAllocation(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelAllocationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAllocation>>>

    export type CancelAllocationMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Cancel Allocation
 */
export const useCancelAllocation = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAllocation>>, TError,{pathParams: CancelAllocationPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelAllocation>>,
        TError,
        {pathParams: CancelAllocationPathParameters},
        TContext
      > => {
      return useMutation(getCancelAllocationMutationOptions(options), queryClient);
    }
    export type getBasePriceEstimateResponse200 = {
  data: GetBasePriceEstimateResponseBody
  status: 200
}

export type getBasePriceEstimateResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getBasePriceEstimateResponseSuccess = (getBasePriceEstimateResponse200) & {
  headers: Headers;
};
export type getBasePriceEstimateResponseError = (getBasePriceEstimateResponseDefault) & {
  headers: Headers;
};

export type getBasePriceEstimateResponse = getBasePriceEstimateResponseSuccess

export const getGetBasePriceEstimateUrl = (params: GetBasePriceEstimateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/base-price-estimate?${stringifiedParams}` : `/auth/v1/trading/base-price-estimate`
}

/**
 * Returns an estimated price for the given instrument, quantity, side, risk group, and settlement date. The returned estimated_price and fees visibility depend on the caller's oms::order::fees::read scopes: fees the caller cannot see are baked into estimated_price, visible fees are returned in the fees array.
 * @summary Get Base Price Estimate
 */
export const getBasePriceEstimate = async (params: GetBasePriceEstimateParams, options?: Parameters<typeof customFetch>[1]): Promise<getBasePriceEstimateResponse> => {

  return customFetch<getBasePriceEstimateResponse>(getGetBasePriceEstimateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBasePriceEstimateQueryKey = (params?: GetBasePriceEstimateParams,) => {
    return [
    `/auth/v1/trading/base-price-estimate`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBasePriceEstimateQueryOptions = <TData = Awaited<ReturnType<typeof getBasePriceEstimate>>, TError = ErrorType<HumaAPIError>>(params: GetBasePriceEstimateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBasePriceEstimateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBasePriceEstimate>>> = ({ signal }) => getBasePriceEstimate(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBasePriceEstimateQueryResult = NonNullable<Awaited<ReturnType<typeof getBasePriceEstimate>>>
export type GetBasePriceEstimateQueryError = ErrorType<HumaAPIError>


export function useGetBasePriceEstimate<TData = Awaited<ReturnType<typeof getBasePriceEstimate>>, TError = ErrorType<HumaAPIError>>(
 params: GetBasePriceEstimateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBasePriceEstimate>>,
          TError,
          Awaited<ReturnType<typeof getBasePriceEstimate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBasePriceEstimate<TData = Awaited<ReturnType<typeof getBasePriceEstimate>>, TError = ErrorType<HumaAPIError>>(
 params: GetBasePriceEstimateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBasePriceEstimate>>,
          TError,
          Awaited<ReturnType<typeof getBasePriceEstimate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBasePriceEstimate<TData = Awaited<ReturnType<typeof getBasePriceEstimate>>, TError = ErrorType<HumaAPIError>>(
 params: GetBasePriceEstimateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Base Price Estimate
 */

export function useGetBasePriceEstimate<TData = Awaited<ReturnType<typeof getBasePriceEstimate>>, TError = ErrorType<HumaAPIError>>(
 params: GetBasePriceEstimateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBasePriceEstimateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBasePriceEstimateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBasePriceEstimate>>, TError = ErrorType<HumaAPIError>>(params: GetBasePriceEstimateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBasePriceEstimateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBasePriceEstimate>>> = ({ signal }) => getBasePriceEstimate(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBasePriceEstimateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBasePriceEstimate>>>
export type GetBasePriceEstimateSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetBasePriceEstimateSuspense<TData = Awaited<ReturnType<typeof getBasePriceEstimate>>, TError = ErrorType<HumaAPIError>>(
 params: GetBasePriceEstimateParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBasePriceEstimateSuspense<TData = Awaited<ReturnType<typeof getBasePriceEstimate>>, TError = ErrorType<HumaAPIError>>(
 params: GetBasePriceEstimateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBasePriceEstimateSuspense<TData = Awaited<ReturnType<typeof getBasePriceEstimate>>, TError = ErrorType<HumaAPIError>>(
 params: GetBasePriceEstimateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Base Price Estimate
 */

export function useGetBasePriceEstimateSuspense<TData = Awaited<ReturnType<typeof getBasePriceEstimate>>, TError = ErrorType<HumaAPIError>>(
 params: GetBasePriceEstimateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBasePriceEstimate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBasePriceEstimateSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type postBestExOrderAnnotationResponse201 = {
  data: BestExOrderAnnotation
  status: 201
}

export type postBestExOrderAnnotationResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postBestExOrderAnnotationResponseSuccess = (postBestExOrderAnnotationResponse201) & {
  headers: Headers;
};
export type postBestExOrderAnnotationResponseError = (postBestExOrderAnnotationResponseDefault) & {
  headers: Headers;
};

export type postBestExOrderAnnotationResponse = postBestExOrderAnnotationResponseSuccess

export const getPostBestExOrderAnnotationUrl = () => {




  return `/auth/v1/trading/best-ex-order-annotations`
}

/**
 * @summary Append a new annotation version for an order
 */
export const postBestExOrderAnnotation = async (postBestExOrderAnnotationRequestBody: PostBestExOrderAnnotationRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<postBestExOrderAnnotationResponse> => {

  return customFetch<postBestExOrderAnnotationResponse>(getPostBestExOrderAnnotationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postBestExOrderAnnotationRequestBody)
  }
);}





export const getPostBestExOrderAnnotationMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBestExOrderAnnotation>>, TError,{data: PostBestExOrderAnnotationRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBestExOrderAnnotation>>, TError,{data: PostBestExOrderAnnotationRequestBody}, TContext> => {

const mutationKey = ['postBestExOrderAnnotation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBestExOrderAnnotation>>, {data: PostBestExOrderAnnotationRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  postBestExOrderAnnotation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostBestExOrderAnnotationMutationResult = NonNullable<Awaited<ReturnType<typeof postBestExOrderAnnotation>>>
    export type PostBestExOrderAnnotationMutationBody = PostBestExOrderAnnotationRequestBody
    export type PostBestExOrderAnnotationMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Append a new annotation version for an order
 */
export const usePostBestExOrderAnnotation = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBestExOrderAnnotation>>, TError,{data: PostBestExOrderAnnotationRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBestExOrderAnnotation>>,
        TError,
        {data: PostBestExOrderAnnotationRequestBody},
        TContext
      > => {
      return useMutation(getPostBestExOrderAnnotationMutationOptions(options), queryClient);
    }
    export type getBestExOrderAnnotationResponse200 = {
  data: BestExOrderAnnotation
  status: 200
}

export type getBestExOrderAnnotationResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getBestExOrderAnnotationResponseSuccess = (getBestExOrderAnnotationResponse200) & {
  headers: Headers;
};
export type getBestExOrderAnnotationResponseError = (getBestExOrderAnnotationResponseDefault) & {
  headers: Headers;
};

export type getBestExOrderAnnotationResponse = getBestExOrderAnnotationResponseSuccess

export const getGetBestExOrderAnnotationUrl = ({ momentExecutionId }: GetBestExOrderAnnotationPathParameters,) => {




  return `/auth/v1/trading/best-ex-order-annotations/${momentExecutionId}`
}

/**
 * @summary Get the latest annotation for an order in the caller's organization
 */
export const getBestExOrderAnnotation = async ({ momentExecutionId }: GetBestExOrderAnnotationPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getBestExOrderAnnotationResponse> => {

  return customFetch<getBestExOrderAnnotationResponse>(getGetBestExOrderAnnotationUrl({ momentExecutionId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBestExOrderAnnotationQueryKey = ({ momentExecutionId }: GetBestExOrderAnnotationPathParameters,) => {
    return [
    `/auth/v1/trading/best-ex-order-annotations/${momentExecutionId}`
    ] as const;
    }


export const getGetBestExOrderAnnotationQueryOptions = <TData = Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError = ErrorType<HumaAPIError>>({ momentExecutionId }: GetBestExOrderAnnotationPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBestExOrderAnnotationQueryKey({ momentExecutionId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBestExOrderAnnotation>>> = ({ signal }) => getBestExOrderAnnotation({ momentExecutionId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: momentExecutionId !== null && momentExecutionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBestExOrderAnnotationQueryResult = NonNullable<Awaited<ReturnType<typeof getBestExOrderAnnotation>>>
export type GetBestExOrderAnnotationQueryError = ErrorType<HumaAPIError>


export function useGetBestExOrderAnnotation<TData = Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBestExOrderAnnotationPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBestExOrderAnnotation>>,
          TError,
          Awaited<ReturnType<typeof getBestExOrderAnnotation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBestExOrderAnnotation<TData = Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBestExOrderAnnotationPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBestExOrderAnnotation>>,
          TError,
          Awaited<ReturnType<typeof getBestExOrderAnnotation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBestExOrderAnnotation<TData = Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBestExOrderAnnotationPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the latest annotation for an order in the caller's organization
 */

export function useGetBestExOrderAnnotation<TData = Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError = ErrorType<HumaAPIError>>(
 { momentExecutionId }: GetBestExOrderAnnotationPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBestExOrderAnnotationQueryOptions({ momentExecutionId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBestExOrderAnnotationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError = ErrorType<HumaAPIError>>({ momentExecutionId }: GetBestExOrderAnnotationPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBestExOrderAnnotationQueryKey({ momentExecutionId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBestExOrderAnnotation>>> = ({ signal }) => getBestExOrderAnnotation({ momentExecutionId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBestExOrderAnnotationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBestExOrderAnnotation>>>
export type GetBestExOrderAnnotationSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetBestExOrderAnnotationSuspense<TData = Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBestExOrderAnnotationPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBestExOrderAnnotationSuspense<TData = Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBestExOrderAnnotationPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBestExOrderAnnotationSuspense<TData = Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBestExOrderAnnotationPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the latest annotation for an order in the caller's organization
 */

export function useGetBestExOrderAnnotationSuspense<TData = Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError = ErrorType<HumaAPIError>>(
 { momentExecutionId }: GetBestExOrderAnnotationPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBestExOrderAnnotation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBestExOrderAnnotationSuspenseQueryOptions({ momentExecutionId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createBulkOrderEntryResponse201 = {
  data: BulkOrderEntry
  status: 201
}

export type createBulkOrderEntryResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createBulkOrderEntryResponseSuccess = (createBulkOrderEntryResponse201) & {
  headers: Headers;
};
export type createBulkOrderEntryResponseError = (createBulkOrderEntryResponseDefault) & {
  headers: Headers;
};

export type createBulkOrderEntryResponse = createBulkOrderEntryResponseSuccess

export const getCreateBulkOrderEntryUrl = () => {




  return `/auth/v1/trading/bulk-order-entry`
}

/**
 * Opens an upload session for the caller, naming it after the Eastern creation time when no name is given.
 * @summary Create Bulk Order Entry
 */
export const createBulkOrderEntry = async (createBulkOrderEntryRequestBody: CreateBulkOrderEntryRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createBulkOrderEntryResponse> => {

  return customFetch<createBulkOrderEntryResponse>(getCreateBulkOrderEntryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createBulkOrderEntryRequestBody)
  }
);}





export const getCreateBulkOrderEntryMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkOrderEntry>>, TError,{data: CreateBulkOrderEntryRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkOrderEntry>>, TError,{data: CreateBulkOrderEntryRequestBody}, TContext> => {

const mutationKey = ['createBulkOrderEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkOrderEntry>>, {data: CreateBulkOrderEntryRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createBulkOrderEntry(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkOrderEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkOrderEntry>>>
    export type CreateBulkOrderEntryMutationBody = CreateBulkOrderEntryRequestBody
    export type CreateBulkOrderEntryMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create Bulk Order Entry
 */
export const useCreateBulkOrderEntry = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkOrderEntry>>, TError,{data: CreateBulkOrderEntryRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkOrderEntry>>,
        TError,
        {data: CreateBulkOrderEntryRequestBody},
        TContext
      > => {
      return useMutation(getCreateBulkOrderEntryMutationOptions(options), queryClient);
    }
    export type listBulkOrderEntryTemplateFieldsResponse200 = {
  data: ListBulkOrderEntryTemplateFieldsResponseBody
  status: 200
}

export type listBulkOrderEntryTemplateFieldsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listBulkOrderEntryTemplateFieldsResponseSuccess = (listBulkOrderEntryTemplateFieldsResponse200) & {
  headers: Headers;
};
export type listBulkOrderEntryTemplateFieldsResponseError = (listBulkOrderEntryTemplateFieldsResponseDefault) & {
  headers: Headers;
};

export type listBulkOrderEntryTemplateFieldsResponse = listBulkOrderEntryTemplateFieldsResponseSuccess

export const getListBulkOrderEntryTemplateFieldsUrl = () => {




  return `/auth/v1/trading/bulk-order-entry/template-fields`
}

/**
 * Lists the draft fields a sheet column can map to, required fields first.
 * @summary List Bulk Order Entry Template Fields
 */
export const listBulkOrderEntryTemplateFields = async ( options?: Parameters<typeof customFetch>[1]): Promise<listBulkOrderEntryTemplateFieldsResponse> => {

  return customFetch<listBulkOrderEntryTemplateFieldsResponse>(getListBulkOrderEntryTemplateFieldsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBulkOrderEntryTemplateFieldsQueryKey = () => {
    return [
    `/auth/v1/trading/bulk-order-entry/template-fields`
    ] as const;
    }


export const getListBulkOrderEntryTemplateFieldsQueryOptions = <TData = Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBulkOrderEntryTemplateFieldsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>> = ({ signal }) => listBulkOrderEntryTemplateFields({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBulkOrderEntryTemplateFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>>
export type ListBulkOrderEntryTemplateFieldsQueryError = ErrorType<HumaAPIError>


export function useListBulkOrderEntryTemplateFields<TData = Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>,
          TError,
          Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBulkOrderEntryTemplateFields<TData = Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>,
          TError,
          Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBulkOrderEntryTemplateFields<TData = Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Bulk Order Entry Template Fields
 */

export function useListBulkOrderEntryTemplateFields<TData = Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBulkOrderEntryTemplateFieldsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListBulkOrderEntryTemplateFieldsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBulkOrderEntryTemplateFieldsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>> = ({ signal }) => listBulkOrderEntryTemplateFields({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBulkOrderEntryTemplateFieldsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>>
export type ListBulkOrderEntryTemplateFieldsSuspenseQueryError = ErrorType<HumaAPIError>


export function useListBulkOrderEntryTemplateFieldsSuspense<TData = Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBulkOrderEntryTemplateFieldsSuspense<TData = Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBulkOrderEntryTemplateFieldsSuspense<TData = Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Bulk Order Entry Template Fields
 */

export function useListBulkOrderEntryTemplateFieldsSuspense<TData = Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBulkOrderEntryTemplateFields>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBulkOrderEntryTemplateFieldsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getBulkOrderEntryResponse200 = {
  data: BulkOrderEntry
  status: 200
}

export type getBulkOrderEntryResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getBulkOrderEntryResponseSuccess = (getBulkOrderEntryResponse200) & {
  headers: Headers;
};
export type getBulkOrderEntryResponseError = (getBulkOrderEntryResponseDefault) & {
  headers: Headers;
};

export type getBulkOrderEntryResponse = getBulkOrderEntryResponseSuccess

export const getGetBulkOrderEntryUrl = ({ entryId }: GetBulkOrderEntryPathParameters,) => {




  return `/auth/v1/trading/bulk-order-entry/${entryId}`
}

/**
 * Reads back one bulk order entry the caller created.
 * @summary Get Bulk Order Entry
 */
export const getBulkOrderEntry = async ({ entryId }: GetBulkOrderEntryPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getBulkOrderEntryResponse> => {

  return customFetch<getBulkOrderEntryResponse>(getGetBulkOrderEntryUrl({ entryId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBulkOrderEntryQueryKey = ({ entryId }: GetBulkOrderEntryPathParameters,) => {
    return [
    `/auth/v1/trading/bulk-order-entry/${entryId}`
    ] as const;
    }


export const getGetBulkOrderEntryQueryOptions = <TData = Awaited<ReturnType<typeof getBulkOrderEntry>>, TError = ErrorType<HumaAPIError>>({ entryId }: GetBulkOrderEntryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBulkOrderEntryQueryKey({ entryId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkOrderEntry>>> = ({ signal }) => getBulkOrderEntry({ entryId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: entryId !== null && entryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBulkOrderEntryQueryResult = NonNullable<Awaited<ReturnType<typeof getBulkOrderEntry>>>
export type GetBulkOrderEntryQueryError = ErrorType<HumaAPIError>


export function useGetBulkOrderEntry<TData = Awaited<ReturnType<typeof getBulkOrderEntry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkOrderEntry>>,
          TError,
          Awaited<ReturnType<typeof getBulkOrderEntry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkOrderEntry<TData = Awaited<ReturnType<typeof getBulkOrderEntry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkOrderEntry>>,
          TError,
          Awaited<ReturnType<typeof getBulkOrderEntry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkOrderEntry<TData = Awaited<ReturnType<typeof getBulkOrderEntry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Bulk Order Entry
 */

export function useGetBulkOrderEntry<TData = Awaited<ReturnType<typeof getBulkOrderEntry>>, TError = ErrorType<HumaAPIError>>(
 { entryId }: GetBulkOrderEntryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBulkOrderEntryQueryOptions({ entryId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBulkOrderEntrySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBulkOrderEntry>>, TError = ErrorType<HumaAPIError>>({ entryId }: GetBulkOrderEntryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBulkOrderEntryQueryKey({ entryId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkOrderEntry>>> = ({ signal }) => getBulkOrderEntry({ entryId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBulkOrderEntrySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBulkOrderEntry>>>
export type GetBulkOrderEntrySuspenseQueryError = ErrorType<HumaAPIError>


export function useGetBulkOrderEntrySuspense<TData = Awaited<ReturnType<typeof getBulkOrderEntry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkOrderEntrySuspense<TData = Awaited<ReturnType<typeof getBulkOrderEntry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkOrderEntrySuspense<TData = Awaited<ReturnType<typeof getBulkOrderEntry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Bulk Order Entry
 */

export function useGetBulkOrderEntrySuspense<TData = Awaited<ReturnType<typeof getBulkOrderEntry>>, TError = ErrorType<HumaAPIError>>(
 { entryId }: GetBulkOrderEntryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBulkOrderEntrySuspenseQueryOptions({ entryId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createBulkOrderEntryDraftResponse201 = {
  data: BulkOrderEntry
  status: 201
}

export type createBulkOrderEntryDraftResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createBulkOrderEntryDraftResponseSuccess = (createBulkOrderEntryDraftResponse201) & {
  headers: Headers;
};
export type createBulkOrderEntryDraftResponseError = (createBulkOrderEntryDraftResponseDefault) & {
  headers: Headers;
};

export type createBulkOrderEntryDraftResponse = createBulkOrderEntryDraftResponseSuccess

export const getCreateBulkOrderEntryDraftUrl = ({ entryId }: CreateBulkOrderEntryDraftPathParameters,) => {




  return `/auth/v1/trading/bulk-order-entry/${entryId}/create-draft`
}

/**
 * Turns the mapped sheet into the entry's order entry draft and returns the updated entry.
 * @summary Create Bulk Order Entry Draft
 */
export const createBulkOrderEntryDraft = async ({ entryId }: CreateBulkOrderEntryDraftPathParameters,
    bulkOrderEntrySheet: BulkOrderEntrySheet, options?: Parameters<typeof customFetch>[1]): Promise<createBulkOrderEntryDraftResponse> => {

  return customFetch<createBulkOrderEntryDraftResponse>(getCreateBulkOrderEntryDraftUrl({ entryId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkOrderEntrySheet)
  }
);}





export const getCreateBulkOrderEntryDraftMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkOrderEntryDraft>>, TError,{pathParams: CreateBulkOrderEntryDraftPathParameters;data: BulkOrderEntrySheet}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkOrderEntryDraft>>, TError,{pathParams: CreateBulkOrderEntryDraftPathParameters;data: BulkOrderEntrySheet}, TContext> => {

const mutationKey = ['createBulkOrderEntryDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkOrderEntryDraft>>, {pathParams: CreateBulkOrderEntryDraftPathParameters;data: BulkOrderEntrySheet}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  createBulkOrderEntryDraft(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkOrderEntryDraftMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkOrderEntryDraft>>>
    export type CreateBulkOrderEntryDraftMutationBody = BulkOrderEntrySheet
    export type CreateBulkOrderEntryDraftMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create Bulk Order Entry Draft
 */
export const useCreateBulkOrderEntryDraft = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkOrderEntryDraft>>, TError,{pathParams: CreateBulkOrderEntryDraftPathParameters;data: BulkOrderEntrySheet}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkOrderEntryDraft>>,
        TError,
        {pathParams: CreateBulkOrderEntryDraftPathParameters;data: BulkOrderEntrySheet},
        TContext
      > => {
      return useMutation(getCreateBulkOrderEntryDraftMutationOptions(options), queryClient);
    }
    export type getBulkOrderEntryFileResponse200 = {
  data: BulkOrderEntryFileDownload
  status: 200
}

export type getBulkOrderEntryFileResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getBulkOrderEntryFileResponseSuccess = (getBulkOrderEntryFileResponse200) & {
  headers: Headers;
};
export type getBulkOrderEntryFileResponseError = (getBulkOrderEntryFileResponseDefault) & {
  headers: Headers;
};

export type getBulkOrderEntryFileResponse = getBulkOrderEntryFileResponseSuccess

export const getGetBulkOrderEntryFileUrl = ({ entryId, type }: GetBulkOrderEntryFilePathParameters,) => {




  return `/auth/v1/trading/bulk-order-entry/${entryId}/file/${type}`
}

/**
 * Returns a presigned download of the newest file of that type once its malware scan comes back clean. An upload that expired without landing is passed over for the file before it.
 * @summary Get Bulk Order Entry File Download
 */
export const getBulkOrderEntryFile = async ({ entryId, type }: GetBulkOrderEntryFilePathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getBulkOrderEntryFileResponse> => {

  return customFetch<getBulkOrderEntryFileResponse>(getGetBulkOrderEntryFileUrl({ entryId, type }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBulkOrderEntryFileQueryKey = ({ entryId, type }: GetBulkOrderEntryFilePathParameters,) => {
    return [
    `/auth/v1/trading/bulk-order-entry/${entryId}/file/${type}`
    ] as const;
    }


export const getGetBulkOrderEntryFileQueryOptions = <TData = Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError = ErrorType<HumaAPIError>>({ entryId, type }: GetBulkOrderEntryFilePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBulkOrderEntryFileQueryKey({ entryId, type });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkOrderEntryFile>>> = ({ signal }) => getBulkOrderEntryFile({ entryId, type }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: entryId !== null && entryId !== undefined && type !== null && type !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBulkOrderEntryFileQueryResult = NonNullable<Awaited<ReturnType<typeof getBulkOrderEntryFile>>>
export type GetBulkOrderEntryFileQueryError = ErrorType<HumaAPIError>


export function useGetBulkOrderEntryFile<TData = Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryFilePathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkOrderEntryFile>>,
          TError,
          Awaited<ReturnType<typeof getBulkOrderEntryFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkOrderEntryFile<TData = Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryFilePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkOrderEntryFile>>,
          TError,
          Awaited<ReturnType<typeof getBulkOrderEntryFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkOrderEntryFile<TData = Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryFilePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Bulk Order Entry File Download
 */

export function useGetBulkOrderEntryFile<TData = Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError = ErrorType<HumaAPIError>>(
 { entryId, type }: GetBulkOrderEntryFilePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBulkOrderEntryFileQueryOptions({ entryId, type },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBulkOrderEntryFileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError = ErrorType<HumaAPIError>>({ entryId, type }: GetBulkOrderEntryFilePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBulkOrderEntryFileQueryKey({ entryId, type });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkOrderEntryFile>>> = ({ signal }) => getBulkOrderEntryFile({ entryId, type }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBulkOrderEntryFileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBulkOrderEntryFile>>>
export type GetBulkOrderEntryFileSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetBulkOrderEntryFileSuspense<TData = Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryFilePathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkOrderEntryFileSuspense<TData = Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryFilePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkOrderEntryFileSuspense<TData = Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetBulkOrderEntryFilePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Bulk Order Entry File Download
 */

export function useGetBulkOrderEntryFileSuspense<TData = Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError = ErrorType<HumaAPIError>>(
 { entryId, type }: GetBulkOrderEntryFilePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBulkOrderEntryFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBulkOrderEntryFileSuspenseQueryOptions({ entryId, type },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createBulkOrderEntryFileResponse201 = {
  data: BulkOrderEntryFileUpload
  status: 201
}

export type createBulkOrderEntryFileResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createBulkOrderEntryFileResponseSuccess = (createBulkOrderEntryFileResponse201) & {
  headers: Headers;
};
export type createBulkOrderEntryFileResponseError = (createBulkOrderEntryFileResponseDefault) & {
  headers: Headers;
};

export type createBulkOrderEntryFileResponse = createBulkOrderEntryFileResponseSuccess

export const getCreateBulkOrderEntryFileUrl = ({ entryId, type }: CreateBulkOrderEntryFilePathParameters,) => {




  return `/auth/v1/trading/bulk-order-entry/${entryId}/file/${type}`
}

/**
 * Records the file against the entry and returns a presigned PUT the browser uploads the sheet to directly.
 * @summary Create Bulk Order Entry File Upload
 */
export const createBulkOrderEntryFile = async ({ entryId, type }: CreateBulkOrderEntryFilePathParameters,
    createBulkOrderEntryFileRequestBody: CreateBulkOrderEntryFileRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createBulkOrderEntryFileResponse> => {

  return customFetch<createBulkOrderEntryFileResponse>(getCreateBulkOrderEntryFileUrl({ entryId, type }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createBulkOrderEntryFileRequestBody)
  }
);}





export const getCreateBulkOrderEntryFileMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkOrderEntryFile>>, TError,{pathParams: CreateBulkOrderEntryFilePathParameters;data: CreateBulkOrderEntryFileRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkOrderEntryFile>>, TError,{pathParams: CreateBulkOrderEntryFilePathParameters;data: CreateBulkOrderEntryFileRequestBody}, TContext> => {

const mutationKey = ['createBulkOrderEntryFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkOrderEntryFile>>, {pathParams: CreateBulkOrderEntryFilePathParameters;data: CreateBulkOrderEntryFileRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  createBulkOrderEntryFile(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkOrderEntryFileMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkOrderEntryFile>>>
    export type CreateBulkOrderEntryFileMutationBody = CreateBulkOrderEntryFileRequestBody
    export type CreateBulkOrderEntryFileMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create Bulk Order Entry File Upload
 */
export const useCreateBulkOrderEntryFile = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkOrderEntryFile>>, TError,{pathParams: CreateBulkOrderEntryFilePathParameters;data: CreateBulkOrderEntryFileRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkOrderEntryFile>>,
        TError,
        {pathParams: CreateBulkOrderEntryFilePathParameters;data: CreateBulkOrderEntryFileRequestBody},
        TContext
      > => {
      return useMutation(getCreateBulkOrderEntryFileMutationOptions(options), queryClient);
    }
    export type parseBulkOrderEntrySheetResponse200 = {
  data: ParseBulkOrderEntryResponseBody
  status: 200
}

export type parseBulkOrderEntrySheetResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type parseBulkOrderEntrySheetResponseSuccess = (parseBulkOrderEntrySheetResponse200) & {
  headers: Headers;
};
export type parseBulkOrderEntrySheetResponseError = (parseBulkOrderEntrySheetResponseDefault) & {
  headers: Headers;
};

export type parseBulkOrderEntrySheetResponse = parseBulkOrderEntrySheetResponseSuccess

export const getParseBulkOrderEntrySheetUrl = ({ entryId }: ParseBulkOrderEntrySheetPathParameters,) => {




  return `/auth/v1/trading/bulk-order-entry/${entryId}/parse`
}

/**
 * Runs the mapped sheet through draft-field parsing and returns the per-row field errors.
 * @summary Parse Bulk Order Entry Sheet
 */
export const parseBulkOrderEntrySheet = async ({ entryId }: ParseBulkOrderEntrySheetPathParameters,
    bulkOrderEntrySheet: BulkOrderEntrySheet, options?: Parameters<typeof customFetch>[1]): Promise<parseBulkOrderEntrySheetResponse> => {

  return customFetch<parseBulkOrderEntrySheetResponse>(getParseBulkOrderEntrySheetUrl({ entryId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkOrderEntrySheet)
  }
);}





export const getParseBulkOrderEntrySheetMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parseBulkOrderEntrySheet>>, TError,{pathParams: ParseBulkOrderEntrySheetPathParameters;data: BulkOrderEntrySheet}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof parseBulkOrderEntrySheet>>, TError,{pathParams: ParseBulkOrderEntrySheetPathParameters;data: BulkOrderEntrySheet}, TContext> => {

const mutationKey = ['parseBulkOrderEntrySheet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parseBulkOrderEntrySheet>>, {pathParams: ParseBulkOrderEntrySheetPathParameters;data: BulkOrderEntrySheet}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  parseBulkOrderEntrySheet(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ParseBulkOrderEntrySheetMutationResult = NonNullable<Awaited<ReturnType<typeof parseBulkOrderEntrySheet>>>
    export type ParseBulkOrderEntrySheetMutationBody = BulkOrderEntrySheet
    export type ParseBulkOrderEntrySheetMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Parse Bulk Order Entry Sheet
 */
export const useParseBulkOrderEntrySheet = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parseBulkOrderEntrySheet>>, TError,{pathParams: ParseBulkOrderEntrySheetPathParameters;data: BulkOrderEntrySheet}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parseBulkOrderEntrySheet>>,
        TError,
        {pathParams: ParseBulkOrderEntrySheetPathParameters;data: BulkOrderEntrySheet},
        TContext
      > => {
      return useMutation(getParseBulkOrderEntrySheetMutationOptions(options), queryClient);
    }
    export type suggestBulkOrderEntryMappingResponse200 = {
  data: SuggestBulkOrderEntryMappingResponseBody
  status: 200
}

export type suggestBulkOrderEntryMappingResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type suggestBulkOrderEntryMappingResponseSuccess = (suggestBulkOrderEntryMappingResponse200) & {
  headers: Headers;
};
export type suggestBulkOrderEntryMappingResponseError = (suggestBulkOrderEntryMappingResponseDefault) & {
  headers: Headers;
};

export type suggestBulkOrderEntryMappingResponse = suggestBulkOrderEntryMappingResponseSuccess

export const getSuggestBulkOrderEntryMappingUrl = ({ entryId }: SuggestBulkOrderEntryMappingPathParameters,) => {




  return `/auth/v1/trading/bulk-order-entry/${entryId}/suggest-mapping`
}

/**
 * Proposes a column_mapping from the sheet's headers and sample cells: exact header aliases first, a model suggestion for the rest. The proposal binds nothing; parse and create-draft take the mapping the user confirms.
 * @summary Suggest Bulk Order Entry Mapping
 */
export const suggestBulkOrderEntryMapping = async ({ entryId }: SuggestBulkOrderEntryMappingPathParameters,
    suggestBulkOrderEntryMappingRequestBody: SuggestBulkOrderEntryMappingRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<suggestBulkOrderEntryMappingResponse> => {

  return customFetch<suggestBulkOrderEntryMappingResponse>(getSuggestBulkOrderEntryMappingUrl({ entryId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(suggestBulkOrderEntryMappingRequestBody)
  }
);}





export const getSuggestBulkOrderEntryMappingMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestBulkOrderEntryMapping>>, TError,{pathParams: SuggestBulkOrderEntryMappingPathParameters;data: SuggestBulkOrderEntryMappingRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof suggestBulkOrderEntryMapping>>, TError,{pathParams: SuggestBulkOrderEntryMappingPathParameters;data: SuggestBulkOrderEntryMappingRequestBody}, TContext> => {

const mutationKey = ['suggestBulkOrderEntryMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suggestBulkOrderEntryMapping>>, {pathParams: SuggestBulkOrderEntryMappingPathParameters;data: SuggestBulkOrderEntryMappingRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  suggestBulkOrderEntryMapping(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SuggestBulkOrderEntryMappingMutationResult = NonNullable<Awaited<ReturnType<typeof suggestBulkOrderEntryMapping>>>
    export type SuggestBulkOrderEntryMappingMutationBody = SuggestBulkOrderEntryMappingRequestBody
    export type SuggestBulkOrderEntryMappingMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Suggest Bulk Order Entry Mapping
 */
export const useSuggestBulkOrderEntryMapping = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestBulkOrderEntryMapping>>, TError,{pathParams: SuggestBulkOrderEntryMappingPathParameters;data: SuggestBulkOrderEntryMappingRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof suggestBulkOrderEntryMapping>>,
        TError,
        {pathParams: SuggestBulkOrderEntryMappingPathParameters;data: SuggestBulkOrderEntryMappingRequestBody},
        TContext
      > => {
      return useMutation(getSuggestBulkOrderEntryMappingMutationOptions(options), queryClient);
    }
    export type getSupportedAlgosResponse200 = {
  data: GetSupportedAlgosResponseBody
  status: 200
}

export type getSupportedAlgosResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getSupportedAlgosResponseSuccess = (getSupportedAlgosResponse200) & {
  headers: Headers;
};
export type getSupportedAlgosResponseError = (getSupportedAlgosResponseDefault) & {
  headers: Headers;
};

export type getSupportedAlgosResponse = getSupportedAlgosResponseSuccess

export const getGetSupportedAlgosUrl = ({ custodianId }: GetSupportedAlgosPathParameters,) => {




  return `/auth/v1/trading/custodians/${custodianId}/algos`
}

/**
 * Returns the trading algos the given custodian supports and, per algo, the fields it accepts with their constraints and helper text. Backed by the same registry that validates submitted algo parameters, so the rendered and validated field sets stay in sync.
 * @summary Get Supported Algos
 */
export const getSupportedAlgos = async ({ custodianId }: GetSupportedAlgosPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getSupportedAlgosResponse> => {

  return customFetch<getSupportedAlgosResponse>(getGetSupportedAlgosUrl({ custodianId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSupportedAlgosQueryKey = ({ custodianId }: GetSupportedAlgosPathParameters,) => {
    return [
    `/auth/v1/trading/custodians/${custodianId}/algos`
    ] as const;
    }


export const getGetSupportedAlgosQueryOptions = <TData = Awaited<ReturnType<typeof getSupportedAlgos>>, TError = ErrorType<HumaAPIError>>({ custodianId }: GetSupportedAlgosPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportedAlgosQueryKey({ custodianId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportedAlgos>>> = ({ signal }) => getSupportedAlgos({ custodianId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: custodianId !== null && custodianId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupportedAlgosQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportedAlgos>>>
export type GetSupportedAlgosQueryError = ErrorType<HumaAPIError>


export function useGetSupportedAlgos<TData = Awaited<ReturnType<typeof getSupportedAlgos>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedAlgosPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedAlgos>>,
          TError,
          Awaited<ReturnType<typeof getSupportedAlgos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedAlgos<TData = Awaited<ReturnType<typeof getSupportedAlgos>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedAlgosPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedAlgos>>,
          TError,
          Awaited<ReturnType<typeof getSupportedAlgos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedAlgos<TData = Awaited<ReturnType<typeof getSupportedAlgos>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedAlgosPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Supported Algos
 */

export function useGetSupportedAlgos<TData = Awaited<ReturnType<typeof getSupportedAlgos>>, TError = ErrorType<HumaAPIError>>(
 { custodianId }: GetSupportedAlgosPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupportedAlgosQueryOptions({ custodianId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSupportedAlgosSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSupportedAlgos>>, TError = ErrorType<HumaAPIError>>({ custodianId }: GetSupportedAlgosPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportedAlgosQueryKey({ custodianId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportedAlgos>>> = ({ signal }) => getSupportedAlgos({ custodianId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupportedAlgosSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportedAlgos>>>
export type GetSupportedAlgosSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetSupportedAlgosSuspense<TData = Awaited<ReturnType<typeof getSupportedAlgos>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedAlgosPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedAlgosSuspense<TData = Awaited<ReturnType<typeof getSupportedAlgos>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedAlgosPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedAlgosSuspense<TData = Awaited<ReturnType<typeof getSupportedAlgos>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedAlgosPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Supported Algos
 */

export function useGetSupportedAlgosSuspense<TData = Awaited<ReturnType<typeof getSupportedAlgos>>, TError = ErrorType<HumaAPIError>>(
 { custodianId }: GetSupportedAlgosPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedAlgos>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupportedAlgosSuspenseQueryOptions({ custodianId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getSupportedParametersResponse200 = {
  data: GetSupportedParametersResponseBody
  status: 200
}

export type getSupportedParametersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getSupportedParametersResponseSuccess = (getSupportedParametersResponse200) & {
  headers: Headers;
};
export type getSupportedParametersResponseError = (getSupportedParametersResponseDefault) & {
  headers: Headers;
};

export type getSupportedParametersResponse = getSupportedParametersResponseSuccess

export const getGetSupportedParametersUrl = ({ custodianId }: GetSupportedParametersPathParameters,) => {




  return `/auth/v1/trading/custodians/${custodianId}/parameters`
}

/**
 * Returns the execution-order parameters (algos, auction orders, and times in force) the given custodian supports and, per parameter, the fields it accepts with their constraints and helper text. Backed by the same registry that validates submitted parameters, so the rendered and validated field sets stay in sync. Also returns the asset types the custodian supports tax-lot aggregation for, and which aggregation keys each supports.
 * @summary Get Supported Execution Order Parameters
 */
export const getSupportedParameters = async ({ custodianId }: GetSupportedParametersPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getSupportedParametersResponse> => {

  return customFetch<getSupportedParametersResponse>(getGetSupportedParametersUrl({ custodianId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSupportedParametersQueryKey = ({ custodianId }: GetSupportedParametersPathParameters,) => {
    return [
    `/auth/v1/trading/custodians/${custodianId}/parameters`
    ] as const;
    }


export const getGetSupportedParametersQueryOptions = <TData = Awaited<ReturnType<typeof getSupportedParameters>>, TError = ErrorType<HumaAPIError>>({ custodianId }: GetSupportedParametersPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportedParametersQueryKey({ custodianId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportedParameters>>> = ({ signal }) => getSupportedParameters({ custodianId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: custodianId !== null && custodianId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupportedParametersQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportedParameters>>>
export type GetSupportedParametersQueryError = ErrorType<HumaAPIError>


export function useGetSupportedParameters<TData = Awaited<ReturnType<typeof getSupportedParameters>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedParametersPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedParameters>>,
          TError,
          Awaited<ReturnType<typeof getSupportedParameters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedParameters<TData = Awaited<ReturnType<typeof getSupportedParameters>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedParametersPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportedParameters>>,
          TError,
          Awaited<ReturnType<typeof getSupportedParameters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedParameters<TData = Awaited<ReturnType<typeof getSupportedParameters>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedParametersPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Supported Execution Order Parameters
 */

export function useGetSupportedParameters<TData = Awaited<ReturnType<typeof getSupportedParameters>>, TError = ErrorType<HumaAPIError>>(
 { custodianId }: GetSupportedParametersPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupportedParametersQueryOptions({ custodianId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSupportedParametersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSupportedParameters>>, TError = ErrorType<HumaAPIError>>({ custodianId }: GetSupportedParametersPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportedParametersQueryKey({ custodianId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportedParameters>>> = ({ signal }) => getSupportedParameters({ custodianId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupportedParametersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportedParameters>>>
export type GetSupportedParametersSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetSupportedParametersSuspense<TData = Awaited<ReturnType<typeof getSupportedParameters>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedParametersPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedParametersSuspense<TData = Awaited<ReturnType<typeof getSupportedParameters>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedParametersPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportedParametersSuspense<TData = Awaited<ReturnType<typeof getSupportedParameters>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetSupportedParametersPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Supported Execution Order Parameters
 */

export function useGetSupportedParametersSuspense<TData = Awaited<ReturnType<typeof getSupportedParameters>>, TError = ErrorType<HumaAPIError>>(
 { custodianId }: GetSupportedParametersPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupportedParameters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupportedParametersSuspenseQueryOptions({ custodianId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listTradingFeeSchedulesResponse200 = {
  data: ListFeeSchedulesResponseBody
  status: 200
}

export type listTradingFeeSchedulesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listTradingFeeSchedulesResponseSuccess = (listTradingFeeSchedulesResponse200) & {
  headers: Headers;
};
export type listTradingFeeSchedulesResponseError = (listTradingFeeSchedulesResponseDefault) & {
  headers: Headers;
};

export type listTradingFeeSchedulesResponse = listTradingFeeSchedulesResponseSuccess

export const getListTradingFeeSchedulesUrl = (params: ListTradingFeeSchedulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/fee-schedules?${stringifiedParams}` : `/auth/v1/trading/fee-schedules`
}

/**
 * Returns the fee schedule version currently in effect. At most one version applies at any instant, so this returns zero or one entry; an empty list means no schedule is in force for the risk group. Use the scheduled endpoint for replacements that have not taken effect yet.
 * @summary List active fee schedules
 */
export const listTradingFeeSchedules = async (params: ListTradingFeeSchedulesParams, options?: Parameters<typeof customFetch>[1]): Promise<listTradingFeeSchedulesResponse> => {

  return customFetch<listTradingFeeSchedulesResponse>(getListTradingFeeSchedulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTradingFeeSchedulesQueryKey = (params?: ListTradingFeeSchedulesParams,) => {
    return [
    `/auth/v1/trading/fee-schedules`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTradingFeeSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingFeeSchedules>>> = ({ signal }) => listTradingFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingFeeSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingFeeSchedules>>>
export type ListTradingFeeSchedulesQueryError = ErrorType<HumaAPIError>


export function useListTradingFeeSchedules<TData = Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingFeeSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingFeeSchedules<TData = Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingFeeSchedules<TData = Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active fee schedules
 */

export function useListTradingFeeSchedules<TData = Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingFeeSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTradingFeeSchedulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingFeeSchedules>>> = ({ signal }) => listTradingFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingFeeSchedulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingFeeSchedules>>>
export type ListTradingFeeSchedulesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListTradingFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingFeeSchedulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active fee schedules
 */

export function useListTradingFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingFeeSchedulesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listTradingArchivedFeeSchedulesResponse200 = {
  data: ListFeeSchedulesResponseBody
  status: 200
}

export type listTradingArchivedFeeSchedulesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listTradingArchivedFeeSchedulesResponseSuccess = (listTradingArchivedFeeSchedulesResponse200) & {
  headers: Headers;
};
export type listTradingArchivedFeeSchedulesResponseError = (listTradingArchivedFeeSchedulesResponseDefault) & {
  headers: Headers;
};

export type listTradingArchivedFeeSchedulesResponse = listTradingArchivedFeeSchedulesResponseSuccess

export const getListTradingArchivedFeeSchedulesUrl = (params: ListTradingArchivedFeeSchedulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/fee-schedules/archived?${stringifiedParams}` : `/auth/v1/trading/fee-schedules/archived`
}

/**
 * Returns the fee schedule versions whose effective window has already closed, most recently retired first, each with the window it was in force over and who created it. Versions that never applied are omitted. Page further back with `before` and `limit`.
 * @summary List archived fee schedules
 */
export const listTradingArchivedFeeSchedules = async (params: ListTradingArchivedFeeSchedulesParams, options?: Parameters<typeof customFetch>[1]): Promise<listTradingArchivedFeeSchedulesResponse> => {

  return customFetch<listTradingArchivedFeeSchedulesResponse>(getListTradingArchivedFeeSchedulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTradingArchivedFeeSchedulesQueryKey = (params?: ListTradingArchivedFeeSchedulesParams,) => {
    return [
    `/auth/v1/trading/fee-schedules/archived`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTradingArchivedFeeSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingArchivedFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingArchivedFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>> = ({ signal }) => listTradingArchivedFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingArchivedFeeSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>>
export type ListTradingArchivedFeeSchedulesQueryError = ErrorType<HumaAPIError>


export function useListTradingArchivedFeeSchedules<TData = Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedFeeSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingArchivedFeeSchedules<TData = Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingArchivedFeeSchedules<TData = Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List archived fee schedules
 */

export function useListTradingArchivedFeeSchedules<TData = Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingArchivedFeeSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTradingArchivedFeeSchedulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingArchivedFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingArchivedFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>> = ({ signal }) => listTradingArchivedFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingArchivedFeeSchedulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>>
export type ListTradingArchivedFeeSchedulesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListTradingArchivedFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedFeeSchedulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingArchivedFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingArchivedFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List archived fee schedules
 */

export function useListTradingArchivedFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingArchivedFeeSchedulesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listTradingScheduledFeeSchedulesResponse200 = {
  data: ListFeeSchedulesResponseBody
  status: 200
}

export type listTradingScheduledFeeSchedulesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listTradingScheduledFeeSchedulesResponseSuccess = (listTradingScheduledFeeSchedulesResponse200) & {
  headers: Headers;
};
export type listTradingScheduledFeeSchedulesResponseError = (listTradingScheduledFeeSchedulesResponseDefault) & {
  headers: Headers;
};

export type listTradingScheduledFeeSchedulesResponse = listTradingScheduledFeeSchedulesResponseSuccess

export const getListTradingScheduledFeeSchedulesUrl = (params: ListTradingScheduledFeeSchedulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/fee-schedules/scheduled?${stringifiedParams}` : `/auth/v1/trading/fee-schedules/scheduled`
}

/**
 * Returns the fee schedule versions scheduled to take effect later, earliest first. Versions superseded before they took effect are omitted; today at most one is ever pending.
 * @summary List scheduled fee schedules
 */
export const listTradingScheduledFeeSchedules = async (params: ListTradingScheduledFeeSchedulesParams, options?: Parameters<typeof customFetch>[1]): Promise<listTradingScheduledFeeSchedulesResponse> => {

  return customFetch<listTradingScheduledFeeSchedulesResponse>(getListTradingScheduledFeeSchedulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTradingScheduledFeeSchedulesQueryKey = (params?: ListTradingScheduledFeeSchedulesParams,) => {
    return [
    `/auth/v1/trading/fee-schedules/scheduled`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTradingScheduledFeeSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingScheduledFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingScheduledFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>> = ({ signal }) => listTradingScheduledFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingScheduledFeeSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>>
export type ListTradingScheduledFeeSchedulesQueryError = ErrorType<HumaAPIError>


export function useListTradingScheduledFeeSchedules<TData = Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledFeeSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingScheduledFeeSchedules<TData = Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingScheduledFeeSchedules<TData = Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List scheduled fee schedules
 */

export function useListTradingScheduledFeeSchedules<TData = Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingScheduledFeeSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTradingScheduledFeeSchedulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingScheduledFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingScheduledFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>> = ({ signal }) => listTradingScheduledFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingScheduledFeeSchedulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>>
export type ListTradingScheduledFeeSchedulesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListTradingScheduledFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledFeeSchedulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingScheduledFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingScheduledFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List scheduled fee schedules
 */

export function useListTradingScheduledFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingScheduledFeeSchedulesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getInquiryResponse200 = {
  data: Inquiry
  status: 200
}

export type getInquiryResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getInquiryResponseSuccess = (getInquiryResponse200) & {
  headers: Headers;
};
export type getInquiryResponseError = (getInquiryResponseDefault) & {
  headers: Headers;
};

export type getInquiryResponse = getInquiryResponseSuccess

export const getGetInquiryUrl = ({ id }: GetInquiryPathParameters,) => {




  return `/auth/v1/trading/inquiry/${id}`
}

/**
 * Returns the inquiry attached to a moment order as of its most recent event. The parent order must be one the caller can see on the blotter.
 * @summary Get an inquiry
 */
export const getInquiry = async ({ id }: GetInquiryPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getInquiryResponse> => {

  return customFetch<getInquiryResponse>(getGetInquiryUrl({ id }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInquiryQueryKey = ({ id }: GetInquiryPathParameters,) => {
    return [
    `/auth/v1/trading/inquiry/${id}`
    ] as const;
    }


export const getGetInquiryQueryOptions = <TData = Awaited<ReturnType<typeof getInquiry>>, TError = ErrorType<HumaAPIError>>({ id }: GetInquiryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInquiryQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInquiry>>> = ({ signal }) => getInquiry({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInquiryQueryResult = NonNullable<Awaited<ReturnType<typeof getInquiry>>>
export type GetInquiryQueryError = ErrorType<HumaAPIError>


export function useGetInquiry<TData = Awaited<ReturnType<typeof getInquiry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInquiryPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInquiry>>,
          TError,
          Awaited<ReturnType<typeof getInquiry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInquiry<TData = Awaited<ReturnType<typeof getInquiry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInquiryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInquiry>>,
          TError,
          Awaited<ReturnType<typeof getInquiry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInquiry<TData = Awaited<ReturnType<typeof getInquiry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInquiryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an inquiry
 */

export function useGetInquiry<TData = Awaited<ReturnType<typeof getInquiry>>, TError = ErrorType<HumaAPIError>>(
 { id }: GetInquiryPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInquiryQueryOptions({ id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInquirySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInquiry>>, TError = ErrorType<HumaAPIError>>({ id }: GetInquiryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInquiryQueryKey({ id });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInquiry>>> = ({ signal }) => getInquiry({ id }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInquirySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInquiry>>>
export type GetInquirySuspenseQueryError = ErrorType<HumaAPIError>


export function useGetInquirySuspense<TData = Awaited<ReturnType<typeof getInquiry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInquiryPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInquirySuspense<TData = Awaited<ReturnType<typeof getInquiry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInquiryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInquirySuspense<TData = Awaited<ReturnType<typeof getInquiry>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetInquiryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an inquiry
 */

export function useGetInquirySuspense<TData = Awaited<ReturnType<typeof getInquiry>>, TError = ErrorType<HumaAPIError>>(
 { id }: GetInquiryPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInquiry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInquirySuspenseQueryOptions({ id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type acceptInquiryResponse202 = {
  data: AcceptInquiryResponseBody
  status: 202
}

export type acceptInquiryResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 202>
}

export type acceptInquiryResponseSuccess = (acceptInquiryResponse202) & {
  headers: Headers;
};
export type acceptInquiryResponseError = (acceptInquiryResponseDefault) & {
  headers: Headers;
};

export type acceptInquiryResponse = acceptInquiryResponseSuccess

export const getAcceptInquiryUrl = ({ id }: AcceptInquiryPathParameters,) => {




  return `/auth/v1/trading/inquiry/${id}/accept`
}

/**
 * Converts the JSON body into an InquiryAcceptRequest protobuf and publishes it to the OEMS sequencer for inquiry-manager to process. The introducing broker id and the submitting user are derived from the caller's JWT. The caller must hold the approve_price grant for the inquiry's type; a #self grant is honored only for the advisor on the inquiry's order. The body must carry the moment_order_id the inquiry sits on: a cancel/replace re-keys the inquiry onto a new order, and an id the inquiry is no longer on is a 404. The inquiry must be pending acceptance (409 otherwise). A quote auto-priced from the street is accepted at the post-fee limit price horizon derived from it, and is a 500 if horizon failed to derive one. The write is asynchronous: a 202 means the acceptance was submitted, not that it has been applied.
 * @summary Accept an inquiry
 */
export const acceptInquiry = async ({ id }: AcceptInquiryPathParameters,
    acceptInquiryBody: AcceptInquiryBody, options?: Parameters<typeof customFetch>[1]): Promise<acceptInquiryResponse> => {

  return customFetch<acceptInquiryResponse>(getAcceptInquiryUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(acceptInquiryBody)
  }
);}





export const getAcceptInquiryMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInquiry>>, TError,{pathParams: AcceptInquiryPathParameters;data: AcceptInquiryBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInquiry>>, TError,{pathParams: AcceptInquiryPathParameters;data: AcceptInquiryBody}, TContext> => {

const mutationKey = ['acceptInquiry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInquiry>>, {pathParams: AcceptInquiryPathParameters;data: AcceptInquiryBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  acceptInquiry(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInquiryMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInquiry>>>
    export type AcceptInquiryMutationBody = AcceptInquiryBody
    export type AcceptInquiryMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Accept an inquiry
 */
export const useAcceptInquiry = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInquiry>>, TError,{pathParams: AcceptInquiryPathParameters;data: AcceptInquiryBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInquiry>>,
        TError,
        {pathParams: AcceptInquiryPathParameters;data: AcceptInquiryBody},
        TContext
      > => {
      return useMutation(getAcceptInquiryMutationOptions(options), queryClient);
    }
    export type rerequestInquiryResponse202 = {
  data: RerequestInquiryResponseBody
  status: 202
}

export type rerequestInquiryResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 202>
}

export type rerequestInquiryResponseSuccess = (rerequestInquiryResponse202) & {
  headers: Headers;
};
export type rerequestInquiryResponseError = (rerequestInquiryResponseDefault) & {
  headers: Headers;
};

export type rerequestInquiryResponse = rerequestInquiryResponseSuccess

export const getRerequestInquiryUrl = ({ id }: RerequestInquiryPathParameters,) => {




  return `/auth/v1/trading/inquiry/${id}/rerequest`
}

/**
 * Converts the path inquiry id into an InquiryRerequest protobuf and publishes it to the OEMS sequencer for inquiry-manager to process. The broker ids and the submitting user are derived from the caller's JWT organization, parent organization and user id. Used for re-requesting a price; the inquiry must already exist. The caller must hold the approve_price grant for the inquiry's type; a #self grant is honored only for the advisor on the inquiry's order. Only quote-wanted inquiries can be re-requested (409 for an IOI); any open quote-wanted inquiry may be, as in inquiry-manager. The write is asynchronous: a 202 means the re-request was submitted, not that it has been applied.
 * @summary Re-request an inquiry
 */
export const rerequestInquiry = async ({ id }: RerequestInquiryPathParameters,
    rerequestInquiryBody: RerequestInquiryBody, options?: Parameters<typeof customFetch>[1]): Promise<rerequestInquiryResponse> => {

  return customFetch<rerequestInquiryResponse>(getRerequestInquiryUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rerequestInquiryBody)
  }
);}





export const getRerequestInquiryMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rerequestInquiry>>, TError,{pathParams: RerequestInquiryPathParameters;data: RerequestInquiryBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rerequestInquiry>>, TError,{pathParams: RerequestInquiryPathParameters;data: RerequestInquiryBody}, TContext> => {

const mutationKey = ['rerequestInquiry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rerequestInquiry>>, {pathParams: RerequestInquiryPathParameters;data: RerequestInquiryBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  rerequestInquiry(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RerequestInquiryMutationResult = NonNullable<Awaited<ReturnType<typeof rerequestInquiry>>>
    export type RerequestInquiryMutationBody = RerequestInquiryBody
    export type RerequestInquiryMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Re-request an inquiry
 */
export const useRerequestInquiry = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rerequestInquiry>>, TError,{pathParams: RerequestInquiryPathParameters;data: RerequestInquiryBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rerequestInquiry>>,
        TError,
        {pathParams: RerequestInquiryPathParameters;data: RerequestInquiryBody},
        TContext
      > => {
      return useMutation(getRerequestInquiryMutationOptions(options), queryClient);
    }
    export type respondToInquiryResponse202 = {
  data: RespondToInquiryResponseBody
  status: 202
}

export type respondToInquiryResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 202>
}

export type respondToInquiryResponseSuccess = (respondToInquiryResponse202) & {
  headers: Headers;
};
export type respondToInquiryResponseError = (respondToInquiryResponseDefault) & {
  headers: Headers;
};

export type respondToInquiryResponse = respondToInquiryResponseSuccess

export const getRespondToInquiryUrl = ({ id }: RespondToInquiryPathParameters,) => {




  return `/auth/v1/trading/inquiry/${id}/response`
}

/**
 * Converts the JSON body into an InquiryResponseRequest protobuf and publishes it to the OEMS sequencer for inquiry-manager to process. The introducing broker id and the submitting user are derived from the caller's JWT. Only quote-wanted inquiries take a trader response (409 for other types); any open inquiry may be responded to, as in inquiry-manager. expire_time is optional; omit it and the quote never expires, staying acceptable until the advisor acts. The write is asynchronous: a 202 means the response was submitted, not that it has been applied.
 * @summary Respond to an inquiry
 */
export const respondToInquiry = async ({ id }: RespondToInquiryPathParameters,
    inquiryResponseBody: InquiryResponseBody, options?: Parameters<typeof customFetch>[1]): Promise<respondToInquiryResponse> => {

  return customFetch<respondToInquiryResponse>(getRespondToInquiryUrl({ id }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inquiryResponseBody)
  }
);}





export const getRespondToInquiryMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToInquiry>>, TError,{pathParams: RespondToInquiryPathParameters;data: InquiryResponseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof respondToInquiry>>, TError,{pathParams: RespondToInquiryPathParameters;data: InquiryResponseBody}, TContext> => {

const mutationKey = ['respondToInquiry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof respondToInquiry>>, {pathParams: RespondToInquiryPathParameters;data: InquiryResponseBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  respondToInquiry(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RespondToInquiryMutationResult = NonNullable<Awaited<ReturnType<typeof respondToInquiry>>>
    export type RespondToInquiryMutationBody = InquiryResponseBody
    export type RespondToInquiryMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Respond to an inquiry
 */
export const useRespondToInquiry = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToInquiry>>, TError,{pathParams: RespondToInquiryPathParameters;data: InquiryResponseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof respondToInquiry>>,
        TError,
        {pathParams: RespondToInquiryPathParameters;data: InquiryResponseBody},
        TContext
      > => {
      return useMutation(getRespondToInquiryMutationOptions(options), queryClient);
    }
    export type getTradingInstrumentMunipointsUrlResponse200 = {
  data: MuniPointsURLResponseBody
  status: 200
}

export type getTradingInstrumentMunipointsUrlResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getTradingInstrumentMunipointsUrlResponseSuccess = (getTradingInstrumentMunipointsUrlResponse200) & {
  headers: Headers;
};
export type getTradingInstrumentMunipointsUrlResponseError = (getTradingInstrumentMunipointsUrlResponseDefault) & {
  headers: Headers;
};

export type getTradingInstrumentMunipointsUrlResponse = getTradingInstrumentMunipointsUrlResponseSuccess

export const getGetTradingInstrumentMunipointsUrlUrl = ({ instrumentId }: GetTradingInstrumentMunipointsUrlPathParameters,) => {




  return `/auth/v1/trading/instrument/${instrumentId}/munipoints`
}

/**
 * Mints a DPC profile URL under the authenticated caller's parent organization. The URL is a session credential and must not be logged or cached.
 * @summary Get a municipal bond's MuniPOINTS profile URL
 */
export const getTradingInstrumentMunipointsUrl = async ({ instrumentId }: GetTradingInstrumentMunipointsUrlPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getTradingInstrumentMunipointsUrlResponse> => {

  return customFetch<getTradingInstrumentMunipointsUrlResponse>(getGetTradingInstrumentMunipointsUrlUrl({ instrumentId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTradingInstrumentMunipointsUrlQueryKey = ({ instrumentId }: GetTradingInstrumentMunipointsUrlPathParameters,) => {
    return [
    `/auth/v1/trading/instrument/${instrumentId}/munipoints`
    ] as const;
    }


export const getGetTradingInstrumentMunipointsUrlQueryOptions = <TData = Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError = ErrorType<HumaAPIError>>({ instrumentId }: GetTradingInstrumentMunipointsUrlPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingInstrumentMunipointsUrlQueryKey({ instrumentId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>> = ({ signal }) => getTradingInstrumentMunipointsUrl({ instrumentId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: instrumentId !== null && instrumentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingInstrumentMunipointsUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>>
export type GetTradingInstrumentMunipointsUrlQueryError = ErrorType<HumaAPIError>


export function useGetTradingInstrumentMunipointsUrl<TData = Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetTradingInstrumentMunipointsUrlPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>,
          TError,
          Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingInstrumentMunipointsUrl<TData = Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetTradingInstrumentMunipointsUrlPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>,
          TError,
          Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingInstrumentMunipointsUrl<TData = Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetTradingInstrumentMunipointsUrlPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a municipal bond's MuniPOINTS profile URL
 */

export function useGetTradingInstrumentMunipointsUrl<TData = Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError = ErrorType<HumaAPIError>>(
 { instrumentId }: GetTradingInstrumentMunipointsUrlPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingInstrumentMunipointsUrlQueryOptions({ instrumentId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTradingInstrumentMunipointsUrlSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError = ErrorType<HumaAPIError>>({ instrumentId }: GetTradingInstrumentMunipointsUrlPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingInstrumentMunipointsUrlQueryKey({ instrumentId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>> = ({ signal }) => getTradingInstrumentMunipointsUrl({ instrumentId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingInstrumentMunipointsUrlSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>>
export type GetTradingInstrumentMunipointsUrlSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetTradingInstrumentMunipointsUrlSuspense<TData = Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetTradingInstrumentMunipointsUrlPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingInstrumentMunipointsUrlSuspense<TData = Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetTradingInstrumentMunipointsUrlPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingInstrumentMunipointsUrlSuspense<TData = Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetTradingInstrumentMunipointsUrlPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a municipal bond's MuniPOINTS profile URL
 */

export function useGetTradingInstrumentMunipointsUrlSuspense<TData = Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError = ErrorType<HumaAPIError>>(
 { instrumentId }: GetTradingInstrumentMunipointsUrlPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTradingInstrumentMunipointsUrl>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingInstrumentMunipointsUrlSuspenseQueryOptions({ instrumentId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getOrderBookResponse200 = {
  data: GetOrderBookResponseBody
  status: 200
}

export type getOrderBookResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getOrderBookResponseSuccess = (getOrderBookResponse200) & {
  headers: Headers;
};
export type getOrderBookResponseError = (getOrderBookResponseDefault) & {
  headers: Headers;
};

export type getOrderBookResponse = getOrderBookResponseSuccess

export const getGetOrderBookUrl = ({ instrumentId }: GetOrderBookPathParameters,
    params: GetOrderBookParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/instrument/${instrumentId}/order-book?${stringifiedParams}` : `/auth/v1/trading/instrument/${instrumentId}/order-book`
}

/**
 * Returns the depth-of-book for an instrument as two separate books: limit-order-book (LOB) liquidity, and — when an rfq_id is supplied — that RFQ's dealer quotes (returned even for a terminal RFQ, tagged via rfq.status).
 * @summary Get Order Book
 */
export const getOrderBook = async ({ instrumentId }: GetOrderBookPathParameters,
    params: GetOrderBookParams, options?: Parameters<typeof customFetch>[1]): Promise<getOrderBookResponse> => {

  return customFetch<getOrderBookResponse>(getGetOrderBookUrl({ instrumentId },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderBookQueryKey = ({ instrumentId }: GetOrderBookPathParameters,
    params?: GetOrderBookParams,) => {
    return [
    `/auth/v1/trading/instrument/${instrumentId}/order-book`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrderBookQueryOptions = <TData = Awaited<ReturnType<typeof getOrderBook>>, TError = ErrorType<HumaAPIError>>({ instrumentId }: GetOrderBookPathParameters,
    params: GetOrderBookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderBookQueryKey({ instrumentId },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderBook>>> = ({ signal }) => getOrderBook({ instrumentId },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: instrumentId !== null && instrumentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderBookQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderBook>>>
export type GetOrderBookQueryError = ErrorType<HumaAPIError>


export function useGetOrderBook<TData = Awaited<ReturnType<typeof getOrderBook>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderBookPathParameters,
    params: GetOrderBookParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderBook>>,
          TError,
          Awaited<ReturnType<typeof getOrderBook>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderBook<TData = Awaited<ReturnType<typeof getOrderBook>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderBookPathParameters,
    params: GetOrderBookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderBook>>,
          TError,
          Awaited<ReturnType<typeof getOrderBook>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderBook<TData = Awaited<ReturnType<typeof getOrderBook>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderBookPathParameters,
    params: GetOrderBookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Order Book
 */

export function useGetOrderBook<TData = Awaited<ReturnType<typeof getOrderBook>>, TError = ErrorType<HumaAPIError>>(
 { instrumentId }: GetOrderBookPathParameters,
    params: GetOrderBookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderBookQueryOptions({ instrumentId },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrderBookSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrderBook>>, TError = ErrorType<HumaAPIError>>({ instrumentId }: GetOrderBookPathParameters,
    params: GetOrderBookParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderBookQueryKey({ instrumentId },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderBook>>> = ({ signal }) => getOrderBook({ instrumentId },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderBookSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderBook>>>
export type GetOrderBookSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetOrderBookSuspense<TData = Awaited<ReturnType<typeof getOrderBook>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderBookPathParameters,
    params: GetOrderBookParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderBookSuspense<TData = Awaited<ReturnType<typeof getOrderBook>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderBookPathParameters,
    params: GetOrderBookParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderBookSuspense<TData = Awaited<ReturnType<typeof getOrderBook>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderBookPathParameters,
    params: GetOrderBookParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Order Book
 */

export function useGetOrderBookSuspense<TData = Awaited<ReturnType<typeof getOrderBook>>, TError = ErrorType<HumaAPIError>>(
 { instrumentId }: GetOrderBookPathParameters,
    params: GetOrderBookParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderBook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderBookSuspenseQueryOptions({ instrumentId },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type previewInstrumentRfqResponse200 = {
  data: InstrumentRfqPreviewResponseBody
  status: 200
}

export type previewInstrumentRfqResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type previewInstrumentRfqResponseSuccess = (previewInstrumentRfqResponse200) & {
  headers: Headers;
};
export type previewInstrumentRfqResponseError = (previewInstrumentRfqResponseDefault) & {
  headers: Headers;
};

export type previewInstrumentRfqResponse = previewInstrumentRfqResponseSuccess

export const getPreviewInstrumentRfqUrl = ({ instrumentId }: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/instrument/${instrumentId}/rfq-preview?${stringifiedParams}` : `/auth/v1/trading/instrument/${instrumentId}/rfq-preview`
}

/**
 * Resolves what the single-order RFQ form opens onto for one instrument: its asset class and subtype, the price type it quotes on (derived server-side from the bond's class and remaining term, not chosen by the caller), and the fully-resolved timer specs for each RFQ protocol the venue supports — the venue's own initiator config merged with MarketAxess's per-instrument options where they apply. Nothing is sent.
 * @summary Preview an RFQ for one instrument
 */
export const previewInstrumentRfq = async ({ instrumentId }: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams, options?: Parameters<typeof customFetch>[1]): Promise<previewInstrumentRfqResponse> => {

  return customFetch<previewInstrumentRfqResponse>(getPreviewInstrumentRfqUrl({ instrumentId },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPreviewInstrumentRfqQueryKey = ({ instrumentId }: PreviewInstrumentRfqPathParameters,
    params?: PreviewInstrumentRfqParams,) => {
    return [
    `/auth/v1/trading/instrument/${instrumentId}/rfq-preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getPreviewInstrumentRfqQueryOptions = <TData = Awaited<ReturnType<typeof previewInstrumentRfq>>, TError = ErrorType<HumaAPIError>>({ instrumentId }: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewInstrumentRfqQueryKey({ instrumentId },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewInstrumentRfq>>> = ({ signal }) => previewInstrumentRfq({ instrumentId },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: instrumentId !== null && instrumentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewInstrumentRfqQueryResult = NonNullable<Awaited<ReturnType<typeof previewInstrumentRfq>>>
export type PreviewInstrumentRfqQueryError = ErrorType<HumaAPIError>


export function usePreviewInstrumentRfq<TData = Awaited<ReturnType<typeof previewInstrumentRfq>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewInstrumentRfq>>,
          TError,
          Awaited<ReturnType<typeof previewInstrumentRfq>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewInstrumentRfq<TData = Awaited<ReturnType<typeof previewInstrumentRfq>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewInstrumentRfq>>,
          TError,
          Awaited<ReturnType<typeof previewInstrumentRfq>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewInstrumentRfq<TData = Awaited<ReturnType<typeof previewInstrumentRfq>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview an RFQ for one instrument
 */

export function usePreviewInstrumentRfq<TData = Awaited<ReturnType<typeof previewInstrumentRfq>>, TError = ErrorType<HumaAPIError>>(
 { instrumentId }: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewInstrumentRfqQueryOptions({ instrumentId },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPreviewInstrumentRfqSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof previewInstrumentRfq>>, TError = ErrorType<HumaAPIError>>({ instrumentId }: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewInstrumentRfqQueryKey({ instrumentId },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewInstrumentRfq>>> = ({ signal }) => previewInstrumentRfq({ instrumentId },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewInstrumentRfqSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof previewInstrumentRfq>>>
export type PreviewInstrumentRfqSuspenseQueryError = ErrorType<HumaAPIError>


export function usePreviewInstrumentRfqSuspense<TData = Awaited<ReturnType<typeof previewInstrumentRfq>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewInstrumentRfqSuspense<TData = Awaited<ReturnType<typeof previewInstrumentRfq>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewInstrumentRfqSuspense<TData = Awaited<ReturnType<typeof previewInstrumentRfq>>, TError = ErrorType<HumaAPIError>>(
 pathParams: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview an RFQ for one instrument
 */

export function usePreviewInstrumentRfqSuspense<TData = Awaited<ReturnType<typeof previewInstrumentRfq>>, TError = ErrorType<HumaAPIError>>(
 { instrumentId }: PreviewInstrumentRfqPathParameters,
    params: PreviewInstrumentRfqParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof previewInstrumentRfq>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewInstrumentRfqSuspenseQueryOptions({ instrumentId },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type replaceIoiOrderResponse201 = {
  data: ReplaceIOIOrderResponseBody
  status: 201
}

export type replaceIoiOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type replaceIoiOrderResponseSuccess = (replaceIoiOrderResponse201) & {
  headers: Headers;
};
export type replaceIoiOrderResponseError = (replaceIoiOrderResponseDefault) & {
  headers: Headers;
};

export type replaceIoiOrderResponse = replaceIoiOrderResponseSuccess

export const getReplaceIoiOrderUrl = ({ orderId }: ReplaceIoiOrderPathParameters,) => {




  return `/auth/v1/trading/ioi/${orderId}/replace`
}

/**
 * Cancels an open IOI order and replaces it with one carrying a reduced quantity, by proxying the amend to orders-api, which validates it and publishes the cancel and the replacement to the OEMS sequencer in one transaction.
 * @summary Replace IOI Order
 */
export const replaceIoiOrder = async ({ orderId }: ReplaceIoiOrderPathParameters,
    replaceIOIOrderRequestBody: ReplaceIOIOrderRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<replaceIoiOrderResponse> => {

  return customFetch<replaceIoiOrderResponse>(getReplaceIoiOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(replaceIOIOrderRequestBody)
  }
);}





export const getReplaceIoiOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceIoiOrder>>, TError,{pathParams: ReplaceIoiOrderPathParameters;data: ReplaceIOIOrderRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceIoiOrder>>, TError,{pathParams: ReplaceIoiOrderPathParameters;data: ReplaceIOIOrderRequestBody}, TContext> => {

const mutationKey = ['replaceIoiOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceIoiOrder>>, {pathParams: ReplaceIoiOrderPathParameters;data: ReplaceIOIOrderRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  replaceIoiOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceIoiOrderMutationResult = NonNullable<Awaited<ReturnType<typeof replaceIoiOrder>>>
    export type ReplaceIoiOrderMutationBody = ReplaceIOIOrderRequestBody
    export type ReplaceIoiOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Replace IOI Order
 */
export const useReplaceIoiOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceIoiOrder>>, TError,{pathParams: ReplaceIoiOrderPathParameters;data: ReplaceIOIOrderRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceIoiOrder>>,
        TError,
        {pathParams: ReplaceIoiOrderPathParameters;data: ReplaceIOIOrderRequestBody},
        TContext
      > => {
      return useMutation(getReplaceIoiOrderMutationOptions(options), queryClient);
    }
    export type getOrderCostsResponse200 = {
  data: GetOrderCostsResponseBody
  status: 200
}

export type getOrderCostsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getOrderCostsResponseSuccess = (getOrderCostsResponse200) & {
  headers: Headers;
};
export type getOrderCostsResponseError = (getOrderCostsResponseDefault) & {
  headers: Headers;
};

export type getOrderCostsResponse = getOrderCostsResponseSuccess

export const getGetOrderCostsUrl = () => {




  return `/auth/v1/trading/order-costs`
}

/**
 * Calculates a full cost breakdown for a potential order from an explicit base price and fees. Returns customer limit price, base and customer implied yield-to-worst, market value, accrued interest, itemized fees in dollars, and net money.
 * @summary Calculate Order Costs
 */
export const getOrderCosts = async (getOrderCostsRequestBody: GetOrderCostsRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<getOrderCostsResponse> => {

  return customFetch<getOrderCostsResponse>(getGetOrderCostsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getOrderCostsRequestBody)
  }
);}





export const getGetOrderCostsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getOrderCosts>>, TError,{data: GetOrderCostsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getOrderCosts>>, TError,{data: GetOrderCostsRequestBody}, TContext> => {

const mutationKey = ['getOrderCosts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getOrderCosts>>, {data: GetOrderCostsRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  getOrderCosts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetOrderCostsMutationResult = NonNullable<Awaited<ReturnType<typeof getOrderCosts>>>
    export type GetOrderCostsMutationBody = GetOrderCostsRequestBody
    export type GetOrderCostsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Calculate Order Costs
 */
export const useGetOrderCosts = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getOrderCosts>>, TError,{data: GetOrderCostsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getOrderCosts>>,
        TError,
        {data: GetOrderCostsRequestBody},
        TContext
      > => {
      return useMutation(getGetOrderCostsMutationOptions(options), queryClient);
    }
    export type getOrderCostsFromCustomerPriceResponse200 = {
  data: GetOrderCostsFromCustomerPriceResponseBody
  status: 200
}

export type getOrderCostsFromCustomerPriceResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getOrderCostsFromCustomerPriceResponseSuccess = (getOrderCostsFromCustomerPriceResponse200) & {
  headers: Headers;
};
export type getOrderCostsFromCustomerPriceResponseError = (getOrderCostsFromCustomerPriceResponseDefault) & {
  headers: Headers;
};

export type getOrderCostsFromCustomerPriceResponse = getOrderCostsFromCustomerPriceResponseSuccess

export const getGetOrderCostsFromCustomerPriceUrl = () => {




  return `/auth/v1/trading/order-costs/from-customer-price`
}

/**
 * Removes the fees in the request from customer_price to get base_price, then returns /order-costs' full breakdown at that base_price. Uses only the inputs passed in.
 * @summary Calculate Order Costs From Customer Price
 */
export const getOrderCostsFromCustomerPrice = async (getOrderCostsFromCustomerPriceRequestBody: GetOrderCostsFromCustomerPriceRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<getOrderCostsFromCustomerPriceResponse> => {

  return customFetch<getOrderCostsFromCustomerPriceResponse>(getGetOrderCostsFromCustomerPriceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getOrderCostsFromCustomerPriceRequestBody)
  }
);}





export const getGetOrderCostsFromCustomerPriceMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getOrderCostsFromCustomerPrice>>, TError,{data: GetOrderCostsFromCustomerPriceRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getOrderCostsFromCustomerPrice>>, TError,{data: GetOrderCostsFromCustomerPriceRequestBody}, TContext> => {

const mutationKey = ['getOrderCostsFromCustomerPrice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getOrderCostsFromCustomerPrice>>, {data: GetOrderCostsFromCustomerPriceRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  getOrderCostsFromCustomerPrice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetOrderCostsFromCustomerPriceMutationResult = NonNullable<Awaited<ReturnType<typeof getOrderCostsFromCustomerPrice>>>
    export type GetOrderCostsFromCustomerPriceMutationBody = GetOrderCostsFromCustomerPriceRequestBody
    export type GetOrderCostsFromCustomerPriceMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Calculate Order Costs From Customer Price
 */
export const useGetOrderCostsFromCustomerPrice = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getOrderCostsFromCustomerPrice>>, TError,{data: GetOrderCostsFromCustomerPriceRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getOrderCostsFromCustomerPrice>>,
        TError,
        {data: GetOrderCostsFromCustomerPriceRequestBody},
        TContext
      > => {
      return useMutation(getGetOrderCostsFromCustomerPriceMutationOptions(options), queryClient);
    }
    export type createOrderEntryDraftResponse200 = {
  data: OrderEntryDraft
  status: 200
}

export type createOrderEntryDraftResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type createOrderEntryDraftResponseSuccess = (createOrderEntryDraftResponse200) & {
  headers: Headers;
};
export type createOrderEntryDraftResponseError = (createOrderEntryDraftResponseDefault) & {
  headers: Headers;
};

export type createOrderEntryDraftResponse = createOrderEntryDraftResponseSuccess

export const getCreateOrderEntryDraftUrl = (params?: CreateOrderEntryDraftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/order-entry-drafts?${stringifiedParams}` : `/auth/v1/trading/order-entry-drafts`
}

/**
 * @summary Create Order Draft
 */
export const createOrderEntryDraft = async (createOrderEntryDraftRequestBody: CreateOrderEntryDraftRequestBody,
    params?: CreateOrderEntryDraftParams, options?: Parameters<typeof customFetch>[1]): Promise<createOrderEntryDraftResponse> => {

  return customFetch<createOrderEntryDraftResponse>(getCreateOrderEntryDraftUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOrderEntryDraftRequestBody)
  }
);}





export const getCreateOrderEntryDraftMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderEntryDraft>>, TError,{data: CreateOrderEntryDraftRequestBody;params?: CreateOrderEntryDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrderEntryDraft>>, TError,{data: CreateOrderEntryDraftRequestBody;params?: CreateOrderEntryDraftParams}, TContext> => {

const mutationKey = ['createOrderEntryDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrderEntryDraft>>, {data: CreateOrderEntryDraftRequestBody;params?: CreateOrderEntryDraftParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createOrderEntryDraft(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderEntryDraftMutationResult = NonNullable<Awaited<ReturnType<typeof createOrderEntryDraft>>>
    export type CreateOrderEntryDraftMutationBody = CreateOrderEntryDraftRequestBody
    export type CreateOrderEntryDraftMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create Order Draft
 */
export const useCreateOrderEntryDraft = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderEntryDraft>>, TError,{data: CreateOrderEntryDraftRequestBody;params?: CreateOrderEntryDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrderEntryDraft>>,
        TError,
        {data: CreateOrderEntryDraftRequestBody;params?: CreateOrderEntryDraftParams},
        TContext
      > => {
      return useMutation(getCreateOrderEntryDraftMutationOptions(options), queryClient);
    }
    export type getOrderEntryDraftTemplateResponse200 = {
  data: OrderEntryDraftTemplate
  status: 200
}

export type getOrderEntryDraftTemplateResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getOrderEntryDraftTemplateResponseSuccess = (getOrderEntryDraftTemplateResponse200) & {
  headers: Headers;
};
export type getOrderEntryDraftTemplateResponseError = (getOrderEntryDraftTemplateResponseDefault) & {
  headers: Headers;
};

export type getOrderEntryDraftTemplateResponse = getOrderEntryDraftTemplateResponseSuccess

export const getGetOrderEntryDraftTemplateUrl = (params?: GetOrderEntryDraftTemplateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/order-entry-drafts/template?${stringifiedParams}` : `/auth/v1/trading/order-entry-drafts/template`
}

/**
 * @summary Get Order Entry Template
 */
export const getOrderEntryDraftTemplate = async (params?: GetOrderEntryDraftTemplateParams, options?: Parameters<typeof customFetch>[1]): Promise<getOrderEntryDraftTemplateResponse> => {

  return customFetch<getOrderEntryDraftTemplateResponse>(getGetOrderEntryDraftTemplateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderEntryDraftTemplateQueryKey = (params?: GetOrderEntryDraftTemplateParams,) => {
    return [
    `/auth/v1/trading/order-entry-drafts/template`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrderEntryDraftTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError = ErrorType<HumaAPIError>>(params?: GetOrderEntryDraftTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderEntryDraftTemplateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>> = ({ signal }) => getOrderEntryDraftTemplate(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderEntryDraftTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>>
export type GetOrderEntryDraftTemplateQueryError = ErrorType<HumaAPIError>


export function useGetOrderEntryDraftTemplate<TData = Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  GetOrderEntryDraftTemplateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>,
          TError,
          Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderEntryDraftTemplate<TData = Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError = ErrorType<HumaAPIError>>(
 params?: GetOrderEntryDraftTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>,
          TError,
          Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderEntryDraftTemplate<TData = Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError = ErrorType<HumaAPIError>>(
 params?: GetOrderEntryDraftTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Order Entry Template
 */

export function useGetOrderEntryDraftTemplate<TData = Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError = ErrorType<HumaAPIError>>(
 params?: GetOrderEntryDraftTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderEntryDraftTemplateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrderEntryDraftTemplateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError = ErrorType<HumaAPIError>>(params?: GetOrderEntryDraftTemplateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderEntryDraftTemplateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>> = ({ signal }) => getOrderEntryDraftTemplate(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderEntryDraftTemplateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>>
export type GetOrderEntryDraftTemplateSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetOrderEntryDraftTemplateSuspense<TData = Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  GetOrderEntryDraftTemplateParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderEntryDraftTemplateSuspense<TData = Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError = ErrorType<HumaAPIError>>(
 params?: GetOrderEntryDraftTemplateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderEntryDraftTemplateSuspense<TData = Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError = ErrorType<HumaAPIError>>(
 params?: GetOrderEntryDraftTemplateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Order Entry Template
 */

export function useGetOrderEntryDraftTemplateSuspense<TData = Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError = ErrorType<HumaAPIError>>(
 params?: GetOrderEntryDraftTemplateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraftTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderEntryDraftTemplateSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deleteOrderEntryDraftResponse200 = {
  data: OrderEntryDraft
  status: 200
}

export type deleteOrderEntryDraftResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteOrderEntryDraftResponseSuccess = (deleteOrderEntryDraftResponse200) & {
  headers: Headers;
};
export type deleteOrderEntryDraftResponseError = (deleteOrderEntryDraftResponseDefault) & {
  headers: Headers;
};

export type deleteOrderEntryDraftResponse = deleteOrderEntryDraftResponseSuccess

export const getDeleteOrderEntryDraftUrl = ({ draftId }: DeleteOrderEntryDraftPathParameters,
    params?: DeleteOrderEntryDraftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/order-entry-drafts/${draftId}?${stringifiedParams}` : `/auth/v1/trading/order-entry-drafts/${draftId}`
}

/**
 * @summary Discard Order Draft
 */
export const deleteOrderEntryDraft = async ({ draftId }: DeleteOrderEntryDraftPathParameters,
    params?: DeleteOrderEntryDraftParams, options?: Parameters<typeof customFetch>[1]): Promise<deleteOrderEntryDraftResponse> => {

  return customFetch<deleteOrderEntryDraftResponse>(getDeleteOrderEntryDraftUrl({ draftId },params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOrderEntryDraftMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrderEntryDraft>>, TError,{pathParams: DeleteOrderEntryDraftPathParameters;params?: DeleteOrderEntryDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrderEntryDraft>>, TError,{pathParams: DeleteOrderEntryDraftPathParameters;params?: DeleteOrderEntryDraftParams}, TContext> => {

const mutationKey = ['deleteOrderEntryDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrderEntryDraft>>, {pathParams: DeleteOrderEntryDraftPathParameters;params?: DeleteOrderEntryDraftParams}> = (props) => {
          const {pathParams,params} = props ?? {};

          return  deleteOrderEntryDraft(pathParams,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrderEntryDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrderEntryDraft>>>

    export type DeleteOrderEntryDraftMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Discard Order Draft
 */
export const useDeleteOrderEntryDraft = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrderEntryDraft>>, TError,{pathParams: DeleteOrderEntryDraftPathParameters;params?: DeleteOrderEntryDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrderEntryDraft>>,
        TError,
        {pathParams: DeleteOrderEntryDraftPathParameters;params?: DeleteOrderEntryDraftParams},
        TContext
      > => {
      return useMutation(getDeleteOrderEntryDraftMutationOptions(options), queryClient);
    }
    export type getOrderEntryDraftResponse200 = {
  data: OrderEntryDraft
  status: 200
}

export type getOrderEntryDraftResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getOrderEntryDraftResponseSuccess = (getOrderEntryDraftResponse200) & {
  headers: Headers;
};
export type getOrderEntryDraftResponseError = (getOrderEntryDraftResponseDefault) & {
  headers: Headers;
};

export type getOrderEntryDraftResponse = getOrderEntryDraftResponseSuccess

export const getGetOrderEntryDraftUrl = ({ draftId }: GetOrderEntryDraftPathParameters,
    params?: GetOrderEntryDraftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/order-entry-drafts/${draftId}?${stringifiedParams}` : `/auth/v1/trading/order-entry-drafts/${draftId}`
}

/**
 * @summary Get Order Draft
 */
export const getOrderEntryDraft = async ({ draftId }: GetOrderEntryDraftPathParameters,
    params?: GetOrderEntryDraftParams, options?: Parameters<typeof customFetch>[1]): Promise<getOrderEntryDraftResponse> => {

  return customFetch<getOrderEntryDraftResponse>(getGetOrderEntryDraftUrl({ draftId },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderEntryDraftQueryKey = ({ draftId }: GetOrderEntryDraftPathParameters,
    params?: GetOrderEntryDraftParams,) => {
    return [
    `/auth/v1/trading/order-entry-drafts/${draftId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrderEntryDraftQueryOptions = <TData = Awaited<ReturnType<typeof getOrderEntryDraft>>, TError = ErrorType<HumaAPIError>>({ draftId }: GetOrderEntryDraftPathParameters,
    params?: GetOrderEntryDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderEntryDraftQueryKey({ draftId },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderEntryDraft>>> = ({ signal }) => getOrderEntryDraft({ draftId },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: draftId !== null && draftId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderEntryDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderEntryDraft>>>
export type GetOrderEntryDraftQueryError = ErrorType<HumaAPIError>


export function useGetOrderEntryDraft<TData = Awaited<ReturnType<typeof getOrderEntryDraft>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderEntryDraftPathParameters,
    params: undefined |  GetOrderEntryDraftParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderEntryDraft>>,
          TError,
          Awaited<ReturnType<typeof getOrderEntryDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderEntryDraft<TData = Awaited<ReturnType<typeof getOrderEntryDraft>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderEntryDraftPathParameters,
    params?: GetOrderEntryDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderEntryDraft>>,
          TError,
          Awaited<ReturnType<typeof getOrderEntryDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderEntryDraft<TData = Awaited<ReturnType<typeof getOrderEntryDraft>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderEntryDraftPathParameters,
    params?: GetOrderEntryDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Order Draft
 */

export function useGetOrderEntryDraft<TData = Awaited<ReturnType<typeof getOrderEntryDraft>>, TError = ErrorType<HumaAPIError>>(
 { draftId }: GetOrderEntryDraftPathParameters,
    params?: GetOrderEntryDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderEntryDraftQueryOptions({ draftId },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrderEntryDraftSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrderEntryDraft>>, TError = ErrorType<HumaAPIError>>({ draftId }: GetOrderEntryDraftPathParameters,
    params?: GetOrderEntryDraftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderEntryDraftQueryKey({ draftId },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderEntryDraft>>> = ({ signal }) => getOrderEntryDraft({ draftId },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderEntryDraftSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderEntryDraft>>>
export type GetOrderEntryDraftSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetOrderEntryDraftSuspense<TData = Awaited<ReturnType<typeof getOrderEntryDraft>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderEntryDraftPathParameters,
    params: undefined |  GetOrderEntryDraftParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderEntryDraftSuspense<TData = Awaited<ReturnType<typeof getOrderEntryDraft>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderEntryDraftPathParameters,
    params?: GetOrderEntryDraftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderEntryDraftSuspense<TData = Awaited<ReturnType<typeof getOrderEntryDraft>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderEntryDraftPathParameters,
    params?: GetOrderEntryDraftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Order Draft
 */

export function useGetOrderEntryDraftSuspense<TData = Awaited<ReturnType<typeof getOrderEntryDraft>>, TError = ErrorType<HumaAPIError>>(
 { draftId }: GetOrderEntryDraftPathParameters,
    params?: GetOrderEntryDraftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderEntryDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderEntryDraftSuspenseQueryOptions({ draftId },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type patchOrderEntryDraftResponse200 = {
  data: OrderEntryDraftPatchResult
  status: 200
}

export type patchOrderEntryDraftResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchOrderEntryDraftResponseSuccess = (patchOrderEntryDraftResponse200) & {
  headers: Headers;
};
export type patchOrderEntryDraftResponseError = (patchOrderEntryDraftResponseDefault) & {
  headers: Headers;
};

export type patchOrderEntryDraftResponse = patchOrderEntryDraftResponseSuccess

export const getPatchOrderEntryDraftUrl = ({ draftId }: PatchOrderEntryDraftPathParameters,
    params?: PatchOrderEntryDraftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/order-entry-drafts/${draftId}?${stringifiedParams}` : `/auth/v1/trading/order-entry-drafts/${draftId}`
}

/**
 * @summary Patch Order Draft
 */
export const patchOrderEntryDraft = async ({ draftId }: PatchOrderEntryDraftPathParameters,
    patchOrderEntryDraftRequestBody: PatchOrderEntryDraftRequestBody,
    params?: PatchOrderEntryDraftParams, options?: Parameters<typeof customFetch>[1]): Promise<patchOrderEntryDraftResponse> => {

  return customFetch<patchOrderEntryDraftResponse>(getPatchOrderEntryDraftUrl({ draftId },params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchOrderEntryDraftRequestBody)
  }
);}





export const getPatchOrderEntryDraftMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOrderEntryDraft>>, TError,{pathParams: PatchOrderEntryDraftPathParameters;data: PatchOrderEntryDraftRequestBody;params?: PatchOrderEntryDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchOrderEntryDraft>>, TError,{pathParams: PatchOrderEntryDraftPathParameters;data: PatchOrderEntryDraftRequestBody;params?: PatchOrderEntryDraftParams}, TContext> => {

const mutationKey = ['patchOrderEntryDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchOrderEntryDraft>>, {pathParams: PatchOrderEntryDraftPathParameters;data: PatchOrderEntryDraftRequestBody;params?: PatchOrderEntryDraftParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  patchOrderEntryDraft(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchOrderEntryDraftMutationResult = NonNullable<Awaited<ReturnType<typeof patchOrderEntryDraft>>>
    export type PatchOrderEntryDraftMutationBody = PatchOrderEntryDraftRequestBody
    export type PatchOrderEntryDraftMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Patch Order Draft
 */
export const usePatchOrderEntryDraft = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOrderEntryDraft>>, TError,{pathParams: PatchOrderEntryDraftPathParameters;data: PatchOrderEntryDraftRequestBody;params?: PatchOrderEntryDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchOrderEntryDraft>>,
        TError,
        {pathParams: PatchOrderEntryDraftPathParameters;data: PatchOrderEntryDraftRequestBody;params?: PatchOrderEntryDraftParams},
        TContext
      > => {
      return useMutation(getPatchOrderEntryDraftMutationOptions(options), queryClient);
    }
    export type submitOrderEntryDraftResponse200 = {
  data: OrderEntryDraft
  status: 200
}

export type submitOrderEntryDraftResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type submitOrderEntryDraftResponseSuccess = (submitOrderEntryDraftResponse200) & {
  headers: Headers;
};
export type submitOrderEntryDraftResponseError = (submitOrderEntryDraftResponseDefault) & {
  headers: Headers;
};

export type submitOrderEntryDraftResponse = submitOrderEntryDraftResponseSuccess

export const getSubmitOrderEntryDraftUrl = ({ draftId }: SubmitOrderEntryDraftPathParameters,
    params?: SubmitOrderEntryDraftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/order-entry-drafts/${draftId}/submit?${stringifiedParams}` : `/auth/v1/trading/order-entry-drafts/${draftId}/submit`
}

/**
 * @summary Submit Order Draft
 */
export const submitOrderEntryDraft = async ({ draftId }: SubmitOrderEntryDraftPathParameters,
    submitOrderEntryDraftRequestBody: SubmitOrderEntryDraftRequestBody,
    params?: SubmitOrderEntryDraftParams, options?: Parameters<typeof customFetch>[1]): Promise<submitOrderEntryDraftResponse> => {

  return customFetch<submitOrderEntryDraftResponse>(getSubmitOrderEntryDraftUrl({ draftId },params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitOrderEntryDraftRequestBody)
  }
);}





export const getSubmitOrderEntryDraftMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOrderEntryDraft>>, TError,{pathParams: SubmitOrderEntryDraftPathParameters;data: SubmitOrderEntryDraftRequestBody;params?: SubmitOrderEntryDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitOrderEntryDraft>>, TError,{pathParams: SubmitOrderEntryDraftPathParameters;data: SubmitOrderEntryDraftRequestBody;params?: SubmitOrderEntryDraftParams}, TContext> => {

const mutationKey = ['submitOrderEntryDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitOrderEntryDraft>>, {pathParams: SubmitOrderEntryDraftPathParameters;data: SubmitOrderEntryDraftRequestBody;params?: SubmitOrderEntryDraftParams}> = (props) => {
          const {pathParams,data,params} = props ?? {};

          return  submitOrderEntryDraft(pathParams,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitOrderEntryDraftMutationResult = NonNullable<Awaited<ReturnType<typeof submitOrderEntryDraft>>>
    export type SubmitOrderEntryDraftMutationBody = SubmitOrderEntryDraftRequestBody
    export type SubmitOrderEntryDraftMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Submit Order Draft
 */
export const useSubmitOrderEntryDraft = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOrderEntryDraft>>, TError,{pathParams: SubmitOrderEntryDraftPathParameters;data: SubmitOrderEntryDraftRequestBody;params?: SubmitOrderEntryDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitOrderEntryDraft>>,
        TError,
        {pathParams: SubmitOrderEntryDraftPathParameters;data: SubmitOrderEntryDraftRequestBody;params?: SubmitOrderEntryDraftParams},
        TContext
      > => {
      return useMutation(getSubmitOrderEntryDraftMutationOptions(options), queryClient);
    }
    export type bulkSendPrincipalBookListRfqsResponse201 = {
  data: PrincipalBookBulkListRFQResponseBody
  status: 201
}

export type bulkSendPrincipalBookListRfqsResponse422 = {
  data: BulkSendPrincipalBookListRfqs422
  status: 422
}

export type bulkSendPrincipalBookListRfqsResponseSuccess = (bulkSendPrincipalBookListRfqsResponse201) & {
  headers: Headers;
};
export type bulkSendPrincipalBookListRfqsResponseError = (bulkSendPrincipalBookListRfqsResponse422) & {
  headers: Headers;
};

export type bulkSendPrincipalBookListRfqsResponse = bulkSendPrincipalBookListRfqsResponseSuccess

export const getBulkSendPrincipalBookListRfqsUrl = () => {




  return `/auth/v1/trading/order/bulk-with-list-rfq/principal-book`
}

/**
 * Creates one order per row out of a principal book and shops them as List RFQs at the chosen venue, in a single all-or-nothing write. Rows are grouped into lists server-side.
 * @summary Send a principal book as List RFQs
 */
export const bulkSendPrincipalBookListRfqs = async (principalBookBulkListRFQRequestBody: PrincipalBookBulkListRFQRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<bulkSendPrincipalBookListRfqsResponse> => {

  return customFetch<bulkSendPrincipalBookListRfqsResponse>(getBulkSendPrincipalBookListRfqsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(principalBookBulkListRFQRequestBody)
  }
);}





export const getBulkSendPrincipalBookListRfqsMutationOptions = <TError = ErrorType<BulkSendPrincipalBookListRfqs422>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkSendPrincipalBookListRfqs>>, TError,{data: PrincipalBookBulkListRFQRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkSendPrincipalBookListRfqs>>, TError,{data: PrincipalBookBulkListRFQRequestBody}, TContext> => {

const mutationKey = ['bulkSendPrincipalBookListRfqs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkSendPrincipalBookListRfqs>>, {data: PrincipalBookBulkListRFQRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  bulkSendPrincipalBookListRfqs(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkSendPrincipalBookListRfqsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkSendPrincipalBookListRfqs>>>
    export type BulkSendPrincipalBookListRfqsMutationBody = PrincipalBookBulkListRFQRequestBody
    export type BulkSendPrincipalBookListRfqsMutationError = ErrorType<BulkSendPrincipalBookListRfqs422>

    /**
 * @summary Send a principal book as List RFQs
 */
export const useBulkSendPrincipalBookListRfqs = <TError = ErrorType<BulkSendPrincipalBookListRfqs422>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkSendPrincipalBookListRfqs>>, TError,{data: PrincipalBookBulkListRFQRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkSendPrincipalBookListRfqs>>,
        TError,
        {data: PrincipalBookBulkListRFQRequestBody},
        TContext
      > => {
      return useMutation(getBulkSendPrincipalBookListRfqsMutationOptions(options), queryClient);
    }
    export type bulkApproveOrdersResponse200 = {
  data: BulkApproveResponseBody
  status: 200
}

export type bulkApproveOrdersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type bulkApproveOrdersResponseSuccess = (bulkApproveOrdersResponse200) & {
  headers: Headers;
};
export type bulkApproveOrdersResponseError = (bulkApproveOrdersResponseDefault) & {
  headers: Headers;
};

export type bulkApproveOrdersResponse = bulkApproveOrdersResponseSuccess

export const getBulkApproveOrdersUrl = () => {




  return `/auth/v1/trading/order/bulk/approve`
}

/**
 * Resolves a SORM order query plus an all/include/exclude selection to a set of order ids (org-scoped) and manually approves each by emitting one manual-approval per order to the OEMS sequencer. A selection larger than 10,000 is truncated to the first 10,000 by order id rather than rejected; selection_matched_count and selection_acted_on_count report the full and approved counts. The write is asynchronous: a success response means the approvals were submitted, not that the orders have been approved.
 * @summary Bulk approve orders
 */
export const bulkApproveOrders = async (bulkApproveRequestBody: BulkApproveRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<bulkApproveOrdersResponse> => {

  return customFetch<bulkApproveOrdersResponse>(getBulkApproveOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkApproveRequestBody)
  }
);}





export const getBulkApproveOrdersMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkApproveOrders>>, TError,{data: BulkApproveRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkApproveOrders>>, TError,{data: BulkApproveRequestBody}, TContext> => {

const mutationKey = ['bulkApproveOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkApproveOrders>>, {data: BulkApproveRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  bulkApproveOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkApproveOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof bulkApproveOrders>>>
    export type BulkApproveOrdersMutationBody = BulkApproveRequestBody
    export type BulkApproveOrdersMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Bulk approve orders
 */
export const useBulkApproveOrders = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkApproveOrders>>, TError,{data: BulkApproveRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkApproveOrders>>,
        TError,
        {data: BulkApproveRequestBody},
        TContext
      > => {
      return useMutation(getBulkApproveOrdersMutationOptions(options), queryClient);
    }
    export type bulkAssignOrdersResponse200 = {
  data: BulkAssignResponseBody
  status: 200
}

export type bulkAssignOrdersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type bulkAssignOrdersResponseSuccess = (bulkAssignOrdersResponse200) & {
  headers: Headers;
};
export type bulkAssignOrdersResponseError = (bulkAssignOrdersResponseDefault) & {
  headers: Headers;
};

export type bulkAssignOrdersResponse = bulkAssignOrdersResponseSuccess

export const getBulkAssignOrdersUrl = () => {




  return `/auth/v1/trading/order/bulk/assign`
}

/**
 * Resolves a SORM order query plus an all/include/exclude selection to a set of order ids (org-scoped) and assigns them to the trader named by trader_id, which must be an order-reading trader in the caller's organization granted access to every selected order's account, by emitting one trader_id metadata update per order to the OEMS sequencer. An empty trader_id clears the assignment (unassign). Unlike bulk claim, which always assigns to the caller, this takes an explicit trader_id. A selection larger than 10,000 is truncated to the first 10,000 by order id rather than rejected; selection_matched_count and selection_acted_on_count report the full and assigned counts. The write is asynchronous: a success response means the events were submitted, not that they have been applied.
 * @summary Bulk assign orders
 */
export const bulkAssignOrders = async (bulkAssignRequestBody: BulkAssignRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<bulkAssignOrdersResponse> => {

  return customFetch<bulkAssignOrdersResponse>(getBulkAssignOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkAssignRequestBody)
  }
);}





export const getBulkAssignOrdersMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAssignOrders>>, TError,{data: BulkAssignRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkAssignOrders>>, TError,{data: BulkAssignRequestBody}, TContext> => {

const mutationKey = ['bulkAssignOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkAssignOrders>>, {data: BulkAssignRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  bulkAssignOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkAssignOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof bulkAssignOrders>>>
    export type BulkAssignOrdersMutationBody = BulkAssignRequestBody
    export type BulkAssignOrdersMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Bulk assign orders
 */
export const useBulkAssignOrders = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAssignOrders>>, TError,{data: BulkAssignRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkAssignOrders>>,
        TError,
        {data: BulkAssignRequestBody},
        TContext
      > => {
      return useMutation(getBulkAssignOrdersMutationOptions(options), queryClient);
    }
    export type bulkCancelOrdersResponse200 = {
  data: BulkCancelResponseBody
  status: 200
}

export type bulkCancelOrdersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type bulkCancelOrdersResponseSuccess = (bulkCancelOrdersResponse200) & {
  headers: Headers;
};
export type bulkCancelOrdersResponseError = (bulkCancelOrdersResponseDefault) & {
  headers: Headers;
};

export type bulkCancelOrdersResponse = bulkCancelOrdersResponseSuccess

export const getBulkCancelOrdersUrl = () => {




  return `/auth/v1/trading/order/bulk/cancel`
}

/**
 * Resolves a SORM order query plus an all/include/exclude selection to a set of order ids (org-scoped) and requests cancellation of each by emitting one parent-order cancel request per order to the OEMS sequencer. A selection larger than 10,000 is truncated to the first 10,000 by order id rather than rejected; selection_matched_count and selection_acted_on_count report the full and cancelled counts. The write is asynchronous: a success response means the requests were submitted, not that the orders have been cancelled.
 * @summary Bulk cancel orders
 */
export const bulkCancelOrders = async (bulkCancelRequestBody: BulkCancelRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<bulkCancelOrdersResponse> => {

  return customFetch<bulkCancelOrdersResponse>(getBulkCancelOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkCancelRequestBody)
  }
);}





export const getBulkCancelOrdersMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCancelOrders>>, TError,{data: BulkCancelRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkCancelOrders>>, TError,{data: BulkCancelRequestBody}, TContext> => {

const mutationKey = ['bulkCancelOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkCancelOrders>>, {data: BulkCancelRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  bulkCancelOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkCancelOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof bulkCancelOrders>>>
    export type BulkCancelOrdersMutationBody = BulkCancelRequestBody
    export type BulkCancelOrdersMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Bulk cancel orders
 */
export const useBulkCancelOrders = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCancelOrders>>, TError,{data: BulkCancelRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkCancelOrders>>,
        TError,
        {data: BulkCancelRequestBody},
        TContext
      > => {
      return useMutation(getBulkCancelOrdersMutationOptions(options), queryClient);
    }
    export type bulkExecuteOrdersResponse200 = {
  data: BulkExecuteResponseBody
  status: 200
}

export type bulkExecuteOrdersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type bulkExecuteOrdersResponseSuccess = (bulkExecuteOrdersResponse200) & {
  headers: Headers;
};
export type bulkExecuteOrdersResponseError = (bulkExecuteOrdersResponseDefault) & {
  headers: Headers;
};

export type bulkExecuteOrdersResponse = bulkExecuteOrdersResponseSuccess

export const getBulkExecuteOrdersUrl = () => {




  return `/auth/v1/trading/order/bulk/execute`
}

/**
 * Resolves a SORM order query plus an all/include/exclude selection to a set of order ids (org-scoped) and submits a custodian-manual execution order for each, at the parent order's price and order type. The selection is restricted server-side to routing-required equities and funds, excluding indications of interest (an order outside that set is dropped); each order's remaining eligibility (custodian, instrument) is validated per order by orders-api. Unlike bulk cancel/assign, each execution is an independent submission that can fail on its own: the response reports a per-order outcome and a partial success is a 200. A selection larger than 500 is rejected rather than partially executed. The submissions are asynchronous downstream: a submitted result returns the created execution order's id, and the fills round-trip through the OEMS.
 * @summary Bulk execute orders
 */
export const bulkExecuteOrders = async (bulkExecuteRequestBody: BulkExecuteRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<bulkExecuteOrdersResponse> => {

  return customFetch<bulkExecuteOrdersResponse>(getBulkExecuteOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkExecuteRequestBody)
  }
);}





export const getBulkExecuteOrdersMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkExecuteOrders>>, TError,{data: BulkExecuteRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkExecuteOrders>>, TError,{data: BulkExecuteRequestBody}, TContext> => {

const mutationKey = ['bulkExecuteOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkExecuteOrders>>, {data: BulkExecuteRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  bulkExecuteOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkExecuteOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof bulkExecuteOrders>>>
    export type BulkExecuteOrdersMutationBody = BulkExecuteRequestBody
    export type BulkExecuteOrdersMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Bulk execute orders
 */
export const useBulkExecuteOrders = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkExecuteOrders>>, TError,{data: BulkExecuteRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkExecuteOrders>>,
        TError,
        {data: BulkExecuteRequestBody},
        TContext
      > => {
      return useMutation(getBulkExecuteOrdersMutationOptions(options), queryClient);
    }
    export type replaceExecutionOrderResponse202 = {
  data: CancelReplaceExecutionOrderResponseBody
  status: 202
}

export type replaceExecutionOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 202>
}

export type replaceExecutionOrderResponseSuccess = (replaceExecutionOrderResponse202) & {
  headers: Headers;
};
export type replaceExecutionOrderResponseError = (replaceExecutionOrderResponseDefault) & {
  headers: Headers;
};

export type replaceExecutionOrderResponse = replaceExecutionOrderResponseSuccess

export const getReplaceExecutionOrderUrl = ({ orderId, executionOrderId }: ReplaceExecutionOrderPathParameters,) => {




  return `/auth/v1/trading/order/${orderId}/execution-order/${executionOrderId}`
}

/**
 * Updates the quantity, limit price and/or order type of a existing execution order, without canceling and resubmitting it. An omitted field leaves that field unchanged. Asynchronous: a success response means the request was submitted, not that the order has been updated — order-manager validates it against the live order and may still reject it, and the venue may reject the update after that.
 * @summary Update an execution order
 */
export const replaceExecutionOrder = async ({ orderId, executionOrderId }: ReplaceExecutionOrderPathParameters,
    cancelReplaceExecutionOrderRequestBody: CancelReplaceExecutionOrderRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<replaceExecutionOrderResponse> => {

  return customFetch<replaceExecutionOrderResponse>(getReplaceExecutionOrderUrl({ orderId, executionOrderId }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelReplaceExecutionOrderRequestBody)
  }
);}





export const getReplaceExecutionOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceExecutionOrder>>, TError,{pathParams: ReplaceExecutionOrderPathParameters;data: CancelReplaceExecutionOrderRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceExecutionOrder>>, TError,{pathParams: ReplaceExecutionOrderPathParameters;data: CancelReplaceExecutionOrderRequestBody}, TContext> => {

const mutationKey = ['replaceExecutionOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceExecutionOrder>>, {pathParams: ReplaceExecutionOrderPathParameters;data: CancelReplaceExecutionOrderRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  replaceExecutionOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceExecutionOrderMutationResult = NonNullable<Awaited<ReturnType<typeof replaceExecutionOrder>>>
    export type ReplaceExecutionOrderMutationBody = CancelReplaceExecutionOrderRequestBody
    export type ReplaceExecutionOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Update an execution order
 */
export const useReplaceExecutionOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceExecutionOrder>>, TError,{pathParams: ReplaceExecutionOrderPathParameters;data: CancelReplaceExecutionOrderRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceExecutionOrder>>,
        TError,
        {pathParams: ReplaceExecutionOrderPathParameters;data: CancelReplaceExecutionOrderRequestBody},
        TContext
      > => {
      return useMutation(getReplaceExecutionOrderMutationOptions(options), queryClient);
    }
    export type createOrderGroupResponse201 = {
  data: CreateOrderGroupsResponseBody
  status: 201
}

export type createOrderGroupResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createOrderGroupResponseSuccess = (createOrderGroupResponse201) & {
  headers: Headers;
};
export type createOrderGroupResponseError = (createOrderGroupResponseDefault) & {
  headers: Headers;
};

export type createOrderGroupResponse = createOrderGroupResponseSuccess

export const getCreateOrderGroupUrl = () => {




  return `/auth/v1/trading/orders/group`
}

/**
 * Combines pending-execution orders into group-parent orders (GPOs) and submits them to orders-api as a block trade. Each group's member orders must share side, instrument, and settlement date; horizon validates groupability, aggregates their account allocations, derives the parent's amount and strictest limit price, and forwards the bulk submission. The write is asynchronous: a success response returns the assigned order IDs, and the GPOs become visible in order queries once they round-trip through the OEMS.
 * @summary Create Order Groups
 */
export const createOrderGroup = async (createOrderGroupsRequestBody: CreateOrderGroupsRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createOrderGroupResponse> => {

  return customFetch<createOrderGroupResponse>(getCreateOrderGroupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOrderGroupsRequestBody)
  }
);}





export const getCreateOrderGroupMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderGroup>>, TError,{data: CreateOrderGroupsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrderGroup>>, TError,{data: CreateOrderGroupsRequestBody}, TContext> => {

const mutationKey = ['createOrderGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrderGroup>>, {data: CreateOrderGroupsRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createOrderGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createOrderGroup>>>
    export type CreateOrderGroupMutationBody = CreateOrderGroupsRequestBody
    export type CreateOrderGroupMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create Order Groups
 */
export const useCreateOrderGroup = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderGroup>>, TError,{data: CreateOrderGroupsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrderGroup>>,
        TError,
        {data: CreateOrderGroupsRequestBody},
        TContext
      > => {
      return useMutation(getCreateOrderGroupMutationOptions(options), queryClient);
    }
    export type postOrderQuoteAnalyticsResponse200 = {
  data: PostOrderQuoteAnalyticsResponseBody
  status: 200
}

export type postOrderQuoteAnalyticsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type postOrderQuoteAnalyticsResponseSuccess = (postOrderQuoteAnalyticsResponse200) & {
  headers: Headers;
};
export type postOrderQuoteAnalyticsResponseError = (postOrderQuoteAnalyticsResponseDefault) & {
  headers: Headers;
};

export type postOrderQuoteAnalyticsResponse = postOrderQuoteAnalyticsResponseSuccess

export const getPostOrderQuoteAnalyticsUrl = () => {




  return `/auth/v1/trading/orders/quote-analytics`
}

/**
 * Returns, for each requested order the caller can access, a live summary of its quote universe: the dealer quotes on its non-terminal RFQs unioned with the instrument's LOB levels on the order's contra side, read fresh for the order's risk group, settlement date and amount. Designed for the blotter's per-second poll: one batched request covers many orders, and orders sharing an instrument, risk group, settlement date and amount share one book read.
 * @summary Get per-order quote analytics
 */
export const postOrderQuoteAnalytics = async (postOrderQuoteAnalyticsRequestBody: PostOrderQuoteAnalyticsRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<postOrderQuoteAnalyticsResponse> => {

  return customFetch<postOrderQuoteAnalyticsResponse>(getPostOrderQuoteAnalyticsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postOrderQuoteAnalyticsRequestBody)
  }
);}





export const getPostOrderQuoteAnalyticsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOrderQuoteAnalytics>>, TError,{data: PostOrderQuoteAnalyticsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postOrderQuoteAnalytics>>, TError,{data: PostOrderQuoteAnalyticsRequestBody}, TContext> => {

const mutationKey = ['postOrderQuoteAnalytics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postOrderQuoteAnalytics>>, {data: PostOrderQuoteAnalyticsRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  postOrderQuoteAnalytics(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostOrderQuoteAnalyticsMutationResult = NonNullable<Awaited<ReturnType<typeof postOrderQuoteAnalytics>>>
    export type PostOrderQuoteAnalyticsMutationBody = PostOrderQuoteAnalyticsRequestBody
    export type PostOrderQuoteAnalyticsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Get per-order quote analytics
 */
export const usePostOrderQuoteAnalytics = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOrderQuoteAnalytics>>, TError,{data: PostOrderQuoteAnalyticsRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postOrderQuoteAnalytics>>,
        TError,
        {data: PostOrderQuoteAnalyticsRequestBody},
        TContext
      > => {
      return useMutation(getPostOrderQuoteAnalyticsMutationOptions(options), queryClient);
    }
    export type patchAllocationResponse200 = {
  data: PatchAllocationResponseBody
  status: 200
}

export type patchAllocationResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchAllocationResponseSuccess = (patchAllocationResponse200) & {
  headers: Headers;
};
export type patchAllocationResponseError = (patchAllocationResponseDefault) & {
  headers: Headers;
};

export type patchAllocationResponse = patchAllocationResponseSuccess

export const getPatchAllocationUrl = ({ orderId }: PatchAllocationPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/allocation`
}

/**
 * Merges per-account fields onto the approved allocation of a block order by proxying to orders-api: attestation completions submitted after the order, and when and by whom each account's order was received. A non-empty attestation_completions replaces the stored set for that account and triggers the attestation order check, recorded as completed by the calling user; receipt fields alone only patch the allocation. Fields left out are untouched. The patch is asynchronous: the returned patch_request_id correlates the allocation_patch_succeeded or allocation_patch_rejected event that answers it.
 * @summary Patch Allocation
 */
export const patchAllocation = async ({ orderId }: PatchAllocationPathParameters,
    patchAllocationRequestBody: PatchAllocationRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<patchAllocationResponse> => {

  return customFetch<patchAllocationResponse>(getPatchAllocationUrl({ orderId }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchAllocationRequestBody)
  }
);}





export const getPatchAllocationMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAllocation>>, TError,{pathParams: PatchAllocationPathParameters;data: PatchAllocationRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAllocation>>, TError,{pathParams: PatchAllocationPathParameters;data: PatchAllocationRequestBody}, TContext> => {

const mutationKey = ['patchAllocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAllocation>>, {pathParams: PatchAllocationPathParameters;data: PatchAllocationRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  patchAllocation(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchAllocationMutationResult = NonNullable<Awaited<ReturnType<typeof patchAllocation>>>
    export type PatchAllocationMutationBody = PatchAllocationRequestBody
    export type PatchAllocationMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Patch Allocation
 */
export const usePatchAllocation = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAllocation>>, TError,{pathParams: PatchAllocationPathParameters;data: PatchAllocationRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAllocation>>,
        TError,
        {pathParams: PatchAllocationPathParameters;data: PatchAllocationRequestBody},
        TContext
      > => {
      return useMutation(getPatchAllocationMutationOptions(options), queryClient);
    }
    export type submitOrderAllocationsResponse201 = {
  data: SubmitAllocationsResponseBody
  status: 201
}

export type submitOrderAllocationsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type submitOrderAllocationsResponseSuccess = (submitOrderAllocationsResponse201) & {
  headers: Headers;
};
export type submitOrderAllocationsResponseError = (submitOrderAllocationsResponseDefault) & {
  headers: Headers;
};

export type submitOrderAllocationsResponse = submitOrderAllocationsResponseSuccess

export const getSubmitOrderAllocationsUrl = ({ orderId }: SubmitOrderAllocationsPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/allocations`
}

/**
 * @summary Submit Order Allocations
 */
export const submitOrderAllocations = async ({ orderId }: SubmitOrderAllocationsPathParameters,
    allocationsBody: AllocationsBody, options?: Parameters<typeof customFetch>[1]): Promise<submitOrderAllocationsResponse> => {

  return customFetch<submitOrderAllocationsResponse>(getSubmitOrderAllocationsUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(allocationsBody)
  }
);}





export const getSubmitOrderAllocationsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOrderAllocations>>, TError,{pathParams: SubmitOrderAllocationsPathParameters;data: AllocationsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitOrderAllocations>>, TError,{pathParams: SubmitOrderAllocationsPathParameters;data: AllocationsBody}, TContext> => {

const mutationKey = ['submitOrderAllocations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitOrderAllocations>>, {pathParams: SubmitOrderAllocationsPathParameters;data: AllocationsBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  submitOrderAllocations(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitOrderAllocationsMutationResult = NonNullable<Awaited<ReturnType<typeof submitOrderAllocations>>>
    export type SubmitOrderAllocationsMutationBody = AllocationsBody
    export type SubmitOrderAllocationsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Submit Order Allocations
 */
export const useSubmitOrderAllocations = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOrderAllocations>>, TError,{pathParams: SubmitOrderAllocationsPathParameters;data: AllocationsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitOrderAllocations>>,
        TError,
        {pathParams: SubmitOrderAllocationsPathParameters;data: AllocationsBody},
        TContext
      > => {
      return useMutation(getSubmitOrderAllocationsMutationOptions(options), queryClient);
    }
    export type resolveOrderAllocationsResponse200 = {
  data: ResolveResponseBody
  status: 200
}

export type resolveOrderAllocationsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type resolveOrderAllocationsResponseSuccess = (resolveOrderAllocationsResponse200) & {
  headers: Headers;
};
export type resolveOrderAllocationsResponseError = (resolveOrderAllocationsResponseDefault) & {
  headers: Headers;
};

export type resolveOrderAllocationsResponse = resolveOrderAllocationsResponseSuccess

export const getResolveOrderAllocationsUrl = ({ orderId }: ResolveOrderAllocationsPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/allocations/resolve`
}

/**
 * @summary Resolve Order Allocations
 */
export const resolveOrderAllocations = async ({ orderId }: ResolveOrderAllocationsPathParameters,
    allocationsBody: AllocationsBody, options?: Parameters<typeof customFetch>[1]): Promise<resolveOrderAllocationsResponse> => {

  return customFetch<resolveOrderAllocationsResponse>(getResolveOrderAllocationsUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(allocationsBody)
  }
);}





export const getResolveOrderAllocationsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveOrderAllocations>>, TError,{pathParams: ResolveOrderAllocationsPathParameters;data: AllocationsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveOrderAllocations>>, TError,{pathParams: ResolveOrderAllocationsPathParameters;data: AllocationsBody}, TContext> => {

const mutationKey = ['resolveOrderAllocations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveOrderAllocations>>, {pathParams: ResolveOrderAllocationsPathParameters;data: AllocationsBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  resolveOrderAllocations(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveOrderAllocationsMutationResult = NonNullable<Awaited<ReturnType<typeof resolveOrderAllocations>>>
    export type ResolveOrderAllocationsMutationBody = AllocationsBody
    export type ResolveOrderAllocationsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Resolve Order Allocations
 */
export const useResolveOrderAllocations = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveOrderAllocations>>, TError,{pathParams: ResolveOrderAllocationsPathParameters;data: AllocationsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resolveOrderAllocations>>,
        TError,
        {pathParams: ResolveOrderAllocationsPathParameters;data: AllocationsBody},
        TContext
      > => {
      return useMutation(getResolveOrderAllocationsMutationOptions(options), queryClient);
    }
    export type updateOrderAnnotationResponse200 = {
  data: UpdateOrderAnnotationResponseBody
  status: 200
}

export type updateOrderAnnotationResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateOrderAnnotationResponseSuccess = (updateOrderAnnotationResponse200) & {
  headers: Headers;
};
export type updateOrderAnnotationResponseError = (updateOrderAnnotationResponseDefault) & {
  headers: Headers;
};

export type updateOrderAnnotationResponse = updateOrderAnnotationResponseSuccess

export const getUpdateOrderAnnotationUrl = ({ orderId }: UpdateOrderAnnotationPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/annotation`
}

/**
 * Replaces or clears the annotation on a parent order the caller can see by emitting an annotation metadata update to the OEMS sequencer. Open orders accept an annotation whenever they were placed; a filled, canceled, rejected or replaced order accepts one only until its expire time, after which the OEMS drops it at end of day and the request fails with 409. The write is asynchronous: a success response means the update was submitted, and the new annotation becomes visible in order queries once it round-trips through the OEMS.
 * @summary Update Order Annotation
 */
export const updateOrderAnnotation = async ({ orderId }: UpdateOrderAnnotationPathParameters,
    updateOrderAnnotationRequestBody: UpdateOrderAnnotationRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<updateOrderAnnotationResponse> => {

  return customFetch<updateOrderAnnotationResponse>(getUpdateOrderAnnotationUrl({ orderId }),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateOrderAnnotationRequestBody)
  }
);}





export const getUpdateOrderAnnotationMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderAnnotation>>, TError,{pathParams: UpdateOrderAnnotationPathParameters;data: UpdateOrderAnnotationRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrderAnnotation>>, TError,{pathParams: UpdateOrderAnnotationPathParameters;data: UpdateOrderAnnotationRequestBody}, TContext> => {

const mutationKey = ['updateOrderAnnotation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrderAnnotation>>, {pathParams: UpdateOrderAnnotationPathParameters;data: UpdateOrderAnnotationRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  updateOrderAnnotation(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrderAnnotationMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrderAnnotation>>>
    export type UpdateOrderAnnotationMutationBody = UpdateOrderAnnotationRequestBody
    export type UpdateOrderAnnotationMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Update Order Annotation
 */
export const useUpdateOrderAnnotation = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderAnnotation>>, TError,{pathParams: UpdateOrderAnnotationPathParameters;data: UpdateOrderAnnotationRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrderAnnotation>>,
        TError,
        {pathParams: UpdateOrderAnnotationPathParameters;data: UpdateOrderAnnotationRequestBody},
        TContext
      > => {
      return useMutation(getUpdateOrderAnnotationMutationOptions(options), queryClient);
    }
    export type approveOrderResponse200 = {
  data: OrderApprovalResponseBody
  status: 200
}

export type approveOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type approveOrderResponseSuccess = (approveOrderResponse200) & {
  headers: Headers;
};
export type approveOrderResponseError = (approveOrderResponseDefault) & {
  headers: Headers;
};

export type approveOrderResponse = approveOrderResponseSuccess

export const getApproveOrderUrl = ({ orderId }: ApproveOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/approve`
}

/**
 * Manually approves a parent order that is pending approval and held for manual review, by proxying the approval to orders-api. The approval is asynchronous: a success response means the request was accepted, and the returned approval_id correlates the eventual outcome — the caller subsequently receives either a system_update event (if the approval fails) or an order_update event (if approved), both carrying this ID. The caller's identity is forwarded to orders-api, which records who approved the order.
 * @summary Approve Order
 */
export const approveOrder = async ({ orderId }: ApproveOrderPathParameters,
    orderApprovalRequestBody: OrderApprovalRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<approveOrderResponse> => {

  return customFetch<approveOrderResponse>(getApproveOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orderApprovalRequestBody)
  }
);}





export const getApproveOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOrder>>, TError,{pathParams: ApproveOrderPathParameters;data: OrderApprovalRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveOrder>>, TError,{pathParams: ApproveOrderPathParameters;data: OrderApprovalRequestBody}, TContext> => {

const mutationKey = ['approveOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveOrder>>, {pathParams: ApproveOrderPathParameters;data: OrderApprovalRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  approveOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveOrderMutationResult = NonNullable<Awaited<ReturnType<typeof approveOrder>>>
    export type ApproveOrderMutationBody = OrderApprovalRequestBody
    export type ApproveOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Approve Order
 */
export const useApproveOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOrder>>, TError,{pathParams: ApproveOrderPathParameters;data: OrderApprovalRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveOrder>>,
        TError,
        {pathParams: ApproveOrderPathParameters;data: OrderApprovalRequestBody},
        TContext
      > => {
      return useMutation(getApproveOrderMutationOptions(options), queryClient);
    }
    export type assignOrderResponse200 = {
  data: OrderAssignResponseBody
  status: 200
}

export type assignOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type assignOrderResponseSuccess = (assignOrderResponse200) & {
  headers: Headers;
};
export type assignOrderResponseError = (assignOrderResponseDefault) & {
  headers: Headers;
};

export type assignOrderResponse = assignOrderResponseSuccess

export const getAssignOrderUrl = ({ orderId }: AssignOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/assign`
}

/**
 * Assigns the parent order to a specific trader by upserting the order's trader_id metadata through orders-api. Unlike claim, which always assigns to the caller, this takes an explicit trader_id, which must be an order-reading trader in the caller's organization who is granted access to the order's account — the same set the assign-trader dropdown lists. The write is asynchronous: a success response means the update was accepted, and the new assignment becomes visible in order queries once it round-trips through the OEMS (typically within a couple of seconds).
 * @summary Assign Order
 */
export const assignOrder = async ({ orderId }: AssignOrderPathParameters,
    orderAssignRequestBody: OrderAssignRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<assignOrderResponse> => {

  return customFetch<assignOrderResponse>(getAssignOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orderAssignRequestBody)
  }
);}





export const getAssignOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignOrder>>, TError,{pathParams: AssignOrderPathParameters;data: OrderAssignRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignOrder>>, TError,{pathParams: AssignOrderPathParameters;data: OrderAssignRequestBody}, TContext> => {

const mutationKey = ['assignOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignOrder>>, {pathParams: AssignOrderPathParameters;data: OrderAssignRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  assignOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignOrderMutationResult = NonNullable<Awaited<ReturnType<typeof assignOrder>>>
    export type AssignOrderMutationBody = OrderAssignRequestBody
    export type AssignOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Assign Order
 */
export const useAssignOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignOrder>>, TError,{pathParams: AssignOrderPathParameters;data: OrderAssignRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignOrder>>,
        TError,
        {pathParams: AssignOrderPathParameters;data: OrderAssignRequestBody},
        TContext
      > => {
      return useMutation(getAssignOrderMutationOptions(options), queryClient);
    }
    export type getOrderAttestationsResponse200 = {
  data: OrderAttestationsBody
  status: 200
}

export type getOrderAttestationsResponse404 = {
  data: HumaAPIError
  status: 404
}

export type getOrderAttestationsResponse422 = {
  data: HumaAPIError
  status: 422
}

export type getOrderAttestationsResponse500 = {
  data: HumaAPIError
  status: 500
}

export type getOrderAttestationsResponseSuccess = (getOrderAttestationsResponse200) & {
  headers: Headers;
};
export type getOrderAttestationsResponseError = (getOrderAttestationsResponse404 | getOrderAttestationsResponse422 | getOrderAttestationsResponse500) & {
  headers: Headers;
};

export type getOrderAttestationsResponse = getOrderAttestationsResponseSuccess

export const getGetOrderAttestationsUrl = ({ orderId }: GetOrderAttestationsPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/attestations`
}

/**
 * Returns what each account on the order attested to: the attestation version the completion pinned, rendered with the advisor's answers.
 *
 * `pdf` nodes carry their stored object key, not a url. A `muni_points` node asks for an acknowledgement and is answered like a checkbox.
 * @summary Get the attestations completed on an order
 */
export const getOrderAttestations = async ({ orderId }: GetOrderAttestationsPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getOrderAttestationsResponse> => {

  return customFetch<getOrderAttestationsResponse>(getGetOrderAttestationsUrl({ orderId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderAttestationsQueryKey = ({ orderId }: GetOrderAttestationsPathParameters,) => {
    return [
    `/auth/v1/trading/orders/${orderId}/attestations`
    ] as const;
    }


export const getGetOrderAttestationsQueryOptions = <TData = Awaited<ReturnType<typeof getOrderAttestations>>, TError = ErrorType<HumaAPIError>>({ orderId }: GetOrderAttestationsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderAttestationsQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderAttestations>>> = ({ signal }) => getOrderAttestations({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderAttestationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderAttestations>>>
export type GetOrderAttestationsQueryError = ErrorType<HumaAPIError>


export function useGetOrderAttestations<TData = Awaited<ReturnType<typeof getOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderAttestationsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderAttestations>>,
          TError,
          Awaited<ReturnType<typeof getOrderAttestations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderAttestations<TData = Awaited<ReturnType<typeof getOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderAttestationsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderAttestations>>,
          TError,
          Awaited<ReturnType<typeof getOrderAttestations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderAttestations<TData = Awaited<ReturnType<typeof getOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderAttestationsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the attestations completed on an order
 */

export function useGetOrderAttestations<TData = Awaited<ReturnType<typeof getOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: GetOrderAttestationsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderAttestationsQueryOptions({ orderId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrderAttestationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrderAttestations>>, TError = ErrorType<HumaAPIError>>({ orderId }: GetOrderAttestationsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderAttestationsQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderAttestations>>> = ({ signal }) => getOrderAttestations({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderAttestationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderAttestations>>>
export type GetOrderAttestationsSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetOrderAttestationsSuspense<TData = Awaited<ReturnType<typeof getOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderAttestationsPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderAttestationsSuspense<TData = Awaited<ReturnType<typeof getOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderAttestationsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderAttestationsSuspense<TData = Awaited<ReturnType<typeof getOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderAttestationsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the attestations completed on an order
 */

export function useGetOrderAttestationsSuspense<TData = Awaited<ReturnType<typeof getOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: GetOrderAttestationsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderAttestationsSuspenseQueryOptions({ orderId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type evaluateOrderAttestationsResponse200 = {
  data: OrderAttestationEvaluation
  status: 200
}

export type evaluateOrderAttestationsResponse404 = {
  data: HumaAPIError
  status: 404
}

export type evaluateOrderAttestationsResponse422 = {
  data: HumaAPIError
  status: 422
}

export type evaluateOrderAttestationsResponse500 = {
  data: HumaAPIError
  status: 500
}

export type evaluateOrderAttestationsResponse502 = {
  data: HumaAPIError
  status: 502
}

export type evaluateOrderAttestationsResponse503 = {
  data: HumaAPIError
  status: 503
}

export type evaluateOrderAttestationsResponseSuccess = (evaluateOrderAttestationsResponse200) & {
  headers: Headers;
};
export type evaluateOrderAttestationsResponseError = (evaluateOrderAttestationsResponse404 | evaluateOrderAttestationsResponse422 | evaluateOrderAttestationsResponse500 | evaluateOrderAttestationsResponse502 | evaluateOrderAttestationsResponse503) & {
  headers: Headers;
};

export type evaluateOrderAttestationsResponse = evaluateOrderAttestationsResponseSuccess

export const getEvaluateOrderAttestationsUrl = ({ orderId }: EvaluateOrderAttestationsPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/attestations/evaluate`
}

/**
 * Answers, for each allocation line of the order, the attestation versions the advisor must complete, and renders those versions.
 *
 * Advisory: validation-engine enforces the requirements again when completions are submitted.
 *
 * `pdf` and `muni_points` urls are presigned or session-bearing: do not log or cache the response.
 * @summary Evaluate the attestations an order's accounts must complete
 */
export const evaluateOrderAttestations = async ({ orderId }: EvaluateOrderAttestationsPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<evaluateOrderAttestationsResponse> => {

  return customFetch<evaluateOrderAttestationsResponse>(getEvaluateOrderAttestationsUrl({ orderId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEvaluateOrderAttestationsQueryKey = ({ orderId }: EvaluateOrderAttestationsPathParameters,) => {
    return [
    `/auth/v1/trading/orders/${orderId}/attestations/evaluate`
    ] as const;
    }


export const getEvaluateOrderAttestationsQueryOptions = <TData = Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError = ErrorType<HumaAPIError>>({ orderId }: EvaluateOrderAttestationsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEvaluateOrderAttestationsQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof evaluateOrderAttestations>>> = ({ signal }) => evaluateOrderAttestations({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EvaluateOrderAttestationsQueryResult = NonNullable<Awaited<ReturnType<typeof evaluateOrderAttestations>>>
export type EvaluateOrderAttestationsQueryError = ErrorType<HumaAPIError>


export function useEvaluateOrderAttestations<TData = Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: EvaluateOrderAttestationsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evaluateOrderAttestations>>,
          TError,
          Awaited<ReturnType<typeof evaluateOrderAttestations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEvaluateOrderAttestations<TData = Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: EvaluateOrderAttestationsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evaluateOrderAttestations>>,
          TError,
          Awaited<ReturnType<typeof evaluateOrderAttestations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEvaluateOrderAttestations<TData = Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: EvaluateOrderAttestationsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Evaluate the attestations an order's accounts must complete
 */

export function useEvaluateOrderAttestations<TData = Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: EvaluateOrderAttestationsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEvaluateOrderAttestationsQueryOptions({ orderId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEvaluateOrderAttestationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError = ErrorType<HumaAPIError>>({ orderId }: EvaluateOrderAttestationsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEvaluateOrderAttestationsQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof evaluateOrderAttestations>>> = ({ signal }) => evaluateOrderAttestations({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EvaluateOrderAttestationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof evaluateOrderAttestations>>>
export type EvaluateOrderAttestationsSuspenseQueryError = ErrorType<HumaAPIError>


export function useEvaluateOrderAttestationsSuspense<TData = Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: EvaluateOrderAttestationsPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEvaluateOrderAttestationsSuspense<TData = Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: EvaluateOrderAttestationsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEvaluateOrderAttestationsSuspense<TData = Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 pathParams: EvaluateOrderAttestationsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Evaluate the attestations an order's accounts must complete
 */

export function useEvaluateOrderAttestationsSuspense<TData = Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: EvaluateOrderAttestationsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof evaluateOrderAttestations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEvaluateOrderAttestationsSuspenseQueryOptions({ orderId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type cancelOrderResponse204 = {
  data: void
  status: 204
}

export type cancelOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type cancelOrderResponseSuccess = (cancelOrderResponse204) & {
  headers: Headers;
};
export type cancelOrderResponseError = (cancelOrderResponseDefault) & {
  headers: Headers;
};

export type cancelOrderResponse = cancelOrderResponseSuccess

export const getCancelOrderUrl = ({ orderId }: CancelOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/cancel`
}

/**
 * Cancels a single order by proxying the cancel to orders-api (which publishes it to the OEMS sequencer). For a group parent order that has filled, set cancel_group_members to also cancel its members' open quantity; leave it unset for a plain order (to ungroup a zero-fill group parent, use the ungroup endpoint instead). The cancel is asynchronous: a success response means orders-api accepted it, and the order leaves order queries once the cancel round-trips through the OEMS. Unlike ungroup, this endpoint does not pre-validate order status — a cancel of an already-terminal order is a harmless no-op, so orders-api and the OEMS remain the authority (mirroring bulk cancel). The one check made here is on IOI orders: a caller without oms::order::cancel may cancel one only as the advisor on it (403 otherwise) and only while its price is still unaccepted (409 otherwise).
 * @summary Cancel Order
 */
export const cancelOrder = async ({ orderId }: CancelOrderPathParameters,
    cancelOrderRequestBody: CancelOrderRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<cancelOrderResponse> => {

  return customFetch<cancelOrderResponse>(getCancelOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelOrderRequestBody)
  }
);}





export const getCancelOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOrder>>, TError,{pathParams: CancelOrderPathParameters;data: CancelOrderRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelOrder>>, TError,{pathParams: CancelOrderPathParameters;data: CancelOrderRequestBody}, TContext> => {

const mutationKey = ['cancelOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelOrder>>, {pathParams: CancelOrderPathParameters;data: CancelOrderRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  cancelOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelOrderMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOrder>>>
    export type CancelOrderMutationBody = CancelOrderRequestBody
    export type CancelOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Cancel Order
 */
export const useCancelOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOrder>>, TError,{pathParams: CancelOrderPathParameters;data: CancelOrderRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelOrder>>,
        TError,
        {pathParams: CancelOrderPathParameters;data: CancelOrderRequestBody},
        TContext
      > => {
      return useMutation(getCancelOrderMutationOptions(options), queryClient);
    }
    export type createCustodianManualExecutionOrderResponse200 = {
  data: ExecutionOrderResponse
  status: 200
}

export type createCustodianManualExecutionOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type createCustodianManualExecutionOrderResponseSuccess = (createCustodianManualExecutionOrderResponse200) & {
  headers: Headers;
};
export type createCustodianManualExecutionOrderResponseError = (createCustodianManualExecutionOrderResponseDefault) & {
  headers: Headers;
};

export type createCustodianManualExecutionOrderResponse = createCustodianManualExecutionOrderResponseSuccess

export const getCreateCustodianManualExecutionOrderUrl = ({ orderId }: CreateCustodianManualExecutionOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/execution-orders/custodian/manual`
}

/**
 * Submits a manual custodian-routed execution order against a parent order, by proxying the request to orders-api (which publishes it to the OEMS sequencer). Used for equities and mutual funds. Submitting multiple splits of one parent order is N independent calls to this endpoint. The submission is asynchronous: a success response returns the created execution order's ID, and the resulting fills round-trip through the OEMS. The caller's identity is forwarded to orders-api.
 * @summary Submit Execution Order (Custodian, Manual)
 */
export const createCustodianManualExecutionOrder = async ({ orderId }: CreateCustodianManualExecutionOrderPathParameters,
    executionOrderRequestCustodianManual: ExecutionOrderRequestCustodianManual, options?: Parameters<typeof customFetch>[1]): Promise<createCustodianManualExecutionOrderResponse> => {

  return customFetch<createCustodianManualExecutionOrderResponse>(getCreateCustodianManualExecutionOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(executionOrderRequestCustodianManual)
  }
);}





export const getCreateCustodianManualExecutionOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustodianManualExecutionOrder>>, TError,{pathParams: CreateCustodianManualExecutionOrderPathParameters;data: ExecutionOrderRequestCustodianManual}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustodianManualExecutionOrder>>, TError,{pathParams: CreateCustodianManualExecutionOrderPathParameters;data: ExecutionOrderRequestCustodianManual}, TContext> => {

const mutationKey = ['createCustodianManualExecutionOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustodianManualExecutionOrder>>, {pathParams: CreateCustodianManualExecutionOrderPathParameters;data: ExecutionOrderRequestCustodianManual}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  createCustodianManualExecutionOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustodianManualExecutionOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createCustodianManualExecutionOrder>>>
    export type CreateCustodianManualExecutionOrderMutationBody = ExecutionOrderRequestCustodianManual
    export type CreateCustodianManualExecutionOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Submit Execution Order (Custodian, Manual)
 */
export const useCreateCustodianManualExecutionOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustodianManualExecutionOrder>>, TError,{pathParams: CreateCustodianManualExecutionOrderPathParameters;data: ExecutionOrderRequestCustodianManual}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCustodianManualExecutionOrder>>,
        TError,
        {pathParams: CreateCustodianManualExecutionOrderPathParameters;data: ExecutionOrderRequestCustodianManual},
        TContext
      > => {
      return useMutation(getCreateCustodianManualExecutionOrderMutationOptions(options), queryClient);
    }
    export type createExternalExecutionOrderResponse200 = {
  data: ExecutionOrderResponse
  status: 200
}

export type createExternalExecutionOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type createExternalExecutionOrderResponseSuccess = (createExternalExecutionOrderResponse200) & {
  headers: Headers;
};
export type createExternalExecutionOrderResponseError = (createExternalExecutionOrderResponseDefault) & {
  headers: Headers;
};

export type createExternalExecutionOrderResponse = createExternalExecutionOrderResponseSuccess

export const getCreateExternalExecutionOrderUrl = ({ orderId }: CreateExternalExecutionOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/execution-orders/external`
}

/**
 * Records a manually-keyed external trade (a voice trade or manual fill) against a parent order, by proxying the request to orders-api. Unlike a custodian-manual submission, an external trade reports a fill that already happened off-platform: the response is synchronous and returns the created execution order's ID. The caller's identity is forwarded to orders-api.
 * @summary Submit Execution Order (External Trade)
 */
export const createExternalExecutionOrder = async ({ orderId }: CreateExternalExecutionOrderPathParameters,
    externalExecutionOrderRequestBody: ExternalExecutionOrderRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<createExternalExecutionOrderResponse> => {

  return customFetch<createExternalExecutionOrderResponse>(getCreateExternalExecutionOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(externalExecutionOrderRequestBody)
  }
);}





export const getCreateExternalExecutionOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExternalExecutionOrder>>, TError,{pathParams: CreateExternalExecutionOrderPathParameters;data: ExternalExecutionOrderRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExternalExecutionOrder>>, TError,{pathParams: CreateExternalExecutionOrderPathParameters;data: ExternalExecutionOrderRequestBody}, TContext> => {

const mutationKey = ['createExternalExecutionOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExternalExecutionOrder>>, {pathParams: CreateExternalExecutionOrderPathParameters;data: ExternalExecutionOrderRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  createExternalExecutionOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExternalExecutionOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createExternalExecutionOrder>>>
    export type CreateExternalExecutionOrderMutationBody = ExternalExecutionOrderRequestBody
    export type CreateExternalExecutionOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Submit Execution Order (External Trade)
 */
export const useCreateExternalExecutionOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExternalExecutionOrder>>, TError,{pathParams: CreateExternalExecutionOrderPathParameters;data: ExternalExecutionOrderRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExternalExecutionOrder>>,
        TError,
        {pathParams: CreateExternalExecutionOrderPathParameters;data: ExternalExecutionOrderRequestBody},
        TContext
      > => {
      return useMutation(getCreateExternalExecutionOrderMutationOptions(options), queryClient);
    }
    export type submitInventoryExecutionOrderResponse200 = {
  data: ExecutionOrderResponse
  status: 200
}

export type submitInventoryExecutionOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type submitInventoryExecutionOrderResponseSuccess = (submitInventoryExecutionOrderResponse200) & {
  headers: Headers;
};
export type submitInventoryExecutionOrderResponseError = (submitInventoryExecutionOrderResponseDefault) & {
  headers: Headers;
};

export type submitInventoryExecutionOrderResponse = submitInventoryExecutionOrderResponseSuccess

export const getSubmitInventoryExecutionOrderUrl = ({ orderId }: SubmitInventoryExecutionOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/execution-orders/inventory`
}

/**
 * Trades a parent order against the firm's own inventory, booked to the principal account (book) named by custodian and custodian account number, by proxying the request to orders-api (which publishes it to the OEMS sequencer). No venue is involved: the execution order fills at the given price for the whole order. Either side: a buy sells to the client from the book, a sell buys from the client into the book. Asynchronous, like the other submissions. The caller's identity is forwarded to orders-api and the trade is attributed to them. Returns 403 when inventory execution orders are not enabled for the organization.
 * @summary Submit Execution Order (Inventory)
 */
export const submitInventoryExecutionOrder = async ({ orderId }: SubmitInventoryExecutionOrderPathParameters,
    submitInventoryExecutionOrderBody: SubmitInventoryExecutionOrderBody, options?: Parameters<typeof customFetch>[1]): Promise<submitInventoryExecutionOrderResponse> => {

  return customFetch<submitInventoryExecutionOrderResponse>(getSubmitInventoryExecutionOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitInventoryExecutionOrderBody)
  }
);}





export const getSubmitInventoryExecutionOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInventoryExecutionOrder>>, TError,{pathParams: SubmitInventoryExecutionOrderPathParameters;data: SubmitInventoryExecutionOrderBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitInventoryExecutionOrder>>, TError,{pathParams: SubmitInventoryExecutionOrderPathParameters;data: SubmitInventoryExecutionOrderBody}, TContext> => {

const mutationKey = ['submitInventoryExecutionOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitInventoryExecutionOrder>>, {pathParams: SubmitInventoryExecutionOrderPathParameters;data: SubmitInventoryExecutionOrderBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  submitInventoryExecutionOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitInventoryExecutionOrderMutationResult = NonNullable<Awaited<ReturnType<typeof submitInventoryExecutionOrder>>>
    export type SubmitInventoryExecutionOrderMutationBody = SubmitInventoryExecutionOrderBody
    export type SubmitInventoryExecutionOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Submit Execution Order (Inventory)
 */
export const useSubmitInventoryExecutionOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInventoryExecutionOrder>>, TError,{pathParams: SubmitInventoryExecutionOrderPathParameters;data: SubmitInventoryExecutionOrderBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitInventoryExecutionOrder>>,
        TError,
        {pathParams: SubmitInventoryExecutionOrderPathParameters;data: SubmitInventoryExecutionOrderBody},
        TContext
      > => {
      return useMutation(getSubmitInventoryExecutionOrderMutationOptions(options), queryClient);
    }
    export type submitLobManualExecutionOrderResponse200 = {
  data: ExecutionOrderResponse
  status: 200
}

export type submitLobManualExecutionOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type submitLobManualExecutionOrderResponseSuccess = (submitLobManualExecutionOrderResponse200) & {
  headers: Headers;
};
export type submitLobManualExecutionOrderResponseError = (submitLobManualExecutionOrderResponseDefault) & {
  headers: Headers;
};

export type submitLobManualExecutionOrderResponse = submitLobManualExecutionOrderResponseSuccess

export const getSubmitLobManualExecutionOrderUrl = ({ orderId }: SubmitLobManualExecutionOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/execution-orders/lob/manual`
}

/**
 * Hits a bid / lifts an ask against a limit-order-book (LOB) level of a parent order, by proxying the request to orders-api (which publishes it to the OEMS sequencer). The book level is identified by venue MPID and an optional limit price. The submission is asynchronous: a success response returns the created execution order's ID, and the resulting fills round-trip through the OEMS. The caller's identity is forwarded to orders-api.
 * @summary Submit Execution Order (LOB, Manual)
 */
export const submitLobManualExecutionOrder = async ({ orderId }: SubmitLobManualExecutionOrderPathParameters,
    submitLOBExecutionOrderBody: SubmitLOBExecutionOrderBody, options?: Parameters<typeof customFetch>[1]): Promise<submitLobManualExecutionOrderResponse> => {

  return customFetch<submitLobManualExecutionOrderResponse>(getSubmitLobManualExecutionOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitLOBExecutionOrderBody)
  }
);}





export const getSubmitLobManualExecutionOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLobManualExecutionOrder>>, TError,{pathParams: SubmitLobManualExecutionOrderPathParameters;data: SubmitLOBExecutionOrderBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitLobManualExecutionOrder>>, TError,{pathParams: SubmitLobManualExecutionOrderPathParameters;data: SubmitLOBExecutionOrderBody}, TContext> => {

const mutationKey = ['submitLobManualExecutionOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitLobManualExecutionOrder>>, {pathParams: SubmitLobManualExecutionOrderPathParameters;data: SubmitLOBExecutionOrderBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  submitLobManualExecutionOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitLobManualExecutionOrderMutationResult = NonNullable<Awaited<ReturnType<typeof submitLobManualExecutionOrder>>>
    export type SubmitLobManualExecutionOrderMutationBody = SubmitLOBExecutionOrderBody
    export type SubmitLobManualExecutionOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Submit Execution Order (LOB, Manual)
 */
export const useSubmitLobManualExecutionOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLobManualExecutionOrder>>, TError,{pathParams: SubmitLobManualExecutionOrderPathParameters;data: SubmitLOBExecutionOrderBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitLobManualExecutionOrder>>,
        TError,
        {pathParams: SubmitLobManualExecutionOrderPathParameters;data: SubmitLOBExecutionOrderBody},
        TContext
      > => {
      return useMutation(getSubmitLobManualExecutionOrderMutationOptions(options), queryClient);
    }
    export type submitLobSorExecutionOrderResponse200 = {
  data: ExecutionOrderResponse
  status: 200
}

export type submitLobSorExecutionOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type submitLobSorExecutionOrderResponseSuccess = (submitLobSorExecutionOrderResponse200) & {
  headers: Headers;
};
export type submitLobSorExecutionOrderResponseError = (submitLobSorExecutionOrderResponseDefault) & {
  headers: Headers;
};

export type submitLobSorExecutionOrderResponse = submitLobSorExecutionOrderResponseSuccess

export const getSubmitLobSorExecutionOrderUrl = ({ orderId }: SubmitLobSorExecutionOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/execution-orders/lob/sor`
}

/**
 * Routes a parent order through the limit-order-book (LOB) smart order router (SOR), by proxying the request to orders-api (which publishes it to the OEMS sequencer). Unlike the LOB-manual submission it pins no venue: the OEMS selects where to route at execution time and records the best-execution snapshot of the book it routed against. The submission is asynchronous: a success response returns the created execution order's ID, and the resulting fills round-trip through the OEMS. The caller's identity is forwarded to orders-api.
 * @summary Submit Execution Order (LOB, SOR)
 */
export const submitLobSorExecutionOrder = async ({ orderId }: SubmitLobSorExecutionOrderPathParameters,
    submitLOBSORExecutionOrderBody: SubmitLOBSORExecutionOrderBody, options?: Parameters<typeof customFetch>[1]): Promise<submitLobSorExecutionOrderResponse> => {

  return customFetch<submitLobSorExecutionOrderResponse>(getSubmitLobSorExecutionOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitLOBSORExecutionOrderBody)
  }
);}





export const getSubmitLobSorExecutionOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLobSorExecutionOrder>>, TError,{pathParams: SubmitLobSorExecutionOrderPathParameters;data: SubmitLOBSORExecutionOrderBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitLobSorExecutionOrder>>, TError,{pathParams: SubmitLobSorExecutionOrderPathParameters;data: SubmitLOBSORExecutionOrderBody}, TContext> => {

const mutationKey = ['submitLobSorExecutionOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitLobSorExecutionOrder>>, {pathParams: SubmitLobSorExecutionOrderPathParameters;data: SubmitLOBSORExecutionOrderBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  submitLobSorExecutionOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitLobSorExecutionOrderMutationResult = NonNullable<Awaited<ReturnType<typeof submitLobSorExecutionOrder>>>
    export type SubmitLobSorExecutionOrderMutationBody = SubmitLOBSORExecutionOrderBody
    export type SubmitLobSorExecutionOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Submit Execution Order (LOB, SOR)
 */
export const useSubmitLobSorExecutionOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLobSorExecutionOrder>>, TError,{pathParams: SubmitLobSorExecutionOrderPathParameters;data: SubmitLOBSORExecutionOrderBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitLobSorExecutionOrder>>,
        TError,
        {pathParams: SubmitLobSorExecutionOrderPathParameters;data: SubmitLOBSORExecutionOrderBody},
        TContext
      > => {
      return useMutation(getSubmitLobSorExecutionOrderMutationOptions(options), queryClient);
    }
    export type submitAutoexRfqExecutionOrderResponse200 = {
  data: ExecutionOrderResponse
  status: 200
}

export type submitAutoexRfqExecutionOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type submitAutoexRfqExecutionOrderResponseSuccess = (submitAutoexRfqExecutionOrderResponse200) & {
  headers: Headers;
};
export type submitAutoexRfqExecutionOrderResponseError = (submitAutoexRfqExecutionOrderResponseDefault) & {
  headers: Headers;
};

export type submitAutoexRfqExecutionOrderResponse = submitAutoexRfqExecutionOrderResponseSuccess

export const getSubmitAutoexRfqExecutionOrderUrl = ({ orderId }: SubmitAutoexRfqExecutionOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/execution-orders/rfq/autoex`
}

/**
 * Sends RFQs for a parent order and lets the auto-executor accept a quote on the trader's behalf once its execution criteria are met, by proxying the request to orders-api (which publishes it to the OEMS sequencer). Several venues may be quoted at once, each producing its own RFQ. This is the auto-ex counterpart of Create an RFQ for an order: that endpoint returns an RFQ id for a quote the trader will accept manually, while this returns the created execution order's ID because it may send more than one RFQ. Asynchronous, like the other submissions. The caller's identity is forwarded to orders-api and the trade is attributed to them.
 * @summary Submit Execution Order (RFQ, Auto-Ex)
 */
export const submitAutoexRfqExecutionOrder = async ({ orderId }: SubmitAutoexRfqExecutionOrderPathParameters,
    submitAutoExRFQExecutionOrderBody: SubmitAutoExRFQExecutionOrderBody, options?: Parameters<typeof customFetch>[1]): Promise<submitAutoexRfqExecutionOrderResponse> => {

  return customFetch<submitAutoexRfqExecutionOrderResponse>(getSubmitAutoexRfqExecutionOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitAutoExRFQExecutionOrderBody)
  }
);}





export const getSubmitAutoexRfqExecutionOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAutoexRfqExecutionOrder>>, TError,{pathParams: SubmitAutoexRfqExecutionOrderPathParameters;data: SubmitAutoExRFQExecutionOrderBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitAutoexRfqExecutionOrder>>, TError,{pathParams: SubmitAutoexRfqExecutionOrderPathParameters;data: SubmitAutoExRFQExecutionOrderBody}, TContext> => {

const mutationKey = ['submitAutoexRfqExecutionOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitAutoexRfqExecutionOrder>>, {pathParams: SubmitAutoexRfqExecutionOrderPathParameters;data: SubmitAutoExRFQExecutionOrderBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  submitAutoexRfqExecutionOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitAutoexRfqExecutionOrderMutationResult = NonNullable<Awaited<ReturnType<typeof submitAutoexRfqExecutionOrder>>>
    export type SubmitAutoexRfqExecutionOrderMutationBody = SubmitAutoExRFQExecutionOrderBody
    export type SubmitAutoexRfqExecutionOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Submit Execution Order (RFQ, Auto-Ex)
 */
export const useSubmitAutoexRfqExecutionOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAutoexRfqExecutionOrder>>, TError,{pathParams: SubmitAutoexRfqExecutionOrderPathParameters;data: SubmitAutoExRFQExecutionOrderBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitAutoexRfqExecutionOrder>>,
        TError,
        {pathParams: SubmitAutoexRfqExecutionOrderPathParameters;data: SubmitAutoExRFQExecutionOrderBody},
        TContext
      > => {
      return useMutation(getSubmitAutoexRfqExecutionOrderMutationOptions(options), queryClient);
    }
    export type submitRfqManualExecutionOrderResponse200 = {
  data: ExecutionOrderResponse
  status: 200
}

export type submitRfqManualExecutionOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type submitRfqManualExecutionOrderResponseSuccess = (submitRfqManualExecutionOrderResponse200) & {
  headers: Headers;
};
export type submitRfqManualExecutionOrderResponseError = (submitRfqManualExecutionOrderResponseDefault) & {
  headers: Headers;
};

export type submitRfqManualExecutionOrderResponse = submitRfqManualExecutionOrderResponseSuccess

export const getSubmitRfqManualExecutionOrderUrl = ({ orderId }: SubmitRfqManualExecutionOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/execution-orders/rfq/manual`
}

/**
 * Accepts a dealer's RFQ quote for a parent order, by proxying the request to orders-api (which publishes it to the OEMS sequencer). The quote is identified by its RFQ id and contra quote id. The submission is asynchronous: a success response returns the created execution order's ID, and the resulting fills round-trip through the OEMS. The caller's identity is forwarded to orders-api.
 * @summary Submit Execution Order (RFQ, Manual)
 */
export const submitRfqManualExecutionOrder = async ({ orderId }: SubmitRfqManualExecutionOrderPathParameters,
    submitRFQExecutionOrderBody: SubmitRFQExecutionOrderBody, options?: Parameters<typeof customFetch>[1]): Promise<submitRfqManualExecutionOrderResponse> => {

  return customFetch<submitRfqManualExecutionOrderResponse>(getSubmitRfqManualExecutionOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitRFQExecutionOrderBody)
  }
);}





export const getSubmitRfqManualExecutionOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitRfqManualExecutionOrder>>, TError,{pathParams: SubmitRfqManualExecutionOrderPathParameters;data: SubmitRFQExecutionOrderBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitRfqManualExecutionOrder>>, TError,{pathParams: SubmitRfqManualExecutionOrderPathParameters;data: SubmitRFQExecutionOrderBody}, TContext> => {

const mutationKey = ['submitRfqManualExecutionOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitRfqManualExecutionOrder>>, {pathParams: SubmitRfqManualExecutionOrderPathParameters;data: SubmitRFQExecutionOrderBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  submitRfqManualExecutionOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitRfqManualExecutionOrderMutationResult = NonNullable<Awaited<ReturnType<typeof submitRfqManualExecutionOrder>>>
    export type SubmitRfqManualExecutionOrderMutationBody = SubmitRFQExecutionOrderBody
    export type SubmitRfqManualExecutionOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Submit Execution Order (RFQ, Manual)
 */
export const useSubmitRfqManualExecutionOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitRfqManualExecutionOrder>>, TError,{pathParams: SubmitRfqManualExecutionOrderPathParameters;data: SubmitRFQExecutionOrderBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitRfqManualExecutionOrder>>,
        TError,
        {pathParams: SubmitRfqManualExecutionOrderPathParameters;data: SubmitRFQExecutionOrderBody},
        TContext
      > => {
      return useMutation(getSubmitRfqManualExecutionOrderMutationOptions(options), queryClient);
    }
    export type cancelExecutionOrderResponse204 = {
  data: void
  status: 204
}

export type cancelExecutionOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type cancelExecutionOrderResponseSuccess = (cancelExecutionOrderResponse204) & {
  headers: Headers;
};
export type cancelExecutionOrderResponseError = (cancelExecutionOrderResponseDefault) & {
  headers: Headers;
};

export type cancelExecutionOrderResponse = cancelExecutionOrderResponseSuccess

export const getCancelExecutionOrderUrl = ({ orderId, executionOrderId }: CancelExecutionOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/execution-orders/${executionOrderId}`
}

/**
 * Cancels a single execution order of a parent order (e.g. one split of a multi-split order), by proxying the cancel to orders-api. Asynchronous, like submission.
 * @summary Cancel Execution Order
 */
export const cancelExecutionOrder = async ({ orderId, executionOrderId }: CancelExecutionOrderPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<cancelExecutionOrderResponse> => {

  return customFetch<cancelExecutionOrderResponse>(getCancelExecutionOrderUrl({ orderId, executionOrderId }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCancelExecutionOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelExecutionOrder>>, TError,{pathParams: CancelExecutionOrderPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelExecutionOrder>>, TError,{pathParams: CancelExecutionOrderPathParameters}, TContext> => {

const mutationKey = ['cancelExecutionOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelExecutionOrder>>, {pathParams: CancelExecutionOrderPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  cancelExecutionOrder(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelExecutionOrderMutationResult = NonNullable<Awaited<ReturnType<typeof cancelExecutionOrder>>>

    export type CancelExecutionOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Cancel Execution Order
 */
export const useCancelExecutionOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelExecutionOrder>>, TError,{pathParams: CancelExecutionOrderPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelExecutionOrder>>,
        TError,
        {pathParams: CancelExecutionOrderPathParameters},
        TContext
      > => {
      return useMutation(getCancelExecutionOrderMutationOptions(options), queryClient);
    }
    export type cancelTradeResponse202 = {
  data: CancelTradeResponseBody
  status: 202
}

export type cancelTradeResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 202>
}

export type cancelTradeResponseSuccess = (cancelTradeResponse202) & {
  headers: Headers;
};
export type cancelTradeResponseError = (cancelTradeResponseDefault) & {
  headers: Headers;
};

export type cancelTradeResponse = cancelTradeResponseSuccess

export const getCancelTradeUrl = ({ orderId, momentExecutionId }: CancelTradePathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/execution/${momentExecutionId}/cancel`
}

/**
 * Requests the cancel of one filled execution of an all-or-none order by proxying it to orders-api (which publishes it to the OEMS sequencer). The cancel is asynchronous: a 202 means orders-api accepted the request, and order-manager accepts or rejects it on the order activity timeline.
 * @summary Cancel Trade
 */
export const cancelTrade = async ({ orderId, momentExecutionId }: CancelTradePathParameters,
    cancelTradeRequestBody: CancelTradeRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<cancelTradeResponse> => {

  return customFetch<cancelTradeResponse>(getCancelTradeUrl({ orderId, momentExecutionId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelTradeRequestBody)
  }
);}





export const getCancelTradeMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTrade>>, TError,{pathParams: CancelTradePathParameters;data: CancelTradeRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelTrade>>, TError,{pathParams: CancelTradePathParameters;data: CancelTradeRequestBody}, TContext> => {

const mutationKey = ['cancelTrade'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelTrade>>, {pathParams: CancelTradePathParameters;data: CancelTradeRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  cancelTrade(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelTradeMutationResult = NonNullable<Awaited<ReturnType<typeof cancelTrade>>>
    export type CancelTradeMutationBody = CancelTradeRequestBody
    export type CancelTradeMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Cancel Trade
 */
export const useCancelTrade = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTrade>>, TError,{pathParams: CancelTradePathParameters;data: CancelTradeRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelTrade>>,
        TError,
        {pathParams: CancelTradePathParameters;data: CancelTradeRequestBody},
        TContext
      > => {
      return useMutation(getCancelTradeMutationOptions(options), queryClient);
    }
    export type getExecutionFeesResponse200 = {
  data: ExecutionFeesResponseBody
  status: 200
}

export type getExecutionFeesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getExecutionFeesResponseSuccess = (getExecutionFeesResponse200) & {
  headers: Headers;
};
export type getExecutionFeesResponseError = (getExecutionFeesResponseDefault) & {
  headers: Headers;
};

export type getExecutionFeesResponse = getExecutionFeesResponseSuccess

export const getGetExecutionFeesUrl = ({ orderId, executionId }: GetExecutionFeesPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/executions/${executionId}/fees`
}

/**
 * Returns the execution-level fees recorded against a single execution of a parent order (trading_execution_fees), filtered to the legs of the broker cascade the caller is permitted to see.
 * @summary Get Execution Fees
 */
export const getExecutionFees = async ({ orderId, executionId }: GetExecutionFeesPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getExecutionFeesResponse> => {

  return customFetch<getExecutionFeesResponse>(getGetExecutionFeesUrl({ orderId, executionId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExecutionFeesQueryKey = ({ orderId, executionId }: GetExecutionFeesPathParameters,) => {
    return [
    `/auth/v1/trading/orders/${orderId}/executions/${executionId}/fees`
    ] as const;
    }


export const getGetExecutionFeesQueryOptions = <TData = Awaited<ReturnType<typeof getExecutionFees>>, TError = ErrorType<HumaAPIError>>({ orderId, executionId }: GetExecutionFeesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExecutionFeesQueryKey({ orderId, executionId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExecutionFees>>> = ({ signal }) => getExecutionFees({ orderId, executionId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined && executionId !== null && executionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExecutionFeesQueryResult = NonNullable<Awaited<ReturnType<typeof getExecutionFees>>>
export type GetExecutionFeesQueryError = ErrorType<HumaAPIError>


export function useGetExecutionFees<TData = Awaited<ReturnType<typeof getExecutionFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetExecutionFeesPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecutionFees>>,
          TError,
          Awaited<ReturnType<typeof getExecutionFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutionFees<TData = Awaited<ReturnType<typeof getExecutionFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetExecutionFeesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecutionFees>>,
          TError,
          Awaited<ReturnType<typeof getExecutionFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutionFees<TData = Awaited<ReturnType<typeof getExecutionFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetExecutionFeesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Execution Fees
 */

export function useGetExecutionFees<TData = Awaited<ReturnType<typeof getExecutionFees>>, TError = ErrorType<HumaAPIError>>(
 { orderId, executionId }: GetExecutionFeesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExecutionFeesQueryOptions({ orderId, executionId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetExecutionFeesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getExecutionFees>>, TError = ErrorType<HumaAPIError>>({ orderId, executionId }: GetExecutionFeesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExecutionFeesQueryKey({ orderId, executionId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExecutionFees>>> = ({ signal }) => getExecutionFees({ orderId, executionId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExecutionFeesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getExecutionFees>>>
export type GetExecutionFeesSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetExecutionFeesSuspense<TData = Awaited<ReturnType<typeof getExecutionFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetExecutionFeesPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutionFeesSuspense<TData = Awaited<ReturnType<typeof getExecutionFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetExecutionFeesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutionFeesSuspense<TData = Awaited<ReturnType<typeof getExecutionFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetExecutionFeesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Execution Fees
 */

export function useGetExecutionFeesSuspense<TData = Awaited<ReturnType<typeof getExecutionFees>>, TError = ErrorType<HumaAPIError>>(
 { orderId, executionId }: GetExecutionFeesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExecutionFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExecutionFeesSuspenseQueryOptions({ orderId, executionId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getOrderFeesResponse200 = {
  data: OrderFeesResponseBody
  status: 200
}

export type getOrderFeesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getOrderFeesResponseSuccess = (getOrderFeesResponse200) & {
  headers: Headers;
};
export type getOrderFeesResponseError = (getOrderFeesResponseDefault) & {
  headers: Headers;
};

export type getOrderFeesResponse = getOrderFeesResponseSuccess

export const getGetOrderFeesUrl = ({ orderId }: GetOrderFeesPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/fees`
}

/**
 * Returns the fees recorded against a parent order (trading_order_fees), filtered to the legs of the broker cascade the caller is permitted to see.
 * @summary Get Order Fees
 */
export const getOrderFees = async ({ orderId }: GetOrderFeesPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getOrderFeesResponse> => {

  return customFetch<getOrderFeesResponse>(getGetOrderFeesUrl({ orderId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderFeesQueryKey = ({ orderId }: GetOrderFeesPathParameters,) => {
    return [
    `/auth/v1/trading/orders/${orderId}/fees`
    ] as const;
    }


export const getGetOrderFeesQueryOptions = <TData = Awaited<ReturnType<typeof getOrderFees>>, TError = ErrorType<HumaAPIError>>({ orderId }: GetOrderFeesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderFeesQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderFees>>> = ({ signal }) => getOrderFees({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderFeesQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderFees>>>
export type GetOrderFeesQueryError = ErrorType<HumaAPIError>


export function useGetOrderFees<TData = Awaited<ReturnType<typeof getOrderFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderFeesPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderFees>>,
          TError,
          Awaited<ReturnType<typeof getOrderFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderFees<TData = Awaited<ReturnType<typeof getOrderFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderFeesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderFees>>,
          TError,
          Awaited<ReturnType<typeof getOrderFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderFees<TData = Awaited<ReturnType<typeof getOrderFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderFeesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Order Fees
 */

export function useGetOrderFees<TData = Awaited<ReturnType<typeof getOrderFees>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: GetOrderFeesPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderFeesQueryOptions({ orderId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrderFeesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrderFees>>, TError = ErrorType<HumaAPIError>>({ orderId }: GetOrderFeesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderFeesQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderFees>>> = ({ signal }) => getOrderFees({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderFeesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderFees>>>
export type GetOrderFeesSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetOrderFeesSuspense<TData = Awaited<ReturnType<typeof getOrderFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderFeesPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderFeesSuspense<TData = Awaited<ReturnType<typeof getOrderFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderFeesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderFeesSuspense<TData = Awaited<ReturnType<typeof getOrderFees>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderFeesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Order Fees
 */

export function useGetOrderFeesSuspense<TData = Awaited<ReturnType<typeof getOrderFees>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: GetOrderFeesPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderFees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderFeesSuspenseQueryOptions({ orderId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type rejectOrderResponse200 = {
  data: OrderRejectionResponseBody
  status: 200
}

export type rejectOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type rejectOrderResponseSuccess = (rejectOrderResponse200) & {
  headers: Headers;
};
export type rejectOrderResponseError = (rejectOrderResponseDefault) & {
  headers: Headers;
};

export type rejectOrderResponse = rejectOrderResponseSuccess

export const getRejectOrderUrl = ({ orderId }: RejectOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/reject`
}

/**
 * Manually rejects a parent order that is pending approval and held for manual review, by proxying the rejection to orders-api. The rejection is asynchronous: a success response means the request was accepted, and the returned rejection_id correlates the eventual outcome — the caller subsequently receives either a system_update event (if the rejection fails) or an order_update event (if rejected), both carrying this ID. The caller's identity is forwarded to orders-api, which records who rejected the order.
 * @summary Reject Order
 */
export const rejectOrder = async ({ orderId }: RejectOrderPathParameters,
    orderRejectionRequestBody: OrderRejectionRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<rejectOrderResponse> => {

  return customFetch<rejectOrderResponse>(getRejectOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orderRejectionRequestBody)
  }
);}





export const getRejectOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectOrder>>, TError,{pathParams: RejectOrderPathParameters;data: OrderRejectionRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectOrder>>, TError,{pathParams: RejectOrderPathParameters;data: OrderRejectionRequestBody}, TContext> => {

const mutationKey = ['rejectOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectOrder>>, {pathParams: RejectOrderPathParameters;data: OrderRejectionRequestBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  rejectOrder(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectOrderMutationResult = NonNullable<Awaited<ReturnType<typeof rejectOrder>>>
    export type RejectOrderMutationBody = OrderRejectionRequestBody
    export type RejectOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Reject Order
 */
export const useRejectOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectOrder>>, TError,{pathParams: RejectOrderPathParameters;data: OrderRejectionRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectOrder>>,
        TError,
        {pathParams: RejectOrderPathParameters;data: OrderRejectionRequestBody},
        TContext
      > => {
      return useMutation(getRejectOrderMutationOptions(options), queryClient);
    }
    export type createOrderRfqResponse201 = {
  data: CreateRFQResponse
  status: 201
}

export type createOrderRfqResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createOrderRfqResponseSuccess = (createOrderRfqResponse201) & {
  headers: Headers;
};
export type createOrderRfqResponseError = (createOrderRfqResponseDefault) & {
  headers: Headers;
};

export type createOrderRfqResponse = createOrderRfqResponseSuccess

export const getCreateOrderRfqUrl = ({ orderId }: CreateOrderRfqPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/rfq`
}

/**
 * Sends a request for quote to one venue for an existing order. The instrument, side, amount, risk group, introducing broker and settlement date are read from the order, so the body carries only the routing choice and the response clock. An order may have several RFQs open at once — this endpoint does not replace or cancel any existing RFQ.
 * @summary Create an RFQ for an order
 */
export const createOrderRfq = async ({ orderId }: CreateOrderRfqPathParameters,
    createRFQBody: CreateRFQBody, options?: Parameters<typeof customFetch>[1]): Promise<createOrderRfqResponse> => {

  return customFetch<createOrderRfqResponse>(getCreateOrderRfqUrl({ orderId }),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createRFQBody)
  }
);}





export const getCreateOrderRfqMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderRfq>>, TError,{pathParams: CreateOrderRfqPathParameters;data: CreateRFQBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrderRfq>>, TError,{pathParams: CreateOrderRfqPathParameters;data: CreateRFQBody}, TContext> => {

const mutationKey = ['createOrderRfq'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrderRfq>>, {pathParams: CreateOrderRfqPathParameters;data: CreateRFQBody}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  createOrderRfq(pathParams,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderRfqMutationResult = NonNullable<Awaited<ReturnType<typeof createOrderRfq>>>
    export type CreateOrderRfqMutationBody = CreateRFQBody
    export type CreateOrderRfqMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Create an RFQ for an order
 */
export const useCreateOrderRfq = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderRfq>>, TError,{pathParams: CreateOrderRfqPathParameters;data: CreateRFQBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrderRfq>>,
        TError,
        {pathParams: CreateOrderRfqPathParameters;data: CreateRFQBody},
        TContext
      > => {
      return useMutation(getCreateOrderRfqMutationOptions(options), queryClient);
    }
    export type listOrderTradersResponse200 = {
  data: ListTradersResponseBody
  status: 200
}

export type listOrderTradersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listOrderTradersResponseSuccess = (listOrderTradersResponse200) & {
  headers: Headers;
};
export type listOrderTradersResponseError = (listOrderTradersResponseDefault) & {
  headers: Headers;
};

export type listOrderTradersResponse = listOrderTradersResponseSuccess

export const getListOrderTradersUrl = ({ orderId }: ListOrderTradersPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/traders`
}

/**
 * Lists the traders the parent order can be assigned to: traders in the caller's organization who hold oms::order::read#all or oms::order::read#introducing_broker and are granted access to the order's account, matched by the order's account number within the caller's tenant and by its custodian when the order records one. A group order's accounts are its member orders'; a trader needs access to every one found. An order with no account, or whose accounts are not found, lists every order-reading trader. Results are ordered by name.
 * @summary List Order Traders
 */
export const listOrderTraders = async ({ orderId }: ListOrderTradersPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<listOrderTradersResponse> => {

  return customFetch<listOrderTradersResponse>(getListOrderTradersUrl({ orderId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrderTradersQueryKey = ({ orderId }: ListOrderTradersPathParameters,) => {
    return [
    `/auth/v1/trading/orders/${orderId}/traders`
    ] as const;
    }


export const getListOrderTradersQueryOptions = <TData = Awaited<ReturnType<typeof listOrderTraders>>, TError = ErrorType<HumaAPIError>>({ orderId }: ListOrderTradersPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrderTradersQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrderTraders>>> = ({ signal }) => listOrderTraders({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrderTradersQueryResult = NonNullable<Awaited<ReturnType<typeof listOrderTraders>>>
export type ListOrderTradersQueryError = ErrorType<HumaAPIError>


export function useListOrderTraders<TData = Awaited<ReturnType<typeof listOrderTraders>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOrderTradersPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrderTraders>>,
          TError,
          Awaited<ReturnType<typeof listOrderTraders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrderTraders<TData = Awaited<ReturnType<typeof listOrderTraders>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOrderTradersPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrderTraders>>,
          TError,
          Awaited<ReturnType<typeof listOrderTraders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrderTraders<TData = Awaited<ReturnType<typeof listOrderTraders>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOrderTradersPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Order Traders
 */

export function useListOrderTraders<TData = Awaited<ReturnType<typeof listOrderTraders>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: ListOrderTradersPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrderTradersQueryOptions({ orderId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListOrderTradersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listOrderTraders>>, TError = ErrorType<HumaAPIError>>({ orderId }: ListOrderTradersPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrderTradersQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrderTraders>>> = ({ signal }) => listOrderTraders({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrderTradersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listOrderTraders>>>
export type ListOrderTradersSuspenseQueryError = ErrorType<HumaAPIError>


export function useListOrderTradersSuspense<TData = Awaited<ReturnType<typeof listOrderTraders>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOrderTradersPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrderTradersSuspense<TData = Awaited<ReturnType<typeof listOrderTraders>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOrderTradersPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrderTradersSuspense<TData = Awaited<ReturnType<typeof listOrderTraders>>, TError = ErrorType<HumaAPIError>>(
 pathParams: ListOrderTradersPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Order Traders
 */

export function useListOrderTradersSuspense<TData = Awaited<ReturnType<typeof listOrderTraders>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: ListOrderTradersPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrderTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrderTradersSuspenseQueryOptions({ orderId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type unclaimOrderResponse200 = {
  data: OrderClaimResponseBody
  status: 200
}

export type unclaimOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type unclaimOrderResponseSuccess = (unclaimOrderResponse200) & {
  headers: Headers;
};
export type unclaimOrderResponseError = (unclaimOrderResponseDefault) & {
  headers: Headers;
};

export type unclaimOrderResponse = unclaimOrderResponseSuccess

export const getUnclaimOrderUrl = ({ orderId }: UnclaimOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/unclaim`
}

/**
 * Removes the parent order's trader assignment by upserting an empty trader_id metadata value through orders-api. The order metadata store is upsert-only, so an empty value is the canonical unclaimed representation; horizon normalizes it to NULL at ingest. The write is asynchronous, like claiming. Any authenticated caller may unclaim, regardless of who holds the claim — exclusivity is a UI affordance, not a server-side guarantee.
 * @summary Unclaim Order
 */
export const unclaimOrder = async ({ orderId }: UnclaimOrderPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<unclaimOrderResponse> => {

  return customFetch<unclaimOrderResponse>(getUnclaimOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUnclaimOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unclaimOrder>>, TError,{pathParams: UnclaimOrderPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unclaimOrder>>, TError,{pathParams: UnclaimOrderPathParameters}, TContext> => {

const mutationKey = ['unclaimOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unclaimOrder>>, {pathParams: UnclaimOrderPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  unclaimOrder(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnclaimOrderMutationResult = NonNullable<Awaited<ReturnType<typeof unclaimOrder>>>

    export type UnclaimOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Unclaim Order
 */
export const useUnclaimOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unclaimOrder>>, TError,{pathParams: UnclaimOrderPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unclaimOrder>>,
        TError,
        {pathParams: UnclaimOrderPathParameters},
        TContext
      > => {
      return useMutation(getUnclaimOrderMutationOptions(options), queryClient);
    }
    export type ungroupOrderResponse204 = {
  data: void
  status: 204
}

export type ungroupOrderResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type ungroupOrderResponseSuccess = (ungroupOrderResponse204) & {
  headers: Headers;
};
export type ungroupOrderResponseError = (ungroupOrderResponseDefault) & {
  headers: Headers;
};

export type ungroupOrderResponse = ungroupOrderResponseSuccess

export const getUngroupOrderUrl = ({ orderId }: UngroupOrderPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/ungroup`
}

/**
 * Dissolves a group parent order (GPO) by canceling it without canceling its members, releasing them back to the blotter to be re-grouped or executed individually. Only a zero-fill, non-terminal group parent can be ungrouped — once any quantity fills, the group must be cancelled instead. The cancel is asynchronous: a success response means orders-api accepted it, and the parent leaves order queries once the cancel round-trips through the OEMS.
 * @summary Ungroup Order
 */
export const ungroupOrder = async ({ orderId }: UngroupOrderPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<ungroupOrderResponse> => {

  return customFetch<ungroupOrderResponse>(getUngroupOrderUrl({ orderId }),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUngroupOrderMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ungroupOrder>>, TError,{pathParams: UngroupOrderPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof ungroupOrder>>, TError,{pathParams: UngroupOrderPathParameters}, TContext> => {

const mutationKey = ['ungroupOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ungroupOrder>>, {pathParams: UngroupOrderPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  ungroupOrder(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UngroupOrderMutationResult = NonNullable<Awaited<ReturnType<typeof ungroupOrder>>>

    export type UngroupOrderMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Ungroup Order
 */
export const useUngroupOrder = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ungroupOrder>>, TError,{pathParams: UngroupOrderPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ungroupOrder>>,
        TError,
        {pathParams: UngroupOrderPathParameters},
        TContext
      > => {
      return useMutation(getUngroupOrderMutationOptions(options), queryClient);
    }
    export type getOrderValidationFlagsResponse200 = {
  data: ValidationFlagsResponseBody
  status: 200
}

export type getOrderValidationFlagsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getOrderValidationFlagsResponseSuccess = (getOrderValidationFlagsResponse200) & {
  headers: Headers;
};
export type getOrderValidationFlagsResponseError = (getOrderValidationFlagsResponseDefault) & {
  headers: Headers;
};

export type getOrderValidationFlagsResponse = getOrderValidationFlagsResponseSuccess

export const getGetOrderValidationFlagsUrl = ({ orderId }: GetOrderValidationFlagsPathParameters,) => {




  return `/auth/v1/trading/orders/${orderId}/validation-flags`
}

/**
 * Returns the outcome of a parent order's automated validation: the failed validation control messages from its FlaggedOnValidation event (trading_validation_flags), and how any resulting manual review was resolved. Responds 200 with status 'passed' or 'auto_rejected', an empty messages list and a null flagged_at when the order was never flagged.
 * @summary Get Order Validation Flags
 */
export const getOrderValidationFlags = async ({ orderId }: GetOrderValidationFlagsPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getOrderValidationFlagsResponse> => {

  return customFetch<getOrderValidationFlagsResponse>(getGetOrderValidationFlagsUrl({ orderId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderValidationFlagsQueryKey = ({ orderId }: GetOrderValidationFlagsPathParameters,) => {
    return [
    `/auth/v1/trading/orders/${orderId}/validation-flags`
    ] as const;
    }


export const getGetOrderValidationFlagsQueryOptions = <TData = Awaited<ReturnType<typeof getOrderValidationFlags>>, TError = ErrorType<HumaAPIError>>({ orderId }: GetOrderValidationFlagsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderValidationFlagsQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderValidationFlags>>> = ({ signal }) => getOrderValidationFlags({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderValidationFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderValidationFlags>>>
export type GetOrderValidationFlagsQueryError = ErrorType<HumaAPIError>


export function useGetOrderValidationFlags<TData = Awaited<ReturnType<typeof getOrderValidationFlags>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderValidationFlagsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderValidationFlags>>,
          TError,
          Awaited<ReturnType<typeof getOrderValidationFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderValidationFlags<TData = Awaited<ReturnType<typeof getOrderValidationFlags>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderValidationFlagsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderValidationFlags>>,
          TError,
          Awaited<ReturnType<typeof getOrderValidationFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderValidationFlags<TData = Awaited<ReturnType<typeof getOrderValidationFlags>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderValidationFlagsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Order Validation Flags
 */

export function useGetOrderValidationFlags<TData = Awaited<ReturnType<typeof getOrderValidationFlags>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: GetOrderValidationFlagsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderValidationFlagsQueryOptions({ orderId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrderValidationFlagsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrderValidationFlags>>, TError = ErrorType<HumaAPIError>>({ orderId }: GetOrderValidationFlagsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderValidationFlagsQueryKey({ orderId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderValidationFlags>>> = ({ signal }) => getOrderValidationFlags({ orderId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderValidationFlagsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderValidationFlags>>>
export type GetOrderValidationFlagsSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetOrderValidationFlagsSuspense<TData = Awaited<ReturnType<typeof getOrderValidationFlags>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderValidationFlagsPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderValidationFlagsSuspense<TData = Awaited<ReturnType<typeof getOrderValidationFlags>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderValidationFlagsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderValidationFlagsSuspense<TData = Awaited<ReturnType<typeof getOrderValidationFlags>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetOrderValidationFlagsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Order Validation Flags
 */

export function useGetOrderValidationFlagsSuspense<TData = Awaited<ReturnType<typeof getOrderValidationFlags>>, TError = ErrorType<HumaAPIError>>(
 { orderId }: GetOrderValidationFlagsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrderValidationFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderValidationFlagsSuspenseQueryOptions({ orderId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listPrincipalAccountAssignmentRulesTreesResponse200 = {
  data: PrincipalAccountAssignmentRulesListResponseBody
  status: 200
}

export type listPrincipalAccountAssignmentRulesTreesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listPrincipalAccountAssignmentRulesTreesResponseSuccess = (listPrincipalAccountAssignmentRulesTreesResponse200) & {
  headers: Headers;
};
export type listPrincipalAccountAssignmentRulesTreesResponseError = (listPrincipalAccountAssignmentRulesTreesResponseDefault) & {
  headers: Headers;
};

export type listPrincipalAccountAssignmentRulesTreesResponse = listPrincipalAccountAssignmentRulesTreesResponseSuccess

export const getListPrincipalAccountAssignmentRulesTreesUrl = () => {




  return `/auth/v1/trading/principal-account-assignment`
}

/**
 * @summary List active principal_account_assignment_rules trees
 */
export const listPrincipalAccountAssignmentRulesTrees = async ( options?: Parameters<typeof customFetch>[1]): Promise<listPrincipalAccountAssignmentRulesTreesResponse> => {

  return customFetch<listPrincipalAccountAssignmentRulesTreesResponse>(getListPrincipalAccountAssignmentRulesTreesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPrincipalAccountAssignmentRulesTreesQueryKey = () => {
    return [
    `/auth/v1/trading/principal-account-assignment`
    ] as const;
    }


export const getListPrincipalAccountAssignmentRulesTreesQueryOptions = <TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPrincipalAccountAssignmentRulesTreesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>> = ({ signal }) => listPrincipalAccountAssignmentRulesTrees({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPrincipalAccountAssignmentRulesTreesQueryResult = NonNullable<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>>
export type ListPrincipalAccountAssignmentRulesTreesQueryError = ErrorType<HumaAPIError>


export function useListPrincipalAccountAssignmentRulesTrees<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>,
          TError,
          Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrincipalAccountAssignmentRulesTrees<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>,
          TError,
          Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrincipalAccountAssignmentRulesTrees<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active principal_account_assignment_rules trees
 */

export function useListPrincipalAccountAssignmentRulesTrees<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPrincipalAccountAssignmentRulesTreesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPrincipalAccountAssignmentRulesTreesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPrincipalAccountAssignmentRulesTreesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>> = ({ signal }) => listPrincipalAccountAssignmentRulesTrees({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPrincipalAccountAssignmentRulesTreesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>>
export type ListPrincipalAccountAssignmentRulesTreesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListPrincipalAccountAssignmentRulesTreesSuspense<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrincipalAccountAssignmentRulesTreesSuspense<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrincipalAccountAssignmentRulesTreesSuspense<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active principal_account_assignment_rules trees
 */

export function useListPrincipalAccountAssignmentRulesTreesSuspense<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesTrees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPrincipalAccountAssignmentRulesTreesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type upsertPrincipalAccountAssignmentRulesTreeResponse200 = {
  data: PrincipalAccountAssignmentRulesTreeItem
  status: 200
}

export type upsertPrincipalAccountAssignmentRulesTreeResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type upsertPrincipalAccountAssignmentRulesTreeResponseSuccess = (upsertPrincipalAccountAssignmentRulesTreeResponse200) & {
  headers: Headers;
};
export type upsertPrincipalAccountAssignmentRulesTreeResponseError = (upsertPrincipalAccountAssignmentRulesTreeResponseDefault) & {
  headers: Headers;
};

export type upsertPrincipalAccountAssignmentRulesTreeResponse = upsertPrincipalAccountAssignmentRulesTreeResponseSuccess

export const getUpsertPrincipalAccountAssignmentRulesTreeUrl = (params?: UpsertPrincipalAccountAssignmentRulesTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/principal-account-assignment?${stringifiedParams}` : `/auth/v1/trading/principal-account-assignment`
}

/**
 * @summary Publish a new version of a principal_account_assignment_rules tree
 */
export const upsertPrincipalAccountAssignmentRulesTree = async (principalAccountAssignmentRulesUpsertRequestBody: PrincipalAccountAssignmentRulesUpsertRequestBody,
    params?: UpsertPrincipalAccountAssignmentRulesTreeParams, options?: Parameters<typeof customFetch>[1]): Promise<upsertPrincipalAccountAssignmentRulesTreeResponse> => {

  return customFetch<upsertPrincipalAccountAssignmentRulesTreeResponse>(getUpsertPrincipalAccountAssignmentRulesTreeUrl(params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(principalAccountAssignmentRulesUpsertRequestBody)
  }
);}





export const getUpsertPrincipalAccountAssignmentRulesTreeMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertPrincipalAccountAssignmentRulesTree>>, TError,{data: PrincipalAccountAssignmentRulesUpsertRequestBody;params?: UpsertPrincipalAccountAssignmentRulesTreeParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertPrincipalAccountAssignmentRulesTree>>, TError,{data: PrincipalAccountAssignmentRulesUpsertRequestBody;params?: UpsertPrincipalAccountAssignmentRulesTreeParams}, TContext> => {

const mutationKey = ['upsertPrincipalAccountAssignmentRulesTree'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertPrincipalAccountAssignmentRulesTree>>, {data: PrincipalAccountAssignmentRulesUpsertRequestBody;params?: UpsertPrincipalAccountAssignmentRulesTreeParams}> = (props) => {
          const {data,params} = props ?? {};

          return  upsertPrincipalAccountAssignmentRulesTree(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertPrincipalAccountAssignmentRulesTreeMutationResult = NonNullable<Awaited<ReturnType<typeof upsertPrincipalAccountAssignmentRulesTree>>>
    export type UpsertPrincipalAccountAssignmentRulesTreeMutationBody = PrincipalAccountAssignmentRulesUpsertRequestBody
    export type UpsertPrincipalAccountAssignmentRulesTreeMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Publish a new version of a principal_account_assignment_rules tree
 */
export const useUpsertPrincipalAccountAssignmentRulesTree = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertPrincipalAccountAssignmentRulesTree>>, TError,{data: PrincipalAccountAssignmentRulesUpsertRequestBody;params?: UpsertPrincipalAccountAssignmentRulesTreeParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertPrincipalAccountAssignmentRulesTree>>,
        TError,
        {data: PrincipalAccountAssignmentRulesUpsertRequestBody;params?: UpsertPrincipalAccountAssignmentRulesTreeParams},
        TContext
      > => {
      return useMutation(getUpsertPrincipalAccountAssignmentRulesTreeMutationOptions(options), queryClient);
    }
    export type resolveDefaultPrincipalBooksResponse200 = {
  data: ResolveDefaultPrincipalBooksResponseBody
  status: 200
}

export type resolveDefaultPrincipalBooksResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type resolveDefaultPrincipalBooksResponseSuccess = (resolveDefaultPrincipalBooksResponse200) & {
  headers: Headers;
};
export type resolveDefaultPrincipalBooksResponseError = (resolveDefaultPrincipalBooksResponseDefault) & {
  headers: Headers;
};

export type resolveDefaultPrincipalBooksResponse = resolveDefaultPrincipalBooksResponseSuccess

export const getResolveDefaultPrincipalBooksUrl = () => {




  return `/auth/v1/trading/principal-account-assignment/bulk/resolve`
}

/**
 * Answers, for each row, the principal book the clearer's principal account assignment rules pick, among the books the caller can see and trade. Rows answer in request order; a row with no default book says why.
 * @summary Resolve default principal books
 */
export const resolveDefaultPrincipalBooks = async (resolveDefaultPrincipalBooksRequestBody: ResolveDefaultPrincipalBooksRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<resolveDefaultPrincipalBooksResponse> => {

  return customFetch<resolveDefaultPrincipalBooksResponse>(getResolveDefaultPrincipalBooksUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resolveDefaultPrincipalBooksRequestBody)
  }
);}





export const getResolveDefaultPrincipalBooksMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveDefaultPrincipalBooks>>, TError,{data: ResolveDefaultPrincipalBooksRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveDefaultPrincipalBooks>>, TError,{data: ResolveDefaultPrincipalBooksRequestBody}, TContext> => {

const mutationKey = ['resolveDefaultPrincipalBooks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveDefaultPrincipalBooks>>, {data: ResolveDefaultPrincipalBooksRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  resolveDefaultPrincipalBooks(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveDefaultPrincipalBooksMutationResult = NonNullable<Awaited<ReturnType<typeof resolveDefaultPrincipalBooks>>>
    export type ResolveDefaultPrincipalBooksMutationBody = ResolveDefaultPrincipalBooksRequestBody
    export type ResolveDefaultPrincipalBooksMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Resolve default principal books
 */
export const useResolveDefaultPrincipalBooks = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveDefaultPrincipalBooks>>, TError,{data: ResolveDefaultPrincipalBooksRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resolveDefaultPrincipalBooks>>,
        TError,
        {data: ResolveDefaultPrincipalBooksRequestBody},
        TContext
      > => {
      return useMutation(getResolveDefaultPrincipalBooksMutationOptions(options), queryClient);
    }
    export type previewPrincipalAccountAssignmentRulesDecisionResponse200 = {
  data: PrincipalAccountAssignmentRulesPreviewResponseBody
  status: 200
}

export type previewPrincipalAccountAssignmentRulesDecisionResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type previewPrincipalAccountAssignmentRulesDecisionResponseSuccess = (previewPrincipalAccountAssignmentRulesDecisionResponse200) & {
  headers: Headers;
};
export type previewPrincipalAccountAssignmentRulesDecisionResponseError = (previewPrincipalAccountAssignmentRulesDecisionResponseDefault) & {
  headers: Headers;
};

export type previewPrincipalAccountAssignmentRulesDecisionResponse = previewPrincipalAccountAssignmentRulesDecisionResponseSuccess

export const getPreviewPrincipalAccountAssignmentRulesDecisionUrl = () => {




  return `/auth/v1/trading/principal-account-assignment/preview`
}

/**
 * @summary Evaluate a record against a draft principal_account_assignment_rules tree
 */
export const previewPrincipalAccountAssignmentRulesDecision = async (principalAccountAssignmentRulesPreviewRequestBody: PrincipalAccountAssignmentRulesPreviewRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<previewPrincipalAccountAssignmentRulesDecisionResponse> => {

  return customFetch<previewPrincipalAccountAssignmentRulesDecisionResponse>(getPreviewPrincipalAccountAssignmentRulesDecisionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(principalAccountAssignmentRulesPreviewRequestBody)
  }
);}





export const getPreviewPrincipalAccountAssignmentRulesDecisionMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewPrincipalAccountAssignmentRulesDecision>>, TError,{data: PrincipalAccountAssignmentRulesPreviewRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewPrincipalAccountAssignmentRulesDecision>>, TError,{data: PrincipalAccountAssignmentRulesPreviewRequestBody}, TContext> => {

const mutationKey = ['previewPrincipalAccountAssignmentRulesDecision'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewPrincipalAccountAssignmentRulesDecision>>, {data: PrincipalAccountAssignmentRulesPreviewRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  previewPrincipalAccountAssignmentRulesDecision(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewPrincipalAccountAssignmentRulesDecisionMutationResult = NonNullable<Awaited<ReturnType<typeof previewPrincipalAccountAssignmentRulesDecision>>>
    export type PreviewPrincipalAccountAssignmentRulesDecisionMutationBody = PrincipalAccountAssignmentRulesPreviewRequestBody
    export type PreviewPrincipalAccountAssignmentRulesDecisionMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Evaluate a record against a draft principal_account_assignment_rules tree
 */
export const usePreviewPrincipalAccountAssignmentRulesDecision = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewPrincipalAccountAssignmentRulesDecision>>, TError,{data: PrincipalAccountAssignmentRulesPreviewRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewPrincipalAccountAssignmentRulesDecision>>,
        TError,
        {data: PrincipalAccountAssignmentRulesPreviewRequestBody},
        TContext
      > => {
      return useMutation(getPreviewPrincipalAccountAssignmentRulesDecisionMutationOptions(options), queryClient);
    }
    export type listPrincipalAccountAssignmentRulesSupportedExpressionsResponse200 = {
  data: PrincipalAccountAssignmentRulesSupportedExpressionsResponseBody
  status: 200
}

export type listPrincipalAccountAssignmentRulesSupportedExpressionsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listPrincipalAccountAssignmentRulesSupportedExpressionsResponseSuccess = (listPrincipalAccountAssignmentRulesSupportedExpressionsResponse200) & {
  headers: Headers;
};
export type listPrincipalAccountAssignmentRulesSupportedExpressionsResponseError = (listPrincipalAccountAssignmentRulesSupportedExpressionsResponseDefault) & {
  headers: Headers;
};

export type listPrincipalAccountAssignmentRulesSupportedExpressionsResponse = listPrincipalAccountAssignmentRulesSupportedExpressionsResponseSuccess

export const getListPrincipalAccountAssignmentRulesSupportedExpressionsUrl = () => {




  return `/auth/v1/trading/principal-account-assignment/supported-expressions`
}

/**
 * @summary List the fields a principal_account_assignment_rules condition may branch on
 */
export const listPrincipalAccountAssignmentRulesSupportedExpressions = async ( options?: Parameters<typeof customFetch>[1]): Promise<listPrincipalAccountAssignmentRulesSupportedExpressionsResponse> => {

  return customFetch<listPrincipalAccountAssignmentRulesSupportedExpressionsResponse>(getListPrincipalAccountAssignmentRulesSupportedExpressionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPrincipalAccountAssignmentRulesSupportedExpressionsQueryKey = () => {
    return [
    `/auth/v1/trading/principal-account-assignment/supported-expressions`
    ] as const;
    }


export const getListPrincipalAccountAssignmentRulesSupportedExpressionsQueryOptions = <TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPrincipalAccountAssignmentRulesSupportedExpressionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>> = ({ signal }) => listPrincipalAccountAssignmentRulesSupportedExpressions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPrincipalAccountAssignmentRulesSupportedExpressionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>>
export type ListPrincipalAccountAssignmentRulesSupportedExpressionsQueryError = ErrorType<HumaAPIError>


export function useListPrincipalAccountAssignmentRulesSupportedExpressions<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>,
          TError,
          Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrincipalAccountAssignmentRulesSupportedExpressions<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>,
          TError,
          Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrincipalAccountAssignmentRulesSupportedExpressions<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the fields a principal_account_assignment_rules condition may branch on
 */

export function useListPrincipalAccountAssignmentRulesSupportedExpressions<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPrincipalAccountAssignmentRulesSupportedExpressionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPrincipalAccountAssignmentRulesSupportedExpressionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPrincipalAccountAssignmentRulesSupportedExpressionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>> = ({ signal }) => listPrincipalAccountAssignmentRulesSupportedExpressions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPrincipalAccountAssignmentRulesSupportedExpressionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>>
export type ListPrincipalAccountAssignmentRulesSupportedExpressionsSuspenseQueryError = ErrorType<HumaAPIError>


export function useListPrincipalAccountAssignmentRulesSupportedExpressionsSuspense<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrincipalAccountAssignmentRulesSupportedExpressionsSuspense<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrincipalAccountAssignmentRulesSupportedExpressionsSuspense<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the fields a principal_account_assignment_rules condition may branch on
 */

export function useListPrincipalAccountAssignmentRulesSupportedExpressionsSuspense<TData = Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPrincipalAccountAssignmentRulesSupportedExpressions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPrincipalAccountAssignmentRulesSupportedExpressionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type archivePrincipalAccountAssignmentRulesTreeResponse200 = {
  data: PrincipalAccountAssignmentRulesTreeItem
  status: 200
}

export type archivePrincipalAccountAssignmentRulesTreeResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type archivePrincipalAccountAssignmentRulesTreeResponseSuccess = (archivePrincipalAccountAssignmentRulesTreeResponse200) & {
  headers: Headers;
};
export type archivePrincipalAccountAssignmentRulesTreeResponseError = (archivePrincipalAccountAssignmentRulesTreeResponseDefault) & {
  headers: Headers;
};

export type archivePrincipalAccountAssignmentRulesTreeResponse = archivePrincipalAccountAssignmentRulesTreeResponseSuccess

export const getArchivePrincipalAccountAssignmentRulesTreeUrl = ({ treeId }: ArchivePrincipalAccountAssignmentRulesTreePathParameters,) => {




  return `/auth/v1/trading/principal-account-assignment/${treeId}`
}

/**
 * @summary Retire the live version of a principal_account_assignment_rules tree
 */
export const archivePrincipalAccountAssignmentRulesTree = async ({ treeId }: ArchivePrincipalAccountAssignmentRulesTreePathParameters, options?: Parameters<typeof customFetch>[1]): Promise<archivePrincipalAccountAssignmentRulesTreeResponse> => {

  return customFetch<archivePrincipalAccountAssignmentRulesTreeResponse>(getArchivePrincipalAccountAssignmentRulesTreeUrl({ treeId }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getArchivePrincipalAccountAssignmentRulesTreeMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archivePrincipalAccountAssignmentRulesTree>>, TError,{pathParams: ArchivePrincipalAccountAssignmentRulesTreePathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archivePrincipalAccountAssignmentRulesTree>>, TError,{pathParams: ArchivePrincipalAccountAssignmentRulesTreePathParameters}, TContext> => {

const mutationKey = ['archivePrincipalAccountAssignmentRulesTree'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archivePrincipalAccountAssignmentRulesTree>>, {pathParams: ArchivePrincipalAccountAssignmentRulesTreePathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  archivePrincipalAccountAssignmentRulesTree(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchivePrincipalAccountAssignmentRulesTreeMutationResult = NonNullable<Awaited<ReturnType<typeof archivePrincipalAccountAssignmentRulesTree>>>

    export type ArchivePrincipalAccountAssignmentRulesTreeMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Retire the live version of a principal_account_assignment_rules tree
 */
export const useArchivePrincipalAccountAssignmentRulesTree = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archivePrincipalAccountAssignmentRulesTree>>, TError,{pathParams: ArchivePrincipalAccountAssignmentRulesTreePathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archivePrincipalAccountAssignmentRulesTree>>,
        TError,
        {pathParams: ArchivePrincipalAccountAssignmentRulesTreePathParameters},
        TContext
      > => {
      return useMutation(getArchivePrincipalAccountAssignmentRulesTreeMutationOptions(options), queryClient);
    }
    export type getPrincipalAccountAssignmentRulesTreeResponse200 = {
  data: PrincipalAccountAssignmentRulesGetResponseBody
  status: 200
}

export type getPrincipalAccountAssignmentRulesTreeResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getPrincipalAccountAssignmentRulesTreeResponseSuccess = (getPrincipalAccountAssignmentRulesTreeResponse200) & {
  headers: Headers;
};
export type getPrincipalAccountAssignmentRulesTreeResponseError = (getPrincipalAccountAssignmentRulesTreeResponseDefault) & {
  headers: Headers;
};

export type getPrincipalAccountAssignmentRulesTreeResponse = getPrincipalAccountAssignmentRulesTreeResponseSuccess

export const getGetPrincipalAccountAssignmentRulesTreeUrl = ({ treeId }: GetPrincipalAccountAssignmentRulesTreePathParameters,) => {




  return `/auth/v1/trading/principal-account-assignment/${treeId}`
}

/**
 * @summary Read a principal_account_assignment_rules tree's version chain
 */
export const getPrincipalAccountAssignmentRulesTree = async ({ treeId }: GetPrincipalAccountAssignmentRulesTreePathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getPrincipalAccountAssignmentRulesTreeResponse> => {

  return customFetch<getPrincipalAccountAssignmentRulesTreeResponse>(getGetPrincipalAccountAssignmentRulesTreeUrl({ treeId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPrincipalAccountAssignmentRulesTreeQueryKey = ({ treeId }: GetPrincipalAccountAssignmentRulesTreePathParameters,) => {
    return [
    `/auth/v1/trading/principal-account-assignment/${treeId}`
    ] as const;
    }


export const getGetPrincipalAccountAssignmentRulesTreeQueryOptions = <TData = Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError = ErrorType<HumaAPIError>>({ treeId }: GetPrincipalAccountAssignmentRulesTreePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPrincipalAccountAssignmentRulesTreeQueryKey({ treeId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>> = ({ signal }) => getPrincipalAccountAssignmentRulesTree({ treeId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: treeId !== null && treeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPrincipalAccountAssignmentRulesTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>>
export type GetPrincipalAccountAssignmentRulesTreeQueryError = ErrorType<HumaAPIError>


export function useGetPrincipalAccountAssignmentRulesTree<TData = Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPrincipalAccountAssignmentRulesTreePathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>,
          TError,
          Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPrincipalAccountAssignmentRulesTree<TData = Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPrincipalAccountAssignmentRulesTreePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>,
          TError,
          Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPrincipalAccountAssignmentRulesTree<TData = Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPrincipalAccountAssignmentRulesTreePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a principal_account_assignment_rules tree's version chain
 */

export function useGetPrincipalAccountAssignmentRulesTree<TData = Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError = ErrorType<HumaAPIError>>(
 { treeId }: GetPrincipalAccountAssignmentRulesTreePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPrincipalAccountAssignmentRulesTreeQueryOptions({ treeId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPrincipalAccountAssignmentRulesTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError = ErrorType<HumaAPIError>>({ treeId }: GetPrincipalAccountAssignmentRulesTreePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPrincipalAccountAssignmentRulesTreeQueryKey({ treeId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>> = ({ signal }) => getPrincipalAccountAssignmentRulesTree({ treeId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPrincipalAccountAssignmentRulesTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>>
export type GetPrincipalAccountAssignmentRulesTreeSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetPrincipalAccountAssignmentRulesTreeSuspense<TData = Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPrincipalAccountAssignmentRulesTreePathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPrincipalAccountAssignmentRulesTreeSuspense<TData = Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPrincipalAccountAssignmentRulesTreePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPrincipalAccountAssignmentRulesTreeSuspense<TData = Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetPrincipalAccountAssignmentRulesTreePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a principal_account_assignment_rules tree's version chain
 */

export function useGetPrincipalAccountAssignmentRulesTreeSuspense<TData = Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError = ErrorType<HumaAPIError>>(
 { treeId }: GetPrincipalAccountAssignmentRulesTreePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPrincipalAccountAssignmentRulesTree>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPrincipalAccountAssignmentRulesTreeSuspenseQueryOptions({ treeId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type hydrateQuotesPlatformResponse200 = {
  data: HydratedQuote[] | null
  status: 200
}

export type hydrateQuotesPlatformResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type hydrateQuotesPlatformResponseSuccess = (hydrateQuotesPlatformResponse200) & {
  headers: Headers;
};
export type hydrateQuotesPlatformResponseError = (hydrateQuotesPlatformResponseDefault) & {
  headers: Headers;
};

export type hydrateQuotesPlatformResponse = hydrateQuotesPlatformResponseSuccess

export const getHydrateQuotesPlatformUrl = () => {




  return `/auth/v1/trading/quotes/hydrate`
}

/**
 * Hydrates pre-fee quotes with post-fee pricing, yield, and spread data.
 * @summary Hydrate Quotes
 */
export const hydrateQuotesPlatform = async (hydrateQuotesRequest: HydrateQuotesRequest, options?: Parameters<typeof customFetch>[1]): Promise<hydrateQuotesPlatformResponse> => {

  return customFetch<hydrateQuotesPlatformResponse>(getHydrateQuotesPlatformUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hydrateQuotesRequest)
  }
);}





export const getHydrateQuotesPlatformMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hydrateQuotesPlatform>>, TError,{data: HydrateQuotesRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hydrateQuotesPlatform>>, TError,{data: HydrateQuotesRequest}, TContext> => {

const mutationKey = ['hydrateQuotesPlatform'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hydrateQuotesPlatform>>, {data: HydrateQuotesRequest}> = (props) => {
          const {data} = props ?? {};

          return  hydrateQuotesPlatform(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HydrateQuotesPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof hydrateQuotesPlatform>>>
    export type HydrateQuotesPlatformMutationBody = HydrateQuotesRequest
    export type HydrateQuotesPlatformMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Hydrate Quotes
 */
export const useHydrateQuotesPlatform = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hydrateQuotesPlatform>>, TError,{data: HydrateQuotesRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hydrateQuotesPlatform>>,
        TError,
        {data: HydrateQuotesRequest},
        TContext
      > => {
      return useMutation(getHydrateQuotesPlatformMutationOptions(options), queryClient);
    }
    export type listTradingRepFeeSchedulesResponse200 = {
  data: ListFeeSchedulesResponseBody
  status: 200
}

export type listTradingRepFeeSchedulesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listTradingRepFeeSchedulesResponseSuccess = (listTradingRepFeeSchedulesResponse200) & {
  headers: Headers;
};
export type listTradingRepFeeSchedulesResponseError = (listTradingRepFeeSchedulesResponseDefault) & {
  headers: Headers;
};

export type listTradingRepFeeSchedulesResponse = listTradingRepFeeSchedulesResponseSuccess

export const getListTradingRepFeeSchedulesUrl = (params: ListTradingRepFeeSchedulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/rep-fee-schedules?${stringifiedParams}` : `/auth/v1/trading/rep-fee-schedules`
}

/**
 * Returns the fee schedule version currently in effect. At most one version applies at any instant, so this returns zero or one entry; an empty list means no schedule is in force for the risk group. Use the scheduled endpoint for replacements that have not taken effect yet.
 * @summary List active rep fee schedules
 */
export const listTradingRepFeeSchedules = async (params: ListTradingRepFeeSchedulesParams, options?: Parameters<typeof customFetch>[1]): Promise<listTradingRepFeeSchedulesResponse> => {

  return customFetch<listTradingRepFeeSchedulesResponse>(getListTradingRepFeeSchedulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTradingRepFeeSchedulesQueryKey = (params?: ListTradingRepFeeSchedulesParams,) => {
    return [
    `/auth/v1/trading/rep-fee-schedules`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTradingRepFeeSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingRepFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>> = ({ signal }) => listTradingRepFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingRepFeeSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>>
export type ListTradingRepFeeSchedulesQueryError = ErrorType<HumaAPIError>


export function useListTradingRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingRepFeeSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingRepFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingRepFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingRepFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingRepFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active rep fee schedules
 */

export function useListTradingRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingRepFeeSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTradingRepFeeSchedulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingRepFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>> = ({ signal }) => listTradingRepFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingRepFeeSchedulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>>
export type ListTradingRepFeeSchedulesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListTradingRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingRepFeeSchedulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active rep fee schedules
 */

export function useListTradingRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingRepFeeSchedulesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listTradingArchivedRepFeeSchedulesResponse200 = {
  data: ListFeeSchedulesResponseBody
  status: 200
}

export type listTradingArchivedRepFeeSchedulesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listTradingArchivedRepFeeSchedulesResponseSuccess = (listTradingArchivedRepFeeSchedulesResponse200) & {
  headers: Headers;
};
export type listTradingArchivedRepFeeSchedulesResponseError = (listTradingArchivedRepFeeSchedulesResponseDefault) & {
  headers: Headers;
};

export type listTradingArchivedRepFeeSchedulesResponse = listTradingArchivedRepFeeSchedulesResponseSuccess

export const getListTradingArchivedRepFeeSchedulesUrl = (params: ListTradingArchivedRepFeeSchedulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/rep-fee-schedules/archived?${stringifiedParams}` : `/auth/v1/trading/rep-fee-schedules/archived`
}

/**
 * Returns the fee schedule versions whose effective window has already closed, most recently retired first, each with the window it was in force over and who created it. Versions that never applied are omitted. Page further back with `before` and `limit`.
 * @summary List archived rep fee schedules
 */
export const listTradingArchivedRepFeeSchedules = async (params: ListTradingArchivedRepFeeSchedulesParams, options?: Parameters<typeof customFetch>[1]): Promise<listTradingArchivedRepFeeSchedulesResponse> => {

  return customFetch<listTradingArchivedRepFeeSchedulesResponse>(getListTradingArchivedRepFeeSchedulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTradingArchivedRepFeeSchedulesQueryKey = (params?: ListTradingArchivedRepFeeSchedulesParams,) => {
    return [
    `/auth/v1/trading/rep-fee-schedules/archived`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTradingArchivedRepFeeSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingArchivedRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingArchivedRepFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>> = ({ signal }) => listTradingArchivedRepFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingArchivedRepFeeSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>>
export type ListTradingArchivedRepFeeSchedulesQueryError = ErrorType<HumaAPIError>


export function useListTradingArchivedRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedRepFeeSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingArchivedRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingArchivedRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List archived rep fee schedules
 */

export function useListTradingArchivedRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingArchivedRepFeeSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTradingArchivedRepFeeSchedulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingArchivedRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingArchivedRepFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>> = ({ signal }) => listTradingArchivedRepFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingArchivedRepFeeSchedulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>>
export type ListTradingArchivedRepFeeSchedulesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListTradingArchivedRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedRepFeeSchedulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingArchivedRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingArchivedRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List archived rep fee schedules
 */

export function useListTradingArchivedRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingArchivedRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingArchivedRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingArchivedRepFeeSchedulesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listTradingScheduledRepFeeSchedulesResponse200 = {
  data: ListFeeSchedulesResponseBody
  status: 200
}

export type listTradingScheduledRepFeeSchedulesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listTradingScheduledRepFeeSchedulesResponseSuccess = (listTradingScheduledRepFeeSchedulesResponse200) & {
  headers: Headers;
};
export type listTradingScheduledRepFeeSchedulesResponseError = (listTradingScheduledRepFeeSchedulesResponseDefault) & {
  headers: Headers;
};

export type listTradingScheduledRepFeeSchedulesResponse = listTradingScheduledRepFeeSchedulesResponseSuccess

export const getListTradingScheduledRepFeeSchedulesUrl = (params: ListTradingScheduledRepFeeSchedulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/rep-fee-schedules/scheduled?${stringifiedParams}` : `/auth/v1/trading/rep-fee-schedules/scheduled`
}

/**
 * Returns the fee schedule versions scheduled to take effect later, earliest first. Versions superseded before they took effect are omitted; today at most one is ever pending.
 * @summary List scheduled rep fee schedules
 */
export const listTradingScheduledRepFeeSchedules = async (params: ListTradingScheduledRepFeeSchedulesParams, options?: Parameters<typeof customFetch>[1]): Promise<listTradingScheduledRepFeeSchedulesResponse> => {

  return customFetch<listTradingScheduledRepFeeSchedulesResponse>(getListTradingScheduledRepFeeSchedulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTradingScheduledRepFeeSchedulesQueryKey = (params?: ListTradingScheduledRepFeeSchedulesParams,) => {
    return [
    `/auth/v1/trading/rep-fee-schedules/scheduled`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTradingScheduledRepFeeSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingScheduledRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingScheduledRepFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>> = ({ signal }) => listTradingScheduledRepFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingScheduledRepFeeSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>>
export type ListTradingScheduledRepFeeSchedulesQueryError = ErrorType<HumaAPIError>


export function useListTradingScheduledRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledRepFeeSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingScheduledRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>,
          TError,
          Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingScheduledRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List scheduled rep fee schedules
 */

export function useListTradingScheduledRepFeeSchedules<TData = Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledRepFeeSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingScheduledRepFeeSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTradingScheduledRepFeeSchedulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(params: ListTradingScheduledRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingScheduledRepFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>> = ({ signal }) => listTradingScheduledRepFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingScheduledRepFeeSchedulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>>
export type ListTradingScheduledRepFeeSchedulesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListTradingScheduledRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledRepFeeSchedulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingScheduledRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingScheduledRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List scheduled rep fee schedules
 */

export function useListTradingScheduledRepFeeSchedulesSuspense<TData = Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError = ErrorType<HumaAPIError>>(
 params: ListTradingScheduledRepFeeSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingScheduledRepFeeSchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingScheduledRepFeeSchedulesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type bulkLookupRfqConfigResponse200 = {
  data: BulkLookupRfqConfigResponseBody
  status: 200
}

export type bulkLookupRfqConfigResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type bulkLookupRfqConfigResponseSuccess = (bulkLookupRfqConfigResponse200) & {
  headers: Headers;
};
export type bulkLookupRfqConfigResponseError = (bulkLookupRfqConfigResponseDefault) & {
  headers: Headers;
};

export type bulkLookupRfqConfigResponse = bulkLookupRfqConfigResponseSuccess

export const getBulkLookupRfqConfigUrl = () => {




  return `/auth/v1/trading/rfq-config/lookup`
}

/**
 * Given a list of (isin, price_type) lookups and a venue MPID, returns the per-instrument config needed to render the RFQ form: asset class, asset class subtype, MKTX product (when MKTX), and the three timer dropdown options (`asap_due_in`, `bin_due_in`, `bin_firm_for`). Currently MKTX-only; non-MKTX venues return 400.
 * @summary Bulk lookup RFQ form config (asset class + timer dropdown options) for (isin, price_type) pairs
 */
export const bulkLookupRfqConfig = async (bulkLookupRfqConfigRequestBody: BulkLookupRfqConfigRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<bulkLookupRfqConfigResponse> => {

  return customFetch<bulkLookupRfqConfigResponse>(getBulkLookupRfqConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkLookupRfqConfigRequestBody)
  }
);}





export const getBulkLookupRfqConfigMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkLookupRfqConfig>>, TError,{data: BulkLookupRfqConfigRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkLookupRfqConfig>>, TError,{data: BulkLookupRfqConfigRequestBody}, TContext> => {

const mutationKey = ['bulkLookupRfqConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkLookupRfqConfig>>, {data: BulkLookupRfqConfigRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  bulkLookupRfqConfig(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkLookupRfqConfigMutationResult = NonNullable<Awaited<ReturnType<typeof bulkLookupRfqConfig>>>
    export type BulkLookupRfqConfigMutationBody = BulkLookupRfqConfigRequestBody
    export type BulkLookupRfqConfigMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Bulk lookup RFQ form config (asset class + timer dropdown options) for (isin, price_type) pairs
 */
export const useBulkLookupRfqConfig = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkLookupRfqConfig>>, TError,{data: BulkLookupRfqConfigRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkLookupRfqConfig>>,
        TError,
        {data: BulkLookupRfqConfigRequestBody},
        TContext
      > => {
      return useMutation(getBulkLookupRfqConfigMutationOptions(options), queryClient);
    }
    export type submitListRfqResponse202 = {
  data: void
  status: 202
}

export type submitListRfqResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 202>
}

export type submitListRfqResponseSuccess = (submitListRfqResponse202) & {
  headers: Headers;
};
export type submitListRfqResponseError = (submitListRfqResponseDefault) & {
  headers: Headers;
};

export type submitListRfqResponse = submitListRfqResponseSuccess

export const getSubmitListRfqUrl = () => {




  return `/auth/v1/trading/rfq/list`
}

/**
 * Re-resolves a SORM order query plus an all/include/exclude selection, regroups it by the venue's asset-class classification through the same path the preview uses, and sends one RFQ per order for each configured group by forwarding to orders-api. The orders sent for are claimed for the caller. The send is asynchronous: a 202 means the RFQs were submitted, not that any has been answered — the orders move to pending on the blotter as they are accepted.
 * @summary Submit a list RFQ
 */
export const submitListRfq = async (listRfqSubmitRequestBody: ListRfqSubmitRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<submitListRfqResponse> => {

  return customFetch<submitListRfqResponse>(getSubmitListRfqUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(listRfqSubmitRequestBody)
  }
);}





export const getSubmitListRfqMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitListRfq>>, TError,{data: ListRfqSubmitRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitListRfq>>, TError,{data: ListRfqSubmitRequestBody}, TContext> => {

const mutationKey = ['submitListRfq'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitListRfq>>, {data: ListRfqSubmitRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  submitListRfq(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitListRfqMutationResult = NonNullable<Awaited<ReturnType<typeof submitListRfq>>>
    export type SubmitListRfqMutationBody = ListRfqSubmitRequestBody
    export type SubmitListRfqMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Submit a list RFQ
 */
export const useSubmitListRfq = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitListRfq>>, TError,{data: ListRfqSubmitRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitListRfq>>,
        TError,
        {data: ListRfqSubmitRequestBody},
        TContext
      > => {
      return useMutation(getSubmitListRfqMutationOptions(options), queryClient);
    }
    export type previewListRfqResponse200 = {
  data: ListRfqPreviewResponseBody
  status: 200
}

export type previewListRfqResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type previewListRfqResponseSuccess = (previewListRfqResponse200) & {
  headers: Headers;
};
export type previewListRfqResponseError = (previewListRfqResponseDefault) & {
  headers: Headers;
};

export type previewListRfqResponse = previewListRfqResponseSuccess

export const getPreviewListRfqUrl = () => {




  return `/auth/v1/trading/rfq/list/preview`
}

/**
 * Resolves a SORM order query plus an all/include/exclude selection to a set of orders (org-scoped, capped at 10,000), keeps the ones a list RFQ can be sent to this venue for, and reports the asset-class groups they fall into. A list RFQ is configured per group, and a group's members are decided by the venue's own classification of each instrument — which is why this cannot be expressed as a query the caller runs itself. Nothing is sent: this is the read the configuration screen is built from.
 * @summary Preview a list RFQ
 */
export const previewListRfq = async (listRfqPreviewRequestBody: ListRfqPreviewRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<previewListRfqResponse> => {

  return customFetch<previewListRfqResponse>(getPreviewListRfqUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(listRfqPreviewRequestBody)
  }
);}





export const getPreviewListRfqMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewListRfq>>, TError,{data: ListRfqPreviewRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewListRfq>>, TError,{data: ListRfqPreviewRequestBody}, TContext> => {

const mutationKey = ['previewListRfq'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewListRfq>>, {data: ListRfqPreviewRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  previewListRfq(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewListRfqMutationResult = NonNullable<Awaited<ReturnType<typeof previewListRfq>>>
    export type PreviewListRfqMutationBody = ListRfqPreviewRequestBody
    export type PreviewListRfqMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Preview a list RFQ
 */
export const usePreviewListRfq = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewListRfq>>, TError,{data: ListRfqPreviewRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewListRfq>>,
        TError,
        {data: ListRfqPreviewRequestBody},
        TContext
      > => {
      return useMutation(getPreviewListRfqMutationOptions(options), queryClient);
    }
    export type cancelRfqResponse204 = {
  data: void
  status: 204
}

export type cancelRfqResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 204>
}

export type cancelRfqResponseSuccess = (cancelRfqResponse204) & {
  headers: Headers;
};
export type cancelRfqResponseError = (cancelRfqResponseDefault) & {
  headers: Headers;
};

export type cancelRfqResponse = cancelRfqResponseSuccess

export const getCancelRfqUrl = ({ rfqId }: CancelRfqPathParameters,) => {




  return `/auth/v1/trading/rfq/${rfqId}`
}

/**
 * Requests the cancellation of one RFQ, by proxying the cancel to orders-api. An order may have several RFQs open at once, so the RFQ id identifies exactly which one is canceled — the others keep running. Asynchronous: a success response means the cancel was submitted, not that the RFQ is canceled.
 * @summary Cancel an RFQ
 */
export const cancelRfq = async ({ rfqId }: CancelRfqPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<cancelRfqResponse> => {

  return customFetch<cancelRfqResponse>(getCancelRfqUrl({ rfqId }),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCancelRfqMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRfq>>, TError,{pathParams: CancelRfqPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelRfq>>, TError,{pathParams: CancelRfqPathParameters}, TContext> => {

const mutationKey = ['cancelRfq'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelRfq>>, {pathParams: CancelRfqPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  cancelRfq(pathParams,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelRfqMutationResult = NonNullable<Awaited<ReturnType<typeof cancelRfq>>>

    export type CancelRfqMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Cancel an RFQ
 */
export const useCancelRfq = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRfq>>, TError,{pathParams: CancelRfqPathParameters}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelRfq>>,
        TError,
        {pathParams: CancelRfqPathParameters},
        TContext
      > => {
      return useMutation(getCancelRfqMutationOptions(options), queryClient);
    }
    export type previewTradingAttestationResponse200 = {
  data: EnrichedAttestation
  status: 200
}

export type previewTradingAttestationResponse404 = {
  data: HumaAPIError
  status: 404
}

export type previewTradingAttestationResponse422 = {
  data: HumaAPIError
  status: 422
}

export type previewTradingAttestationResponse500 = {
  data: HumaAPIError
  status: 500
}

export type previewTradingAttestationResponse502 = {
  data: HumaAPIError
  status: 502
}

export type previewTradingAttestationResponse503 = {
  data: HumaAPIError
  status: 503
}

export type previewTradingAttestationResponseSuccess = (previewTradingAttestationResponse200) & {
  headers: Headers;
};
export type previewTradingAttestationResponseError = (previewTradingAttestationResponse404 | previewTradingAttestationResponse422 | previewTradingAttestationResponse500 | previewTradingAttestationResponse502 | previewTradingAttestationResponse503) & {
  headers: Headers;
};

export type previewTradingAttestationResponse = previewTradingAttestationResponseSuccess

export const getPreviewTradingAttestationUrl = () => {




  return `/auth/v1/trading/risk/attestations/preview`
}

/**
 * Renders the node kinds whose content is minted per order — `pdf` and `muni_points` — so an admin authoring an attestation sees the real document rather than a placeholder.
 *
 * Renders the current published version: validation-engine reads it from a compacted topic, so an unsaved draft and a version published moments ago both answer 404. Structural preview of work in progress stays in the authoring UI.
 *
 * Rendering a `muni_points` node opens a real MuniPOINTS session, and the response carries presigned credentials: do not log or cache it.
 * @summary Render a saved attestation as an advisor would see it
 */
export const previewTradingAttestation = async (attestationPreviewSpec: AttestationPreviewSpec, options?: Parameters<typeof customFetch>[1]): Promise<previewTradingAttestationResponse> => {

  return customFetch<previewTradingAttestationResponse>(getPreviewTradingAttestationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(attestationPreviewSpec)
  }
);}





export const getPreviewTradingAttestationMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewTradingAttestation>>, TError,{data: AttestationPreviewSpec}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewTradingAttestation>>, TError,{data: AttestationPreviewSpec}, TContext> => {

const mutationKey = ['previewTradingAttestation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewTradingAttestation>>, {data: AttestationPreviewSpec}> = (props) => {
          const {data} = props ?? {};

          return  previewTradingAttestation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewTradingAttestationMutationResult = NonNullable<Awaited<ReturnType<typeof previewTradingAttestation>>>
    export type PreviewTradingAttestationMutationBody = AttestationPreviewSpec
    export type PreviewTradingAttestationMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Render a saved attestation as an advisor would see it
 */
export const usePreviewTradingAttestation = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewTradingAttestation>>, TError,{data: AttestationPreviewSpec}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewTradingAttestation>>,
        TError,
        {data: AttestationPreviewSpec},
        TContext
      > => {
      return useMutation(getPreviewTradingAttestationMutationOptions(options), queryClient);
    }
    export type createTradingAttestationUploadResponse201 = {
  data: AttestationUploadResponse
  status: 201
}

export type createTradingAttestationUploadResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 201>
}

export type createTradingAttestationUploadResponseSuccess = (createTradingAttestationUploadResponse201) & {
  headers: Headers;
};
export type createTradingAttestationUploadResponseError = (createTradingAttestationUploadResponseDefault) & {
  headers: Headers;
};

export type createTradingAttestationUploadResponse = createTradingAttestationUploadResponseSuccess

export const getCreateTradingAttestationUploadUrl = () => {




  return `/auth/v1/trading/risk/attestations/uploads`
}

/**
 * Mints an object key and a presigned URL for a `pdf` attestation node's document, then PUT the bytes straight to the returned upload_url with the same content_type sent here — the bytes never transit horizon or risky-business. Save the attestation with the returned s3_key: keys are write-once, so replacing a document means minting a new upload and therefore a new attestation version.
 * @summary Mint a presigned upload for an attestation document
 */
export const createTradingAttestationUpload = async (attestationUploadSpec: AttestationUploadSpec, options?: Parameters<typeof customFetch>[1]): Promise<createTradingAttestationUploadResponse> => {

  return customFetch<createTradingAttestationUploadResponse>(getCreateTradingAttestationUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(attestationUploadSpec)
  }
);}





export const getCreateTradingAttestationUploadMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTradingAttestationUpload>>, TError,{data: AttestationUploadSpec}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTradingAttestationUpload>>, TError,{data: AttestationUploadSpec}, TContext> => {

const mutationKey = ['createTradingAttestationUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTradingAttestationUpload>>, {data: AttestationUploadSpec}> = (props) => {
          const {data} = props ?? {};

          return  createTradingAttestationUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTradingAttestationUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createTradingAttestationUpload>>>
    export type CreateTradingAttestationUploadMutationBody = AttestationUploadSpec
    export type CreateTradingAttestationUploadMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Mint a presigned upload for an attestation document
 */
export const useCreateTradingAttestationUpload = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTradingAttestationUpload>>, TError,{data: AttestationUploadSpec}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTradingAttestationUpload>>,
        TError,
        {data: AttestationUploadSpec},
        TContext
      > => {
      return useMutation(getCreateTradingAttestationUploadMutationOptions(options), queryClient);
    }
    export type listTradersResponse200 = {
  data: ListTradersResponseBody
  status: 200
}

export type listTradersResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listTradersResponseSuccess = (listTradersResponse200) & {
  headers: Headers;
};
export type listTradersResponseError = (listTradersResponseDefault) & {
  headers: Headers;
};

export type listTradersResponse = listTradersResponseSuccess

export const getListTradersUrl = () => {




  return `/auth/v1/trading/traders`
}

/**
 * Lists the active traders in the caller's organization — the users an order can be assigned to. A trader is a user whose role grants the ability to create orders. Results are ordered by name.
 * @summary List Traders
 */
export const listTraders = async ( options?: Parameters<typeof customFetch>[1]): Promise<listTradersResponse> => {

  return customFetch<listTradersResponse>(getListTradersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTradersQueryKey = () => {
    return [
    `/auth/v1/trading/traders`
    ] as const;
    }


export const getListTradersQueryOptions = <TData = Awaited<ReturnType<typeof listTraders>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTraders>>> = ({ signal }) => listTraders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradersQueryResult = NonNullable<Awaited<ReturnType<typeof listTraders>>>
export type ListTradersQueryError = ErrorType<HumaAPIError>


export function useListTraders<TData = Awaited<ReturnType<typeof listTraders>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTraders>>,
          TError,
          Awaited<ReturnType<typeof listTraders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTraders<TData = Awaited<ReturnType<typeof listTraders>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTraders>>,
          TError,
          Awaited<ReturnType<typeof listTraders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTraders<TData = Awaited<ReturnType<typeof listTraders>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Traders
 */

export function useListTraders<TData = Awaited<ReturnType<typeof listTraders>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTradersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listTraders>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTraders>>> = ({ signal }) => listTraders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTraders>>>
export type ListTradersSuspenseQueryError = ErrorType<HumaAPIError>


export function useListTradersSuspense<TData = Awaited<ReturnType<typeof listTraders>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradersSuspense<TData = Awaited<ReturnType<typeof listTraders>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradersSuspense<TData = Awaited<ReturnType<typeof listTraders>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Traders
 */

export function useListTradersSuspense<TData = Awaited<ReturnType<typeof listTraders>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTraders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradersSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listTradingVenueConfigurationsResponse200 = {
  data: ListVenueConfigurationsResponseBody
  status: 200
}

export type listTradingVenueConfigurationsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listTradingVenueConfigurationsResponseSuccess = (listTradingVenueConfigurationsResponse200) & {
  headers: Headers;
};
export type listTradingVenueConfigurationsResponseError = (listTradingVenueConfigurationsResponseDefault) & {
  headers: Headers;
};

export type listTradingVenueConfigurationsResponse = listTradingVenueConfigurationsResponseSuccess

export const getListTradingVenueConfigurationsUrl = (params?: ListTradingVenueConfigurationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/venue-configurations?${stringifiedParams}` : `/auth/v1/trading/venue-configurations`
}

/**
 * Returns venue configurations: each venue's RFQ initiator configs (supported asset classes and RFQ types, sides, disclosure modes, the due / firm-until / expire time constraints that drive the RFQ form's timer options, and whether a venue trader id is required) plus its limit-order-book pull configs. With a risk_group_id, the list is scoped to the venues that risk group can reach, omitting any it has no enabled connection to. Without one, every venue the org is configured for is returned — for a list RFQ, which spans an org's risk groups and resolves reachability per order at submit.
 * @summary List venue configurations
 */
export const listTradingVenueConfigurations = async (params?: ListTradingVenueConfigurationsParams, options?: Parameters<typeof customFetch>[1]): Promise<listTradingVenueConfigurationsResponse> => {

  return customFetch<listTradingVenueConfigurationsResponse>(getListTradingVenueConfigurationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTradingVenueConfigurationsQueryKey = (params?: ListTradingVenueConfigurationsParams,) => {
    return [
    `/auth/v1/trading/venue-configurations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTradingVenueConfigurationsQueryOptions = <TData = Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError = ErrorType<HumaAPIError>>(params?: ListTradingVenueConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingVenueConfigurationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingVenueConfigurations>>> = ({ signal }) => listTradingVenueConfigurations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingVenueConfigurationsQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingVenueConfigurations>>>
export type ListTradingVenueConfigurationsQueryError = ErrorType<HumaAPIError>


export function useListTradingVenueConfigurations<TData = Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListTradingVenueConfigurationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingVenueConfigurations>>,
          TError,
          Awaited<ReturnType<typeof listTradingVenueConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingVenueConfigurations<TData = Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListTradingVenueConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingVenueConfigurations>>,
          TError,
          Awaited<ReturnType<typeof listTradingVenueConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingVenueConfigurations<TData = Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListTradingVenueConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List venue configurations
 */

export function useListTradingVenueConfigurations<TData = Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListTradingVenueConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingVenueConfigurationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTradingVenueConfigurationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError = ErrorType<HumaAPIError>>(params?: ListTradingVenueConfigurationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingVenueConfigurationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingVenueConfigurations>>> = ({ signal }) => listTradingVenueConfigurations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingVenueConfigurationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingVenueConfigurations>>>
export type ListTradingVenueConfigurationsSuspenseQueryError = ErrorType<HumaAPIError>


export function useListTradingVenueConfigurationsSuspense<TData = Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListTradingVenueConfigurationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingVenueConfigurationsSuspense<TData = Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListTradingVenueConfigurationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingVenueConfigurationsSuspense<TData = Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListTradingVenueConfigurationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List venue configurations
 */

export function useListTradingVenueConfigurationsSuspense<TData = Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError = ErrorType<HumaAPIError>>(
 params?: ListTradingVenueConfigurationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTradingVenueConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingVenueConfigurationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getFeeConfigResponse200 = {
  data: GetFeeConfigResponseBody
  status: 200
}

export type getFeeConfigResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getFeeConfigResponseSuccess = (getFeeConfigResponse200) & {
  headers: Headers;
};
export type getFeeConfigResponseError = (getFeeConfigResponseDefault) & {
  headers: Headers;
};

export type getFeeConfigResponse = getFeeConfigResponseSuccess

export const getGetFeeConfigUrl = ({ riskGroupId, instrumentId }: GetFeeConfigPathParameters,
    params: GetFeeConfigParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/trading/${riskGroupId}/fees/${instrumentId}?${stringifiedParams}` : `/auth/v1/trading/${riskGroupId}/fees/${instrumentId}`
}

/**
 * Returns the combined desk and rep fees configured for the given risk group and instrument. Side is required so side-specific rules resolve correctly; trade size is optional and, when omitted, the endpoint samples a neutral default, so returned fees may not reflect every amount-tiered rule.
 * @summary Get Fee Configuration
 */
export const getFeeConfig = async ({ riskGroupId, instrumentId }: GetFeeConfigPathParameters,
    params: GetFeeConfigParams, options?: Parameters<typeof customFetch>[1]): Promise<getFeeConfigResponse> => {

  return customFetch<getFeeConfigResponse>(getGetFeeConfigUrl({ riskGroupId, instrumentId },params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFeeConfigQueryKey = ({ riskGroupId, instrumentId }: GetFeeConfigPathParameters,
    params?: GetFeeConfigParams,) => {
    return [
    `/auth/v1/trading/${riskGroupId}/fees/${instrumentId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFeeConfigQueryOptions = <TData = Awaited<ReturnType<typeof getFeeConfig>>, TError = ErrorType<HumaAPIError>>({ riskGroupId, instrumentId }: GetFeeConfigPathParameters,
    params: GetFeeConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeeConfigQueryKey({ riskGroupId, instrumentId },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeeConfig>>> = ({ signal }) => getFeeConfig({ riskGroupId, instrumentId },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: riskGroupId !== null && riskGroupId !== undefined && instrumentId !== null && instrumentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeeConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getFeeConfig>>>
export type GetFeeConfigQueryError = ErrorType<HumaAPIError>


export function useGetFeeConfig<TData = Awaited<ReturnType<typeof getFeeConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetFeeConfigPathParameters,
    params: GetFeeConfigParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeeConfig>>,
          TError,
          Awaited<ReturnType<typeof getFeeConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeeConfig<TData = Awaited<ReturnType<typeof getFeeConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetFeeConfigPathParameters,
    params: GetFeeConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeeConfig>>,
          TError,
          Awaited<ReturnType<typeof getFeeConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeeConfig<TData = Awaited<ReturnType<typeof getFeeConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetFeeConfigPathParameters,
    params: GetFeeConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Fee Configuration
 */

export function useGetFeeConfig<TData = Awaited<ReturnType<typeof getFeeConfig>>, TError = ErrorType<HumaAPIError>>(
 { riskGroupId, instrumentId }: GetFeeConfigPathParameters,
    params: GetFeeConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeeConfigQueryOptions({ riskGroupId, instrumentId },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFeeConfigSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFeeConfig>>, TError = ErrorType<HumaAPIError>>({ riskGroupId, instrumentId }: GetFeeConfigPathParameters,
    params: GetFeeConfigParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeeConfigQueryKey({ riskGroupId, instrumentId },params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeeConfig>>> = ({ signal }) => getFeeConfig({ riskGroupId, instrumentId },params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeeConfigSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFeeConfig>>>
export type GetFeeConfigSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetFeeConfigSuspense<TData = Awaited<ReturnType<typeof getFeeConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetFeeConfigPathParameters,
    params: GetFeeConfigParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeeConfigSuspense<TData = Awaited<ReturnType<typeof getFeeConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetFeeConfigPathParameters,
    params: GetFeeConfigParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeeConfigSuspense<TData = Awaited<ReturnType<typeof getFeeConfig>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetFeeConfigPathParameters,
    params: GetFeeConfigParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Fee Configuration
 */

export function useGetFeeConfigSuspense<TData = Awaited<ReturnType<typeof getFeeConfig>>, TError = ErrorType<HumaAPIError>>(
 { riskGroupId, instrumentId }: GetFeeConfigPathParameters,
    params: GetFeeConfigParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeeConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeeConfigSuspenseQueryOptions({ riskGroupId, instrumentId },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getCurrentUserProfileResponse200 = {
  data: UserProfileResponse
  status: 200
}

export type getCurrentUserProfileResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getCurrentUserProfileResponseSuccess = (getCurrentUserProfileResponse200) & {
  headers: Headers;
};
export type getCurrentUserProfileResponseError = (getCurrentUserProfileResponseDefault) & {
  headers: Headers;
};

export type getCurrentUserProfileResponse = getCurrentUserProfileResponseSuccess

export const getGetCurrentUserProfileUrl = () => {




  return `/auth/v1/user-profile/self`
}

/**
 * @summary Get the caller's own user profile
 */
export const getCurrentUserProfile = async ( options?: Parameters<typeof customFetch>[1]): Promise<getCurrentUserProfileResponse> => {

  return customFetch<getCurrentUserProfileResponse>(getGetCurrentUserProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentUserProfileQueryKey = () => {
    return [
    `/auth/v1/user-profile/self`
    ] as const;
    }


export const getGetCurrentUserProfileQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUserProfile>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserProfile>>> = ({ signal }) => getCurrentUserProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUserProfile>>>
export type GetCurrentUserProfileQueryError = ErrorType<HumaAPIError>


export function useGetCurrentUserProfile<TData = Awaited<ReturnType<typeof getCurrentUserProfile>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserProfile<TData = Awaited<ReturnType<typeof getCurrentUserProfile>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserProfile<TData = Awaited<ReturnType<typeof getCurrentUserProfile>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the caller's own user profile
 */

export function useGetCurrentUserProfile<TData = Awaited<ReturnType<typeof getCurrentUserProfile>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCurrentUserProfileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUserProfile>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserProfile>>> = ({ signal }) => getCurrentUserProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUserProfile>>>
export type GetCurrentUserProfileSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetCurrentUserProfileSuspense<TData = Awaited<ReturnType<typeof getCurrentUserProfile>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserProfileSuspense<TData = Awaited<ReturnType<typeof getCurrentUserProfile>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserProfileSuspense<TData = Awaited<ReturnType<typeof getCurrentUserProfile>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the caller's own user profile
 */

export function useGetCurrentUserProfileSuspense<TData = Awaited<ReturnType<typeof getCurrentUserProfile>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserProfileSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type patchCurrentUserProfileResponse200 = {
  data: UserProfileResponse
  status: 200
}

export type patchCurrentUserProfileResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchCurrentUserProfileResponseSuccess = (patchCurrentUserProfileResponse200) & {
  headers: Headers;
};
export type patchCurrentUserProfileResponseError = (patchCurrentUserProfileResponseDefault) & {
  headers: Headers;
};

export type patchCurrentUserProfileResponse = patchCurrentUserProfileResponseSuccess

export const getPatchCurrentUserProfileUrl = () => {




  return `/auth/v1/user-profile/self`
}

/**
 * @summary Update the caller's own user profile
 */
export const patchCurrentUserProfile = async (patchCurrentUserProfileRequestBody: PatchCurrentUserProfileRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<patchCurrentUserProfileResponse> => {

  return customFetch<patchCurrentUserProfileResponse>(getPatchCurrentUserProfileUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchCurrentUserProfileRequestBody)
  }
);}





export const getPatchCurrentUserProfileMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCurrentUserProfile>>, TError,{data: PatchCurrentUserProfileRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCurrentUserProfile>>, TError,{data: PatchCurrentUserProfileRequestBody}, TContext> => {

const mutationKey = ['patchCurrentUserProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCurrentUserProfile>>, {data: PatchCurrentUserProfileRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  patchCurrentUserProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchCurrentUserProfileMutationResult = NonNullable<Awaited<ReturnType<typeof patchCurrentUserProfile>>>
    export type PatchCurrentUserProfileMutationBody = PatchCurrentUserProfileRequestBody
    export type PatchCurrentUserProfileMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Update the caller's own user profile
 */
export const usePatchCurrentUserProfile = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCurrentUserProfile>>, TError,{data: PatchCurrentUserProfileRequestBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCurrentUserProfile>>,
        TError,
        {data: PatchCurrentUserProfileRequestBody},
        TContext
      > => {
      return useMutation(getPatchCurrentUserProfileMutationOptions(options), queryClient);
    }
    export type getUserProfileResponse200 = {
  data: UserProfileResponse
  status: 200
}

export type getUserProfileResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getUserProfileResponseSuccess = (getUserProfileResponse200) & {
  headers: Headers;
};
export type getUserProfileResponseError = (getUserProfileResponseDefault) & {
  headers: Headers;
};

export type getUserProfileResponse = getUserProfileResponseSuccess

export const getGetUserProfileUrl = ({ userId }: GetUserProfilePathParameters,) => {




  return `/auth/v1/user-profile/${userId}`
}

/**
 * @summary Get a user profile by user ID
 */
export const getUserProfile = async ({ userId }: GetUserProfilePathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getUserProfileResponse> => {

  return customFetch<getUserProfileResponse>(getGetUserProfileUrl({ userId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserProfileQueryKey = ({ userId }: GetUserProfilePathParameters,) => {
    return [
    `/auth/v1/user-profile/${userId}`
    ] as const;
    }


export const getGetUserProfileQueryOptions = <TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<HumaAPIError>>({ userId }: GetUserProfilePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserProfileQueryKey({ userId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserProfile>>> = ({ signal }) => getUserProfile({ userId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getUserProfile>>>
export type GetUserProfileQueryError = ErrorType<HumaAPIError>


export function useGetUserProfile<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserProfilePathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getUserProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserProfile<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserProfilePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getUserProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserProfile<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserProfilePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user profile by user ID
 */

export function useGetUserProfile<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<HumaAPIError>>(
 { userId }: GetUserProfilePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserProfileQueryOptions({ userId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserProfileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<HumaAPIError>>({ userId }: GetUserProfilePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserProfileQueryKey({ userId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserProfile>>> = ({ signal }) => getUserProfile({ userId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserProfile>>>
export type GetUserProfileSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetUserProfileSuspense<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserProfilePathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserProfileSuspense<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserProfilePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserProfileSuspense<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserProfilePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user profile by user ID
 */

export function useGetUserProfileSuspense<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<HumaAPIError>>(
 { userId }: GetUserProfilePathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserProfileSuspenseQueryOptions({ userId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getUserByIdResponse200 = {
  data: User
  status: 200
}

export type getUserByIdResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getUserByIdResponseSuccess = (getUserByIdResponse200) & {
  headers: Headers;
};
export type getUserByIdResponseError = (getUserByIdResponseDefault) & {
  headers: Headers;
};

export type getUserByIdResponse = getUserByIdResponseSuccess

export const getGetUserByIdUrl = ({ userId }: GetUserByIdPathParameters,) => {




  return `/auth/v1/users/${userId}`
}

/**
 * @summary Get a user by ID
 */
export const getUserById = async ({ userId }: GetUserByIdPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getUserByIdResponse> => {

  return customFetch<getUserByIdResponse>(getGetUserByIdUrl({ userId }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserByIdQueryKey = ({ userId }: GetUserByIdPathParameters,) => {
    return [
    `/auth/v1/users/${userId}`
    ] as const;
    }


export const getGetUserByIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserById>>, TError = ErrorType<HumaAPIError>>({ userId }: GetUserByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserByIdQueryKey({ userId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserById>>> = ({ signal }) => getUserById({ userId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserById>>>
export type GetUserByIdQueryError = ErrorType<HumaAPIError>


export function useGetUserById<TData = Awaited<ReturnType<typeof getUserById>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserByIdPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserById>>,
          TError,
          Awaited<ReturnType<typeof getUserById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserById<TData = Awaited<ReturnType<typeof getUserById>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserById>>,
          TError,
          Awaited<ReturnType<typeof getUserById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserById<TData = Awaited<ReturnType<typeof getUserById>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user by ID
 */

export function useGetUserById<TData = Awaited<ReturnType<typeof getUserById>>, TError = ErrorType<HumaAPIError>>(
 { userId }: GetUserByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserByIdQueryOptions({ userId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserById>>, TError = ErrorType<HumaAPIError>>({ userId }: GetUserByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserByIdQueryKey({ userId });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserById>>> = ({ signal }) => getUserById({ userId }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserById>>>
export type GetUserByIdSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetUserByIdSuspense<TData = Awaited<ReturnType<typeof getUserById>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserByIdPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserByIdSuspense<TData = Awaited<ReturnType<typeof getUserById>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserByIdSuspense<TData = Awaited<ReturnType<typeof getUserById>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetUserByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user by ID
 */

export function useGetUserByIdSuspense<TData = Awaited<ReturnType<typeof getUserById>>, TError = ErrorType<HumaAPIError>>(
 { userId }: GetUserByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserByIdSuspenseQueryOptions({ userId },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






